import React from "react";

const DataVizChart = () => {
  return (
    <svg viewBox="0 0 1200.7 1989.01">
      <g id="titlebox">
        <rect className="cls-22" y="0" width="1202" height="97.52" />
      </g>
      <g>
        <path
          className="cls-9"
          d="m308.55,57.57h4.79v-11.12h-2.2v6.66h-12.49v-18.99h47.11v18.99h-12.49v-6.66h-2.2v11.12h4.79v13.98h-27.3v-13.98Z"
        />
        <path
          className="cls-9"
          d="m346.8,56.08c0-10.46,7.04-16.35,19.59-16.35s19.59,5.89,19.59,16.35-7.04,16.35-19.59,16.35-19.59-5.89-19.59-16.35Zm21.58,0c0-2.75-.61-3.8-1.98-3.8s-1.98,1.05-1.98,3.8.61,3.8,1.98,3.8,1.98-1.05,1.98-3.8Z"
        />
        <path
          className="cls-9"
          d="m386.97,56.08c0-10.46,7.04-16.35,19.59-16.35s19.59,5.89,19.59,16.35-7.04,16.35-19.59,16.35-19.59-5.89-19.59-16.35Zm21.58,0c0-2.75-.61-3.8-1.98-3.8s-1.98,1.05-1.98,3.8.61,3.8,1.98,3.8,1.98-1.05,1.98-3.8Z"
        />
        <path
          className="cls-9"
          d="m427.8,57.57h2.04v-10.84h-2.04v-13.98h18.88v24.82h2.04v13.98h-20.91v-13.98Z"
        />
        <path
          className="cls-9"
          d="m466,69.07h-.22l-.33,2.48h-14.75v-13.26h2.75c2.7,1.71,6.16,2.75,10.35,2.75,1.65,0,2.75-.17,3.91-.61v-.22c-12.82-1.71-17.61-5.39-17.61-11.23,0-5.45,4.24-9.25,10.95-9.25,3.63,0,6.6,1.1,9.03,3.36h.22l.33-2.48h14.75v12.16h-2.75c-2.48-1.38-6-2.2-9.58-2.2-1.6,0-2.59.17-3.63.5v.22c13.54,2.75,17.67,5.12,17.67,11.17s-4.29,9.96-11.61,9.96c-3.63,0-6.33-.94-9.47-3.36Z"
        />
        <path
          className="cls-9"
          d="m497.53,56.08c0-10.46,7.04-16.35,19.59-16.35s19.59,5.89,19.59,16.35-7.04,16.35-19.59,16.35-19.59-5.89-19.59-16.35Zm21.58,0c0-2.75-.61-3.8-1.98-3.8s-1.98,1.05-1.98,3.8.61,3.8,1.98,3.8,1.98-1.05,1.98-3.8Z"
        />
        <path
          className="cls-9"
          d="m538.37,57.57h2.04v-2.97h-2.04v-13.98h4.62c2.42-5.5,7.38-8.75,13.59-8.75s9.8,3.14,9.8,8.53c0,5.01-3.19,8.09-8.25,8.09-3.47,0-6.11-1.43-7.76-4.07l-.22.05c.83,3.69,3.91,5.83,8.59,5.83,3.14,0,5.94-.99,7.82-2.86v7.16h-9.3v2.97h4.62v13.98h-23.5v-13.98Z"
        />
        <path
          className="cls-9"
          d="m580.14,62.96v-8.37h-2.04v-12.33c3.25-.55,5.06-2.97,6.16-8.15h12.55v6.49h5.72v13.98h-5.72v1.6c0,1.43.77,1.87,2.59,1.87.61,0,1.49-.06,2.59-.33l.83,13.48c-2.42.77-5.78,1.21-9.69,1.21-9.47,0-12.99-2.53-12.99-9.47Z"
        />
        <path
          className="cls-9"
          d="m604.68,57.57h2.04v-10.84h-2.04v-13.98h18.88v13.43h.22c2.15-4.46,5.45-6.44,10.35-6.44,6.71,0,10.35,3.8,10.35,10.9v6.93h2.04v13.98h-18.88v-17.06c0-1.27-.66-1.98-1.82-1.98-.99,0-1.76.55-2.26,1.65v3.41h2.04v13.98h-20.91v-13.98Z"
        />
        <path
          className="cls-9"
          d="m647.88,56.08c0-10.62,6.88-16.35,19.48-16.35,11.56,0,17.67,4.79,17.67,13.59,0,1.49-.17,3.03-.39,4.13h-19.37c.22,2.04,1.82,2.64,6.49,2.64,4.02,0,7.71-.44,11.01-1.27l1.32,11.17c-3.8,1.6-8.75,2.42-14.42,2.42-14.53,0-21.8-5.45-21.8-16.35Zm21.3-2.53v-.5c0-2.48-.61-3.58-1.98-3.58s-1.98,1.1-1.98,3.58v.5h3.96Z"
        />
        <path
          className="cls-9"
          d="m706.05,57.57h4.79v-11.12h-2.2v6.66h-12.49v-18.99h47.11v18.99h-12.49v-6.66h-2.2v11.12h4.79v13.98h-27.3v-13.98Z"
        />
        <path
          className="cls-9"
          d="m745.18,57.57h2.04v-2.97h-2.04v-13.98h17.89v.99c-.83,1.27-1.16,2.92-1.32,5.61h.22c1.32-4.73,4.73-7.48,9.8-7.48,5.34,0,8.59,3.08,8.59,8.15s-3.08,8.2-8.2,8.2c-3.91,0-6.71-1.87-7.87-5.34h-.22v6.82h4.62v13.98h-23.5v-13.98Z"
        />
        <path
          className="cls-9"
          d="m780.13,64.61c0-5.39,3.41-7.71,11.23-7.71,2.81,0,5.23.27,7.43.94v-6.27c0-2.53-.5-4.07-1.71-5.12l-.22.11c.33.77.5,1.82.5,2.92,0,4.68-2.97,7.21-7.93,7.21s-8.26-2.64-8.26-7.38c0-6.44,5.83-9.58,16.95-9.58,12.05,0,17.5,3.69,17.5,11.78v6.05h2.04v13.65c-2.31.83-5.12,1.21-8.15,1.21-4.84,0-7.71-.99-8.86-3.14h-.22c-2.37,2.09-5.83,3.14-10.18,3.14-6.83,0-10.13-2.53-10.13-7.82Zm18.66.61v-2.97c-.27-.44-.88-.66-1.49-.66-1.05,0-1.6.77-1.6,2.2s.55,2.15,1.6,2.15c.66,0,1.21-.28,1.49-.72Z"
        />
        <path
          className="cls-9"
          d="m819.03,56.14c0-10.46,4.35-16.4,11.72-16.4,4.51,0,7.71,2.26,9.41,6.44h.22v-1.93c0-2.53-1.21-4.84-2.86-5.61v-5.89h19.7v24.82h2.04v13.98h-18.33v-5.56h-.22c-1.76,4.24-5.06,6.44-9.74,6.44-7.65,0-11.94-5.89-11.94-16.29Zm21.36,2.64v-5.45c-.39-.66-1.05-1.05-1.82-1.05-1.32,0-1.93,1.16-1.93,3.8s.61,3.8,1.93,3.8c.77,0,1.43-.39,1.82-1.1Z"
        />
        <path
          className="cls-9"
          d="m860.64,56.08c0-10.62,6.88-16.35,19.48-16.35,11.56,0,17.67,4.79,17.67,13.59,0,1.49-.17,3.03-.39,4.13h-19.37c.22,2.04,1.82,2.64,6.49,2.64,4.02,0,7.71-.44,11.01-1.27l1.32,11.17c-3.8,1.6-8.75,2.42-14.42,2.42-14.53,0-21.8-5.45-21.8-16.35Zm21.3-2.53v-.5c0-2.48-.61-3.58-1.98-3.58s-1.98,1.1-1.98,3.58v.5h3.96Z"
        />
      </g>
      <rect
        className="cls-10"
        x="931.33"
        y="55.73"
        width="237.83"
        height="41.78"
      />
      <g>
        <path
          className="cls-20"
          d="m974.29,83.86h-2.85v-3.7h-4.3v3.7h-2.86v-9.47h2.86v3.48h4.3v-3.48h2.85v9.47Z"
        />
        <path
          className="cls-20"
          d="m986.81,79.12c0,.88-.2,1.7-.61,2.44-.41.74-1.01,1.33-1.82,1.77s-1.79.66-2.95.66-2.16-.23-2.97-.68-1.41-1.06-1.81-1.8c-.39-.74-.59-1.54-.59-2.39s.2-1.65.59-2.39.99-1.34,1.81-1.79c.81-.45,1.81-.68,2.98-.68.88,0,1.66.13,2.34.39.69.26,1.25.61,1.69,1.06s.78.96,1,1.55.34,1.21.34,1.86Zm-2.91,0c0-.36-.05-.68-.16-.97s-.26-.55-.47-.77c-.21-.22-.47-.39-.78-.51s-.66-.18-1.06-.18c-.77,0-1.37.22-1.8.67s-.66,1.03-.66,1.76.22,1.31.66,1.76c.44.45,1.04.67,1.8.67.52,0,.97-.1,1.34-.31s.65-.49.84-.86.29-.79.29-1.26Z"
        />
        <path
          className="cls-20"
          d="m1003.74,74.39l-4.1,9.6h-1.65l-2.46-5.58-2.52,5.58h-1.67l-4.02-9.6h2.96l1.97,5.25,2.26-5.25h2.04l2.21,5.25,2.06-5.25h2.93Z"
        />
        <path
          className="cls-20"
          d="m1018.29,76.69h-3.47v7.17h-2.85v-7.17h-3.47v-2.3h9.8v2.3Z"
        />
        <path
          className="cls-20"
          d="m1029.3,79.12c0,.88-.2,1.7-.61,2.44-.41.74-1.01,1.33-1.82,1.77s-1.79.66-2.95.66-2.16-.23-2.97-.68-1.41-1.06-1.81-1.8c-.39-.74-.59-1.54-.59-2.39s.2-1.65.59-2.39.99-1.34,1.81-1.79c.81-.45,1.81-.68,2.98-.68.88,0,1.66.13,2.34.39.69.26,1.25.61,1.69,1.06s.78.96,1,1.55.34,1.21.34,1.86Zm-2.91,0c0-.36-.05-.68-.16-.97s-.26-.55-.47-.77c-.21-.22-.47-.39-.78-.51s-.66-.18-1.06-.18c-.77,0-1.37.22-1.8.67s-.66,1.03-.66,1.76.22,1.31.66,1.76c.44.45,1.04.67,1.8.67.52,0,.97-.1,1.34-.31s.65-.49.84-.86.29-.79.29-1.26Z"
        />
        <path
          className="cls-20"
          d="m1044.4,83.86h-3.07l-.75-1.68c-.27-.62-.52-1.07-.74-1.35s-.43-.47-.64-.55c-.21-.08-.48-.12-.8-.12h-.32v3.7h-2.86v-9.47h4.86c.78,0,1.43.16,1.93.48s.86.71,1.08,1.16c.22.46.33.89.33,1.3,0,.48-.09.88-.28,1.21-.18.33-.38.57-.58.72s-.44.29-.69.43c.31.18.56.39.75.63.2.24.47.74.81,1.48l.96,2.06Zm-3.88-6.48c0-.44-.14-.74-.43-.92s-.75-.26-1.4-.26h-.6v2.28h.62c.7,0,1.17-.08,1.43-.23.26-.15.39-.45.39-.88Z"
        />
        <path
          className="cls-20"
          d="m1052.85,83.86h-7.14v-9.47h7.03v1.9h-4.17v1.74h3.98v1.91h-3.98v2.02h4.29v1.91Z"
        />
        <path
          className="cls-20"
          d="m1065.16,83.86h-2.93l-.77-1.92h-4.12l-.79,1.92h-2.93l4.19-9.47h3.16l4.18,9.47Zm-4.35-3.57l-1.39-3.46-1.4,3.46h2.79Z"
        />
        <path
          className="cls-20"
          d="m1076.16,79.29c0,.97-.18,1.75-.53,2.34-.35.59-.77,1.06-1.25,1.43-.68.53-1.63.8-2.85.8h-5.11v-9.47h3.94c.59,0,1.1.03,1.52.09.42.06.8.15,1.14.26s.62.24.86.38.45.29.64.45c.32.26.61.58.85.94.24.36.44.78.58,1.25.14.47.22.99.22,1.54Zm-2.91-.12c0-.77-.15-1.37-.44-1.8-.29-.43-.65-.72-1.06-.86-.41-.15-.83-.22-1.26-.22h-1.22v5.61h1.22c.75,0,1.39-.18,1.94-.53s.82-1.09.82-2.19Z"
        />
        <path
          className="cls-20"
          d="m1090.57,83.15c-.39.21-.79.37-1.2.49s-.82.21-1.24.26c-.42.05-.85.08-1.29.08-.83,0-1.56-.11-2.22-.34-.65-.23-1.22-.56-1.7-1.01-.48-.44-.84-.96-1.08-1.56-.24-.59-.36-1.25-.36-1.96,0-.82.14-1.53.42-2.14s.68-1.12,1.19-1.53c.51-.41,1.09-.71,1.74-.9.65-.19,1.33-.29,2.05-.29,1.08,0,2.29.24,3.66.72v2.52c-.47-.29-.93-.53-1.39-.73-.46-.19-1-.29-1.62-.29-.55,0-1.07.11-1.54.33s-.86.53-1.16.94-.44.88-.44,1.42c0,.48.13.92.38,1.32s.61.72,1.06.95c.45.23.97.35,1.54.35.46,0,.9-.06,1.31-.17s.75-.24,1.04-.37c.28-.14.57-.3.86-.49v2.4Z"
        />
        <path
          className="cls-20"
          d="m1102.5,83.86h-2.85v-3.7h-4.3v3.7h-2.86v-9.47h2.86v3.48h4.3v-3.48h2.85v9.47Z"
        />
        <path
          className="cls-20"
          d="m1115.28,83.86h-2.93l-.77-1.92h-4.12l-.79,1.92h-2.93l4.19-9.47h3.16l4.18,9.47Zm-4.35-3.57l-1.39-3.46-1.4,3.46h2.79Z"
        />
        <path
          className="cls-20"
          d="m1125.71,83.86h-3.07l-.75-1.68c-.27-.62-.52-1.07-.74-1.35s-.43-.47-.64-.55c-.21-.08-.48-.12-.8-.12h-.32v3.7h-2.86v-9.47h4.86c.78,0,1.43.16,1.93.48s.86.71,1.08,1.16c.22.46.33.89.33,1.3,0,.48-.09.88-.28,1.21-.18.33-.38.57-.58.72s-.44.29-.69.43c.31.18.56.39.75.63.2.24.47.74.81,1.48l.96,2.06Zm-3.88-6.48c0-.44-.14-.74-.43-.92s-.75-.26-1.4-.26h-.6v2.28h.62c.7,0,1.17-.08,1.43-.23.26-.15.39-.45.39-.88Z"
        />
        <path
          className="cls-20"
          d="m1135.49,76.69h-3.47v7.17h-2.85v-7.17h-3.47v-2.3h9.8v2.3Z"
        />
      </g>
      <g id="barchart">
        <path
          className="cls-19"
          d="m782.54,439.5c0,1.6-.59,2.48-1.63,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
        />
        <g>
          <path
            className="cls-19"
            d="m796.92,441.9v-.39l.5-.48c1.2-1.14,1.74-1.75,1.75-2.46,0-.48-.23-.92-.93-.92-.43,0-.78.22-1,.4l-.2-.45c.33-.28.79-.48,1.33-.48,1.01,0,1.44.69,1.44,1.37,0,.87-.63,1.57-1.62,2.53l-.38.35h0s2.11.01,2.11.01v.53h-3Z"
          />
          <path
            className="cls-19"
            d="m803.76,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m807.47,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
        </g>
        <g>
          <path
            className="cls-19"
            d="m821.66,441.9v-1.28h-2.19v-.42l2.1-3h.69v2.92h.66v.5h-.66v1.28h-.6Zm0-1.78v-1.57c0-.25,0-.49.02-.74h-.02c-.14.28-.26.48-.39.69l-1.15,1.6h0s1.54.01,1.54.01Z"
          />
          <path
            className="cls-19"
            d="m826.53,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m830.24,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.63-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
        </g>
        <g>
          <path
            className="cls-19"
            d="m845.55,437.65c-.13,0-.3,0-.48.03-1,.17-1.53.9-1.63,1.67h.02c.22-.3.62-.54,1.14-.54.83,0,1.42.6,1.42,1.52,0,.86-.59,1.66-1.56,1.66s-1.66-.78-1.66-2c0-.93.33-1.66.8-2.12.39-.38.91-.62,1.5-.69.19-.03.35-.04.46-.04v.52Zm-.18,2.71c0-.67-.38-1.08-.97-1.08-.38,0-.74.24-.91.58-.04.07-.07.17-.07.28.01.77.37,1.35,1.03,1.35.55,0,.92-.46.92-1.13Z"
          />
          <path
            className="cls-19"
            d="m849.7,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.63-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m853.42,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
        </g>
        <g>
          <path
            className="cls-19"
            d="m867.21,440.71c0-.59.35-1.01.93-1.26v-.02c-.53-.25-.75-.65-.75-1.06,0-.74.63-1.25,1.45-1.25.91,0,1.37.57,1.37,1.16,0,.4-.19.83-.77,1.1v.02c.58.23.95.64.95,1.22,0,.82-.7,1.37-1.6,1.37-.98,0-1.58-.59-1.58-1.27Zm2.53-.03c0-.57-.4-.85-1.03-1.03-.55.16-.85.52-.85.97-.02.48.34.9.94.9s.94-.35.94-.84Zm-1.75-2.35c0,.47.35.73.9.87.41-.14.72-.43.72-.85,0-.38-.22-.77-.8-.77-.53,0-.82.35-.82.75Z"
          />
          <path
            className="cls-19"
            d="m874.11,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m877.82,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.63-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
        </g>
        <g>
          <path
            className="cls-19"
            d="m889.21,437.79h-.02l-.82.44-.12-.49,1.03-.55h.54v4.7h-.62v-4.11Z"
          />
          <path
            className="cls-19"
            d="m894.67,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.64-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m898.38,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.63-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
          <path
            className="cls-19"
            d="m902.09,439.5c0,1.6-.59,2.48-1.64,2.48-.92,0-1.54-.86-1.56-2.42,0-1.58.68-2.45,1.63-2.45s1.56.88,1.56,2.38Zm-2.55.07c0,1.22.38,1.92.96,1.92.65,0,.96-.76.96-1.96s-.3-1.92-.96-1.92c-.56,0-.96.68-.96,1.96Z"
          />
        </g>
        <g className="cls-8">
          <rect
            className="cls-20"
            x="778.95"
            y="432.81"
            width="116.22"
            height="1.17"
          />
        </g>
        <g className="cls-8">
          <g>
            <rect
              className="cls-20"
              x="778.37"
              y="424.62"
              width="1.17"
              height="8.77"
            />
            <rect
              className="cls-20"
              x="801.61"
              y="424.62"
              width="1.17"
              height="8.77"
            />
            <rect
              className="cls-20"
              x="824.86"
              y="424.62"
              width="1.17"
              height="8.77"
            />
            <rect
              className="cls-20"
              x="848.1"
              y="424.62"
              width="1.17"
              height="8.77"
            />
            <rect
              className="cls-20"
              x="871.34"
              y="424.62"
              width="1.17"
              height="8.77"
            />
            <rect
              className="cls-20"
              x="894.59"
              y="424.62"
              width="1.17"
              height="8.77"
            />
          </g>
        </g>
        <g className="cls-8">
          <rect
            className="cls-20"
            x="778.37"
            y="135.16"
            width="1.17"
            height="298.24"
          />
          <g>
            <rect
              className="cls-20"
              x="778.95"
              y="425.79"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="411.59"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="397.39"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="383.19"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="368.99"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="354.79"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="340.58"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="326.38"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="312.18"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="297.98"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="283.78"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="269.57"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="255.37"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="241.17"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="226.97"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="212.77"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="198.57"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="184.36"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="170.16"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="155.96"
              width="2.91"
              height="1"
            />
            <rect
              className="cls-20"
              x="778.95"
              y="141.76"
              width="2.91"
              height="1"
            />
          </g>
        </g>
        <g>
          <rect
            id="excelBar"
            className="cls-14 bar"
            x="778.95"
            y="137.15"
            width="97.98"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m877.22,147.62h-98.56v-10.72h98.56v10.72Zm-97.98-.5h97.39v-9.73h-97.39v9.73Z"
          />
        </g>
        <g>
          <rect
            id="tableauBar"
            className="cls-14 bar"
            x="778.95"
            y="151.35"
            width="68.57"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m847.82,161.82h-69.16v-10.72h69.16v10.72Zm-68.57-.5h67.98v-9.73h-67.98v9.73Z"
          />
        </g>
        <g>
          <rect
            id="powerpointBar"
            className="cls-14 bar"
            x="778.95"
            y="165.55"
            width="64.04"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m843.29,176.02h-64.63v-10.72h64.63v10.72Zm-64.04-.5h63.45v-9.73h-63.45v9.73Z"
          />
        </g>
        <g>
          <rect
            id="powerBIBar"
            className="cls-14 bar"
            x="778.95"
            y="179.75"
            width="45.09"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m824.34,190.23h-45.68v-10.72h45.68v10.72Zm-45.09-.5h44.51v-9.73h-44.51v9.73Z"
          />
        </g>
        <g>
          <rect
            id="RBar"
            className="cls-14 bar"
            x="778.95"
            y="193.95"
            width="43.35"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m822.6,204.43h-43.94v-10.72h43.94v10.72Zm-43.35-.5h42.76v-9.73h-42.76v9.73Z"
          />
        </g>
        <g>
          <rect
            id="googlesheetsBar"
            className="cls-14 bar"
            x="778.95"
            y="208.15"
            width="43"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m822.25,218.63h-43.59v-10.72h43.59v10.72Zm-43-.5h42.42v-9.73h-42.42v9.73Z"
          />
        </g>
        <g>
          <rect
            id="illustratorBar"
            className="cls-14 bar"
            x="778.95"
            y="222.36"
            width="38.7"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m817.95,232.83h-39.29v-10.72h39.29v10.72Zm-38.7-.5h38.12v-9.73h-38.12v9.73Z"
          />
        </g>
        <g>
          <rect
            id="penAndPaperBar"
            className="cls-14 bar"
            x="778.95"
            y="236.56"
            width="38.7"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m817.95,247.03h-39.29v-10.72h39.29v10.72Zm-38.7-.5h38.12v-9.73h-38.12v9.73Z"
          />
        </g>
        <g>
          <rect
            id="GGPlot2Bar"
            className="cls-14 bar"
            x="778.95"
            y="250.76"
            width="37.77"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m817.02,261.23h-38.36v-10.72h38.36v10.72Zm-37.77-.5h37.19v-9.73h-37.19v9.73Z"
          />
        </g>
        <g>
          <rect
            id="pythonBar"
            className="cls-14 bar"
            x="778.95"
            y="264.96"
            width="36.61"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m815.86,275.44h-37.2v-10.72h37.2v10.72Zm-36.61-.5h36.02v-9.73h-36.02v9.73Z"
          />
        </g>
        <g>
          <rect
            id="D3Bar"
            className="cls-14 bar"
            x="778.95"
            y="279.16"
            width="30.92"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m810.16,289.64h-31.5v-10.72h31.5v10.72Zm-30.92-.5h30.33v-9.73h-30.33v9.73Z"
          />
        </g>
        <g>
          <rect
            id="figmaBar"
            className="cls-14 bar"
            x="778.95"
            y="293.36"
            width="28.94"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m808.19,303.84h-29.53v-10.72h29.53v10.72Zm-28.94-.5h28.35v-9.73h-28.35v9.73Z"
          />
        </g>
        <g>
          <rect
            id="plotlyBar"
            className="cls-14 bar"
            x="778.95"
            y="307.57"
            width="21.15"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m800.4,318.04h-21.74v-10.72h21.74v10.72Zm-21.15-.5h20.57v-9.73h-20.57v9.73Z"
          />
        </g>
        <g>
          <rect
            id="RAWGraphsBar"
            className="cls-14 bar"
            x="778.95"
            y="321.77"
            width="17.9"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m797.15,332.24h-18.49v-10.72h18.49v10.72Zm-17.9-.5h17.31v-9.73h-17.31v9.73Z"
          />
        </g>
        <g>
          <rect
            id="datawrapperBar"
            className="cls-14 bar"
            x="778.95"
            y="335.97"
            width="16.15"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m795.4,346.44h-16.74v-10.72h16.74v10.72Zm-16.16-.5h15.57v-9.73h-15.57v9.73Z"
          />
        </g>
        <g>
          <rect
            id="googleDataStudioBar"
            className="cls-14 bar"
            x="778.95"
            y="350.17"
            width="15.57"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m794.82,360.65h-16.16v-10.72h16.16v10.72Zm-15.57-.5h14.99v-9.73h-14.99v9.73Z"
          />
        </g>
        <g>
          <rect
            id="arcGISBar"
            className="cls-14 bar"
            x="778.95"
            y="364.37"
            width="15.46"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m794.7,374.85h-16.04v-10.72h16.04v10.72Zm-15.46-.5h14.87v-9.73h-14.87v9.73Z"
          />
        </g>
        <g>
          <rect
            id="flourishBar"
            className="cls-14 bar"
            x="778.95"
            y="378.58"
            width="15.46"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m794.7,389.05h-16.04v-10.72h16.04v10.72Zm-15.46-.5h14.87v-9.73h-14.87v9.73Z"
          />
        </g>
        <g>
          <rect
            id="QGISBar"
            className="cls-14 bar"
            x="778.95"
            y="392.78"
            width="14.88"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m794.12,403.25h-15.46v-10.72h15.46v10.72Zm-14.88-.5h14.29v-9.73h-14.29v9.73Z"
          />
        </g>
        <g>
          <rect
            id="mapboxBar"
            className="cls-14 bar"
            x="778.95"
            y="406.98"
            width="13.95"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m793.19,417.45h-14.53v-10.72h14.53v10.72Zm-13.95-.5h13.36v-9.73h-13.36v9.73Z"
          />
        </g>
        <g>
          <rect
            id="canvasBar"
            className="cls-14 bar"
            x="778.95"
            y="421.18"
            width="12.9"
            height="10.23"
          />
          <path
            className="cls-14"
            d="m792.15,431.66h-13.49v-10.72h13.49v10.72Zm-12.9-.5h12.31v-9.73h-12.31v9.73Z"
          />
        </g>
        <g>
          <path
            className="cls-20"
            d="m750.87,145.23h-5.1v-6.86h5.02v1.38h-2.98v1.26h2.84v1.38h-2.84v1.47h3.06v1.38Z"
          />
          <path
            className="cls-20"
            d="m757.48,145.23h-2.17l-.96-1.43-.96,1.43h-1.92l1.92-2.48-1.96-2.57h2.16l.92,1.37.93-1.37h1.92l-1.88,2.39,2,2.65Z"
          />
          <path
            className="cls-20"
            d="m762.07,144.99c-.15.06-.3.11-.46.16s-.35.09-.55.12c-.2.03-.42.05-.67.05-.54,0-1-.09-1.38-.28s-.67-.42-.87-.7c-.2-.28-.34-.57-.42-.86-.08-.29-.12-.55-.12-.78s.04-.48.12-.78c.08-.29.22-.58.42-.85s.49-.5.86-.69.84-.28,1.39-.28c.37,0,.67.03.9.08.23.05.47.12.7.21v1.4c-.57-.19-1.02-.28-1.34-.28s-.59.1-.83.29c-.24.19-.36.49-.36.89,0,.27.06.49.18.68.12.18.27.32.46.4s.37.13.56.13c.18,0,.38-.03.6-.08.22-.05.5-.13.82-.23v1.4Z"
          />
          <path
            className="cls-20"
            d="m768.02,143.14h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path className="cls-20" d="m770.73,145.23h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m738.3,154.23h-2.48v5.2h-2.04v-5.2h-2.48v-1.67h7v1.67Z"
          />
          <path
            className="cls-20"
            d="m743.79,159.17c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m749.94,156.94c0,.58-.11,1.07-.34,1.45-.22.38-.51.67-.86.85s-.7.27-1.06.27c-.26,0-.49-.03-.68-.09s-.34-.13-.44-.2c-.11-.07-.21-.16-.33-.25v.46h-1.76v-6.86h1.76v2.12c.13-.1.31-.19.54-.27.23-.08.49-.12.79-.12.4,0,.75.07,1.06.22.31.15.56.35.75.6.19.25.34.53.43.84s.14.64.14.98Zm-1.85-.04c0-.43-.1-.76-.29-.99s-.42-.34-.68-.34-.56.11-.89.32v1.93c.25.24.54.36.89.36.22,0,.43-.09.65-.27.21-.18.32-.52.32-1.01Z"
          />
          <path className="cls-20" d="m752.56,159.43h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m758.87,157.34h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m764.89,159.17c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m770.82,159.43h-1.76v-.72c-.25.27-.51.47-.78.61s-.6.2-.98.2c-.75,0-1.24-.22-1.46-.67-.22-.44-.33-.94-.33-1.5v-2.96h1.76v2.72c0,.27.04.51.13.72s.29.31.58.31c.26,0,.46-.07.61-.22.15-.15.3-.34.46-.57v-2.96h1.76v5.04Z"
          />
          <path
            className="cls-20"
            d="m719.09,168.92c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path
            className="cls-20"
            d="m725.13,171.1c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m733.81,168.58l-1.96,5.04h-1.11l-1.11-2.75-1.1,2.75h-1.11l-2.01-5.04h1.78l.91,2.55.97-2.55h1.12l.98,2.55.88-2.55h1.76Z"
          />
          <path
            className="cls-20"
            d="m739.4,171.54h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m744.64,168.86l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m750.51,171.07c0,.34-.05.66-.14.98-.09.31-.24.6-.43.85-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85c.22.38.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74s-.22-.33-.37-.41c-.15-.08-.3-.13-.46-.13-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m756.92,171.1c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m759.68,173.63h-1.76v-5.04h1.76v5.04Zm-.14-6.21c0,.21-.07.38-.22.53-.15.15-.32.22-.52.22-.14,0-.26-.03-.37-.1s-.2-.16-.27-.27-.1-.24-.1-.38c0-.2.07-.38.21-.53s.32-.22.52-.22.38.07.52.22.22.33.22.53Z"
          />
          <path
            className="cls-20"
            d="m766.2,173.63h-1.76v-2.72c0-.28-.04-.52-.13-.73-.09-.21-.29-.31-.59-.31-.14,0-.27.03-.38.08-.11.05-.21.12-.29.21-.09.09-.16.17-.22.25-.06.08-.12.16-.18.25v2.96h-1.76v-5.04h1.76v.72c.28-.3.55-.51.83-.63.28-.12.59-.18.93-.18,1.19,0,1.79.72,1.79,2.17v2.96Z"
          />
          <path
            className="cls-20"
            d="m771.17,173.33c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m734.59,183.12c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path
            className="cls-20"
            d="m740.63,185.3c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m749.31,182.78l-1.96,5.04h-1.11l-1.11-2.75-1.1,2.75h-1.11l-2.01-5.04h1.78l.91,2.55.97-2.55h1.12l.98,2.55.88-2.55h1.76Z"
          />
          <path
            className="cls-20"
            d="m754.9,185.74h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m760.13,183.06l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m767.16,185.88c0,.59-.2,1.06-.6,1.42-.4.35-.96.53-1.67.53h-3.91v-6.86h3.27c.42,0,.79.04,1.11.12.31.08.57.2.76.34.19.14.33.31.43.51s.14.41.14.64c0,.25-.05.48-.15.7-.1.21-.22.39-.36.52-.14.14-.29.23-.44.29.46.19.81.42,1.06.7.24.28.36.65.36,1.1Zm-2.38-2.94c0-.33-.11-.55-.32-.66s-.55-.16-1.01-.16h-.43v1.64h.44c.47,0,.8-.05,1.01-.16.21-.11.31-.33.31-.66Zm.33,2.86c0-.59-.42-.88-1.26-.88h-.83v1.76h.83c.84,0,1.26-.29,1.26-.88Z"
          />
          <path className="cls-20" d="m770.52,187.83h-2.04v-6.86h2.04v6.86Z" />
          <path
            className="cls-20"
            d="m771.3,202.03h-2.19l-.53-1.22c-.2-.45-.37-.77-.53-.98-.16-.21-.31-.34-.46-.4-.15-.06-.34-.09-.57-.09h-.23v2.68h-2.04v-6.86h3.47c.56,0,1.02.12,1.38.35s.62.51.77.84c.16.33.24.64.24.94,0,.35-.07.64-.2.88s-.27.41-.42.52-.31.21-.49.31c.22.13.4.28.54.46s.33.53.58,1.07l.68,1.49Zm-2.77-4.69c0-.32-.1-.54-.31-.66s-.54-.19-1-.19h-.43v1.65h.44c.5,0,.84-.06,1.02-.17.18-.11.28-.32.28-.64Z"
          />
          <path
            className="cls-20"
            d="m706.12,215.74c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path
            className="cls-20"
            d="m712.93,213.7c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m719.33,213.7c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m725.25,212.26h-.87c.31.27.46.6.46,1,0,.21-.04.41-.13.6-.09.19-.21.36-.38.51-.17.15-.37.27-.62.36-.25.09-.53.15-.84.17-.41.02-.61.13-.61.33,0,.08.03.14.08.17.05.04.13.06.25.08s.3.04.57.06c.3.03.58.07.84.14.26.07.5.21.73.42.22.21.34.51.34.91,0,.31-.08.59-.25.83-.17.24-.44.43-.81.56-.37.14-.87.2-1.48.2-.89,0-1.54-.12-1.95-.36-.42-.24-.62-.56-.62-.97,0-.11.03-.23.08-.38.05-.14.17-.28.34-.41.17-.13.43-.22.76-.27-.12-.04-.22-.13-.3-.25-.08-.12-.13-.25-.13-.39,0-.18.06-.35.18-.52.12-.17.31-.28.58-.33-.37-.1-.69-.29-.96-.56s-.41-.63-.41-1.06c0-.33.06-.62.19-.87.13-.25.3-.45.52-.6s.48-.27.77-.34.61-.11.96-.11h2.73v1.07Zm-1.59,4.91c0-.22-.12-.36-.35-.43-.23-.06-.47-.1-.72-.1-.41,0-.7.04-.88.13s-.27.23-.27.42c0,.38.37.56,1.12.56.33,0,.6-.05.8-.15.2-.1.3-.25.3-.44Zm-.35-4.06c0-.25-.09-.46-.26-.61-.17-.15-.36-.23-.57-.23-.27,0-.48.09-.64.28-.15.19-.23.38-.23.58,0,.14.03.27.1.4.07.12.16.22.28.29s.27.11.44.11c.25,0,.46-.08.63-.24s.25-.35.25-.58Z"
          />
          <path className="cls-20" d="m727.87,216.23h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m734.18,214.14h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m743.03,214.23c0,.43-.11.8-.33,1.11-.22.31-.52.55-.91.72-.39.17-.83.25-1.33.25-.14,0-.31,0-.52-.03-.2-.02-.47-.07-.81-.15-.34-.08-.69-.2-1.05-.37v-1.68c.34.21.68.39,1.01.54.33.14.68.21,1.06.21.35,0,.57-.06.68-.18s.15-.23.15-.33c0-.18-.09-.34-.26-.47s-.43-.26-.77-.39c-.37-.16-.7-.33-.98-.52s-.51-.42-.69-.7c-.18-.28-.27-.61-.27-1s.09-.7.27-1,.45-.54.82-.72.82-.27,1.35-.27c.38,0,.73.04,1.05.11.32.07.59.16.79.25s.35.17.43.22v1.61c-.28-.2-.58-.38-.93-.54-.34-.16-.7-.24-1.09-.24-.25,0-.44.05-.55.15-.11.1-.17.22-.17.37,0,.14.06.25.17.35s.32.22.61.36c.52.25.94.47,1.25.67.31.2.56.43.73.69.18.26.27.58.27.97Z"
          />
          <path
            className="cls-20"
            d="m749.43,216.23h-1.76v-2.61s0-.04,0-.06c0-.02,0-.06,0-.12,0-.24-.05-.46-.15-.66-.1-.2-.29-.3-.58-.3-.22,0-.42.08-.59.23-.17.15-.33.34-.48.57v2.96h-1.76v-6.86h1.76v2.55c.29-.31.58-.53.86-.64s.58-.17.9-.17c1.19,0,1.79.68,1.79,2.04v3.1Z"
          />
          <path
            className="cls-20"
            d="m755.59,214.14h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m761.55,214.14h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m766.33,215.93c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m770.99,214.75c0,.46-.17.84-.5,1.13-.33.29-.83.43-1.49.43-.37,0-.7-.03-.98-.1-.29-.07-.6-.16-.94-.29v-1.27c.3.17.55.3.77.39s.46.13.72.13c.44,0,.66-.12.66-.37,0-.08-.03-.16-.1-.22s-.17-.14-.33-.22c-.16-.08-.37-.18-.63-.29-.33-.15-.6-.34-.83-.58-.23-.24-.34-.54-.34-.9,0-.25.08-.49.23-.72s.38-.42.69-.57c.31-.15.68-.22,1.11-.22.1,0,.24,0,.4.02.16.01.37.05.61.12.25.06.48.15.7.27v1.23c-.1-.06-.19-.12-.26-.16-.07-.04-.16-.09-.28-.14s-.25-.1-.41-.14c-.16-.04-.32-.06-.49-.06-.2,0-.34.04-.42.12s-.11.16-.11.24.04.16.12.23c.08.07.25.16.52.26.39.15.7.31.94.47s.4.34.5.53c.1.19.15.42.15.68Z"
          />
          <path className="cls-20" d="m721.98,230.42h-2.04v-6.86h2.04v6.86Z" />
          <path className="cls-20" d="m725.26,230.42h-1.76v-6.86h1.76v6.86Z" />
          <path className="cls-20" d="m728.32,230.42h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m734.76,230.42h-1.76v-.72c-.25.27-.51.47-.78.61s-.6.2-.98.2c-.75,0-1.24-.22-1.46-.67-.22-.44-.33-.94-.33-1.5v-2.96h1.76v2.72c0,.27.04.51.13.72s.29.31.58.31c.26,0,.46-.07.61-.22.15-.15.3-.34.46-.57v-2.96h1.76v5.04Z"
          />
          <path
            className="cls-20"
            d="m739.78,228.95c0,.46-.17.84-.5,1.13-.33.29-.83.43-1.49.43-.37,0-.7-.03-.98-.1-.29-.07-.6-.16-.94-.29v-1.27c.3.17.55.3.77.39s.46.13.72.13c.44,0,.66-.12.66-.37,0-.08-.03-.16-.1-.22s-.17-.14-.33-.22c-.16-.08-.37-.18-.63-.29-.33-.15-.6-.34-.83-.58-.23-.24-.34-.54-.34-.9,0-.25.08-.49.23-.72s.38-.42.69-.57c.31-.15.68-.22,1.11-.22.1,0,.24,0,.4.02.16.01.37.05.61.12.25.06.48.15.7.27v1.23c-.1-.06-.19-.12-.26-.16-.07-.04-.16-.09-.28-.14s-.25-.1-.41-.14c-.16-.04-.32-.06-.49-.06-.2,0-.34.04-.42.12s-.11.16-.11.24.04.16.12.23c.08.07.25.16.52.26.39.15.7.31.94.47s.4.34.5.53c.1.19.15.42.15.68Z"
          />
          <path
            className="cls-20"
            d="m744.65,230.13c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m749.79,225.66l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m755.37,230.17c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m759.84,230.13c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m766.1,227.9c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m771.38,225.66l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m715.07,239.92c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path
            className="cls-20"
            d="m720.73,242.54h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m726.9,244.62h-1.76v-2.72c0-.28-.04-.52-.13-.73-.09-.21-.29-.31-.59-.31-.14,0-.27.03-.38.08-.11.05-.21.12-.29.21-.09.09-.16.17-.22.25-.06.08-.12.16-.18.25v2.96h-1.76v-5.04h1.76v.72c.28-.3.55-.51.83-.63.28-.12.59-.18.93-.18,1.19,0,1.79.72,1.79,2.17v2.96Z"
          />
          <path
            className="cls-20"
            d="m737.98,244.62h-2.3l-.43-.46c-.28.19-.6.33-.97.42s-.73.13-1.09.13c-.77,0-1.36-.17-1.76-.52s-.61-.76-.61-1.24c0-.35.1-.65.31-.92s.6-.61,1.19-1.02c-.17-.18-.31-.35-.42-.52s-.19-.32-.25-.48-.08-.32-.08-.49c0-.33.09-.63.27-.92.18-.29.45-.51.8-.68s.76-.26,1.24-.26c.35,0,.66.05.93.16s.5.25.67.42c.17.17.3.35.39.55.09.2.13.38.13.56,0,.35-.12.68-.35.98-.24.3-.55.55-.95.76l.91.99c.28-.26.53-.59.75-.99h1.63c-.42.81-.9,1.47-1.46,1.98l1.46,1.55Zm-3.62-1.42l-1.19-1.27c-.43.28-.65.56-.65.83,0,.16.08.33.23.49.15.17.38.25.67.25.35,0,.67-.1.94-.31Zm.28-3.8c0-.09-.02-.18-.07-.28-.05-.09-.12-.17-.23-.23-.11-.06-.24-.09-.4-.09-.22,0-.39.06-.5.18s-.17.24-.17.37c0,.09.03.18.09.28s.14.2.24.31c.1.11.2.21.3.32.5-.22.75-.51.75-.85Z"
          />
          <path
            className="cls-20"
            d="m748.27,239.92c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path
            className="cls-20"
            d="m753.99,244.37c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m760.14,242.07c0,.34-.05.66-.14.98-.09.31-.24.6-.43.85-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85c.22.38.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74s-.22-.33-.37-.41c-.15-.08-.3-.13-.46-.13-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m766.15,242.54h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m771.38,239.86l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m735.69,258.34c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path
            className="cls-20"
            d="m743.68,258.34c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path
            className="cls-20"
            d="m751.14,254.12c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path className="cls-20" d="m753.84,258.82h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m760.4,256.3c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m765.23,258.53c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m770.99,258.82h-5.14v-.13c.2-.19.42-.43.65-.7.24-.27.54-.63.92-1.07.17-.2.33-.4.49-.59s.28-.38.39-.57c.11-.18.2-.39.27-.61s.11-.45.11-.68c0-.32-.09-.57-.27-.77-.18-.2-.41-.29-.69-.29-.55,0-1.1.29-1.65.87v-1.62c.19-.13.35-.23.47-.3.12-.08.27-.15.43-.22s.35-.14.57-.19.46-.08.72-.08c.41,0,.79.09,1.13.26s.6.42.8.74c.19.32.29.7.29,1.13,0,.3-.04.59-.13.85s-.18.48-.27.64c-.09.16-.22.36-.38.6-.28.42-.58.83-.9,1.21h2.19v1.54Z"
          />
          <path
            className="cls-20"
            d="m741.45,268.32c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path
            className="cls-20"
            d="m747.62,267.98l-3.38,7.33h-1.78l1.37-2.95-1.97-4.38h1.89l1.01,2.51,1.15-2.51h1.71Z"
          />
          <path
            className="cls-20"
            d="m752.05,272.73c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m758.13,273.02h-1.76v-2.61s0-.04,0-.06c0-.02,0-.06,0-.12,0-.24-.05-.46-.15-.66-.1-.2-.29-.3-.58-.3-.22,0-.42.08-.59.23-.17.15-.33.34-.48.57v2.96h-1.76v-6.86h1.76v2.55c.29-.31.58-.53.86-.64s.58-.17.9-.17c1.19,0,1.79.68,1.79,2.04v3.1Z"
          />
          <path
            className="cls-20"
            d="m764.67,270.5c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m770.89,273.02h-1.76v-2.72c0-.28-.04-.52-.13-.73-.09-.21-.29-.31-.59-.31-.14,0-.27.03-.38.08-.11.05-.21.12-.29.21-.09.09-.16.17-.22.25-.06.08-.12.16-.18.25v2.96h-1.76v-5.04h1.76v.72c.28-.3.55-.51.83-.63.28-.12.59-.18.93-.18,1.19,0,1.79.72,1.79,2.17v2.96Z"
          />
          <path
            className="cls-20"
            d="m765.03,283.92c0,.7-.13,1.27-.38,1.69-.25.43-.55.77-.89,1.04-.49.39-1.16.58-2.04.58h-3.65v-6.86h2.81c.42,0,.79.02,1.09.07.3.04.57.11.81.19.24.08.45.17.62.27.17.1.32.21.45.32.23.19.43.42.61.68.17.26.31.56.42.91.1.34.15.72.15,1.12Zm-2.08-.09c0-.56-.11-.99-.32-1.31s-.46-.52-.76-.63c-.29-.11-.59-.16-.9-.16h-.87v4.07h.87c.53,0,1-.13,1.39-.39.39-.26.59-.79.59-1.59Z"
          />
          <path
            className="cls-20"
            d="m770.57,285.32c0,.36-.07.67-.21.92-.14.25-.33.46-.55.62s-.47.28-.73.35c-.26.07-.51.11-.75.11-.34,0-.72-.05-1.13-.15-.41-.1-.76-.21-1.04-.35v-1.54c.23.19.47.35.74.48s.54.2.82.2c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.47s-.22-.24-.4-.32c-.17-.08-.37-.12-.6-.12h-.22v-1.1h.26c.23,0,.42-.04.56-.13.15-.09.25-.2.32-.32.07-.12.1-.24.1-.35,0-.21-.08-.39-.24-.55-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.09-.47.2-.68.35v-1.32c.32-.14.62-.24.9-.32.28-.08.6-.12.95-.12.51,0,.94.1,1.28.3.34.2.59.44.75.73.16.29.24.55.24.8,0,.21-.04.41-.13.61s-.2.39-.34.54c-.14.16-.29.28-.44.37.27.15.51.35.72.6.21.26.31.62.31,1.08Z"
          />
          <path
            className="cls-20"
            d="m746.56,298.65h-2.81v2.78h-2.04v-6.86h4.85v1.38h-2.81v1.33h2.81v1.38Z"
          />
          <path
            className="cls-20"
            d="m749.49,301.42h-1.76v-5.04h1.76v5.04Zm-.14-6.21c0,.21-.07.38-.22.53-.15.15-.32.22-.52.22-.14,0-.26-.03-.37-.1s-.2-.16-.27-.27-.1-.24-.1-.38c0-.2.07-.38.21-.53s.32-.22.52-.22.38.07.52.22.22.33.22.53Z"
          />
          <path
            className="cls-20"
            d="m755.7,297.46h-.87c.31.27.46.6.46,1,0,.21-.04.41-.13.6-.09.19-.21.36-.38.51-.17.15-.37.27-.62.36-.25.09-.53.15-.84.17-.41.02-.61.13-.61.33,0,.08.03.14.08.17.05.04.13.06.25.08s.3.04.57.06c.3.03.58.07.84.14.26.07.5.21.73.42.22.21.34.51.34.91,0,.31-.08.59-.25.83-.17.24-.44.43-.81.56-.37.14-.87.2-1.48.2-.89,0-1.54-.12-1.95-.36-.42-.24-.62-.56-.62-.97,0-.11.03-.23.08-.38.05-.14.17-.28.34-.41.17-.13.43-.22.76-.27-.12-.04-.22-.13-.3-.25-.08-.12-.13-.25-.13-.39,0-.18.06-.35.18-.52.12-.17.31-.28.58-.33-.37-.1-.69-.29-.96-.56s-.41-.63-.41-1.06c0-.33.06-.62.19-.87.13-.25.3-.45.52-.6s.48-.27.77-.34.61-.11.96-.11h2.73v1.07Zm-1.59,4.91c0-.22-.12-.36-.35-.43-.23-.06-.47-.1-.72-.1-.41,0-.7.04-.88.13s-.27.23-.27.42c0,.38.37.56,1.12.56.33,0,.6-.05.8-.15.2-.1.3-.25.3-.44Zm-.35-4.06c0-.25-.09-.46-.26-.61-.17-.15-.36-.23-.57-.23-.27,0-.48.09-.64.28-.15.19-.23.38-.23.58,0,.14.03.27.1.4.07.12.16.22.28.29s.27.11.44.11c.25,0,.46-.08.63-.24s.25-.35.25-.58Z"
          />
          <path
            className="cls-20"
            d="m765.19,301.42h-1.76v-2.69c0-.36-.06-.62-.17-.8-.12-.18-.3-.26-.55-.26s-.44.08-.6.23c-.16.15-.31.34-.47.57v2.96h-1.76v-2.69c0-.34-.05-.6-.16-.79s-.3-.28-.57-.28c-.13,0-.25.03-.36.08-.11.05-.2.11-.27.18-.07.07-.15.16-.25.29-.1.13-.16.21-.19.24v2.96h-1.76v-5.04h1.76v.72c.26-.28.53-.49.81-.62.27-.13.59-.19.95-.19.17,0,.33.02.48.05.15.03.3.09.45.16.15.08.28.18.4.31.12.13.22.29.29.46.28-.32.58-.57.88-.73.3-.17.66-.25,1.05-.25s.73.08,1,.24.47.4.6.7c.13.31.19.68.19,1.11v3.08Z"
          />
          <path
            className="cls-20"
            d="m771.39,301.17c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m748.19,310.92c0,.25-.04.5-.13.75-.09.24-.22.47-.42.68-.19.21-.45.38-.78.51s-.71.2-1.15.2h-1.34v2.58h-2.04v-6.86h3.38c.44,0,.83.07,1.15.2.33.13.59.3.78.52.19.21.33.44.42.69.09.25.13.5.13.76Zm-2.08.01c0-.33-.1-.55-.29-.67-.19-.12-.53-.18-1.02-.18h-.43v1.65h.44c.34,0,.6-.02.78-.06s.31-.12.4-.24.12-.28.12-.5Z"
          />
          <path className="cls-20" d="m750.89,315.62h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m757.45,313.1c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m762.28,315.33c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path className="cls-20" d="m764.9,315.62h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m771.44,310.58l-3.38,7.33h-1.78l1.37-2.95-1.97-4.38h1.89l1.01,2.51,1.15-2.51h1.71Z"
          />
          <path
            className="cls-20"
            d="m715.45,329.82h-2.19l-.53-1.22c-.2-.45-.37-.77-.53-.98-.16-.21-.31-.34-.46-.4-.15-.06-.34-.09-.57-.09h-.23v2.68h-2.04v-6.86h3.47c.56,0,1.02.12,1.38.35s.62.51.77.84c.16.33.24.64.24.94,0,.35-.07.64-.2.88s-.27.41-.42.52-.31.21-.49.31c.22.13.4.28.54.46s.33.53.58,1.07l.68,1.49Zm-2.77-4.69c0-.32-.1-.54-.31-.66s-.54-.19-1-.19h-.43v1.65h.44c.5,0,.84-.06,1.02-.17.18-.11.28-.32.28-.64Z"
          />
          <path
            className="cls-20"
            d="m723.8,329.82h-2.09l-.55-1.39h-2.94l-.56,1.39h-2.09l2.99-6.86h2.26l2.98,6.86Zm-3.11-2.59l-.99-2.51-1,2.51h1.99Z"
          />
          <path
            className="cls-20"
            d="m735.09,322.96l-2.93,6.95h-1.18l-1.76-4.05-1.8,4.05h-1.19l-2.87-6.95h2.11l1.41,3.8,1.61-3.8h1.46l1.58,3.8,1.47-3.8h2.09Z"
          />
          <path
            className="cls-20"
            d="m742.41,329.34c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path
            className="cls-20"
            d="m748.1,325.05l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m753.68,329.57c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m759.83,327.27c0,.34-.05.66-.14.98-.09.31-.24.6-.43.85-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85c.22.38.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74s-.22-.33-.37-.41c-.15-.08-.3-.13-.46-.13-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m766.05,329.82h-1.76v-2.61s0-.04,0-.06c0-.02,0-.06,0-.12,0-.24-.05-.46-.15-.66-.1-.2-.29-.3-.58-.3-.22,0-.42.08-.59.23-.17.15-.33.34-.48.57v2.96h-1.76v-6.86h1.76v2.55c.29-.31.58-.53.86-.64s.58-.17.9-.17c1.19,0,1.79.68,1.79,2.04v3.1Z"
          />
          <path
            className="cls-20"
            d="m770.99,328.35c0,.46-.17.84-.5,1.13-.33.29-.83.43-1.49.43-.37,0-.7-.03-.98-.1-.29-.07-.6-.16-.94-.29v-1.27c.3.17.55.3.77.39s.46.13.72.13c.44,0,.66-.12.66-.37,0-.08-.03-.16-.1-.22s-.17-.14-.33-.22c-.16-.08-.37-.18-.63-.29-.33-.15-.6-.34-.83-.58-.23-.24-.34-.54-.34-.9,0-.25.08-.49.23-.72s.38-.42.69-.57c.31-.15.68-.22,1.11-.22.1,0,.24,0,.4.02.16.01.37.05.61.12.25.06.48.15.7.27v1.23c-.1-.06-.19-.12-.26-.16-.07-.04-.16-.09-.28-.14s-.25-.1-.41-.14c-.16-.04-.32-.06-.49-.06-.2,0-.34.04-.42.12s-.11.16-.11.24.04.16.12.23c.08.07.25.16.52.26.39.15.7.31.94.47s.4.34.5.53c.1.19.15.42.15.68Z"
          />
          <path
            className="cls-20"
            d="m711.91,340.72c0,.7-.13,1.27-.38,1.69-.25.43-.55.77-.89,1.04-.49.39-1.16.58-2.04.58h-3.65v-6.86h2.81c.42,0,.79.02,1.09.07.3.04.57.11.81.19.24.08.45.17.62.27.17.1.32.21.45.32.23.19.43.42.61.68.17.26.31.56.42.91.1.34.15.72.15,1.12Zm-2.08-.09c0-.56-.11-.99-.32-1.31s-.46-.52-.76-.63c-.29-.11-.59-.16-.9-.16h-.87v4.07h.87c.53,0,1-.13,1.39-.39.39-.26.59-.79.59-1.59Z"
          />
          <path
            className="cls-20"
            d="m718.03,343.77c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m722.51,343.73c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m728.43,343.77c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m737.04,338.98l-1.96,5.04h-1.11l-1.11-2.75-1.1,2.75h-1.11l-2.01-5.04h1.78l.91,2.55.97-2.55h1.12l.98,2.55.88-2.55h1.76Z"
          />
          <path
            className="cls-20"
            d="m742.04,339.25l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m747.61,343.77c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m753.77,341.47c0,.34-.05.66-.14.98-.09.31-.24.6-.43.85-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85c.22.38.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74s-.22-.33-.37-.41c-.15-.08-.3-.13-.46-.13-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m760.14,341.47c0,.34-.05.66-.14.98-.09.31-.24.6-.43.85-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85c.22.38.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74s-.22-.33-.37-.41c-.15-.08-.3-.13-.46-.13-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m766.15,341.93h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m771.38,339.25l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m679.76,357.74c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path
            className="cls-20"
            d="m686.56,355.7c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m692.97,355.7c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m698.88,354.26h-.87c.31.27.46.6.46,1,0,.21-.04.41-.13.6-.09.19-.21.36-.38.51-.17.15-.37.27-.62.36-.25.09-.53.15-.84.17-.41.02-.61.13-.61.33,0,.08.03.14.08.17.05.04.13.06.25.08s.3.04.57.06c.3.03.58.07.84.14.26.07.5.21.73.42.22.21.34.51.34.91,0,.31-.08.59-.25.83-.17.24-.44.43-.81.56-.37.14-.87.2-1.48.2-.89,0-1.54-.12-1.95-.36-.42-.24-.62-.56-.62-.97,0-.11.03-.23.08-.38.05-.14.17-.28.34-.41.17-.13.43-.22.76-.27-.12-.04-.22-.13-.3-.25-.08-.12-.13-.25-.13-.39,0-.18.06-.35.18-.52.12-.17.31-.28.58-.33-.37-.1-.69-.29-.96-.56s-.41-.63-.41-1.06c0-.33.06-.62.19-.87.13-.25.3-.45.52-.6s.48-.27.77-.34.61-.11.96-.11h2.73v1.07Zm-1.59,4.91c0-.22-.12-.36-.35-.43-.23-.06-.47-.1-.72-.1-.41,0-.7.04-.88.13s-.27.23-.27.42c0,.38.37.56,1.12.56.33,0,.6-.05.8-.15.2-.1.3-.25.3-.44Zm-.35-4.06c0-.25-.09-.46-.26-.61-.17-.15-.36-.23-.57-.23-.27,0-.48.09-.64.28-.15.19-.23.38-.23.58,0,.14.03.27.1.4.07.12.16.22.28.29s.27.11.44.11c.25,0,.46-.08.63-.24s.25-.35.25-.58Z"
          />
          <path className="cls-20" d="m701.5,358.22h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m707.81,356.13h-3.5c.07.31.24.56.5.75.27.2.57.29.91.29.59,0,1.25-.17,1.96-.51v1.1c-.26.14-.57.26-.94.37-.37.11-.83.17-1.4.17-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.54-.96-.94-.21-.4-.32-.84-.32-1.35s.11-.94.32-1.33c.21-.39.54-.7.96-.92.43-.22.95-.33,1.56-.33.4,0,.79.09,1.17.27s.69.47.93.87c.24.4.36.92.36,1.55v.36Zm-1.65-.88c0-.32-.08-.58-.24-.77-.16-.19-.38-.29-.68-.29s-.53.1-.71.29c-.18.2-.27.45-.27.77h1.9Z"
          />
          <path
            className="cls-20"
            d="m718.89,354.92c0,.7-.13,1.27-.38,1.69-.25.43-.55.77-.89,1.04-.49.39-1.16.58-2.04.58h-3.65v-6.86h2.81c.42,0,.79.02,1.09.07.3.04.57.11.81.19.24.08.45.17.62.27.17.1.32.21.45.32.23.19.43.42.61.68.17.26.31.56.42.91.1.34.15.72.15,1.12Zm-2.08-.09c0-.56-.11-.99-.32-1.31s-.46-.52-.76-.63c-.29-.11-.59-.16-.9-.16h-.87v4.07h.87c.53,0,1-.13,1.39-.39.39-.26.59-.79.59-1.59Z"
          />
          <path
            className="cls-20"
            d="m725.02,357.97c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m729.49,357.93c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m735.42,357.97c-.26.1-.5.18-.71.25-.22.06-.48.09-.79.09s-.49-.05-.61-.16-.2-.23-.24-.38c-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.19.02.32.05.41s.1.14.19.14c.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m743.96,356.23c0,.43-.11.8-.33,1.11-.22.31-.52.55-.91.72-.39.17-.83.25-1.33.25-.14,0-.31,0-.52-.03-.2-.02-.47-.07-.81-.15-.34-.08-.69-.2-1.05-.37v-1.68c.34.21.68.39,1.01.54.33.14.68.21,1.06.21.35,0,.57-.06.68-.18s.15-.23.15-.33c0-.18-.09-.34-.26-.47s-.43-.26-.77-.39c-.37-.16-.7-.33-.98-.52s-.51-.42-.69-.7c-.18-.28-.27-.61-.27-1s.09-.7.27-1,.45-.54.82-.72.82-.27,1.35-.27c.38,0,.73.04,1.05.11.32.07.59.16.79.25s.35.17.43.22v1.61c-.28-.2-.58-.38-.93-.54-.34-.16-.7-.24-1.09-.24-.25,0-.44.05-.55.15-.11.1-.17.22-.17.37,0,.14.06.25.17.35s.32.22.61.36c.52.25.94.47,1.25.67.31.2.56.43.73.69.18.26.27.58.27.97Z"
          />
          <path
            className="cls-20"
            d="m748.98,357.93c-.18.09-.43.17-.75.26-.32.08-.63.12-.92.12-1.27,0-1.9-.63-1.9-1.88v-2.01h-.8v-.31l2.36-2.44h.2v1.51h1.68v1.24h-1.68v1.61c0,.19.01.34.03.46s.09.21.19.29c.11.08.27.12.48.12.28,0,.65-.12,1.1-.36v1.39Z"
          />
          <path
            className="cls-20"
            d="m754.98,358.22h-1.76v-.72c-.25.27-.51.47-.78.61s-.6.2-.98.2c-.75,0-1.24-.22-1.46-.67-.22-.44-.33-.94-.33-1.5v-2.96h1.76v2.72c0,.27.04.51.13.72s.29.31.58.31c.26,0,.46-.07.61-.22.15-.15.3-.34.46-.57v-2.96h1.76v5.04Z"
          />
          <path
            className="cls-20"
            d="m761.37,358.22h-1.76v-.46c-.19.16-.38.29-.59.39-.21.1-.49.15-.86.15s-.72-.09-1.06-.27-.63-.46-.86-.85c-.22-.38-.34-.87-.34-1.45,0-.46.08-.89.25-1.29.17-.4.43-.73.8-.98s.8-.38,1.33-.38c.33,0,.59.04.79.11.2.07.38.17.54.28v-2.12h1.76v6.86Zm-1.76-1.6v-1.93c-.21-.12-.37-.2-.48-.25-.12-.05-.25-.07-.41-.07-.28,0-.51.12-.69.36-.18.24-.28.56-.28.97,0,.45.1.77.29.97.19.2.42.3.68.3.21,0,.38-.03.51-.1.13-.07.26-.15.38-.25Z"
          />
          <path
            className="cls-20"
            d="m764.33,358.22h-1.76v-5.04h1.76v5.04Zm-.14-6.21c0,.21-.07.38-.22.53-.15.15-.32.22-.52.22-.14,0-.26-.03-.37-.1s-.2-.16-.27-.27-.1-.24-.1-.38c0-.2.07-.38.21-.53s.32-.22.52-.22.38.07.52.22.22.33.22.53Z"
          />
          <path
            className="cls-20"
            d="m771.03,355.7c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m743.85,372.42h-2.09l-.55-1.39h-2.94l-.56,1.39h-2.09l2.99-6.86h2.26l2.98,6.86Zm-3.11-2.59l-.99-2.51-1,2.51h1.99Z"
          />
          <path
            className="cls-20"
            d="m748.83,367.65l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m753.22,372.19c-.15.06-.3.11-.46.16s-.35.09-.55.12c-.2.03-.42.05-.67.05-.54,0-1-.09-1.38-.28s-.67-.42-.87-.7c-.2-.28-.34-.57-.42-.86-.08-.29-.12-.55-.12-.78s.04-.48.12-.78c.08-.29.22-.58.42-.85s.49-.5.86-.69.84-.28,1.39-.28c.37,0,.67.03.9.08.23.05.47.12.7.21v1.4c-.57-.19-1.02-.28-1.34-.28s-.59.1-.83.29c-.24.19-.36.49-.36.89,0,.27.06.49.18.68.12.18.27.32.46.4s.37.13.56.13c.18,0,.38-.03.6-.08.22-.05.5-.13.82-.23v1.4Z"
          />
          <path
            className="cls-20"
            d="m760.75,371.94c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38-.58-.25-1.05-.65-1.4-1.18-.35-.53-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.03.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path className="cls-20" d="m764.41,372.42h-2.04v-6.86h2.04v6.86Z" />
          <path
            className="cls-20"
            d="m770.85,370.43c0,.43-.11.8-.33,1.11-.22.31-.52.55-.91.72-.39.17-.83.25-1.33.25-.14,0-.31,0-.52-.03-.2-.02-.47-.07-.81-.15-.34-.08-.69-.2-1.05-.37v-1.68c.34.21.68.39,1.01.54.33.14.68.21,1.06.21.35,0,.57-.06.68-.18s.15-.23.15-.33c0-.18-.09-.34-.26-.47s-.43-.26-.77-.39c-.37-.16-.7-.33-.98-.52s-.51-.42-.69-.7c-.18-.28-.27-.61-.27-1s.09-.7.27-1,.45-.54.82-.72.82-.27,1.35-.27c.38,0,.73.04,1.05.11.32.07.59.16.79.25s.35.17.43.22v1.61c-.28-.2-.58-.38-.93-.54-.34-.16-.7-.24-1.09-.24-.25,0-.44.05-.55.15-.11.1-.17.22-.17.37,0,.14.06.25.17.35s.32.22.61.36c.52.25.94.47,1.25.67.31.2.56.43.73.69.18.26.27.58.27.97Z"
          />
          <path
            className="cls-20"
            d="m736.41,383.85h-2.81v2.78h-2.04v-6.86h4.85v1.38h-2.81v1.33h2.81v1.38Z"
          />
          <path className="cls-20" d="m739.35,386.62h-1.76v-6.86h1.76v6.86Z" />
          <path
            className="cls-20"
            d="m745.9,384.1c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55.35-.13.76-.19,1.23-.19s.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82.12.31.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94s-.42-.34-.74-.34-.57.11-.74.34-.26.54-.26.94.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m752.05,386.62h-1.76v-.72c-.25.27-.51.47-.78.61s-.6.2-.98.2c-.75,0-1.24-.22-1.46-.67-.22-.44-.33-.94-.33-1.5v-2.96h1.76v2.72c0,.27.04.51.13.72s.29.31.58.31c.26,0,.46-.07.61-.22.15-.15.3-.34.46-.57v-2.96h1.76v5.04Z"
          />
          <path
            className="cls-20"
            d="m757.55,381.85l-.65,1.79c-.27-.26-.54-.39-.81-.39-.25,0-.46.08-.64.25-.18.17-.35.48-.52.94v2.17h-1.76v-5.04h1.76v1.22c.11-.3.31-.59.59-.88.28-.29.61-.43.99-.43.2,0,.37.03.52.09.15.06.33.15.53.27Z"
          />
          <path
            className="cls-20"
            d="m759.53,386.62h-1.76v-5.04h1.76v5.04Zm-.14-6.21c0,.21-.07.38-.22.53-.15.15-.32.22-.52.22-.14,0-.26-.03-.37-.1s-.2-.16-.27-.27-.1-.24-.1-.38c0-.2.07-.38.21-.53s.32-.22.52-.22.38.07.52.22.22.33.22.53Z"
          />
          <path
            className="cls-20"
            d="m764.63,385.15c0,.46-.17.84-.5,1.13-.33.29-.83.43-1.49.43-.37,0-.7-.03-.98-.1-.29-.07-.6-.16-.94-.29v-1.27c.3.17.55.3.77.39s.46.13.72.13c.44,0,.66-.12.66-.37,0-.08-.03-.16-.1-.22s-.17-.14-.33-.22c-.16-.08-.37-.18-.63-.29-.33-.15-.6-.34-.83-.58-.23-.24-.34-.54-.34-.9,0-.25.08-.49.23-.72s.38-.42.69-.57c.31-.15.68-.22,1.11-.22.1,0,.24,0,.4.02.16.01.37.05.61.12.25.06.48.15.7.27v1.23c-.1-.06-.19-.12-.26-.16-.07-.04-.16-.09-.28-.14s-.25-.1-.41-.14c-.16-.04-.32-.06-.49-.06-.2,0-.34.04-.42.12s-.11.16-.11.24.04.16.12.23c.08.07.25.16.52.26.39.15.7.31.94.47s.4.34.5.53c.1.19.15.42.15.68Z"
          />
          <path
            className="cls-20"
            d="m770.89,386.62h-1.76v-2.61s0-.04,0-.06c0-.02,0-.06,0-.12,0-.24-.05-.46-.15-.66-.1-.2-.29-.3-.58-.3-.22,0-.42.08-.59.23-.17.15-.33.34-.48.57v2.96h-1.76v-6.86h1.76v2.55c.29-.31.58-.53.86-.64s.58-.17.9-.17c1.19,0,1.79.68,1.79,2.04v3.1Z"
          />
          <path
            className="cls-20"
            d="m753.39,401.32l-1.43,1.32c-.56-.12-1.12-.29-1.67-.51s-1.1-.47-1.66-.79c-.43-.24-.76-.47-.98-.69-.38-.14-.74-.35-1.07-.63-.34-.29-.62-.65-.83-1.1-.22-.45-.32-.96-.32-1.54,0-.62.14-1.19.42-1.73s.71-.97,1.29-1.3c.58-.33,1.29-.49,2.13-.49.64,0,1.21.1,1.7.29.49.19.89.45,1.21.78.31.33.55.71.7,1.13.16.42.23.86.23,1.32,0,.55-.1,1.05-.29,1.48s-.45.79-.77,1.08c-.32.29-.67.51-1.07.68.36.17.73.3,1.1.41s.79.17,1.26.17l.06.11Zm-2.37-3.93c0-.26-.04-.49-.11-.71-.08-.21-.19-.4-.34-.55-.15-.16-.34-.28-.55-.37s-.47-.13-.76-.13c-.55,0-.98.16-1.29.49-.31.32-.47.75-.47,1.27s.16.95.47,1.28c.31.33.74.49,1.29.49.37,0,.69-.08.96-.23.26-.15.46-.36.6-.62.14-.27.21-.57.21-.91Z"
          />
          <path
            className="cls-20"
            d="m760.75,400.34c-.15.06-.27.1-.38.14s-.2.07-.3.1c-.1.03-.23.07-.42.11-.31.07-.62.13-.93.17s-.63.06-.97.06c-.69,0-1.32-.13-1.9-.38s-1.05-.65-1.4-1.18c-.35-.54-.52-1.19-.52-1.97,0-.5.09-.99.27-1.48s.46-.87.83-1.16c.31-.24.62-.43.93-.55.31-.13.62-.21.92-.26s.63-.06.99-.06c.6,0,1.09.05,1.47.14s.81.21,1.27.36v1.62c-.31-.18-.63-.33-.97-.46-.34-.12-.77-.18-1.28-.18-.59,0-1.06.11-1.41.34-.35.23-.6.5-.74.81-.14.31-.21.62-.21.91,0,.35.08.67.24.96.16.29.4.53.72.7.32.18.71.27,1.17.27.26,0,.54-.04.83-.1v-.81h-.92v-1.38h2.7v3.3Z"
          />
          <path className="cls-20" d="m764.41,400.82h-2.04v-6.86h2.04v6.86Z" />
          <path
            className="cls-20"
            d="m770.85,398.83c0,.43-.11.8-.33,1.12-.22.31-.52.55-.91.72-.39.17-.83.25-1.33.25-.14,0-.31,0-.52-.03-.2-.02-.47-.07-.81-.15s-.69-.21-1.05-.37v-1.68c.34.21.68.39,1.01.54.33.14.68.21,1.06.21.35,0,.57-.06.68-.18s.15-.23.15-.33c0-.18-.09-.34-.26-.47s-.43-.26-.77-.39c-.37-.16-.7-.33-.98-.52s-.51-.42-.69-.7c-.18-.28-.27-.61-.27-1s.09-.7.27-1,.45-.54.82-.72.82-.27,1.35-.27c.38,0,.73.04,1.05.11.32.07.59.16.79.25s.35.17.43.22v1.61c-.28-.2-.58-.38-.93-.54-.34-.16-.7-.24-1.09-.24-.25,0-.44.05-.55.15-.11.1-.17.22-.17.37,0,.14.06.25.17.35s.32.22.61.36c.52.25.94.47,1.25.67.31.2.56.43.73.69.18.26.27.58.27.97Z"
          />
          <path
            className="cls-20"
            d="m739.66,415.02h-2.04v-3.98l-1.84,2.3h-.16l-1.85-2.3v3.98h-1.98v-6.86h1.85l2.08,2.58,2.09-2.58h1.85v6.86Z"
          />
          <path
            className="cls-20"
            d="m746.24,414.77c-.26.1-.5.19-.71.25s-.48.09-.79.09-.49-.05-.61-.16c-.11-.1-.2-.23-.24-.38-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5s.61-.26,1.04-.4c.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1.06-.02.13-.05.2-.09,0-.24-.05-.44-.15-.57s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26-.33.17-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.18.02.32.05.41.03.09.1.14.19.14.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m752.39,412.47c0,.34-.05.66-.14.98s-.24.6-.43.85c-.19.25-.44.45-.75.6-.3.15-.66.22-1.06.22-.33,0-.58-.03-.77-.1-.19-.07-.37-.16-.56-.28v2.58h-1.76v-7.33h1.76v.46c.18-.16.37-.28.58-.39.21-.1.5-.16.87-.16s.72.09,1.06.27.63.46.86.85.34.87.34,1.45Zm-1.85.04c0-.3-.05-.55-.14-.74-.09-.19-.22-.33-.37-.41s-.3-.13-.46-.13c-.21,0-.38.03-.51.1-.13.07-.26.15-.38.25v1.93c.06.03.13.07.2.11.07.04.14.08.21.11.07.03.15.05.22.07.08.02.17.03.26.03.28,0,.51-.12.69-.36.19-.24.28-.56.28-.97Z"
          />
          <path
            className="cls-20"
            d="m758.77,412.54c0,.58-.11,1.07-.34,1.45s-.51.67-.86.85-.7.27-1.06.27c-.26,0-.49-.03-.68-.09-.19-.06-.34-.13-.44-.2-.11-.07-.21-.16-.33-.26v.46h-1.76v-6.86h1.76v2.12c.13-.1.31-.19.54-.27.23-.08.49-.12.79-.12.4,0,.75.07,1.06.22s.56.35.75.6c.19.25.34.53.43.84.09.31.14.64.14.98Zm-1.85-.04c0-.43-.1-.76-.29-.99-.19-.23-.42-.34-.68-.34s-.56.11-.89.32v1.93c.25.24.54.36.89.36.22,0,.43-.09.65-.27.21-.18.32-.52.32-1.01Z"
          />
          <path
            className="cls-20"
            d="m765.17,412.5c0,.5-.11.95-.32,1.34s-.54.7-.96.93c-.43.23-.95.34-1.56.34s-1.14-.11-1.57-.34c-.43-.23-.75-.54-.96-.93-.21-.39-.32-.84-.32-1.34,0-.38.06-.72.18-1.04.12-.31.3-.58.54-.82.24-.24.54-.42.9-.55s.76-.19,1.23-.19.88.07,1.24.2c.36.13.66.31.89.55.24.23.42.51.54.82s.18.66.18,1.04Zm-1.85,0c0-.4-.09-.71-.26-.94-.17-.23-.42-.34-.74-.34s-.57.11-.74.34c-.17.23-.26.54-.26.94s.09.71.26.94c.17.23.42.35.74.35s.57-.11.74-.34.26-.54.26-.94Z"
          />
          <path
            className="cls-20"
            d="m771.33,415.02h-2.17l-.96-1.43-.96,1.43h-1.92l1.92-2.48-1.96-2.57h2.16l.92,1.37.93-1.37h1.92l-1.88,2.39,2,2.65Z"
          />
          <path
            className="cls-20"
            d="m742.27,428.71c-.28.15-.57.27-.86.36-.29.09-.59.15-.89.19s-.61.06-.92.06c-.59,0-1.12-.08-1.58-.25-.47-.17-.87-.41-1.22-.73-.34-.32-.6-.7-.77-1.13-.17-.43-.26-.9-.26-1.42,0-.59.1-1.11.3-1.55.2-.44.48-.81.85-1.11.36-.29.78-.51,1.24-.65.46-.14.95-.21,1.47-.21.77,0,1.64.17,2.61.52v1.82c-.33-.21-.67-.39-.99-.53-.33-.14-.71-.21-1.15-.21-.39,0-.76.08-1.1.24-.34.16-.62.38-.83.68s-.31.64-.31,1.03c0,.35.09.66.27.95s.44.52.76.69c.32.17.69.25,1.1.25.33,0,.64-.04.93-.12s.54-.17.74-.27c.2-.1.41-.22.62-.35v1.74Z"
          />
          <path
            className="cls-20"
            d="m748.51,428.97c-.26.1-.5.19-.71.25s-.48.09-.79.09-.49-.05-.61-.16c-.11-.1-.2-.23-.24-.38-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5s.61-.26,1.04-.4c.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.58s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26s-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23.56-.07.84-.07c.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.18.02.32.05.41.03.09.1.14.19.14.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m754.51,429.22h-1.76v-2.72c0-.28-.04-.52-.13-.73-.09-.21-.29-.31-.59-.31-.14,0-.27.03-.38.08-.11.05-.21.12-.29.21-.09.09-.16.17-.22.25s-.12.16-.18.25v2.96h-1.76v-5.04h1.76v.72c.28-.3.55-.51.83-.63.28-.12.59-.18.93-.18,1.19,0,1.79.72,1.79,2.17v2.96Z"
          />
          <path
            className="cls-20"
            d="m760.81,424.18l-2.26,5.04h-1.3l-2.21-5.04h1.89l1.03,2.64,1.14-2.64h1.71Z"
          />
          <path
            className="cls-20"
            d="m766.55,428.97c-.26.1-.5.19-.71.25s-.48.09-.79.09-.49-.05-.61-.16c-.11-.1-.2-.23-.24-.38-.19.16-.4.28-.63.38s-.53.15-.91.15-.65-.06-.88-.19c-.22-.13-.38-.29-.47-.48-.09-.19-.13-.39-.13-.6,0-.31.08-.57.23-.77.16-.2.36-.37.62-.5s.61-.26,1.04-.4c.24-.08.43-.14.55-.18.13-.04.22-.07.28-.1s.13-.05.2-.09c0-.24-.05-.44-.15-.58s-.31-.21-.63-.21c-.38,0-.74.09-1.07.26s-.63.39-.9.66v-1.37c.22-.16.45-.29.71-.39s.52-.18.8-.23.56-.07.84-.07c.72,0,1.26.14,1.62.42.36.28.54.67.54,1.17v1.95c0,.18.02.32.05.41.03.09.1.14.19.14.11,0,.26-.05.45-.14v.94Zm-2.45-.97v-1.19c-.42.17-.72.33-.91.46-.19.14-.29.32-.29.56,0,.17.05.3.14.39.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.25Z"
          />
          <path
            className="cls-20"
            d="m770.99,427.75c0,.46-.17.84-.5,1.13-.33.29-.83.43-1.49.43-.37,0-.7-.03-.98-.1-.29-.07-.6-.16-.94-.29v-1.27c.3.17.55.3.77.39s.46.13.72.13c.44,0,.66-.12.66-.37,0-.08-.03-.16-.1-.22s-.17-.14-.33-.22c-.16-.08-.37-.18-.63-.29-.33-.15-.6-.34-.83-.58s-.34-.54-.34-.9c0-.25.08-.49.23-.72.15-.23.38-.42.69-.57.31-.15.68-.22,1.11-.22.1,0,.24,0,.4.02s.37.05.61.12c.25.06.48.15.7.27v1.23c-.1-.06-.19-.12-.26-.16-.07-.04-.16-.09-.28-.14s-.25-.1-.41-.14c-.16-.04-.32-.06-.49-.06-.2,0-.34.04-.42.12s-.11.16-.11.24.04.16.12.23c.08.07.25.16.52.27.39.15.7.31.94.47s.4.34.5.53c.1.19.15.42.15.68Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m863.19,144.5c0,.16-.03.34-.1.55-.07.21-.19.41-.38.62s-.46.39-.81.53-.81.21-1.35.21-1.01-.07-1.36-.21-.62-.32-.81-.53c-.19-.21-.31-.42-.37-.62s-.09-.38-.09-.55c0-.34.1-.66.29-.97s.46-.54.8-.7c-.27-.17-.49-.37-.63-.59s-.22-.51-.22-.86c0-.2.04-.4.12-.62.08-.22.22-.43.41-.63.19-.2.44-.36.75-.49.31-.12.69-.18,1.13-.18s.85.06,1.16.18.56.28.75.48.32.41.4.62.11.42.11.63c0,.36-.07.64-.22.86-.15.21-.36.41-.64.59.22.12.42.26.57.43.16.17.28.36.38.58.09.22.14.44.14.66Zm-1.74-.18c0-.21-.05-.39-.14-.54s-.21-.27-.35-.34-.28-.11-.42-.11c-.23,0-.43.09-.62.27s-.28.42-.28.73c0,.33.09.58.28.75s.4.26.63.26.45-.09.63-.28c.18-.19.27-.43.27-.73Zm-.2-2.81c0-.21-.05-.42-.16-.62-.11-.2-.28-.29-.53-.29s-.43.09-.55.28-.17.4-.17.63c0,.26.07.48.21.65.14.17.3.25.49.25s.35-.08.49-.25c.14-.17.21-.38.21-.65Z"
          />
          <path
            className="cls-13"
            d="m869.11,144.86h-.8v1.46h-1.8v-1.46h-2.75v-1.29l3.1-4.02h1.45v4.15h.8v1.16Zm-2.6-1.16v-2.17l-1.68,2.17h1.68Z"
          />
          <path
            className="cls-13"
            d="m874.6,144.44c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m833.35,158.4c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
          <path
            className="cls-13"
            d="m839.7,156.34c0,.51-.11,1.02-.33,1.53s-.54,1-.94,1.47c-.41.47-.88.89-1.42,1.27l-1.67-.55c.77-.66,1.35-1.27,1.72-1.83-.12.03-.27.05-.45.05-.4,0-.76-.09-1.09-.27s-.6-.44-.8-.78-.3-.72-.3-1.15c0-.31.06-.61.18-.9s.3-.55.53-.79.51-.42.83-.55.68-.2,1.06-.2c.43,0,.82.07,1.16.22s.62.35.85.6c.22.25.39.54.51.86s.17.65.17,1Zm-1.76-.22c0-.27-.08-.49-.24-.67s-.37-.27-.62-.27c-.21,0-.38.05-.52.15-.13.1-.23.23-.29.37-.06.15-.09.28-.09.42,0,.31.09.54.26.69.17.15.38.22.61.22.22,0,.39-.05.53-.15s.23-.22.29-.36c.06-.14.09-.27.09-.4Z"
          />
          <path
            className="cls-13"
            d="m845.64,157.14c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m829.14,172.32c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
          <path
            className="cls-13"
            d="m835.09,172.32c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
          <path className="cls-13" d="m839.72,174.44h-1.85v-6.77h1.85v6.77Z" />
        </g>
        <g>
          <path
            className="cls-13"
            d="m809.26,186.04c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m815.68,186.09c0,.16-.03.34-.1.55-.07.21-.19.41-.38.62s-.46.39-.81.53-.81.21-1.35.21-1.01-.07-1.36-.21-.62-.32-.81-.53c-.19-.21-.31-.42-.37-.62s-.09-.38-.09-.55c0-.34.1-.66.29-.97s.46-.54.8-.7c-.27-.17-.49-.37-.63-.59s-.22-.51-.22-.86c0-.2.04-.4.12-.62.08-.22.22-.43.41-.63.19-.2.44-.36.75-.49.31-.12.69-.18,1.13-.18s.85.06,1.16.18.56.28.75.48.32.41.4.62.11.42.11.63c0,.36-.07.64-.22.86-.15.21-.36.41-.64.59.22.12.42.26.57.43.16.17.28.36.38.58.09.22.14.44.14.66Zm-1.74-.18c0-.21-.05-.39-.14-.54s-.21-.27-.35-.34-.28-.11-.42-.11c-.23,0-.43.09-.62.27s-.28.42-.28.73c0,.33.09.58.28.75s.4.26.63.26.45-.09.63-.28c.18-.19.27-.43.27-.73Zm-.2-2.81c0-.21-.05-.42-.16-.62-.11-.2-.28-.29-.53-.29s-.43.09-.55.28-.17.4-.17.63c0,.26.07.48.21.65.14.17.3.25.49.25s.35-.08.49-.25c.14-.17.21-.38.21-.65Z"
          />
          <path
            className="cls-13"
            d="m821.62,186.09c0,.16-.03.34-.1.55-.07.21-.19.41-.38.62s-.46.39-.81.53-.81.21-1.35.21-1.01-.07-1.36-.21-.62-.32-.81-.53c-.19-.21-.31-.42-.37-.62s-.09-.38-.09-.55c0-.34.1-.66.29-.97s.46-.54.8-.7c-.27-.17-.49-.37-.63-.59s-.22-.51-.22-.86c0-.2.04-.4.12-.62.08-.22.22-.43.41-.63.19-.2.44-.36.75-.49.31-.12.69-.18,1.13-.18s.85.06,1.16.18.56.28.75.48.32.41.4.62.11.42.11.63c0,.36-.07.64-.22.86-.15.21-.36.41-.64.59.22.12.42.26.57.43.16.17.28.36.38.58.09.22.14.44.14.66Zm-1.74-.18c0-.21-.05-.39-.14-.54s-.21-.27-.35-.34-.28-.11-.42-.11c-.23,0-.43.09-.62.27s-.28.42-.28.73c0,.33.09.58.28.75s.4.26.63.26.45-.09.63-.28c.18-.19.27-.43.27-.73Zm-.2-2.81c0-.21-.05-.42-.16-.62-.11-.2-.28-.29-.53-.29s-.43.09-.55.28-.17.4-.17.63c0,.26.07.48.21.65.14.17.3.25.49.25s.35-.08.49-.25c.14-.17.21-.38.21-.65Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m809.32,200.22c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m815.71,195.52l-2.89,6.66-1.57-.5,2.07-4.86h-2.74v-1.5h5.13v.2Z"
          />
          <path
            className="cls-13"
            d="m821.2,200.22c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m807.93,214.35c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m814.32,209.65l-2.89,6.66-1.57-.5,2.07-4.86h-2.74v-1.5h5.13v.2Z"
          />
          <path
            className="cls-13"
            d="m820.29,212.85c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m804.32,228.64c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m810.27,228.64c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m816.21,228.64c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m804.67,243.63c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m810.61,243.63c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m816.55,243.63c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m803.03,258.04c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-13"
            d="m809.39,259.92h-5.14v-.13c.2-.19.42-.42.65-.69s.54-.62.92-1.06c.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6.11-.44.11-.67c0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3s.27-.15.43-.22c.16-.07.35-.13.57-.19s.46-.08.72-.08c.41,0,.79.08,1.13.25s.6.41.8.73c.19.32.29.69.29,1.11,0,.3-.04.58-.13.84s-.18.47-.27.63-.22.36-.38.59c-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
          <path
            className="cls-13"
            d="m814.98,257.8c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m801.57,271.15c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path className="cls-13" d="m806.28,273.02h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m813.53,270.91c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m796.3,287.3h-5.14v-.13c.2-.19.42-.42.65-.69s.54-.62.92-1.06c.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6.11-.44.11-.67c0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3s.27-.15.43-.22c.16-.07.35-.13.57-.19s.46-.08.72-.08c.41,0,.79.08,1.13.25s.6.41.8.73c.19.32.29.69.29,1.11,0,.3-.04.58-.13.84s-.18.47-.27.63-.22.36-.38.59c-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
          <path
            className="cls-13"
            d="m802.31,284.96c0,.31-.06.61-.18.91-.12.29-.3.55-.53.78s-.51.41-.83.54-.68.2-1.07.2c-.56,0-1.05-.12-1.46-.37s-.71-.58-.92-.99c-.2-.41-.3-.85-.3-1.32,0-.38.06-.76.19-1.15s.31-.77.55-1.14c.24-.38.53-.73.85-1.05s.69-.64,1.11-.94l1.67.55c-.27.23-.5.44-.69.62s-.38.38-.56.58-.33.41-.47.62c.12-.03.27-.05.45-.05.4,0,.76.09,1.1.27.33.18.6.44.8.78s.3.72.3,1.15Zm-1.76-.03c0-.31-.09-.54-.26-.69-.17-.15-.38-.22-.61-.22-.31,0-.54.1-.68.3-.14.2-.22.4-.22.62,0,.26.08.48.25.66.17.18.37.27.62.27.21,0,.38-.05.51-.15s.23-.22.3-.37c.06-.15.09-.28.09-.42Z"
          />
          <path
            className="cls-13"
            d="m808.25,284.96c0,.31-.06.61-.18.91-.12.29-.3.55-.53.78s-.51.41-.83.54-.68.2-1.07.2c-.56,0-1.05-.12-1.46-.37s-.71-.58-.92-.99c-.2-.41-.3-.85-.3-1.32,0-.38.06-.76.19-1.15s.31-.77.55-1.14c.24-.38.53-.73.85-1.05s.69-.64,1.11-.94l1.67.55c-.27.23-.5.44-.69.62s-.38.38-.56.58-.33.41-.47.62c.12-.03.27-.05.45-.05.4,0,.76.09,1.1.27.33.18.6.44.8.78s.3.72.3,1.15Zm-1.76-.03c0-.31-.09-.54-.26-.69-.17-.15-.38-.22-.61-.22-.31,0-.54.1-.68.3-.14.2-.22.4-.22.62,0,.26.08.48.25.66.17.18.37.27.62.27.21,0,.38-.05.51-.15s.23-.22.3-.37c.06-.15.09-.28.09-.42Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m794.32,302.12h-5.14v-.13c.2-.19.42-.42.65-.69s.54-.62.92-1.06c.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6.11-.44.11-.67c0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3s.27-.15.43-.22c.16-.07.35-.13.57-.19s.46-.08.72-.08c.41,0,.79.08,1.13.25s.6.41.8.73c.19.32.29.69.29,1.11,0,.3-.04.58-.13.84s-.18.47-.27.63-.22.36-.38.59c-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
          <path
            className="cls-13"
            d="m800.3,300.66h-.8v1.46h-1.8v-1.46h-2.75v-1.29l3.1-4.02h1.45v4.15h.8v1.16Zm-2.6-1.16v-2.17l-1.68,2.17h1.68Z"
          />
          <path
            className="cls-13"
            d="m806.27,297.94c0,.51-.11,1.02-.33,1.53s-.54,1-.94,1.47c-.41.47-.88.89-1.42,1.27l-1.67-.55c.77-.66,1.35-1.27,1.72-1.83-.12.03-.27.05-.45.05-.4,0-.76-.09-1.09-.27s-.6-.44-.8-.78-.3-.72-.3-1.15c0-.31.06-.61.18-.9s.3-.55.53-.79.51-.42.83-.55.68-.2,1.06-.2c.43,0,.82.07,1.16.22s.62.35.85.6c.22.25.39.54.51.86s.17.65.17,1Zm-1.76-.22c0-.27-.08-.49-.24-.67s-.37-.27-.62-.27c-.21,0-.38.05-.52.15-.13.1-.23.23-.29.37-.06.15-.09.28-.09.42,0,.31.09.54.26.69.17.15.38.22.61.22.22,0,.39-.05.53-.15s.23-.22.29-.36c.06-.14.09-.27.09-.4Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m785.59,315.62h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m793.25,313.8c0,.16-.03.34-.1.55-.07.21-.19.41-.38.62s-.46.39-.81.53-.81.21-1.35.21-1.01-.07-1.36-.21-.62-.32-.81-.53c-.19-.21-.31-.42-.37-.62s-.09-.38-.09-.55c0-.34.1-.66.29-.97s.46-.54.8-.7c-.27-.17-.49-.37-.63-.59s-.22-.51-.22-.86c0-.2.04-.4.12-.62.08-.22.22-.43.41-.63.19-.2.44-.36.75-.49.31-.12.69-.18,1.13-.18s.85.06,1.16.18.56.28.75.48.32.41.4.62.11.42.11.63c0,.36-.07.64-.22.86-.15.21-.36.41-.64.59.22.12.42.26.57.43.16.17.28.36.38.58.09.22.14.44.14.66Zm-1.74-.18c0-.21-.05-.39-.14-.54s-.21-.27-.35-.34-.28-.11-.42-.11c-.23,0-.43.09-.62.27s-.28.42-.28.73c0,.33.09.58.28.75s.4.26.63.26.45-.09.63-.28c.18-.19.27-.43.27-.73Zm-.2-2.81c0-.21-.05-.42-.16-.62-.11-.2-.28-.29-.53-.29s-.43.09-.55.28-.17.4-.17.63c0,.26.07.48.21.65.14.17.3.25.49.25s.35-.08.49-.25c.14-.17.21-.38.21-.65Z"
          />
          <path
            className="cls-13"
            d="m799.13,315.62h-5.14v-.13c.2-.19.42-.42.65-.69s.54-.62.92-1.06c.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6.11-.44.11-.67c0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3s.27-.15.43-.22c.16-.07.35-.13.57-.19s.46-.08.72-.08c.41,0,.79.08,1.13.25s.6.41.8.73c.19.32.29.69.29,1.11,0,.3-.04.58-.13.84s-.18.47-.27.63-.22.36-.38.59c-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m782.92,330.67h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m790.17,328.55c0,.39-.09.75-.27,1.09-.18.34-.45.61-.82.81-.36.2-.8.31-1.33.31-.42,0-.82-.05-1.2-.16s-.73-.27-1.05-.49v-1.46c.21.16.5.31.88.47.38.16.71.24.99.24.33,0,.56-.09.7-.26s.2-.35.2-.54c0-.15-.04-.3-.12-.43s-.21-.25-.4-.34c-.19-.09-.45-.13-.77-.13-.35,0-.7.06-1.02.2v-3.95h3.92v1.43h-2.42v1.16c.05,0,.11-.01.16-.02.06,0,.1,0,.12,0,.03,0,.07,0,.14,0,.46,0,.86.1,1.2.29s.61.45.79.76c.18.32.28.66.28,1.04Z"
          />
          <path
            className="cls-13"
            d="m796.49,329.21h-.8v1.46h-1.8v-1.46h-2.75v-1.29l3.1-4.02h1.45v4.15h.8v1.16Zm-2.6-1.16v-2.17l-1.68,2.17h1.68Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,345.02h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m807.91,343.14c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-20"
            d="m814.33,340.84c0,.51-.11,1.02-.33,1.53s-.54,1-.94,1.47c-.41.47-.88.89-1.42,1.27l-1.67-.55c.77-.66,1.35-1.27,1.72-1.83-.12.03-.27.05-.45.05-.4,0-.76-.09-1.09-.27s-.6-.44-.8-.78-.3-.72-.3-1.15c0-.31.06-.61.18-.9s.3-.55.53-.79.51-.42.83-.55.68-.2,1.06-.2c.43,0,.82.07,1.16.22s.62.35.85.6c.22.25.39.54.51.86s.17.65.17,1Zm-1.76-.22c0-.27-.08-.49-.24-.67s-.37-.27-.62-.27c-.21,0-.38.05-.52.15-.13.1-.23.23-.29.37-.06.15-.09.28-.09.42,0,.31.09.54.26.69.17.15.38.22.61.22.22,0,.39-.05.53-.15s.23-.22.29-.36c.06-.14.09-.27.09-.4Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,358.6h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m807.91,356.72c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-20"
            d="m814.3,357.14h-.8v1.46h-1.8v-1.46h-2.75v-1.29l3.1-4.02h1.45v4.15h.8v1.16Zm-2.6-1.16v-2.17l-1.68,2.17h1.68Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,373.52h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m807.91,371.64c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-20"
            d="m813.85,371.64c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,386.72h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m807.91,384.84c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
          <path
            className="cls-20"
            d="m813.85,384.84c0,.35-.07.66-.21.91s-.32.46-.55.61c-.23.16-.47.27-.73.34s-.51.1-.75.1c-.34,0-.72-.05-1.13-.14s-.76-.21-1.04-.34v-1.52c.23.19.47.35.74.48s.54.19.82.19c.21,0,.39-.04.53-.12.15-.08.25-.18.33-.3.07-.12.11-.25.11-.38,0-.17-.05-.33-.14-.46s-.22-.24-.4-.32-.37-.12-.6-.12h-.22v-1.09h.26c.23,0,.42-.04.56-.13.15-.09.25-.19.32-.31s.1-.24.1-.34c0-.21-.08-.39-.24-.54-.16-.16-.36-.24-.61-.24-.22,0-.46.04-.7.13-.24.08-.47.2-.68.34v-1.3c.32-.13.62-.24.9-.31.28-.08.6-.11.95-.11.51,0,.94.1,1.28.3.34.2.59.44.75.72.16.28.24.55.24.79,0,.2-.04.4-.13.61s-.2.38-.34.54c-.14.16-.29.28-.44.37.27.14.51.34.72.6s.31.61.31,1.06Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,400.98h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m808.33,400.98h-5.14v-.13c.2-.19.42-.42.65-.69.24-.27.54-.62.92-1.06.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6c.08-.22.11-.44.11-.67,0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3.12-.08.27-.15.43-.22.16-.07.35-.13.57-.19.22-.05.46-.08.72-.08.41,0,.79.08,1.13.25.34.17.6.41.8.73.19.32.29.69.29,1.11,0,.3-.04.58-.13.84-.09.26-.18.47-.27.63-.09.16-.22.36-.38.59-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
          <path
            className="cls-20"
            d="m814.33,399.16c0,.16-.03.34-.1.55-.07.21-.19.41-.38.62s-.46.39-.81.53-.81.21-1.35.21-1.01-.07-1.36-.21c-.35-.14-.62-.32-.81-.53-.19-.21-.31-.42-.37-.62-.06-.2-.09-.38-.09-.55,0-.34.1-.66.29-.97s.46-.54.8-.7c-.27-.17-.49-.37-.63-.59-.15-.22-.22-.51-.22-.86,0-.2.04-.4.12-.62.08-.22.22-.43.41-.63.19-.2.44-.36.75-.49.31-.12.69-.18,1.13-.18s.85.06,1.16.18.56.28.75.48.32.41.4.62.11.42.11.63c0,.36-.07.64-.22.86-.15.21-.36.41-.64.59.22.12.42.26.57.43.16.17.28.36.38.58.09.22.14.44.14.66Zm-1.74-.18c0-.21-.05-.39-.14-.54s-.21-.26-.35-.34c-.14-.08-.28-.11-.42-.11-.23,0-.43.09-.62.27-.19.18-.28.42-.28.73,0,.33.09.58.28.75.19.17.4.26.63.26s.45-.09.63-.28c.18-.19.27-.43.27-.73Zm-.2-2.81c0-.21-.05-.42-.16-.62-.11-.2-.28-.29-.53-.29s-.43.09-.55.28c-.11.19-.17.4-.17.63,0,.26.07.48.21.65.14.17.3.25.49.25s.35-.08.49-.25c.14-.17.21-.38.21-.65Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,416.18h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-20"
            d="m808.33,416.18h-5.14v-.13c.2-.19.42-.42.65-.69.24-.27.54-.62.92-1.06.17-.2.33-.39.49-.59.15-.19.28-.38.39-.56s.2-.38.27-.6c.08-.22.11-.44.11-.67,0-.31-.09-.57-.27-.76-.18-.19-.41-.29-.69-.29-.55,0-1.1.29-1.65.86v-1.6c.19-.12.35-.22.47-.3.12-.08.27-.15.43-.22.16-.07.35-.13.57-.19.22-.05.46-.08.72-.08.41,0,.79.08,1.13.25.34.17.6.41.8.73.19.32.29.69.29,1.11,0,.3-.04.58-.13.84-.09.26-.18.47-.27.63-.09.16-.22.36-.38.59-.28.42-.58.81-.9,1.19h2.19v1.52Z"
          />
          <path
            className="cls-20"
            d="m814.33,412.8c0,.59-.07,1.1-.21,1.54-.14.44-.33.8-.58,1.09-.25.28-.53.49-.84.63-.32.14-.65.21-1.01.21s-.69-.07-1.01-.21c-.32-.14-.6-.35-.84-.63s-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1c.14.44.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47-.08-.38-.28-.58-.59-.58-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.54.59.54s.51-.18.59-.54c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <g>
          <path className="cls-20" d="m800.73,430.07h-1.85v-6.77h1.85v6.77Z" />
          <path className="cls-20" d="m806.67,430.07h-1.85v-6.77h1.85v6.77Z" />
          <path className="cls-20" d="m812.61,430.07h-1.85v-6.77h1.85v6.77Z" />
        </g>
        <g>
          <path
            className="cls-17"
            d="m630.97,142.76h-3.67v-7.06l-3.31,4.09h-.29l-3.32-4.09v7.06h-3.57v-12.18h3.33l3.74,4.57,3.76-4.57h3.33v12.18Z"
          />
          <path
            className="cls-17"
            d="m643.41,138.27c0,.89-.19,1.68-.58,2.38s-.97,1.25-1.74,1.65c-.77.4-1.71.61-2.82.61s-2.05-.2-2.82-.61-1.35-.96-1.73-1.65c-.38-.7-.58-1.49-.58-2.38,0-.67.11-1.29.32-1.84s.54-1.04.98-1.46c.44-.42.97-.75,1.61-.98s1.38-.34,2.21-.34,1.59.12,2.24.35c.65.23,1.18.56,1.61.97s.75.9.96,1.46.33,1.17.33,1.85Zm-3.33,0c0-.71-.15-1.26-.46-1.67-.31-.4-.75-.6-1.34-.6s-1.02.2-1.33.6c-.31.4-.46.96-.46,1.67s.16,1.26.47,1.67.75.62,1.33.62,1.03-.2,1.34-.61c.31-.41.46-.97.46-1.67Z"
          />
          <path
            className="cls-17"
            d="m652.05,140.15c0,.82-.3,1.49-.9,2s-1.49.77-2.68.77c-.66,0-1.25-.06-1.77-.18s-1.08-.29-1.69-.51v-2.25c.53.3,1,.54,1.39.69s.82.24,1.29.24c.79,0,1.19-.22,1.19-.65,0-.15-.06-.28-.17-.39-.12-.11-.31-.24-.6-.39-.29-.14-.66-.31-1.14-.51-.59-.26-1.08-.6-1.49-1.04s-.62-.96-.62-1.59c0-.45.14-.87.41-1.28.27-.41.68-.75,1.24-1.01s1.22-.39,2-.39c.19,0,.43.01.72.04.29.03.66.1,1.1.21s.86.27,1.26.47v2.19c-.19-.11-.34-.21-.47-.28s-.29-.16-.5-.25-.46-.18-.74-.25-.58-.11-.87-.11c-.36,0-.61.07-.75.21s-.2.28-.2.42.07.28.21.41.45.28.94.47c.7.27,1.27.55,1.69.83s.72.6.9.94.27.74.27,1.2Z"
          />
          <path
            className="cls-17"
            d="m660.82,142.24c-.33.16-.78.31-1.36.46-.58.15-1.13.22-1.66.22-2.28,0-3.42-1.11-3.42-3.34v-3.57h-1.43v-.55l4.25-4.32h.36v2.68h3.02v2.2h-3.02v2.87c0,.33.02.6.06.81s.16.38.35.51c.19.14.48.21.87.21.5,0,1.17-.21,1.99-.63v2.47Z"
          />
          <path
            className="cls-17"
            d="m627.35,151.41c0,.45-.08.89-.23,1.32-.16.43-.41.83-.75,1.2s-.81.67-1.4.91c-.59.23-1.28.35-2.08.35h-2.41v4.57h-3.67v-12.18h6.08c.8,0,1.49.12,2.08.35.59.23,1.06.54,1.4.91s.6.78.75,1.22c.15.44.23.89.23,1.34Zm-3.74.02c0-.58-.17-.98-.51-1.19-.34-.21-.96-.32-1.84-.32h-.77v2.94h.79c.61,0,1.08-.04,1.41-.11s.57-.22.71-.42.22-.5.22-.89Z"
          />
          <path
            className="cls-17"
            d="m638.23,155.27c0,.89-.19,1.68-.58,2.38s-.97,1.25-1.74,1.65c-.77.4-1.71.61-2.82.61s-2.05-.2-2.82-.61-1.35-.96-1.73-1.65c-.38-.7-.58-1.49-.58-2.38,0-.67.11-1.29.32-1.84s.54-1.04.98-1.46c.44-.42.97-.75,1.61-.98s1.38-.34,2.21-.34,1.59.12,2.24.35c.65.23,1.18.56,1.61.97s.75.9.96,1.46.33,1.17.33,1.85Zm-3.33,0c0-.71-.15-1.26-.46-1.67-.31-.4-.75-.6-1.34-.6s-1.02.2-1.33.6c-.31.4-.46.96-.46,1.67s.16,1.26.47,1.67.75.62,1.33.62,1.03-.2,1.34-.61c.31-.41.46-.97.46-1.67Z"
          />
          <path
            className="cls-17"
            d="m649.7,155.22c0,.6-.08,1.17-.25,1.73s-.43,1.06-.78,1.51c-.35.45-.8.8-1.35,1.06s-1.18.39-1.91.39c-.59,0-1.05-.06-1.38-.18-.34-.12-.67-.29-1.01-.49v4.59h-3.16v-13.02h3.16v.81c.32-.28.67-.51,1.05-.69s.9-.28,1.56-.28,1.29.16,1.92.48,1.14.82,1.55,1.51.61,1.54.61,2.58Zm-3.33.07c0-.54-.08-.98-.25-1.31s-.39-.58-.66-.73-.55-.22-.83-.22c-.38,0-.68.06-.92.18s-.47.27-.68.45v3.42c.11.06.23.12.36.2.12.07.25.14.38.19s.26.1.4.13.3.05.46.05c.5,0,.91-.21,1.25-.63s.5-1,.5-1.72Z"
          />
          <path
            className="cls-17"
            d="m660.77,159.76h-3.16v-1.27c-.45.48-.92.84-1.41,1.08-.49.24-1.08.36-1.77.36-1.35,0-2.22-.39-2.62-1.18s-.6-1.68-.6-2.67v-5.26h3.16v4.83c0,.49.08.91.24,1.28.16.37.51.55,1.05.55.46,0,.83-.13,1.1-.4s.55-.6.83-1.01v-5.26h3.16v8.95Z"
          />
          <path
            className="cls-17"
            d="m666.13,159.76h-3.17v-12.18h3.17v12.18Z"
          />
          <path
            className="cls-17"
            d="m677.59,159.31c-.46.18-.89.33-1.28.44s-.86.17-1.42.17c-.52,0-.88-.09-1.09-.28s-.35-.41-.44-.67c-.34.28-.72.5-1.13.68s-.96.27-1.63.27-1.18-.11-1.58-.34c-.4-.23-.68-.51-.84-.85-.16-.34-.24-.7-.24-1.06,0-.55.14-1.01.42-1.37.28-.36.65-.65,1.12-.88s1.09-.47,1.86-.71c.44-.14.77-.25,1-.32s.39-.13.51-.17.23-.09.35-.16c0-.43-.09-.77-.26-1.02s-.56-.37-1.14-.37c-.69,0-1.33.15-1.92.46s-1.13.7-1.63,1.18v-2.43c.39-.28.82-.51,1.27-.69s.93-.31,1.43-.4,1-.13,1.51-.13c1.29,0,2.27.25,2.92.75s.98,1.19.98,2.07v3.45c0,.33.03.57.09.73.06.16.17.24.34.24.2,0,.47-.08.81-.25v1.66Zm-4.4-1.71v-2.12c-.75.3-1.3.58-1.64.82s-.52.57-.52.99c0,.3.09.53.26.69.17.16.37.24.6.24s.43-.06.65-.18c.21-.12.43-.27.65-.44Z"
          />
          <path
            className="cls-17"
            d="m686.7,151.29l-1.17,3.17c-.48-.46-.97-.69-1.46-.69-.45,0-.83.15-1.16.45-.33.3-.64.86-.94,1.67v3.85h-3.16v-8.95h3.16v2.16c.2-.53.55-1.05,1.05-1.56s1.1-.76,1.78-.76c.36,0,.67.05.94.16.27.11.58.27.95.48Z"
          />
          <path
            className="cls-17"
            d="m629.33,170.89c0,1.25-.23,2.25-.68,3.01-.46.76-.99,1.37-1.6,1.84-.87.69-2.09,1.03-3.67,1.03h-6.57v-12.18h5.06c.76,0,1.41.04,1.96.12s1.03.19,1.46.33.8.3,1.11.48.58.37.82.58c.42.34.78.74,1.09,1.2s.56,1,.75,1.61c.18.61.28,1.27.28,1.99Zm-3.74-.16c0-.99-.19-1.76-.57-2.32-.38-.55-.83-.92-1.36-1.11s-1.07-.28-1.62-.28h-1.56v7.22h1.56c.96,0,1.79-.23,2.5-.69s1.05-1.4,1.05-2.82Z"
          />
          <path
            className="cls-17"
            d="m640.36,176.31c-.46.18-.89.33-1.28.44s-.86.17-1.42.17c-.52,0-.88-.09-1.09-.28s-.35-.41-.44-.67c-.34.28-.72.5-1.13.68s-.96.27-1.63.27-1.18-.11-1.58-.34c-.4-.23-.68-.51-.84-.85-.16-.34-.24-.7-.24-1.06,0-.55.14-1.01.42-1.37.28-.36.65-.65,1.12-.88s1.09-.47,1.86-.71c.44-.14.77-.25,1-.32s.39-.13.51-.17.23-.09.35-.16c0-.43-.09-.77-.26-1.02s-.56-.37-1.14-.37c-.69,0-1.33.15-1.92.46s-1.13.7-1.63,1.18v-2.43c.39-.28.82-.51,1.27-.69s.93-.31,1.43-.4,1-.13,1.51-.13c1.29,0,2.27.25,2.92.75s.98,1.19.98,2.07v3.45c0,.33.03.57.09.73.06.16.17.24.34.24.2,0,.47-.08.81-.25v1.66Zm-4.4-1.71v-2.12c-.75.3-1.3.58-1.64.82s-.52.57-.52.99c0,.3.09.53.26.69.17.16.37.24.6.24s.43-.06.65-.18c.21-.12.43-.27.65-.44Z"
          />
          <path
            className="cls-17"
            d="m648.41,176.24c-.33.16-.78.31-1.36.46-.58.15-1.13.22-1.66.22-2.28,0-3.42-1.11-3.42-3.34v-3.57h-1.43v-.55l4.25-4.32h.36v2.68h3.02v2.2h-3.02v2.87c0,.33.02.6.06.81s.16.38.35.51c.19.14.48.21.87.21.5,0,1.17-.21,1.99-.63v2.47Z"
          />
          <path
            className="cls-17"
            d="m659.08,176.31c-.46.18-.89.33-1.28.44s-.86.17-1.42.17c-.52,0-.88-.09-1.09-.28s-.35-.41-.44-.67c-.34.28-.72.5-1.13.68s-.96.27-1.63.27-1.18-.11-1.58-.34c-.4-.23-.68-.51-.84-.85-.16-.34-.24-.7-.24-1.06,0-.55.14-1.01.42-1.37.28-.36.65-.65,1.12-.88s1.09-.47,1.86-.71c.44-.14.77-.25,1-.32s.39-.13.51-.17.23-.09.35-.16c0-.43-.09-.77-.26-1.02s-.56-.37-1.14-.37c-.69,0-1.33.15-1.92.46s-1.13.7-1.63,1.18v-2.43c.39-.28.82-.51,1.27-.69s.93-.31,1.43-.4,1-.13,1.51-.13c1.29,0,2.27.25,2.92.75s.98,1.19.98,2.07v3.45c0,.33.03.57.09.73.06.16.17.24.34.24.2,0,.47-.08.81-.25v1.66Zm-4.4-1.71v-2.12c-.75.3-1.3.58-1.64.82s-.52.57-.52.99c0,.3.09.53.26.69.17.16.37.24.6.24s.43-.06.65-.18c.21-.12.43-.27.65-.44Z"
          />
          <path
            className="cls-17"
            d="m628.72,181.58l-5.49,12.34h-2.43l-5.39-12.34h3.82l2.79,7.03,2.87-7.03h3.83Z"
          />
          <path
            className="cls-17"
            d="m632.95,193.76h-3.17v-8.95h3.17v8.95Zm-.25-11.01c0,.37-.13.68-.4.94s-.58.39-.94.39c-.25,0-.47-.06-.67-.18-.2-.12-.36-.28-.48-.48s-.18-.43-.18-.67c0-.36.13-.68.39-.94s.57-.4.94-.4.68.13.94.4.4.58.4.94Z"
          />
          <path
            className="cls-17"
            d="m643.64,185.1l-4.28,6.32h4.19v2.34h-9.18v-.29l4.28-6.32h-3.92v-2.34h8.9v.29Z"
          />
          <path
            className="cls-17"
            d="m628.48,201.54h-4.46v9.22h-3.67v-9.22h-4.46v-2.96h12.59v2.96Z"
          />
          <path
            className="cls-17"
            d="m638.19,206.27c0,.89-.19,1.68-.58,2.38s-.97,1.25-1.74,1.65c-.77.4-1.71.61-2.82.61s-2.05-.2-2.82-.61-1.35-.96-1.73-1.65c-.38-.7-.58-1.49-.58-2.38,0-.67.11-1.29.32-1.84s.54-1.04.98-1.46c.44-.42.97-.75,1.61-.98s1.38-.34,2.21-.34,1.59.12,2.24.35c.65.23,1.18.56,1.61.97s.75.9.96,1.46.33,1.17.33,1.85Zm-3.33,0c0-.71-.15-1.26-.46-1.67-.31-.4-.75-.6-1.34-.6s-1.02.2-1.33.6c-.31.4-.46.96-.46,1.67s.16,1.26.47,1.67.75.62,1.33.62,1.03-.2,1.34-.61c.31-.41.46-.97.46-1.67Z"
          />
          <path
            className="cls-17"
            d="m649.71,206.27c0,.89-.19,1.68-.58,2.38s-.97,1.25-1.74,1.65c-.77.4-1.71.61-2.82.61s-2.05-.2-2.82-.61-1.35-.96-1.73-1.65c-.38-.7-.58-1.49-.58-2.38,0-.67.11-1.29.32-1.84s.54-1.04.98-1.46c.44-.42.97-.75,1.61-.98s1.38-.34,2.21-.34,1.59.12,2.24.35c.65.23,1.18.56,1.61.97s.75.9.96,1.46.33,1.17.33,1.85Zm-3.33,0c0-.71-.15-1.26-.46-1.67-.31-.4-.75-.6-1.34-.6s-1.02.2-1.33.6c-.31.4-.46.96-.46,1.67s.16,1.26.47,1.67.75.62,1.33.62,1.03-.2,1.34-.61c.31-.41.46-.97.46-1.67Z"
          />
          <path
            className="cls-17"
            d="m654.68,210.76h-3.17v-12.18h3.17v12.18Z"
          />
          <path
            className="cls-17"
            d="m663.86,208.15c0,.82-.3,1.49-.9,2s-1.49.77-2.68.77c-.66,0-1.25-.06-1.77-.18s-1.08-.29-1.69-.51v-2.25c.53.3,1,.54,1.39.69s.82.24,1.29.24c.79,0,1.19-.22,1.19-.65,0-.15-.06-.28-.17-.39-.12-.11-.31-.24-.6-.39-.29-.14-.66-.31-1.14-.51-.59-.26-1.08-.6-1.49-1.04s-.62-.96-.62-1.59c0-.45.14-.87.41-1.28.27-.41.68-.75,1.24-1.01s1.22-.39,2-.39c.19,0,.43.01.72.04.29.03.66.1,1.1.21s.86.27,1.26.47v2.19c-.19-.11-.34-.21-.47-.28s-.29-.16-.5-.25-.46-.18-.74-.25-.58-.11-.87-.11c-.36,0-.61.07-.75.21s-.2.28-.2.42.07.28.21.41.45.28.94.47c.7.27,1.27.55,1.69.83s.72.6.9.94.27.74.27,1.2Z"
          />
        </g>
      </g>

      <g id="pod">
        <line
          className="cls-2"
          x1="133.39"
          y1="292.96"
          x2="133.39"
          y2="316.66"
        />

        <path
          className="cls-2"
          d="m133.37,293.15c51.88,5.84,84.65,10.45,140.49,21.76,260.71,52.79,497.76,159.47,657.96,258.55"
        />
        <circle className="cls-2" cx="598.99" cy="411.55" r="2.69" />
        <circle className="cls-2" cx="670.64" cy="439.81" r="2.69" />
        <circle className="cls-2" cx="931.81" cy="573.45" r="2.69" />
        <circle className="cls-2" cx="835.35" cy="1044.46" r="2.69" />
        <circle className="cls-2" cx="729.72" cy="1044.46" r="2.69" />
        <circle className="cls-2" cx="250.05" cy="311.39" r="2.69" />
        <circle className="cls-2" cx="133.39" cy="293.15" r="2.69" />
        <circle className="cls-2" cx="392.37" cy="343.44" r="2.69" />
        <circle className="cls-2" cx="504.21" cy="375.86" r="2.69" />
        <circle className="cls-2" cx="391.11" cy="919.11" r="2.69" />
        <circle className="cls-2" cx="284.44" cy="1236.14" r="2.69" />
        <circle className="cls-2" cx="380.42" cy="1310.87" r="2.69" />
        <line className="cls-2" x1="598.7" y1="93.25" x2="598.99" y2="411.55" />
        <line
          className="cls-2"
          x1="250.05"
          y1="309.56"
          x2="250.05"
          y2="544.57"
        />
        <line
          className="cls-2"
          x1="504.23"
          y1="672.18"
          x2="504.23"
          y2="376.35"
        />
        <line
          className="cls-2"
          x1="392.37"
          y1="343.44"
          x2="392.37"
          y2="375.33"
        />
        <line
          className="cls-2"
          x1="670.64"
          y1="479.48"
          x2="670.64"
          y2="439.81"
        />
        <path
          className="cls-2"
          d="m835.67,621.78c4.44-9.82,12.58-23.86,27.37-34.58,49.75-36.03,122.92,3.08,130.39,7.2,50.83,28.07,78.56,106.44,77.67,163.53"
        />
        <line
          className="cls-2"
          x1="132.11"
          y1="396.3"
          x2="132.11"
          y2="795.34"
        />
        <line className="cls-2" x1="667.9" y1="548.6" x2="667.9" y2="828.4" />
        <line
          className="cls-2"
          x1="391.11"
          y1="457.16"
          x2="391.11"
          y2="919.11"
        />
        <path
          className="cls-2"
          d="m284.17,958.09c14.08-12.39,32.74-25.48,70.65-33.97,30.74-6.89,55.52-3.49,71.02-1.22,36.14,5.29,93.09,24.86,91.03,129.31"
        />
        <line
          className="cls-2"
          x1="835.35"
          y1="702.23"
          x2="835.35"
          y2="1044.96"
        />
        <path
          className="cls-2"
          d="m672.59,1044.55h193.73c39.74-2.73,72.84,6.61,93.83,36.95,12.94,18.7,14.34,28.78,14.54,34.91"
        />
        <circle className="cls-15" cx="658.88" cy="1044.46" r="15.84" />
        <line
          className="cls-2"
          x1="835.35"
          y1="682.72"
          x2="835.35"
          y2="702.14"
        />
        <line
          className="cls-2"
          x1="668.39"
          y1="530.09"
          x2="668.39"
          y2="549.51"
        />
        <line
          className="cls-2"
          x1="729.72"
          y1="1044.46"
          x2="729.72"
          y2="1227.92"
        />
        <line
          className="cls-2"
          x1="284.44"
          y1="1033.81"
          x2="284.44"
          y2="1236.68"
        />
        <path
          className="cls-2"
          d="m207.95,1279.16c4.58-7.25,15.15-21.76,34.29-31.92,6.18-3.28,30.96-14.99,62.67-8.28,61.89,13.11,71.29,65.97,76.51,72.08"
        />
        <path
          className="cls-2"
          d="m345.61,1311.22c38.11-.36,37.44.22,69.05.65,23.97.33,66.71,10.97,76.39,69.94"
        />
        <circle className="cls-15" cx="338.95" cy="1310.5" r="15.84" />
        <line
          className="cls-2"
          x1="727.39"
          y1="1255.66"
          x2="727.39"
          y2="1429.31"
        />
        <line
          className="cls-2"
          x1="206.29"
          y1="1332.73"
          x2="206.29"
          y2="1515.95"
        />
        <line
          className="cls-2"
          x1="972.26"
          y1="1193.42"
          x2="972.26"
          y2="1507.36"
        />
        <line
          className="cls-2"
          x1="487.39"
          y1="1451.31"
          x2="487.39"
          y2="1621.16"
        />
        <line
          className="cls-2"
          x1="726.38"
          y1="1501.31"
          x2="726.38"
          y2="1672.11"
        />
        <g>
          <path
            className="cls-16"
            d="m473.82,327.54c.77,0,1.4.21,1.88.64s.73.98.73,1.66c0,.46-.12.87-.36,1.22s-.6.62-1.07.82c.26.14.49.33.7.57s.46.65.76,1.22c.5.99.87,1.68,1.11,2.05h-1.76c-.12-.18-.29-.47-.49-.86-.45-.87-.79-1.46-1-1.76s-.41-.52-.61-.64-.42-.19-.67-.19h-.57v3.46h-1.58v-8.19h2.95Zm-.36,3.49c.41,0,.74-.1.98-.31s.35-.49.35-.85-.12-.66-.35-.84-.57-.28-1-.28h-.98v2.28h1.01Z"
          />
          <path
            className="cls-16"
            d="m480.9,330.14c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path className="cls-16" d="m486.55,327.54v8.19h-1.44v-8.19h1.44Z" />
          <path className="cls-16" d="m489.53,327.54v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m497.06,330.14c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m502.08,330.25l1.31,3.17,1.28-3.17h1.54l-2.47,5.58h-.7l-2.51-5.58h1.55Z"
          />
          <path
            className="cls-16"
            d="m509.4,330.14c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m516.28,330.14c.19,0,.38.04.57.13s.4.23.65.43l-.52,1.26c-.42-.31-.75-.47-1.01-.47-.22,0-.44.08-.66.25s-.39.39-.52.66-.2.55-.2.82v2.5h-1.44v-5.47h1.44v1.39h.02c.26-.53.53-.91.79-1.15s.56-.35.87-.35Z"
          />
          <path
            className="cls-16"
            d="m526.67,327.54v1.24h-3.41v2.12h3.41v1.25h-3.41v3.59h-1.58v-8.19h4.99Z"
          />
          <path
            className="cls-16"
            d="m533.23,330.14c.7,0,1.24.15,1.61.45s.56.72.56,1.25v2.68c0,.21.08.31.25.31.07,0,.17-.03.3-.09s.23-.13.32-.21v.83c-.5.31-.96.46-1.38.46-.26,0-.46-.04-.59-.13s-.24-.24-.29-.46c-.55.39-1.1.59-1.66.59-.39,0-.73-.13-1.02-.4s-.42-.58-.42-.96c0-.47.14-.85.42-1.12s.77-.51,1.48-.71l1.17-.34v-.25c0-.54-.32-.8-.97-.8-.33,0-.66.08-.99.23s-.63.38-.9.67v-1.29c.6-.47,1.31-.71,2.13-.71Zm-.88,4.11c0,.2.06.36.19.48s.28.18.47.18c.32,0,.63-.14.95-.43v-1.44c-.4.14-.72.27-.95.39s-.4.24-.5.37-.16.28-.16.46Z"
          />
          <path
            className="cls-16"
            d="m540.23,330.14c.59,0,1.05.19,1.4.58s.52.89.52,1.52v3.48h-1.44v-3.33c0-.36-.08-.64-.25-.84s-.4-.31-.69-.31c-.22,0-.43.07-.63.2s-.41.35-.64.65v3.64h-1.44v-5.47h1.44v.77c.27-.31.54-.54.82-.67s.58-.2.91-.2Z"
          />
          <path
            className="cls-16"
            d="m547.25,330.37v-2.84h1.44v8.19h-2.53c-.88,0-1.58-.25-2.1-.76s-.79-1.19-.79-2.06c0-.52.12-.98.37-1.41s.58-.75,1.01-.99.89-.36,1.39-.36c.38,0,.79.08,1.22.23Zm-.76,4.25h.76v-3.17c-.3-.15-.61-.23-.93-.23-.48,0-.86.15-1.15.45s-.43.7-.43,1.18c0,1.18.58,1.76,1.75,1.76Z"
          />
          <path
            className="cls-16"
            d="m555.22,327.54v6.95h3.97v1.24h-5.55v-8.19h1.58Z"
          />
          <path
            className="cls-16"
            d="m473.32,343.14c.64,0,1.21.12,1.73.37v1.22c-.51-.3-1-.45-1.45-.45-.49,0-.89.15-1.21.46s-.47.72-.47,1.25.16.92.47,1.24.73.47,1.26.47c.39,0,.89-.13,1.5-.39v1.17c-.57.23-1.15.35-1.75.35-.89,0-1.61-.25-2.16-.76s-.83-1.18-.83-2.02.27-1.57.81-2.1,1.24-.8,2.1-.8Z"
          />
          <path
            className="cls-16"
            d="m476.99,340.72c.22,0,.41.08.57.24s.24.35.24.57-.08.41-.24.57-.35.25-.58.25-.41-.08-.57-.25-.24-.36-.24-.57c0-.23.08-.42.25-.58s.35-.24.57-.24Zm.72,2.53v5.47h-1.44v-5.47h1.44Z"
          />
          <path
            className="cls-16"
            d="m482.33,343.14c.19,0,.38.04.57.13s.4.23.65.43l-.52,1.26c-.42-.31-.75-.47-1.01-.47-.22,0-.44.08-.66.25s-.39.39-.52.66-.2.55-.2.82v2.5h-1.44v-5.47h1.44v1.39h.02c.26-.53.53-.91.79-1.15s.56-.35.87-.35Z"
          />
          <path
            className="cls-16"
            d="m486.6,343.14c.64,0,1.21.12,1.73.37v1.22c-.51-.3-1-.45-1.45-.45-.49,0-.89.15-1.21.46s-.47.72-.47,1.25.16.92.47,1.24.73.47,1.26.47c.39,0,.89-.13,1.5-.39v1.17c-.57.23-1.15.35-1.75.35-.89,0-1.61-.25-2.16-.76s-.83-1.18-.83-2.02.27-1.57.81-2.1,1.24-.8,2.1-.8Z"
          />
          <path className="cls-16" d="m491,340.54v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m494.94,343.14c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m500.46,343.14c.3,0,.58.03.85.1s.55.18.84.33v1.15c-.27-.18-.57-.32-.88-.42s-.59-.16-.84-.16c-.21,0-.37.04-.49.12s-.18.19-.18.33c0,.08.05.16.15.25s.37.23.8.45c.62.32,1.06.61,1.32.88s.38.59.38.96c0,.53-.18.94-.55,1.25s-.86.45-1.49.45c-.39,0-.75-.04-1.09-.13s-.62-.19-.84-.31v-1.2c.7.39,1.29.59,1.78.59.25,0,.45-.04.6-.13s.23-.2.23-.35c0-.09-.03-.16-.08-.23s-.14-.14-.25-.22-.45-.25-1.03-.53c-.44-.21-.77-.44-.98-.69s-.32-.54-.32-.88c0-.48.19-.87.57-1.16s.88-.43,1.49-.43Z"
          />
          <path
            className="cls-16"
            d="m509.16,340.43c.17,0,.34.02.52.05s.32.07.43.12v1.17c-.2-.05-.42-.08-.65-.08-.35,0-.61.09-.78.27s-.25.48-.25.9v.39h.94v1.09h-.94v4.38h-1.44v-4.38h-.78v-1.09h.78v-.41c0-.74.2-1.32.59-1.76s.92-.65,1.58-.65Z"
          />
          <path
            className="cls-16"
            d="m512.85,343.14c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m520.14,343.14c.19,0,.38.04.57.13s.4.23.65.43l-.52,1.26c-.42-.31-.75-.47-1.01-.47-.22,0-.44.08-.66.25s-.39.39-.52.66-.2.55-.2.82v2.5h-1.44v-5.47h1.44v1.39h.02c.26-.53.53-.91.79-1.15s.56-.35.87-.35Z"
          />
          <path
            className="cls-16"
            d="m528.53,343.14c.42,0,.78.1,1.07.3s.51.46.65.79c.31-.38.62-.66.92-.83s.64-.26,1.01-.26c.58,0,1.04.19,1.4.57s.53.88.53,1.51v3.5h-1.44v-3.26c0-.38-.08-.68-.24-.9s-.4-.33-.71-.33c-.44,0-.87.28-1.27.85v3.64h-1.44v-3.29c0-.38-.09-.67-.26-.88s-.4-.32-.69-.32c-.23,0-.45.07-.64.2s-.4.35-.63.65v3.64h-1.44v-5.47h1.44v.77c.26-.3.53-.52.8-.66s.58-.21.93-.21Z"
          />
          <path
            className="cls-16"
            d="m538.23,343.14c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m545.53,343.14c.19,0,.38.04.57.13s.4.23.65.43l-.52,1.26c-.42-.31-.75-.47-1.01-.47-.22,0-.44.08-.66.25s-.39.39-.52.66-.2.55-.2.82v2.5h-1.44v-5.47h1.44v1.39h.02c.26-.53.53-.91.79-1.15s.56-.35.87-.35Z"
          />
          <path
            className="cls-16"
            d="m549.62,343.14c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m560.4,343.37v-2.84h1.44v8.19h-2.53c-.88,0-1.58-.25-2.1-.76s-.79-1.19-.79-2.06c0-.52.12-.98.37-1.41s.58-.75,1.01-.99.89-.36,1.39-.36c.38,0,.79.08,1.22.23Zm-.76,4.25h.76v-3.17c-.3-.15-.61-.23-.93-.23-.48,0-.86.15-1.15.45s-.43.7-.43,1.18c0,1.18.58,1.76,1.75,1.76Z"
          />
          <path
            className="cls-16"
            d="m565.72,343.14c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m570.97,341.79h.12v1.45h1.88v1.09h-1.88v2.53c0,.25.07.45.22.6s.35.23.61.23c.34,0,.72-.12,1.16-.36v1.15c-.52.23-1.01.35-1.46.35-.62,0-1.1-.17-1.44-.5s-.52-.79-.52-1.37v-2.62h-.86v-.23l2.17-2.31Z"
          />
          <path
            className="cls-16"
            d="m575.87,343.14c.7,0,1.24.15,1.61.45s.56.72.56,1.25v2.68c0,.21.08.31.25.31.07,0,.17-.03.3-.09s.23-.13.32-.21v.83c-.5.31-.96.46-1.38.46-.26,0-.46-.04-.59-.13s-.24-.24-.29-.46c-.55.39-1.1.59-1.66.59-.39,0-.73-.13-1.02-.4s-.42-.58-.42-.96c0-.47.14-.85.42-1.12s.77-.51,1.48-.71l1.17-.34v-.25c0-.54-.32-.8-.97-.8-.33,0-.66.08-.99.23s-.63.38-.9.67v-1.29c.6-.47,1.31-.71,2.13-.71Zm-.88,4.11c0,.2.06.36.19.48s.28.18.47.18c.32,0,.63-.14.95-.43v-1.44c-.4.14-.72.27-.95.39s-.4.24-.5.37-.16.28-.16.46Z"
          />
          <path
            className="cls-16"
            d="m580.46,340.72c.22,0,.41.08.57.24s.24.35.24.57-.08.41-.24.57-.35.25-.58.25-.41-.08-.57-.25-.24-.36-.24-.57c0-.23.08-.42.25-.58s.35-.24.57-.24Zm.72,2.53v5.47h-1.44v-5.47h1.44Z"
          />
          <path className="cls-16" d="m584.16,340.54v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m587.42,343.14c.3,0,.58.03.85.1s.55.18.84.33v1.15c-.27-.18-.57-.32-.88-.42s-.59-.16-.84-.16c-.21,0-.37.04-.49.12s-.18.19-.18.33c0,.08.05.16.15.25s.37.23.8.45c.62.32,1.06.61,1.32.88s.38.59.38.96c0,.53-.18.94-.55,1.25s-.86.45-1.49.45c-.39,0-.75-.04-1.09-.13s-.62-.19-.84-.31v-1.2c.7.39,1.29.59,1.78.59.25,0,.45-.04.6-.13s.23-.2.23-.35c0-.09-.03-.16-.08-.23s-.14-.14-.25-.22-.45-.25-1.03-.53c-.44-.21-.77-.44-.98-.69s-.32-.54-.32-.88c0-.48.19-.87.57-1.16s.88-.43,1.49-.43Z"
          />
        </g>
        <g>
          <path
            className="cls-16"
            d="m823.92,454.86c.46,0,.92.05,1.37.16s.93.29,1.44.54v1.49c-.5-.29-.97-.5-1.4-.63s-.87-.19-1.34-.19c-.58,0-1.11.12-1.58.36s-.83.58-1.09,1.02-.39.92-.39,1.46.13,1.04.39,1.47.62.77,1.09,1,1,.35,1.58.35c.45,0,.88-.06,1.29-.19s.92-.36,1.54-.7v1.49c-.53.28-1.02.47-1.46.59s-.96.18-1.56.18c-.86,0-1.63-.17-2.31-.52s-1.21-.84-1.6-1.49-.58-1.35-.58-2.12c0-.82.2-1.56.6-2.22s.95-1.16,1.65-1.52,1.49-.53,2.37-.53Z"
          />
          <path className="cls-16" d="m829.64,454.97v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m831.89,455.15c.22,0,.41.08.57.24s.24.35.24.57-.08.41-.24.57-.35.25-.58.25-.41-.08-.57-.25-.24-.36-.24-.57c0-.23.08-.42.25-.58s.35-.24.57-.24Zm.72,2.53v5.47h-1.44v-5.47h1.44Z"
          />
          <path
            className="cls-16"
            d="m836.73,457.57c.64,0,1.21.12,1.73.37v1.22c-.51-.3-1-.45-1.45-.45-.49,0-.89.15-1.21.46s-.47.72-.47,1.25.16.92.47,1.24.73.47,1.26.47c.39,0,.89-.13,1.5-.39v1.17c-.57.23-1.15.35-1.75.35-.89,0-1.61-.25-2.16-.76s-.83-1.18-.83-2.02.27-1.57.81-2.1,1.24-.8,2.1-.8Z"
          />
          <path
            className="cls-16"
            d="m841.07,454.97v8.19h-1.44v-8.19h1.44Zm3.97,2.71l-2.22,2.7,2.5,2.77h-1.83l-2.4-2.77,2.26-2.7h1.69Z"
          />
          <path
            className="cls-16"
            d="m851.9,457.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m859.23,457.57c.59,0,1.05.19,1.4.58s.52.89.52,1.52v3.48h-1.44v-3.33c0-.36-.08-.64-.25-.84s-.4-.31-.69-.31c-.22,0-.43.07-.63.2s-.41.35-.64.65v3.64h-1.44v-5.47h1.44v.77c.27-.31.54-.54.82-.67s.58-.2.91-.2Z"
          />
          <path
            className="cls-16"
            d="m867.39,456.23h.12v1.45h1.88v1.09h-1.88v2.53c0,.25.07.45.22.6s.35.23.61.23c.34,0,.72-.12,1.16-.36v1.15c-.52.23-1.01.35-1.46.35-.62,0-1.1-.17-1.44-.5s-.52-.79-.52-1.37v-2.62h-.86v-.23l2.17-2.31Z"
          />
          <path
            className="cls-16"
            d="m871.76,454.97v3.48h.04c.46-.58,1.03-.87,1.68-.87.58,0,1.05.19,1.41.57s.53.88.53,1.5v3.5h-1.44v-3.23c0-.37-.09-.66-.26-.88s-.41-.33-.71-.33c-.22,0-.42.06-.62.19s-.4.33-.63.62v3.62h-1.44v-8.19h1.44Z"
          />
          <path
            className="cls-16"
            d="m879.26,457.57c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m820.89,467.97v3.06c.43-.3.91-.46,1.45-.46.48,0,.92.12,1.31.35s.7.57.91,1,.33.91.33,1.43c0,.9-.27,1.61-.8,2.12s-1.27.78-2.2.78c-.84,0-1.65-.15-2.44-.46v-7.83h1.44Zm0,7.04c.31.11.67.16,1.08.16.44,0,.79-.16,1.05-.48s.39-.77.39-1.34c0-.52-.13-.93-.39-1.23s-.61-.46-1.04-.46c-.2,0-.38.04-.55.11s-.35.19-.54.35v2.9Z"
          />
          <path
            className="cls-16"
            d="m828,470.57c.7,0,1.24.15,1.61.45s.56.72.56,1.25v2.68c0,.21.08.31.25.31.07,0,.17-.03.3-.09s.23-.13.32-.21v.83c-.5.31-.96.46-1.38.46-.26,0-.46-.04-.59-.13s-.24-.24-.29-.46c-.55.39-1.1.59-1.66.59-.39,0-.73-.13-1.02-.4s-.42-.58-.42-.96c0-.47.14-.85.42-1.12s.77-.51,1.48-.71l1.17-.34v-.25c0-.54-.32-.8-.97-.8-.33,0-.66.08-.99.23s-.63.38-.9.67v-1.29c.6-.47,1.31-.71,2.13-.71Zm-.88,4.11c0,.2.06.36.19.48s.28.18.47.18c.32,0,.63-.14.95-.43v-1.44c-.4.14-.72.27-.95.39s-.4.24-.5.37-.16.28-.16.46Z"
          />
          <path
            className="cls-16"
            d="m834.96,470.57c.19,0,.38.04.57.13s.4.23.65.43l-.52,1.26c-.42-.31-.75-.47-1.01-.47-.22,0-.44.08-.66.25s-.39.39-.52.66-.2.55-.2.82v2.5h-1.44v-5.47h1.44v1.39h.02c.26-.53.53-.91.79-1.15s.56-.35.87-.35Z"
          />
          <path
            className="cls-16"
            d="m838.62,470.57c.3,0,.58.03.85.1s.55.18.84.33v1.15c-.27-.18-.57-.32-.88-.42s-.59-.16-.84-.16c-.21,0-.37.04-.49.12s-.18.19-.18.33c0,.08.05.16.15.25s.37.23.8.45c.62.32,1.06.61,1.32.88s.38.59.38.96c0,.53-.18.94-.55,1.25s-.86.45-1.49.45c-.39,0-.75-.04-1.09-.13s-.62-.19-.84-.31v-1.2c.7.39,1.29.59,1.78.59.25,0,.45-.04.6-.13s.23-.2.23-.35c0-.09-.03-.16-.08-.23s-.14-.14-.25-.22-.45-.25-1.03-.53c-.44-.21-.77-.44-.98-.69s-.32-.54-.32-.88c0-.48.19-.87.57-1.16s.88-.43,1.49-.43Z"
          />
          <path
            className="cls-16"
            d="m846.99,470.57c.7,0,1.24.15,1.61.45s.56.72.56,1.25v2.68c0,.21.08.31.25.31.07,0,.17-.03.3-.09s.23-.13.32-.21v.83c-.5.31-.96.46-1.38.46-.26,0-.46-.04-.59-.13s-.24-.24-.29-.46c-.55.39-1.1.59-1.66.59-.39,0-.73-.13-1.02-.4s-.42-.58-.42-.96c0-.47.14-.85.42-1.12s.77-.51,1.48-.71l1.17-.34v-.25c0-.54-.32-.8-.97-.8-.33,0-.66.08-.99.23s-.63.38-.9.67v-1.29c.6-.47,1.31-.71,2.13-.71Zm-.88,4.11c0,.2.06.36.19.48s.28.18.47.18c.32,0,.63-.14.95-.43v-1.44c-.4.14-.72.27-.95.39s-.4.24-.5.37-.16.28-.16.46Z"
          />
          <path
            className="cls-16"
            d="m852.26,467.97v3.06c.43-.3.91-.46,1.45-.46.48,0,.92.12,1.31.35s.7.57.91,1,.33.91.33,1.43c0,.9-.27,1.61-.8,2.12s-1.27.78-2.2.78c-.84,0-1.65-.15-2.44-.46v-7.83h1.44Zm0,7.04c.31.11.67.16,1.08.16.44,0,.79-.16,1.05-.48s.39-.77.39-1.34c0-.52-.13-.93-.39-1.23s-.61-.46-1.04-.46c-.2,0-.38.04-.55.11s-.35.19-.54.35v2.9Z"
          />
          <path
            className="cls-16"
            d="m860.12,470.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m865.13,470.68l1.31,3.17,1.28-3.17h1.54l-2.47,5.58h-.7l-2.51-5.58h1.55Z"
          />
          <path
            className="cls-16"
            d="m872.46,470.57c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path
            className="cls-16"
            d="m881.03,469.23h.12v1.45h1.88v1.09h-1.88v2.53c0,.25.07.45.22.6s.35.23.61.23c.34,0,.72-.12,1.16-.36v1.15c-.52.23-1.01.35-1.46.35-.62,0-1.1-.17-1.44-.5s-.52-.79-.52-1.37v-2.62h-.86v-.23l2.17-2.31Z"
          />
          <path
            className="cls-16"
            d="m886.68,470.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m820.89,480.97v3.48h.04c.46-.58,1.03-.87,1.68-.87.58,0,1.05.19,1.41.57s.53.88.53,1.5v3.5h-1.44v-3.23c0-.37-.09-.66-.26-.88s-.41-.33-.71-.33c-.22,0-.42.06-.62.19s-.4.33-.63.62v3.62h-1.44v-8.19h1.44Z"
          />
          <path
            className="cls-16"
            d="m826.71,481.15c.22,0,.41.08.57.24s.24.35.24.57-.08.41-.24.57-.35.25-.58.25-.41-.08-.57-.25-.24-.36-.24-.57c0-.23.08-.42.25-.58s.35-.24.57-.24Zm.72,2.53v5.47h-1.44v-5.47h1.44Z"
          />
          <path
            className="cls-16"
            d="m833.97,483.68v1.02h-.94c.15.19.26.36.32.52s.09.33.09.51c0,.44-.16.84-.49,1.2-.29.32-.79.52-1.49.62-.38.05-.63.1-.75.16s-.18.15-.18.28c0,.11.08.2.23.26s.39.12.72.17c.82.13,1.43.34,1.82.61s.58.63.58,1.08c0,.58-.24,1.02-.71,1.33s-1.15.47-2.04.47c-.84,0-1.51-.15-2-.44s-.74-.69-.74-1.18c0-.7.48-1.18,1.44-1.44-.41-.18-.62-.42-.62-.71,0-.38.31-.65.94-.79v-.02c-.43-.12-.76-.33-1.02-.63s-.38-.65-.38-1.05c0-.59.22-1.07.67-1.43s1.03-.54,1.75-.54h2.82Zm-4.25,6.55c0,.49.49.73,1.46.73.42,0,.75-.07.99-.2s.36-.31.36-.53c0-.24-.14-.42-.41-.55s-.66-.18-1.15-.18c-.37,0-.67.07-.91.21s-.35.31-.35.52Zm.35-4.57c0,.29.1.52.3.71s.45.28.74.28.54-.1.73-.3.29-.45.29-.75c0-.27-.1-.5-.3-.68s-.44-.27-.72-.27-.53.1-.74.3-.3.43-.3.7Z"
          />
          <path
            className="cls-16"
            d="m836.24,480.97v3.48h.04c.46-.58,1.03-.87,1.68-.87.58,0,1.05.19,1.41.57s.53.88.53,1.5v3.5h-1.44v-3.23c0-.37-.09-.66-.26-.88s-.41-.33-.71-.33c-.22,0-.42.06-.62.19s-.4.33-.63.62v3.62h-1.44v-8.19h1.44Z"
          />
          <path className="cls-16" d="m842.78,480.97v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m845.03,481.15c.22,0,.41.08.57.24s.24.35.24.57-.08.41-.24.57-.35.25-.58.25-.41-.08-.57-.25-.24-.36-.24-.57c0-.23.08-.42.25-.58s.35-.24.57-.24Zm.72,2.53v5.47h-1.44v-5.47h1.44Z"
          />
          <path
            className="cls-16"
            d="m852.29,483.68v1.02h-.94c.15.19.26.36.32.52s.09.33.09.51c0,.44-.16.84-.49,1.2-.29.32-.79.52-1.49.62-.38.05-.63.1-.75.16s-.18.15-.18.28c0,.11.08.2.23.26s.39.12.72.17c.82.13,1.43.34,1.82.61s.58.63.58,1.08c0,.58-.24,1.02-.71,1.33s-1.15.47-2.04.47c-.84,0-1.51-.15-2-.44s-.74-.69-.74-1.18c0-.7.48-1.18,1.44-1.44-.41-.18-.62-.42-.62-.71,0-.38.31-.65.94-.79v-.02c-.43-.12-.76-.33-1.02-.63s-.38-.65-.38-1.05c0-.59.22-1.07.67-1.43s1.03-.54,1.75-.54h2.82Zm-4.25,6.55c0,.49.49.73,1.46.73.42,0,.75-.07.99-.2s.36-.31.36-.53c0-.24-.14-.42-.41-.55s-.66-.18-1.15-.18c-.37,0-.67.07-.91.21s-.35.31-.35.52Zm.35-4.57c0,.29.1.52.3.71s.45.28.74.28.54-.1.73-.3.29-.45.29-.75c0-.27-.1-.5-.3-.68s-.44-.27-.72-.27-.53.1-.74.3-.3.43-.3.7Z"
          />
          <path
            className="cls-16"
            d="m854.57,480.97v3.48h.04c.46-.58,1.03-.87,1.68-.87.58,0,1.05.19,1.41.57s.53.88.53,1.5v3.5h-1.44v-3.23c0-.37-.09-.66-.26-.88s-.41-.33-.71-.33c-.22,0-.42.06-.62.19s-.4.33-.63.62v3.62h-1.44v-8.19h1.44Z"
          />
          <path
            className="cls-16"
            d="m861.12,482.23h.12v1.45h1.88v1.09h-1.88v2.53c0,.25.07.45.22.6s.35.23.61.23c.34,0,.72-.12,1.16-.36v1.15c-.52.23-1.01.35-1.46.35-.62,0-1.1-.17-1.44-.5s-.52-.79-.52-1.37v-2.62h-.86v-.23l2.17-2.31Z"
          />
          <path
            className="cls-16"
            d="m869.35,483.57c.7,0,1.24.15,1.61.45s.56.72.56,1.25v2.68c0,.21.08.31.25.31.07,0,.17-.03.3-.09s.23-.13.32-.21v.83c-.5.31-.96.46-1.38.46-.26,0-.46-.04-.59-.13s-.24-.24-.29-.46c-.55.39-1.1.59-1.66.59-.39,0-.73-.13-1.02-.4s-.42-.58-.42-.96c0-.47.14-.85.42-1.12s.77-.51,1.48-.71l1.17-.34v-.25c0-.54-.32-.8-.97-.8-.33,0-.66.08-.99.23s-.63.38-.9.67v-1.29c.6-.47,1.31-.71,2.13-.71Zm-.88,4.11c0,.2.06.36.19.48s.28.18.47.18c.32,0,.63-.14.95-.43v-1.44c-.4.14-.72.27-.95.39s-.4.24-.5.37-.16.28-.16.46Z"
          />
          <path
            className="cls-16"
            d="m878.01,482.23h.12v1.45h1.88v1.09h-1.88v2.53c0,.25.07.45.22.6s.35.23.61.23c.34,0,.72-.12,1.16-.36v1.15c-.52.23-1.01.35-1.46.35-.62,0-1.1-.17-1.44-.5s-.52-.79-.52-1.37v-2.62h-.86v-.23l2.17-2.31Z"
          />
          <path
            className="cls-16"
            d="m883.65,483.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m890.53,483.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path className="cls-16" d="m896.19,480.97v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m821.22,496.57c.3,0,.58.03.85.1s.55.18.84.33v1.15c-.27-.18-.57-.32-.88-.42s-.59-.16-.84-.16c-.21,0-.37.04-.49.12s-.18.19-.18.33c0,.08.05.16.15.25s.37.23.8.45c.62.32,1.06.61,1.32.88s.38.59.38.96c0,.53-.18.94-.55,1.25s-.86.45-1.49.45c-.39,0-.75-.04-1.09-.13s-.62-.19-.84-.31v-1.2c.7.39,1.29.59,1.78.59.25,0,.45-.04.6-.13s.23-.2.23-.35c0-.09-.03-.16-.08-.23s-.14-.14-.25-.22-.45-.25-1.03-.53c-.44-.21-.77-.44-.98-.69s-.32-.54-.32-.88c0-.48.19-.87.57-1.16s.88-.43,1.49-.43Z"
          />
          <path
            className="cls-16"
            d="m825.73,493.97v3.48h.04c.46-.58,1.03-.87,1.68-.87.58,0,1.05.19,1.41.57s.53.88.53,1.5v3.5h-1.44v-3.23c0-.37-.09-.66-.26-.88s-.41-.33-.71-.33c-.22,0-.42.06-.62.19s-.4.33-.63.62v3.62h-1.44v-8.19h1.44Z"
          />
          <path
            className="cls-16"
            d="m833.5,496.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m838.44,496.68l1.27,3.16,1.29-3.16h.94l1.28,3.16,1.27-3.16h1.5l-2.44,5.58h-.61l-1.48-3.35-1.48,3.35h-.6l-2.46-5.58h1.5Z"
          />
          <path
            className="cls-16"
            d="m849.89,496.57c.59,0,1.05.19,1.4.58s.52.89.52,1.52v3.48h-1.44v-3.33c0-.36-.08-.64-.25-.84s-.4-.31-.69-.31c-.22,0-.43.07-.63.2s-.41.35-.64.65v3.64h-1.44v-5.47h1.44v.77c.27-.31.54-.54.82-.67s.58-.2.91-.2Z"
          />
          <path
            className="cls-16"
            d="m857.99,493.97v3.06c.43-.3.91-.46,1.45-.46.48,0,.92.12,1.31.35s.7.57.91,1,.33.91.33,1.43c0,.9-.27,1.61-.8,2.12s-1.27.78-2.2.78c-.84,0-1.65-.15-2.44-.46v-7.83h1.44Zm0,7.04c.31.11.67.16,1.08.16.44,0,.79-.16,1.05-.48s.39-.77.39-1.34c0-.52-.13-.93-.39-1.23s-.61-.46-1.04-.46c-.2,0-.38.04-.55.11s-.35.19-.54.35v2.9Z"
          />
          <path
            className="cls-16"
            d="m865.58,496.57c.8,0,1.44.26,1.91.77s.7,1.23.7,2.14v.22h-3.87c.06.49.24.86.55,1.13s.73.4,1.26.4c.34,0,.67-.06.99-.18s.65-.3.99-.54v1.07c-.64.45-1.42.68-2.33.68-.86,0-1.57-.26-2.12-.78s-.82-1.21-.82-2.07.25-1.51.76-2.04,1.17-.79,1.98-.79Zm1.26,2.26c-.04-.4-.16-.71-.36-.93s-.48-.34-.84-.34-.66.11-.88.32-.36.53-.42.95h2.5Z"
          />
          <path className="cls-16" d="m870.82,493.97v8.19h-1.44v-8.19h1.44Z" />
          <path
            className="cls-16"
            d="m875.02,496.57c.57,0,1.09.12,1.55.36s.82.57,1.08,1,.38.92.38,1.46-.12,1.06-.37,1.49-.6.76-1.08,1.01-1,.37-1.57.37-1.1-.12-1.56-.37-.83-.58-1.07-1.01-.37-.92-.37-1.49.13-1.04.39-1.47.62-.76,1.08-1,.97-.35,1.54-.35Zm-1.49,2.82c0,.55.13.98.4,1.31s.63.49,1.08.49.84-.16,1.11-.47.4-.76.4-1.34-.14-.98-.41-1.29-.64-.45-1.1-.45c-.44,0-.79.16-1.07.48s-.41.74-.41,1.27Z"
          />
          <path
            className="cls-16"
            d="m879.96,496.68l1.27,3.16,1.29-3.16h.94l1.28,3.16,1.27-3.16h1.5l-2.44,5.58h-.61l-1.48-3.35-1.48,3.35h-.6l-2.46-5.58h1.5Z"
          />
        </g>
        <path
          className="cls-6"
          d="m469.97,351.74c-13.82,22.19-24.1,57.74-11.89,80.86,2.23,4.22,4.87,8.25,6.49,12.73,1.62,4.48,2.12,9.63.04,13.92"
        />
        <line
          className="cls-2"
          x1="204.76"
          y1="1576.2"
          x2="204.76"
          y2="1736.52"
        />
        <path
          className="cls-6"
          d="m786.18,444.97c-.19,4.53.39,9.3,2.98,13.03,2.58,3.73,7.6,6.03,11.82,4.37,2.87-1.13,4.93-3.82,7.84-4.85,2.35-.84,5.11-.42,7.12,1.07"
        />
        <path
          className="cls-6"
          d="m781.9,450.69l4.23-5.71c1.59,1.67,3.19,3.34,4.78,5"
        />
      </g>
      <g id="canvas">
        <line
          className="cls-2"
          x1="201.78"
          y1="1784.51"
          x2="201.78"
          y2="1803.93"
        />
        <path
          id="canvasLeaf"
          className="cls-14 leaf"
          d="m205.78,1724.61c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m168.96,1763.94c-.31.16-.62.29-.95.39s-.65.17-.98.21c-.33.04-.67.06-1.02.06-.65,0-1.23-.09-1.74-.27-.51-.18-.96-.44-1.34-.79-.38-.35-.66-.76-.85-1.22-.19-.47-.28-.98-.28-1.54,0-.64.11-1.2.33-1.68s.53-.88.93-1.2c.4-.32.85-.55,1.36-.71.51-.15,1.05-.23,1.61-.23.85,0,1.8.19,2.87.56v1.98c-.37-.23-.73-.42-1.09-.57-.36-.15-.78-.23-1.27-.23-.43,0-.84.09-1.21.26s-.68.42-.91.74c-.23.32-.34.69-.34,1.12,0,.38.1.72.3,1.03s.48.56.83.75c.36.18.76.28,1.21.28.36,0,.7-.04,1.03-.13s.59-.19.81-.29c.22-.11.45-.23.68-.38v1.88Z"
          />
          <path
            className="cls-13"
            d="m178.64,1764.5h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m187.72,1764.5h-2l-3.86-4.15v4.15h-2.22v-7.44h1.99l3.85,4.12v-4.12h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m196.87,1757.05l-3.36,7.54h-1.48l-3.29-7.54h2.34l1.7,4.3,1.75-4.3h2.34Z"
          />
          <path
            className="cls-13"
            d="m205.27,1764.5h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m211.47,1762.33c0,.46-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.07-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51s-.47-.28-.84-.43c-.41-.17-.77-.36-1.07-.56s-.56-.46-.75-.76c-.19-.3-.29-.66-.29-1.08s.1-.76.3-1.09c.2-.32.5-.58.9-.78s.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.59-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16s-.19.24-.19.4c0,.15.06.27.19.38s.35.24.67.39c.57.27,1.03.51,1.38.73s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m193.85,1788.41h-2.22v-8.12h2.22v8.12Z" />
          <path className="cls-13" d="m200.98,1788.41h-2.22v-8.12h2.22v8.12Z" />
          <path className="cls-13" d="m208.11,1788.41h-2.22v-8.12h2.22v8.12Z" />
        </g>
        <circle className="cls-2" cx="201.78" cy="1804.02" r="2.49" />
        <path
          className="cls-2"
          d="m138.21,1823.71c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_20" data-name="frequency copy 20">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="142.25"
            y1="1847.2"
            x2="142.25"
            y2="1895.1"
          />
          <path
            className="cls-22"
            d="m171.85,1910.46c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="132.94"
            y1="1899.23"
            x2="132.94"
            y2="1922.24"
          />
          <line
            className="cls-1"
            x1="146.63"
            y1="1894.1"
            x2="146.63"
            y2="1920.11"
          />
          <line
            className="cls-1"
            x1="122.03"
            y1="1901.64"
            x2="122.03"
            y2="1922.65"
          />
          <circle className="cls-11" cx="146.63" cy="1922" r="5.7" />
          <circle className="cls-12" cx="122.03" cy="1922" r="5.7" />
          <circle className="cls-18" cx="132.69" cy="1922" r="5.7" />
          <circle
            id="canvasFreq"
            className="cls-14 tooltip"
            cx="143.09"
            cy="1841.71"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m146.37,1836h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m136.88,1854.85h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m144.01,1854.85h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m151.15,1854.85h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_20" data-name="likeability copy 20">
          <line
            className="cls-1"
            x1="262.45"
            y1="1853.62"
            x2="262.45"
            y2="1894.6"
          />
          <circle
            id="canvasLike"
            className="cls-14 tooltip"
            cx="262.81"
            cy="1843.26"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m293.54,1909.92c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="233.88"
            y1="1910.79"
            x2="233.88"
            y2="1926.8"
          />
          <line
            className="cls-1"
            x1="251.92"
            y1="1899.79"
            x2="251.92"
            y2="1926.8"
          />
          <line
            className="cls-1"
            x1="280.62"
            y1="1900.51"
            x2="280.62"
            y2="1927.52"
          />
          <circle className="cls-18" cx="233.88" cy="1924.5" r="5.7" />
          <circle className="cls-11" cx="280.62" cy="1924.5" r="5.7" />
          <circle className="cls-12" cx="251.92" cy="1924.5" r="5.7" />
          <path
            className="cls-13"
            d="m266.32,1840.87h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m257.2,1857.06h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m266.4,1853.01c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
            />
            <path
              className="cls-13"
              d="m273.53,1854.88c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="mapbox">
        <line
          className="cls-2"
          x1="724.95"
          y1="1717.68"
          x2="724.95"
          y2="1737.1"
        />
        <path
          id="mapboxLeaf"
          className="cls-14 leaf"
          d="m728.94,1657.78c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m694.12,1697.67h-2.25v-4.31l-2.02,2.5h-.18l-2.03-2.5v4.31h-2.18v-7.44h2.04l2.29,2.79,2.3-2.79h2.04v7.44Z"
          />
          <path
            className="cls-13"
            d="m704.17,1697.67h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m711.61,1692.56c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m719.65,1695.55c0,.64-.22,1.15-.66,1.54-.44.38-1.05.57-1.84.57h-4.3v-7.44h3.6c.47,0,.87.04,1.22.13.35.09.62.21.83.37.21.16.37.34.47.55.1.21.16.44.16.69,0,.27-.05.52-.16.75-.11.23-.24.42-.4.57-.16.15-.32.25-.48.31.51.2.9.45,1.16.76.27.31.4.7.4,1.19Zm-2.62-3.19c0-.36-.12-.6-.35-.71s-.6-.18-1.11-.18h-.47v1.78h.48c.51,0,.88-.06,1.11-.18s.34-.36.34-.71Zm.37,3.1c0-.64-.46-.96-1.39-.96h-.91v1.91h.91c.92,0,1.39-.32,1.39-.95Z"
          />
          <path
            className="cls-13"
            d="m729.06,1693.94c0,.7-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.88s.15-1.29.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.53,2.34-.53.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.17-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24s.51-.39.66-.68.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m738.39,1697.67h-2.88l-.79-.93s-.18-.23-.47-.57c-.29-.34-.48-.58-.57-.71-.43.58-.78,1.04-1.05,1.38l-.68.84h-2.84l3.16-3.87-3.01-3.57h2.87l.51.62c.29.36.64.81,1.05,1.35.39-.57.7-1,.93-1.27l.58-.7h2.81l-2.89,3.57,3.27,3.87Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m717.02,1721.58h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m726.14,1721.58h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
          <path
            className="cls-13"
            d="m733.34,1717.53c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
          />
        </g>
        <circle className="cls-2" cx="724.95" cy="1737.19" r="2.49" />
        <path
          className="cls-2"
          d="m661.38,1756.88c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_19" data-name="frequency copy 19">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="665.42"
            y1="1780.37"
            x2="665.42"
            y2="1828.27"
          />
          <path
            className="cls-22"
            d="m695.75,1844.78c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="671.13"
            y1="1834.11"
            x2="671.13"
            y2="1857.12"
          />
          <line
            className="cls-1"
            x1="657.82"
            y1="1833.81"
            x2="657.82"
            y2="1859.82"
          />
          <line
            className="cls-1"
            x1="644.89"
            y1="1838.81"
            x2="644.89"
            y2="1859.82"
          />
          <circle className="cls-11" cx="671.13" cy="1858.26" r="5.7" />
          <circle className="cls-12" cx="644.89" cy="1858.26" r="5.7" />
          <circle className="cls-18" cx="657.19" cy="1858.26" r="5.7" />
          <circle
            id="mapboxFreq"
            className="cls-14 tooltip"
            cx="666.26"
            cy="1774.88"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m669.53,1769.17h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m660.05,1788.02h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m667.18,1788.02h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m676.37,1783c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
            />
          </g>
        </g>
        <g id="likeability_copy_19" data-name="likeability copy 19">
          <line
            className="cls-1"
            x1="785.62"
            y1="1786.79"
            x2="785.62"
            y2="1827.77"
          />
          <circle
            id="mapboxLike"
            className="cls-14 tooltip"
            cx="785.97"
            cy="1776.43"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m811.03,1846.06c-.54-.33-1.25-.85-2.24-1.47-2.98-1.89-5.44-3.09-5.89-3.32-4.67-2.44-12.14-3.28-14.01-3.46-2.01-.2-9.02-.76-17.79,1.27-3.88.9-8.15,1.89-11.92,4.43-.95.64-5.42,4.01-6.99,5.49-.12.11-.51.5-1.3,1.16-.26.21-.68.42-1.2.47-.89.1-2.01-.11-2.25-.92-.33-1.14.27-1.79.72-2.39.5-.68,1.06-1.31,2.04-2.3,2.37-2.38,2.15-2.09,2.43-2.34,3.35-2.98,7.55-5.59,7.55-5.59,7.79-4.84,16.04-7.46,16.04-7.46,9.62-3.05,17.39-3.19,19.07-3.2,7.83-.07,13.44,1.4,17.19,2.38,0,0,4.09,1.07,9.24,3.96,1.89,1.06,3.39,2.08,4.42,3.94,1.1,1.99,1.06,3.85,1.05,4.23-.02.63-.19,3.13-2.1,5.08-1.67,1.71-3.51,2.25-5.29,2.5-.98.14-3.19.15-5.59-.73-1.44-.53-2.45-1.25-3.18-1.72Z"
          />
          <line
            className="cls-1"
            x1="749.75"
            y1="1848.03"
            x2="749.75"
            y2="1864.04"
          />
          <line
            className="cls-1"
            x1="784.88"
            y1="1835.03"
            x2="784.88"
            y2="1877.04"
          />
          <line
            className="cls-1"
            x1="788.07"
            y1="1834.53"
            x2="788.07"
            y2="1861.54"
          />
          <circle className="cls-18" cx="749.75" cy="1859.99" r="5.7" />
          <circle className="cls-11" cx="788.07" cy="1859.99" r="5.7" />
          <circle className="cls-12" cx="784.88" cy="1874.99" r="5.7" />
          <path
            className="cls-13"
            d="m789.49,1774.04h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m780.37,1790.23h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m787.5,1790.23h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m796.71,1787.43c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="QGIS">
        <line
          className="cls-2"
          x1="486.11"
          y1="1667.41"
          x2="486.11"
          y2="1686.83"
        />
        <path
          id="QGISLeaf"
          className="cls-14 leaf"
          d="m490.1,1607.51c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05s2.19,10.73,2.84,11.64c2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m454.91,1647.93l-1.57,1.43c-.62-.14-1.23-.32-1.84-.55-.6-.23-1.21-.52-1.83-.85-.48-.26-.83-.51-1.07-.75-.42-.15-.81-.38-1.18-.68s-.68-.71-.92-1.19c-.24-.48-.36-1.04-.36-1.68,0-.67.15-1.3.46-1.88.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.71,0,1.33.11,1.87.31.54.21.98.49,1.33.85.35.36.6.76.77,1.22.17.46.26.94.26,1.43,0,.6-.11,1.14-.32,1.61-.21.47-.5.86-.84,1.17s-.74.56-1.18.74c.4.18.8.33,1.21.45.4.12.87.18,1.39.18l.06.12Zm-2.6-4.26c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4s-.52-.14-.83-.14c-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m463.01,1646.87c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path className="cls-13" d="m467.03,1647.4h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m474.11,1645.23c0,.47-.12.87-.36,1.21-.24.34-.57.6-1,.78s-.92.27-1.47.27c-.15,0-.34,0-.57-.03-.22-.02-.52-.08-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51-.19-.14-.47-.28-.84-.43-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.19-.3-.29-.66-.29-1.08s.1-.76.3-1.09.5-.58.9-.78.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.58-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16s-.19.24-.19.4c0,.15.06.27.19.38s.35.24.67.39c.57.27,1.03.51,1.38.72s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m478.18,1671.31h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m487.3,1671.31h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
          <path
            className="cls-13"
            d="m494.5,1669.13c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
          />
        </g>
        <circle className="cls-2" cx="486.11" cy="1686.92" r="2.49" />
        <path
          className="cls-2"
          d="m422.54,1706.61c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_18" data-name="frequency copy 18">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="426.58"
            y1="1730.1"
            x2="426.58"
            y2="1778"
          />
          <path
            className="cls-22"
            d="m460.28,1789.26c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="418.66"
            y1="1778"
            x2="418.66"
            y2="1816.01"
          />
          <line
            className="cls-1"
            x1="429.32"
            y1="1779.04"
            x2="429.32"
            y2="1805.05"
          />
          <circle className="cls-11" cx="429.32" cy="1807.35" r="5.7" />
          <circle className="cls-12" cx="418.66" cy="1816.35" r="5.7" />
          <circle className="cls-18" cx="418.66" cy="1799.35" r="5.7" />
          <circle
            id="QGISFreq"
            className="cls-14 tooltip"
            cx="427.42"
            cy="1724.61"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m430.7,1718.9h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m421.21,1737.75h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m430.34,1737.75h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m437.54,1735.56c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
        </g>
        <g id="likeability_copy_18" data-name="likeability copy 18">
          <line
            className="cls-1"
            x1="546.78"
            y1="1736.52"
            x2="546.78"
            y2="1777.5"
          />
          <circle
            id="QGISLike"
            className="cls-14 tooltip"
            cx="547.14"
            cy="1726.16"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m582.27,1790.25c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="525.08"
            y1="1790.53"
            x2="525.08"
            y2="1806.54"
          />
          <line
            className="cls-1"
            x1="551.32"
            y1="1778.54"
            x2="551.32"
            y2="1820.55"
          />
          <line
            className="cls-1"
            x1="556.24"
            y1="1780.32"
            x2="556.24"
            y2="1807.33"
          />
          <circle className="cls-18" cx="525.08" cy="1804.78" r="5.7" />
          <circle className="cls-11" cx="556.24" cy="1804.78" r="5.7" />
          <circle className="cls-12" cx="551.32" cy="1821.78" r="5.7" />
          <path
            className="cls-13"
            d="m550.65,1723.77h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m541.53,1739.96h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m550.66,1739.96h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m557.87,1737.16c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="flourish">
        <line
          className="cls-2"
          x1="971.47"
          y1="1556.25"
          x2="971.47"
          y2="1575.67"
        />
        <path
          id="flourishLeaf"
          className="cls-14 leaf"
          d="m975.47,1496.35c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m937.32,1533.23h-3.09v3.01h-2.25v-7.44h5.33v1.49h-3.09v1.44h3.09v1.5Z"
          />
          <path
            className="cls-13"
            d="m944.48,1536.24h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m953.13,1532.51c0,.7-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.88s.15-1.29.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.53,2.34-.53.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.17-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24s.51-.39.66-.68.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m962.28,1532.91c0,.64-.12,1.18-.36,1.63s-.55.8-.95,1.07c-.39.26-.81.45-1.27.56-.45.12-.91.17-1.36.17-.63,0-1.24-.11-1.84-.32-.6-.21-1.1-.58-1.5-1.1-.4-.52-.6-1.19-.6-2.01v-4.11h2.24v3.53c0,.49.07.9.21,1.22.14.32.34.56.59.7.25.15.55.22.89.22s.62-.07.88-.22c.25-.15.45-.38.59-.7.14-.32.21-.72.21-1.21v-3.54h2.25v4.11Z"
          />
          <path
            className="cls-13"
            d="m971.25,1536.24h-2.41l-.58-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18s.3-.35.3-.69Z"
          />
          <path className="cls-13" d="m974.52,1536.24h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m981.61,1534.08c0,.46-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.07-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51s-.47-.28-.84-.43c-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.2-.3-.29-.66-.29-1.08s.1-.76.3-1.09c.2-.32.5-.58.9-.78.4-.19.9-.29,1.48-.29.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.59s-.77-.26-1.2-.26c-.28,0-.48.05-.61.16-.12.11-.19.24-.19.4,0,.15.06.27.19.38.13.11.35.24.67.39.57.27,1.03.51,1.38.73s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
          <path
            className="cls-13"
            d="m991,1536.24h-2.24v-2.91h-3.38v2.91h-2.25v-7.44h2.25v2.73h3.38v-2.73h2.24v7.44Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m963.54,1560.16h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m972.16,1557.9c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m979.29,1557.9c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <circle className="cls-2" cx="971.47" cy="1575.77" r="2.49" />
        <path
          className="cls-2"
          d="m907.9,1595.46c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_17" data-name="frequency copy 17">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="911.95"
            y1="1618.94"
            x2="911.95"
            y2="1666.84"
          />
          <path
            className="cls-22"
            d="m945.23,1683.92c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="910.33"
            y1="1673.09"
            x2="910.33"
            y2="1711.1"
          />
          <line
            className="cls-1"
            x1="897.21"
            y1="1673.92"
            x2="897.21"
            y2="1690.93"
          />
          <line
            className="cls-1"
            x1="913.61"
            y1="1669.42"
            x2="913.61"
            y2="1695.43"
          />
          <circle className="cls-11" cx="913.61" cy="1695.43" r="5.7" />
          <circle className="cls-12" cx="910.33" cy="1712.43" r="5.7" />
          <circle className="cls-18" cx="897.21" cy="1695.43" r="5.7" />
          <circle
            id="flourishFreq"
            className="cls-14 tooltip"
            cx="912.78"
            cy="1613.45"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m916.06,1607.75h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m906.57,1626.59h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m915.19,1624.33c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m920.84,1626.59h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_17" data-name="likeability copy 17">
          <line
            className="cls-1"
            x1="1032.15"
            y1="1625.36"
            x2="1032.15"
            y2="1666.34"
          />
          <circle
            id="flourishLike"
            className="cls-14 tooltip"
            cx="1032.5"
            cy="1615"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m1061.61,1683.92c-.53-.33-1.24-.85-2.22-1.47-2.95-1.89-5.39-3.09-5.83-3.32-4.63-2.44-12.01-3.28-13.86-3.46-1.99-.2-8.92-.76-17.6,1.27-3.84.9-8.07,1.89-11.79,4.43-.94.64-5.37,4.01-6.92,5.49-.12.11-.5.5-1.29,1.16-.25.21-.67.42-1.19.47-.88.1-1.99-.11-2.22-.92-.32-1.14.27-1.79.72-2.39.5-.68,1.05-1.31,2.02-2.3,2.35-2.38,2.13-2.09,2.41-2.34,3.31-2.98,7.47-5.59,7.47-5.59,7.71-4.84,15.87-7.46,15.87-7.46,9.52-3.05,17.21-3.19,18.87-3.2,7.75-.07,13.3,1.4,17.01,2.38,0,0,4.05,1.07,9.14,3.96,1.87,1.06,3.36,2.08,4.37,3.94,1.09,1.99,1.05,3.85,1.04,4.23-.02.63-.19,3.13-2.08,5.08-1.65,1.71-3.47,2.25-5.23,2.5-.97.14-3.15.15-5.53-.73-1.42-.53-2.42-1.25-3.15-1.72Z"
          />
          <line
            className="cls-1"
            x1="1000.12"
            y1="1687.43"
            x2="1000.12"
            y2="1703.44"
          />
          <line
            className="cls-1"
            x1="1049.11"
            y1="1677.5"
            x2="1049.11"
            y2="1699.51"
          />
          <line
            className="cls-1"
            x1="1027.77"
            y1="1670.27"
            x2="1027.77"
            y2="1697.28"
          />
          <circle className="cls-18" cx="1000.12" cy="1698.15" r="5.7" />
          <circle className="cls-11" cx="1027.77" cy="1698.15" r="5.7" />
          <circle className="cls-12" cx="1049.11" cy="1698.15" r="5.7" />
          <path
            className="cls-13"
            d="m1036.01,1612.62h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m1026.89,1628.81h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m1036.02,1628.81h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m1043.22,1623.79c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="arcGIS">
        <line
          className="cls-2"
          x1="205.25"
          y1="1556.69"
          x2="205.25"
          y2="1576.1"
        />
        <path
          id="arcGISLeaf"
          className="cls-14 leaf"
          d="m209.24,1496.79c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05s2.19,10.73,2.84,11.64c2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m173.93,1536.67h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m182.13,1536.67h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m189.81,1536.11c-.31.16-.62.29-.95.39s-.65.17-.98.21c-.33.04-.67.06-1.02.06-.65,0-1.23-.09-1.74-.27-.51-.18-.96-.44-1.34-.79-.38-.35-.66-.76-.85-1.22-.19-.47-.28-.98-.28-1.54,0-.64.11-1.2.33-1.68s.53-.88.93-1.2c.4-.32.85-.55,1.36-.71.51-.15,1.05-.23,1.61-.23.85,0,1.8.19,2.87.56v1.98c-.37-.23-.73-.42-1.09-.57-.36-.15-.78-.23-1.27-.23-.43,0-.84.09-1.21.26s-.68.42-.91.74c-.23.32-.34.69-.34,1.12,0,.38.1.72.3,1.03s.48.56.83.75c.36.18.76.28,1.21.28.36,0,.7-.04,1.03-.13s.59-.19.81-.29c.22-.11.45-.23.68-.38v1.88Z"
          />
          <path
            className="cls-13"
            d="m198.34,1536.15c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15s.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76.35.19.78.29,1.28.29.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path className="cls-13" d="m202.36,1536.67h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m209.45,1534.51c0,.46-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.07-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51s-.47-.28-.84-.43c-.41-.17-.77-.36-1.07-.56s-.56-.46-.75-.76c-.19-.3-.29-.66-.29-1.08s.1-.76.3-1.09c.2-.32.5-.58.9-.78s.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.59-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16s-.19.24-.19.4c0,.15.06.27.19.38s.35.24.67.39c.57.27,1.03.51,1.38.73s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m197.31,1560.59h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m205.93,1558.34c0,.43-.08.79-.25,1.09s-.39.54-.67.73-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.36.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m213.06,1558.34c0,.43-.08.79-.25,1.09s-.39.54-.67.73-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.36.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <circle className="cls-2" cx="205.25" cy="1576.2" r="2.49" />
        <path
          className="cls-2"
          d="m141.67,1595.89c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_16" data-name="frequency copy 16">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="145.72"
            y1="1619.37"
            x2="145.72"
            y2="1667.28"
          />
          <path
            className="cls-22"
            d="m179.54,1682.01c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="141.2"
            y1="1673.25"
            x2="141.2"
            y2="1711.26"
          />
          <line className="cls-1" x1="133" y1="1674.48" x2="133" y2="1691.49" />
          <line
            className="cls-1"
            x1="150.22"
            y1="1669.98"
            x2="150.22"
            y2="1695.99"
          />
          <circle className="cls-11" cx="141.2" cy="1708.75" r="5.7" />
          <circle className="cls-12" cx="133" cy="1694.75" r="5.7" />
          <circle className="cls-18" cx="150.22" cy="1694.75" r="5.7" />
          <circle
            id="arcGISFreq"
            className="cls-14 tooltip"
            cx="146.56"
            cy="1613.89"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m149.83,1608.18h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m140.35,1627.02h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m148.96,1624.77c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m156.67,1622.97c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
            />
          </g>
        </g>
        <g id="likeability_copy_16" data-name="likeability copy 16">
          <line
            className="cls-1"
            x1="265.92"
            y1="1625.79"
            x2="265.92"
            y2="1666.77"
          />
          <circle
            id="arcGISLike"
            className="cls-14 tooltip"
            cx="266.27"
            cy="1615.44"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m301.39,1680.52c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="248.11"
            y1="1675.63"
            x2="248.11"
            y2="1691.64"
          />
          <line
            className="cls-1"
            x1="276.81"
            y1="1672.11"
            x2="276.81"
            y2="1694.12"
          />
          <line
            className="cls-1"
            x1="263.69"
            y1="1669.61"
            x2="263.69"
            y2="1696.62"
          />
          <circle className="cls-18" cx="248.11" cy="1694.12" r="5.7" />
          <circle className="cls-11" cx="276.81" cy="1694.12" r="5.7" />
          <circle className="cls-12" cx="263.69" cy="1694.12" r="5.7" />
          <path
            className="cls-13"
            d="m269.78,1613.05h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m260.67,1629.24h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m269.79,1629.24h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m276.99,1624.22c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="googleDataStudio">
        <line
          className="cls-2"
          x1="726.38"
          y1="1481.89"
          x2="726.38"
          y2="1501.31"
        />
        <path
          id="googleDataStudioLeaf"
          className="cls-14 leaf"
          d="m730.37,1421.99c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m699.55,1449.08c-.16.06-.3.11-.41.15s-.22.08-.33.11c-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.75,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28s-.58-1.29-.58-2.14c0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6s.68-.23,1.01-.28.69-.07,1.09-.07c.65,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.55.37-.39.25-.66.54-.81.88s-.23.67-.23.99c0,.38.09.72.26,1.04.17.32.44.57.79.76.35.19.78.29,1.28.29.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m709.28,1445.88c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39-.63.34-1.4.52-2.31.52s-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.34.35.82.53,1.42.53.41,0,.76-.08,1.05-.24s.51-.39.66-.68c.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m718.64,1445.88c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54-1.11-.83-1.42-1.41c-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.34.35.82.53,1.41.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m727.06,1449.08c-.16.06-.3.11-.41.15s-.22.08-.33.11-.26.07-.46.12c-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28s.69-.07,1.09-.07c.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.84-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76.36.19.78.29,1.28.29.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m734.48,1449.6h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m741.4,1449.6h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m700.18,1457.02c0,.76-.14,1.38-.42,1.84-.28.46-.6.84-.98,1.12-.53.42-1.28.63-2.24.63h-4.02v-7.44h3.09c.46,0,.86.02,1.2.07.33.05.63.12.89.2.26.09.49.19.68.3.19.11.35.23.5.35.25.21.48.45.67.74.19.28.34.61.46.98.11.37.17.78.17,1.21Zm-2.28-.1c0-.6-.12-1.08-.35-1.42-.23-.34-.51-.56-.83-.68-.32-.12-.66-.17-.99-.17h-.96v4.41h.96c.59,0,1.1-.14,1.53-.42s.64-.85.64-1.72Z"
          />
          <path
            className="cls-13"
            d="m709.27,1460.6h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m716.3,1454.97h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m724.83,1460.6h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m697.73,1469.44c0,.46-.12.87-.36,1.21s-.57.6-1,.78c-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.08-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51-.19-.14-.47-.28-.84-.43-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.19-.3-.29-.66-.29-1.08s.1-.76.29-1.09.5-.58.9-.78.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.59s-.77-.26-1.2-.26c-.28,0-.48.05-.61.16-.12.11-.19.24-.19.4,0,.15.06.27.19.38.13.11.35.24.67.39.57.27,1.03.51,1.38.72s.61.46.81.74.29.63.29,1.05Z"
          />
          <path
            className="cls-13"
            d="m706.4,1465.97h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m715.46,1468.27c0,.64-.12,1.18-.36,1.63-.24.45-.55.8-.95,1.07-.39.26-.81.45-1.27.56-.45.11-.91.17-1.36.17-.63,0-1.24-.11-1.84-.32-.6-.21-1.09-.58-1.5-1.1s-.6-1.19-.6-2.01v-4.11h2.24v3.53c0,.49.07.9.21,1.22.14.32.34.55.59.7.25.15.55.22.89.22s.62-.07.88-.22c.25-.15.45-.38.59-.7.14-.32.21-.72.21-1.21v-3.54h2.25v4.11Z"
          />
          <path
            className="cls-13"
            d="m724.88,1468.02c0,.76-.14,1.38-.42,1.84s-.6.84-.98,1.12c-.53.42-1.28.63-2.24.63h-4.02v-7.44h3.09c.47,0,.86.02,1.2.07.33.05.63.12.89.2.27.09.49.19.68.3.19.11.35.23.5.35.25.21.48.45.67.74.19.28.34.61.46.98.11.37.17.78.17,1.21Zm-2.28-.1c0-.6-.12-1.08-.35-1.42-.23-.34-.51-.56-.83-.68s-.65-.17-.99-.17h-.96v4.41h.96c.59,0,1.1-.14,1.53-.42s.64-.85.64-1.72Z"
          />
          <path className="cls-13" d="m728.52,1471.6h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m738.36,1467.88c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54-1.11-.83-1.42-1.41c-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.34.35.82.53,1.41.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m718.45,1485.8h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m727.07,1483.54c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m734.74,1484.04h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
          />
        </g>
        <circle className="cls-2" cx="726.38" cy="1501.4" r="2.49" />
        <path
          className="cls-2"
          d="m662.81,1521.1c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_15" data-name="frequency copy 15">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="666.85"
            y1="1544.58"
            x2="666.85"
            y2="1592.48"
          />
          <path
            className="cls-22"
            d="m689.54,1605.49c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="651.49"
            y1="1596.73"
            x2="651.49"
            y2="1634.74"
          />
          <line
            className="cls-1"
            x1="648.21"
            y1="1596.99"
            x2="648.21"
            y2="1614"
          />
          <line
            className="cls-1"
            x1="654.77"
            y1="1595.22"
            x2="654.77"
            y2="1621.23"
          />
          <circle className="cls-11" cx="654.77" cy="1623.66" r="5.7" />
          <circle className="cls-12" cx="651.49" cy="1633.66" r="5.7" />
          <circle className="cls-18" cx="648.21" cy="1616.66" r="5.7" />
          <circle
            id="googleDataStudioFreq"
            className="cls-14 tooltip"
            cx="667.69"
            cy="1539.09"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m670.96,1533.39h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m661.48,1552.23h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m670.1,1549.97c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.12-.9.12c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.46c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.29.12-.41c0-.25-.09-.46-.28-.65s-.43-.29-.74-.29c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.87.28.65.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m677.77,1550.48h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
          </g>
        </g>
        <g id="likeability_copy_15" data-name="likeability copy 15">
          <line
            className="cls-1"
            x1="787.05"
            y1="1551"
            x2="787.05"
            y2="1591.98"
          />
          <circle
            id="googleDataStudioLike"
            className="cls-14 tooltip"
            cx="787.4"
            cy="1540.64"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m820.24,1605.25c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="768.6"
            y1="1598.83"
            x2="768.6"
            y2="1614.84"
          />
          <line
            className="cls-1"
            x1="800.58"
            y1="1596.95"
            x2="800.58"
            y2="1618.96"
          />
          <line
            className="cls-1"
            x1="776.8"
            y1="1597.83"
            x2="776.8"
            y2="1624.84"
          />
          <circle className="cls-18" cx="768.6" cy="1618.45" r="5.7" />
          <circle className="cls-11" cx="800.58" cy="1618.45" r="5.7" />
          <circle className="cls-12" cx="776.8" cy="1628.45" r="5.7" />
          <path
            className="cls-13"
            d="m790.92,1538.25h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m781.8,1554.45h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m790.42,1552.19c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.12-.9.12c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.46c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.29.12-.41c0-.25-.09-.46-.28-.65s-.43-.29-.74-.29c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.87.28.65.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m797.55,1552.19c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.12-.9.12c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.46c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.29.12-.41c0-.25-.09-.46-.28-.65s-.43-.29-.74-.29c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.87.28.65.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="datawrapper">
        <line
          className="cls-2"
          x1="487.39"
          y1="1429.31"
          x2="487.39"
          y2="1448.73"
        />
        <path
          id="datawrapperLeaf"
          className="cls-14 leaf"
          d="m491.38,1369.41c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m455.45,1400.98c0,.76-.14,1.38-.42,1.84-.28.46-.6.84-.98,1.12-.53.42-1.28.63-2.24.63h-4.02v-7.44h3.09c.47,0,.86.02,1.2.07.33.05.63.12.89.2.27.09.49.19.68.3s.35.23.5.35c.25.21.48.45.67.74.19.28.34.61.46.98.11.37.17.78.17,1.21Zm-2.28-.1c0-.6-.12-1.08-.35-1.42-.23-.34-.51-.56-.83-.68-.32-.11-.65-.17-.99-.17h-.96v4.41h.96c.59,0,1.1-.14,1.53-.42s.64-.85.64-1.72Z"
          />
          <path
            className="cls-13"
            d="m464.54,1404.57h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m471.56,1398.94h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m480.1,1404.57h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m459.85,1408.13l-3.22,7.54h-1.3l-1.93-4.39-1.98,4.39h-1.31l-3.16-7.54h2.33l1.55,4.12,1.77-4.12h1.61l1.74,4.12,1.62-4.12h2.3Z"
          />
          <path
            className="cls-13"
            d="m468.09,1415.57h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m477.29,1415.57h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m484.72,1410.47c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m492.41,1410.47c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.64.33.86.56.21.23.36.48.46.75s.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.43-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m499.27,1415.57h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m507.98,1415.57h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m479.46,1433.22h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m488.08,1430.96c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m495.78,1428.2c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
          />
        </g>
        <circle className="cls-2" cx="487.39" cy="1448.83" r="2.49" />
        <path
          className="cls-2"
          d="m423.82,1468.52c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_14" data-name="frequency copy 14">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="427.86"
            y1="1492"
            x2="427.86"
            y2="1539.9"
          />
          <path
            className="cls-22"
            d="m460.28,1553.88c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="419.48"
            y1="1544.97"
            x2="419.48"
            y2="1571.97"
          />
          <line
            className="cls-1"
            x1="426.04"
            y1="1544.83"
            x2="426.04"
            y2="1557.84"
          />
          <line
            className="cls-1"
            x1="420.48"
            y1="1545.41"
            x2="420.48"
            y2="1571.42"
          />
          <circle className="cls-11" cx="426.04" cy="1554.94" r="5.7" />
          <circle className="cls-12" cx="420.3" cy="1571.94" r="5.7" />
          <circle className="cls-18" cx="419.48" cy="1561.94" r="5.7" />
          <circle
            id="datawrapperFreq"
            className="cls-14 tooltip"
            cx="428.7"
            cy="1486.51"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m431.97,1480.81h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m422.49,1499.65h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m431.11,1497.4c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m438.82,1497.47c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
        </g>
        <g id="likeability_copy_14" data-name="likeability copy 14">
          <line
            className="cls-1"
            x1="548.06"
            y1="1498.42"
            x2="548.06"
            y2="1539.4"
          />
          <circle
            id="datawrapperLike"
            className="cls-14 tooltip"
            cx="548.42"
            cy="1488.06"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m581.91,1552.89c-.54-.33-1.26-.85-2.25-1.47-2.99-1.89-5.47-3.09-5.92-3.32-4.7-2.44-12.2-3.28-14.08-3.46-2.02-.2-9.06-.76-17.87,1.27-3.9.9-8.19,1.89-11.98,4.43-.95.64-5.45,4.01-7.02,5.49-.12.11-.51.5-1.31,1.16-.26.21-.68.42-1.21.47-.89.1-2.02-.11-2.26-.92-.33-1.14.27-1.79.73-2.39.51-.68,1.06-1.31,2.05-2.3,2.38-2.38,2.17-2.09,2.44-2.34,3.36-2.98,7.59-5.59,7.59-5.59,7.82-4.84,16.11-7.46,16.11-7.46,9.67-3.05,17.47-3.19,19.16-3.2,7.87-.07,13.5,1.4,17.27,2.38,0,0,4.11,1.07,9.28,3.96,1.9,1.06,3.41,2.08,4.44,3.94,1.11,1.99,1.07,3.85,1.05,4.23-.02.63-.19,3.13-2.11,5.08-1.67,1.71-3.52,2.25-5.31,2.5-.98.14-3.2.15-5.62-.73-1.44-.53-2.46-1.25-3.2-1.72Z"
          />
          <line className="cls-1" x1="520" y1="1555.65" x2="520" y2="1565.66" />
          <line
            className="cls-1"
            x1="546.04"
            y1="1541.74"
            x2="546.04"
            y2="1563.75"
          />
          <line
            className="cls-1"
            x1="565.66"
            y1="1538.91"
            x2="565.66"
            y2="1562.92"
          />
          <circle className="cls-18" cx="520.73" cy="1565.73" r="5.7" />
          <circle className="cls-11" cx="546.4" cy="1565.73" r="5.7" />
          <circle className="cls-12" cx="565.66" cy="1565.73" r="5.7" />
          <path
            className="cls-13"
            d="m551.93,1485.68h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m542.81,1501.87h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m551.43,1499.61c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m558.64,1499.33c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="RAWGraphs">
        <line
          className="cls-2"
          x1="206.29"
          y1="1335.16"
          x2="206.29"
          y2="1354.58"
        />
        <path
          id="RAWGraphsLeaf"
          className="cls-14 leaf"
          d="m210.28,1275.26c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m174.9,1308.42h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m184.1,1308.42h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m196.52,1300.97l-3.22,7.54h-1.3l-1.93-4.39-1.98,4.39h-1.31l-3.16-7.54h2.33l1.55,4.12,1.77-4.12h1.61l1.74,4.12,1.62-4.12h2.3Z"
          />
          <path
            className="cls-13"
            d="m174.72,1318.89c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15s.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76.35.19.78.29,1.28.29.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m183.69,1319.42h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m192.89,1319.42h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m200.32,1314.32c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m209.43,1319.42h-2.24v-2.91h-3.38v2.91h-2.25v-7.44h2.25v2.73h3.38v-2.73h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m216.5,1317.25c0,.46-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.07-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51s-.47-.28-.84-.43c-.41-.17-.77-.36-1.07-.56s-.56-.46-.75-.76c-.19-.3-.29-.66-.29-1.08s.1-.76.3-1.09c.2-.32.5-.58.9-.78s.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.59-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16s-.19.24-.19.4c0,.15.06.27.19.38s.35.24.67.39c.57.27,1.03.51,1.38.73s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m198.36,1339.07h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m207.06,1336.52c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
          <path
            className="cls-13"
            d="m214.65,1337.31h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
          />
        </g>
        <circle className="cls-2" cx="206.29" cy="1354.67" r="2.49" />
        <path
          className="cls-2"
          d="m142.72,1374.37c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_13" data-name="frequency copy 13">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="146.76"
            y1="1397.85"
            x2="146.76"
            y2="1445.75"
          />
          <path
            className="cls-22"
            d="m179.27,1455.19c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="156.96"
            y1="1440.96"
            x2="156.96"
            y2="1467.97"
          />
          <line
            className="cls-1"
            x1="133.18"
            y1="1449.48"
            x2="133.18"
            y2="1468.49"
          />
          <line
            className="cls-1"
            x1="134.5"
            y1="1447.07"
            x2="134.5"
            y2="1473.08"
          />
          <circle className="cls-11" cx="156.96" cy="1468.67" r="5.7" />
          <circle className="cls-12" cx="134" cy="1478.67" r="5.7" />
          <circle className="cls-18" cx="133.18" cy="1468.67" r="5.7" />
          <circle
            id="RAWGraphsFreq"
            className="cls-14 tooltip"
            cx="147.6"
            cy="1392.36"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m150.87,1386.65h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m141.39,1405.5h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m150.09,1402.95c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m155.65,1405.5h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_13" data-name="likeability copy 13">
          <line
            className="cls-1"
            x1="266.96"
            y1="1404.27"
            x2="266.96"
            y2="1445.25"
          />
          <circle
            id="RAWGraphsLike"
            className="cls-14 tooltip"
            cx="267.32"
            cy="1393.91"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m303.1,1455.19c-.54-.33-1.26-.85-2.26-1.47-3-1.89-5.48-3.09-5.93-3.32-4.71-2.44-12.22-3.28-14.11-3.46-2.02-.2-9.08-.76-17.91,1.27-3.91.9-8.21,1.89-12,4.43-.95.64-5.46,4.01-7.04,5.49-.12.11-.51.5-1.31,1.16-.26.21-.68.42-1.21.47-.9.1-2.03-.11-2.26-.92-.33-1.14.27-1.79.73-2.39.51-.68,1.06-1.31,2.05-2.3,2.39-2.38,2.17-2.09,2.45-2.34,3.37-2.98,7.6-5.59,7.6-5.59,7.84-4.84,16.15-7.46,16.15-7.46,9.69-3.05,17.51-3.19,19.2-3.2,7.88-.07,13.53,1.4,17.31,2.38,0,0,4.12,1.07,9.3,3.96,1.9,1.06,3.42,2.08,4.45,3.94,1.11,1.99,1.07,3.85,1.05,4.23-.02.63-.19,3.13-2.11,5.08-1.68,1.71-3.53,2.25-5.32,2.5-.98.14-3.21.15-5.63-.73-1.45-.53-2.46-1.25-3.2-1.72Z"
          />
          <line
            className="cls-1"
            x1="241.96"
            y1="1457.96"
            x2="241.96"
            y2="1467.97"
          />
          <line
            className="cls-1"
            x1="288.59"
            y1="1446.96"
            x2="288.59"
            y2="1468.96"
          />
          <line
            className="cls-1"
            x1="265.28"
            y1="1445.96"
            x2="265.28"
            y2="1469.96"
          />
          <circle className="cls-18" cx="241.96" cy="1468.9" r="5.7" />
          <circle className="cls-11" cx="265.28" cy="1468.9" r="5.7" />
          <circle className="cls-12" cx="288.59" cy="1468.9" r="5.7" />
          <path
            className="cls-13"
            d="m270.83,1391.52h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m261.71,1407.71h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m270.87,1405.96h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
            <path
              className="cls-13"
              d="m278.04,1402.7c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="plotly">
        <line
          className="cls-2"
          x1="727.39"
          y1="1236.14"
          x2="727.39"
          y2="1255.56"
        />
        <path
          id="plotlyLeaf"
          className="cls-14 leaf"
          d="m731.38,1176.24c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05s2.19,10.73,2.84,11.64c2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m695.24,1211.3c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.64.33.86.56.21.23.36.48.46.75s.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.43-.26.09-.12.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m702.14,1216.4h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m710.78,1212.67c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.75.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38.82.53,1.42.53c.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m718.69,1210.77h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m725.65,1216.4h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m732.8,1208.96l-2.92,4.03v3.41h-2.25v-3.37l-2.97-4.08h2.33l1.71,2.34,1.71-2.34h2.38Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m719.46,1240.05h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m728.65,1237.86c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
          />
          <path
            className="cls-13"
            d="m735.71,1240.05h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
        </g>
        <circle className="cls-2" cx="727.39" cy="1255.66" r="2.49" />
        <path
          className="cls-2"
          d="m663.82,1275.35c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_12" data-name="frequency copy 12">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="667.86"
            y1="1298.83"
            x2="667.86"
            y2="1346.73"
          />
          <path
            className="cls-22"
            d="m700.6,1357.15c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="658.16"
            y1="1348.13"
            x2="658.16"
            y2="1375.14"
          />
          <line
            className="cls-1"
            x1="657.34"
            y1="1344.94"
            x2="657.34"
            y2="1363.95"
          />
          <line
            className="cls-1"
            x1="672.1"
            y1="1341.99"
            x2="672.1"
            y2="1368"
          />
          <circle className="cls-11" cx="672.1" cy="1366.67" r="5.7" />
          <circle className="cls-12" cx="658.16" cy="1375.67" r="5.7" />
          <circle className="cls-18" cx="657.34" cy="1366.67" r="5.7" />
          <circle
            id="plotlyFreq"
            className="cls-14 tooltip"
            cx="668.7"
            cy="1293.34"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m671.97,1287.64h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m662.49,1306.48h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m671.68,1304.3c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m676.75,1306.48h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_12" data-name="likeability copy 12">
          <line
            className="cls-1"
            x1="788.06"
            y1="1305.25"
            x2="788.06"
            y2="1346.23"
          />
          <circle
            id="plotlyLike"
            className="cls-14 tooltip"
            cx="788.41"
            cy="1294.89"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m819.8,1356.47c-.55-.33-1.28-.85-2.29-1.47-3.04-1.89-5.55-3.09-6.01-3.32-4.77-2.44-12.38-3.28-14.29-3.46-2.05-.2-9.2-.76-18.14,1.27-3.96.9-8.32,1.89-12.16,4.43-.97.64-5.53,4.01-7.13,5.49-.12.11-.52.5-1.33,1.16-.26.21-.69.42-1.22.47-.91.1-2.05-.11-2.29-.92-.33-1.14.28-1.79.74-2.39.51-.68,1.08-1.31,2.08-2.3,2.42-2.38,2.2-2.09,2.48-2.34,3.42-2.98,7.7-5.59,7.7-5.59,7.94-4.84,16.36-7.46,16.36-7.46,9.82-3.05,17.74-3.19,19.45-3.2,7.98-.07,13.71,1.4,17.53,2.38,0,0,4.17,1.07,9.42,3.96,1.93,1.06,3.46,2.08,4.51,3.94,1.12,1.99,1.08,3.85,1.07,4.23-.02.63-.19,3.13-2.14,5.08-1.7,1.71-3.58,2.25-5.39,2.5-1,.14-3.25.15-5.7-.73-1.47-.53-2.49-1.25-3.25-1.72Z"
          />
          <line
            className="cls-1"
            x1="758.93"
            y1="1359.95"
            x2="758.93"
            y2="1369.96"
          />
          <line
            className="cls-1"
            x1="791.51"
            y1="1344.44"
            x2="791.51"
            y2="1366.45"
          />
          <line
            className="cls-1"
            x1="794.76"
            y1="1346.73"
            x2="794.76"
            y2="1370.74"
          />
          <circle className="cls-18" cx="758.93" cy="1368.6" r="5.7" />
          <circle className="cls-11" cx="791.51" cy="1368.6" r="5.7" />
          <circle className="cls-21" cx="794.76" cy="1378.6" r="5.7" />
          <path
            className="cls-13"
            d="m791.93,1292.51h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m782.81,1308.7h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m792,1306.51c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.63-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.46-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.47-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m799.14,1304.64c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.77.53.78.7,1.31.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="figma">
        <line
          className="cls-2"
          x1="972.26"
          y1="1171.42"
          x2="972.26"
          y2="1190.84"
        />
        <path
          id="figmaLeaf"
          className="cls-14 leaf"
          d="m976.25,1111.52c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m939,1148.66h-3.09v3.01h-2.25v-7.44h5.33v1.49h-3.09v1.44h3.09v1.5Z"
          />
          <path className="cls-13" d="m942.76,1151.68h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m951.67,1151.15c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11s-.26.07-.46.12c-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.75,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.17.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m962.09,1151.68h-2.25v-4.31l-2.02,2.5h-.18l-2.03-2.5v4.31h-2.18v-7.44h2.04l2.29,2.79,2.3-2.79h2.04v7.44Z"
          />
          <path
            className="cls-13"
            d="m972.14,1151.68h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m966.32,1175.32h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
          <path
            className="cls-13"
            d="m973.49,1173.57h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
          />
          <path
            className="cls-13"
            d="m980.65,1170.31c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
          />
        </g>
        <circle className="cls-2" cx="972.26" cy="1190.93" r="2.49" />
        <path
          className="cls-2"
          d="m908.69,1210.62c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_11" data-name="frequency copy 11">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="912.73"
            y1="1234.11"
            x2="912.73"
            y2="1282.01"
          />
          <path
            className="cls-22"
            d="m941.24,1295.44c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="892.42"
            y1="1288.99"
            x2="892.42"
            y2="1306"
          />
          <line
            className="cls-1"
            x1="901.44"
            y1="1284.49"
            x2="901.44"
            y2="1308.5"
          />
          <line
            className="cls-1"
            x1="918.66"
            y1="1284.49"
            x2="918.66"
            y2="1310.5"
          />
          <circle className="cls-11" cx="901.44" cy="1307.21" r="5.7" />
          <circle className="cls-12" cx="918.66" cy="1307.21" r="5.7" />
          <circle className="cls-18" cx="892.42" cy="1307.21" r="5.7" />
          <circle
            id="figmaFreq"
            className="cls-14 tooltip"
            cx="913.57"
            cy="1228.62"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m916.85,1222.91h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m909.36,1241.76h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m916.52,1240h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
            <path
              className="cls-13"
              d="m923.2,1239.21c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
          </g>
        </g>
        <g id="likeability_copy_11" data-name="likeability copy 11">
          <line
            className="cls-1"
            x1="1032.93"
            y1="1240.53"
            x2="1032.93"
            y2="1281.51"
          />
          <circle
            id="figmaLike"
            className="cls-14 tooltip"
            cx="1033.29"
            cy="1230.17"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m1064,1295.44c-.55-.33-1.27-.85-2.27-1.47-3.02-1.89-5.52-3.09-5.97-3.32-4.74-2.44-12.32-3.28-14.21-3.46-2.04-.2-9.15-.76-18.05,1.27-3.94.9-8.27,1.89-12.09,4.43-.96.64-5.5,4.01-7.09,5.49-.12.11-.51.5-1.32,1.16-.26.21-.69.42-1.22.47-.9.1-2.04-.11-2.28-.92-.33-1.14.28-1.79.74-2.39.51-.68,1.07-1.31,2.07-2.3,2.41-2.38,2.19-2.09,2.47-2.34,3.4-2.98,7.66-5.59,7.66-5.59,7.9-4.84,16.27-7.46,16.27-7.46,9.76-3.05,17.64-3.19,19.35-3.2,7.94-.07,13.64,1.4,17.44,2.38,0,0,4.15,1.07,9.37,3.96,1.92,1.06,3.44,2.08,4.48,3.94,1.12,1.99,1.08,3.85,1.06,4.23-.02.63-.19,3.13-2.13,5.08-1.69,1.71-3.56,2.25-5.36,2.5-.99.14-3.23.15-5.67-.73-1.46-.53-2.48-1.25-3.23-1.72Z"
          />
          <line
            className="cls-1"
            x1="1003.02"
            y1="1298.71"
            x2="1003.02"
            y2="1308.72"
          />
          <line
            className="cls-1"
            x1="1032.18"
            y1="1286.71"
            x2="1032.18"
            y2="1308.72"
          />
          <line
            className="cls-1"
            x1="1045.14"
            y1="1279.01"
            x2="1045.14"
            y2="1303.02"
          />
          <circle className="cls-18" cx="1003.02" cy="1308.72" r="5.7" />
          <circle className="cls-11" cx="1032.18" cy="1308.72" r="5.7" />
          <circle className="cls-21" cx="1045.14" cy="1308.72" r="5.7" />
          <path
            className="cls-13"
            d="m1036.8,1227.78h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m1029.68,1243.97h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m1036.84,1242.22h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
            <path
              className="cls-13"
              d="m1043.52,1241.43c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="D3">
        <line
          className="cls-2"
          x1="514.24"
          y1="1097.89"
          x2="514.24"
          y2="1117.31"
        />
        <path
          className="cls-2"
          d="m450.67,1137.1c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <path
          id="D3Leaf"
          className="cls-14 leaf"
          d="m518.23,1037.99c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m483.3,1074.56c0,.76-.14,1.38-.42,1.84-.28.46-.6.84-.98,1.12-.53.42-1.28.63-2.24.63h-4.02v-7.44h3.09c.47,0,.86.02,1.2.07.33.05.63.12.89.2s.49.19.68.3c.19.11.35.23.5.35.25.21.48.45.67.74.19.28.34.61.46.98.11.37.17.78.17,1.21Zm-2.28-.1c0-.6-.12-1.08-.35-1.42-.23-.34-.51-.56-.83-.68-.32-.12-.65-.17-.99-.17h-.96v4.41h.96c.59,0,1.1-.14,1.53-.42s.64-.85.64-1.72Z"
          />
          <path
            className="cls-13"
            d="m489.39,1076.08c0,.39-.08.72-.23,1-.15.28-.36.5-.61.67-.25.17-.52.3-.8.38s-.56.12-.82.12c-.38,0-.79-.05-1.25-.16-.45-.11-.84-.23-1.14-.38v-1.67c.25.21.52.38.81.52s.59.21.9.21c.23,0,.43-.04.59-.13.16-.09.28-.19.36-.33.08-.13.12-.27.12-.42,0-.19-.05-.36-.15-.5s-.25-.26-.44-.35-.41-.13-.66-.13h-.24v-1.2h.28c.25,0,.46-.05.62-.14.16-.1.28-.21.35-.35.07-.13.11-.26.11-.38,0-.23-.09-.43-.26-.6-.17-.17-.4-.26-.67-.26-.25,0-.5.05-.77.14-.27.09-.52.22-.75.38v-1.43c.35-.15.68-.26.99-.35.31-.08.66-.13,1.04-.13.56,0,1.03.11,1.41.33.38.22.65.48.83.79.17.31.26.6.26.87,0,.22-.05.44-.14.67-.1.22-.22.42-.38.59-.16.17-.32.31-.49.4.3.16.56.38.79.66s.34.67.34,1.17Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m508.3,1101.8h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
          <path
            className="cls-13"
            d="m515.51,1098.99c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
          />
          <path
            className="cls-13"
            d="m522.64,1098.99c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
          />
        </g>
        <g id="frequency_copy_10" data-name="frequency copy 10">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="454.71"
            y1="1160.58"
            x2="454.71"
            y2="1208.48"
          />
          <path
            className="cls-22"
            d="m481.59,1222.62c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="435.06"
            y1="1216.88"
            x2="435.06"
            y2="1233.89"
          />
          <line
            className="cls-1"
            x1="440.8"
            y1="1214.33"
            x2="440.8"
            y2="1238.34"
          />
          <line
            className="cls-1"
            x1="455.56"
            y1="1212.38"
            x2="455.56"
            y2="1238.39"
          />
          <circle className="cls-11" cx="440.8" cy="1244.21" r="5.7" />
          <circle className="cls-12" cx="455.56" cy="1234.21" r="5.7" />
          <circle className="cls-18" cx="435.06" cy="1234.21" r="5.7" />
          <circle
            id="D3Freq"
            className="cls-14 tooltip"
            cx="455.55"
            cy="1155.09"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m458.82,1149.38h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m451.33,1168.23h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m458.54,1165.42c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
            <path
              className="cls-13"
              d="m465.63,1166.48h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
          </g>
        </g>
        <g id="likeability_copy_10" data-name="likeability copy 10">
          <line
            className="cls-1"
            x1="574.91"
            y1="1161"
            x2="574.91"
            y2="1202.98"
          />
          <circle
            id="D3Like"
            className="cls-14 tooltip"
            cx="575.26"
            cy="1156.64"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m601.46,1221.8c-.54-.33-1.27-.85-2.27-1.47-3.01-1.89-5.51-3.09-5.96-3.32-4.73-2.44-12.28-3.28-14.17-3.46-2.03-.2-9.12-.76-17.99,1.27-3.92.9-8.25,1.89-12.05,4.43-.96.64-5.48,4.01-7.07,5.49-.12.11-.51.5-1.32,1.16-.26.21-.68.42-1.21.47-.9.1-2.04-.11-2.27-.92-.33-1.14.28-1.79.73-2.39.51-.68,1.07-1.31,2.06-2.3,2.4-2.38,2.18-2.09,2.46-2.34,3.39-2.98,7.64-5.59,7.64-5.59,7.88-4.84,16.22-7.46,16.22-7.46,9.74-3.05,17.59-3.19,19.29-3.2,7.92-.07,13.59,1.4,17.39,2.38,0,0,4.14,1.07,9.35,3.96,1.91,1.06,3.43,2.08,4.47,3.94,1.11,1.99,1.07,3.85,1.06,4.23-.02.63-.19,3.13-2.12,5.08-1.68,1.71-3.55,2.25-5.35,2.5-.99.14-3.22.15-5.66-.73-1.45-.53-2.47-1.25-3.22-1.72Z"
          />
          <line
            className="cls-1"
            x1="540.42"
            y1="1224.07"
            x2="540.42"
            y2="1234.08"
          />
          <line
            className="cls-1"
            x1="587.26"
            y1="1208.48"
            x2="587.26"
            y2="1230.49"
          />
          <line
            className="cls-1"
            x1="564.65"
            y1="1206.33"
            x2="564.65"
            y2="1230.34"
          />
          <circle className="cls-18" cx="540.42" cy="1234.2" r="5.7" />
          <circle className="cls-11" cx="564.65" cy="1234.2" r="5.7" />
          <circle className="cls-21" cx="587.26" cy="1234.2" r="5.7" />
          <path
            className="cls-13"
            d="m578.78,1154.25h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m571.65,1170.44h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m578.36,1167.9c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m585.98,1168.26c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
        <circle className="cls-2" cx="514.24" cy="1117.4" r="2.49" />
      </g>
      <g id="python">
        <line
          className="cls-2"
          x1="284.93"
          y1="1014.3"
          x2="284.93"
          y2="1033.72"
        />
        <path
          id="pythonLeaf"
          className="cls-14 leaf"
          d="m288.92,954.4c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m252.78,989.46c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.12.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m261.28,987.12l-2.92,4.03v3.41h-2.25v-3.37l-2.97-4.08h2.33l1.71,2.34,1.71-2.34h2.38Z"
          />
          <path
            className="cls-13"
            d="m269.42,988.93h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m278.6,994.56h-2.24v-2.91h-3.38v2.91h-2.25v-7.44h2.25v2.73h3.38v-2.73h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m288.43,990.83c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.31.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31.54.2.98.48,1.33.83.35.35.61.75.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.34.35.82.53,1.42.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m297.75,994.56h-2l-3.86-4.15v4.15h-2.22v-7.44h1.99l3.85,4.12v-4.12h2.24v7.44Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m278.48,1015.95c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path className="cls-13" d="m284.12,1018.21h-2.22v-8.12h2.22v8.12Z" />
          <path
            className="cls-13"
            d="m292.83,1015.67c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
        </g>
        <circle className="cls-2" cx="284.93" cy="1033.81" r="2.49" />
        <path
          className="cls-2"
          d="m221.36,1053.51c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_9" data-name="frequency copy 9">
          <line
            className="cls-1"
            x1="419.12"
            y1="843.7"
            x2="419.12"
            y2="866.35"
          />
          <line
            className="cls-1"
            x1="225.4"
            y1="1076.99"
            x2="225.4"
            y2="1124.89"
          />
          <path
            className="cls-22"
            d="m259.09,1136.15c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="208.55"
            y1="1129.53"
            x2="208.55"
            y2="1144.54"
          />
          <line
            className="cls-1"
            x1="233.15"
            y1="1126.03"
            x2="233.15"
            y2="1148.04"
          />
          <line
            className="cls-1"
            x1="221.54"
            y1="1125.03"
            x2="221.54"
            y2="1149.04"
          />
          <circle className="cls-11" cx="221.67" cy="1148.84" r="5.7" />
          <circle className="cls-12" cx="233.15" cy="1148.65" r="5.7" />
          <circle className="cls-18" cx="208.55" cy="1148.65" r="5.7" />
          <circle
            id="pythonFreq"
            className="cls-14 tooltip"
            cx="226.24"
            cy="1071.5"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m229.51,1065.8h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m221.52,1082.38c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m227.16,1084.64h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m235.86,1082.1c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
          </g>
        </g>
        <g id="likeability_copy_9" data-name="likeability copy 9">
          <line
            className="cls-1"
            x1="345.6"
            y1="1077.41"
            x2="345.6"
            y2="1119.39"
          />
          <circle
            id="pythonLike"
            className="cls-14 tooltip"
            cx="345.95"
            cy="1073.05"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m376.19,1136.15c-.55-.33-1.28-.85-2.29-1.47-3.05-1.89-5.57-3.09-6.03-3.32-4.79-2.44-12.43-3.28-14.35-3.46-2.05-.2-9.23-.76-18.22,1.27-3.97.9-8.35,1.89-12.2,4.43-.97.64-5.55,4.01-7.16,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.06-.11-2.3-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.08-1.31,2.09-2.3,2.43-2.38,2.21-2.09,2.49-2.34,3.43-2.98,7.73-5.59,7.73-5.59,7.97-4.84,16.42-7.46,16.42-7.46,9.86-3.05,17.81-3.19,19.53-3.2,8.02-.07,13.76,1.4,17.6,2.38,0,0,4.19,1.07,9.46,3.96,1.94,1.06,3.47,2.08,4.53,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.15,5.08-1.71,1.71-3.59,2.25-5.41,2.5-1,.14-3.26.15-5.73-.73-1.47-.53-2.5-1.25-3.26-1.72Z"
          />
          <line
            className="cls-1"
            x1="318.21"
            y1="1135.74"
            x2="318.21"
            y2="1145.75"
          />
          <line
            className="cls-1"
            x1="344.38"
            y1="1126.79"
            x2="344.38"
            y2="1148.8"
          />
          <line
            className="cls-1"
            x1="354.19"
            y1="1125.09"
            x2="354.19"
            y2="1149.1"
          />
          <circle className="cls-18" cx="318.21" cy="1148.8" r="5.7" />
          <circle className="cls-11" cx="344.38" cy="1148.8" r="5.7" />
          <circle className="cls-21" cx="354.19" cy="1148.8" r="5.7" />
          <path
            className="cls-13"
            d="m349.47,1070.67h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m341.84,1084.6c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m347.48,1086.86h-2.22v-8.12h2.22v8.12Z"
            />
            <path
              className="cls-13"
              d="m356.1,1084.6c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="GGPlot2">
        <path
          className="cls-2"
          d="m605.04,914.85c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_8" data-name="frequency copy 8">
          <line
            className="cls-1"
            x1="611.08"
            y1="938.34"
            x2="611.08"
            y2="986.24"
          />
          <path
            className="cls-22"
            d="m639.59,997.5c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="589.07"
            y1="992.03"
            x2="589.07"
            y2="1007.04"
          />
          <line
            className="cls-1"
            x1="598.79"
            y1="989.53"
            x2="598.79"
            y2="1011.54"
          />
          <line
            className="cls-1"
            x1="616.31"
            y1="985.01"
            x2="616.31"
            y2="1009.02"
          />
          <circle className="cls-11" cx="598.79" cy="1016.97" r="5.7" />
          <circle className="cls-12" cx="616.31" cy="1010.97" r="5.7" />
          <circle className="cls-18" cx="589.77" cy="1010.97" r="5.7" />
          <circle
            id="GGPlot2Freq"
            className="cls-14 tooltip"
            cx="611.92"
            cy="932.85"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m615.19,927.14h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m607.2,943.73c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.12-.9.12c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.46c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.29.12-.41c0-.25-.1-.46-.29-.65s-.43-.29-.73-.29c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.12.12,1.54.36s.71.53.9.87.29.65.29.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m614.83,945.98h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.72.49.96.87.35.82.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m621.54,943.44c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.96.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.43.24-.65c0-.18-.05-.36-.14-.52s-.26-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.79.33,1.24Z"
            />
          </g>
        </g>
        <g id="likeability_copy_8" data-name="likeability copy 8">
          <line
            className="cls-1"
            x1="731.28"
            y1="938.76"
            x2="731.28"
            y2="980.73"
          />
          <circle
            id="GGPlot2Like"
            className="cls-14 tooltip"
            cx="731.63"
            cy="934.4"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m762.56,997.5c-.54-.33-1.26-.85-2.25-1.47-2.99-1.89-5.46-3.09-5.91-3.32-4.69-2.44-12.18-3.28-14.06-3.46-2.01-.2-9.05-.76-17.86,1.27-3.89.9-8.18,1.89-11.96,4.43-.95.64-5.44,4.01-7.02,5.49-.12.11-.51.5-1.31,1.16-.26.21-.68.42-1.2.47-.89.1-2.02-.11-2.26-.92-.33-1.14.27-1.79.73-2.39.51-.68,1.06-1.31,2.05-2.3,2.38-2.38,2.16-2.09,2.44-2.34,3.36-2.98,7.58-5.59,7.58-5.59,7.82-4.84,16.1-7.46,16.1-7.46,9.66-3.05,17.46-3.19,19.14-3.2,7.86-.07,13.49,1.4,17.25,2.38,0,0,4.11,1.07,9.27,3.96,1.9,1.06,3.4,2.08,4.44,3.94,1.11,1.99,1.06,3.85,1.05,4.23-.02.63-.19,3.13-2.11,5.08-1.67,1.71-3.52,2.25-5.31,2.5-.98.14-3.2.15-5.61-.73-1.44-.53-2.45-1.25-3.19-1.72Z"
          />
          <line
            className="cls-1"
            x1="701.36"
            y1="998.38"
            x2="701.36"
            y2="1008.39"
          />
          <line
            className="cls-1"
            x1="749.44"
            y1="988.53"
            x2="749.44"
            y2="1010.54"
          />
          <line
            className="cls-1"
            x1="726.2"
            y1="986.08"
            x2="726.2"
            y2="1010.09"
          />
          <circle className="cls-18" cx="701.36" cy="1012.08" r="5.7" />
          <circle className="cls-11" cx="726.2" cy="1012.08" r="5.7" />
          <circle className="cls-21" cx="749.44" cy="1012.08" r="5.7" />
          <path
            className="cls-13"
            d="m735.14,932.01h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m727.52,945.95c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m735.15,948.2h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m742.28,948.2h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
        <line
          className="cls-2"
          x1="665.61"
          y1="875.65"
          x2="665.61"
          y2="895.07"
        />
        <circle className="cls-2" cx="665.61" cy="895.16" r="2.49" />
        <path
          id="GGPlot2Leaf"
          className="cls-14 leaf"
          d="m670.6,815.75c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m635.03,855.38c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.75,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.53.5-.95.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49s-.85-.2-1.41-.2c-.65,0-1.17.12-1.56.37-.39.24-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.17.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m643.82,855.38c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.75,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.53.5-.95.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49s-.85-.2-1.41-.2c-.65,0-1.17.12-1.56.37-.39.24-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.17.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m652.03,850.8c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.45h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.36-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path className="cls-13" d="m654.99,855.91h-1.94v-7.45h1.94v7.45Z" />
          <path
            className="cls-13"
            d="m662.21,853.17c0,.54-.12,1.03-.35,1.46s-.59.76-1.06,1.01c-.47.25-1.04.37-1.72.37s-1.25-.12-1.72-.37-.82-.58-1.06-1.01c-.23-.43-.35-.91-.35-1.46,0-.41.07-.79.2-1.12s.33-.63.6-.89c.27-.26.6-.46.99-.6.39-.14.84-.21,1.35-.21s.97.07,1.37.21c.4.14.72.34.98.59.26.25.46.55.59.89.13.34.2.72.2,1.13Zm-2.04,0c0-.43-.09-.77-.28-1.02-.19-.25-.46-.37-.82-.37s-.63.12-.81.37c-.19.25-.28.58-.28,1.02s.09.77.28,1.02c.19.25.46.38.81.38s.63-.12.82-.37c.19-.25.28-.59.28-1.02Z"
          />
          <path
            className="cls-13"
            d="m667.53,855.59c-.2.1-.48.19-.83.28s-.69.13-1.01.13c-1.39,0-2.09-.68-2.09-2.04v-2.18h-.88v-.34l2.59-2.64h.22v1.64h1.85v1.34h-1.85v1.75c0,.21.01.37.04.49.02.13.1.23.21.31s.29.13.53.13c.31,0,.71-.13,1.21-.39v1.51Z"
          />
          <path
            className="cls-13"
            d="m673.86,855.91h-5.66v-.15c.22-.21.46-.46.72-.76.26-.29.6-.68,1.01-1.17.19-.22.37-.43.53-.64.17-.21.31-.42.43-.62s.22-.42.3-.66c.08-.24.12-.48.12-.74,0-.34-.1-.62-.3-.83-.2-.21-.45-.32-.76-.32-.61,0-1.21.32-1.82.95v-1.76c.21-.14.38-.25.52-.33.14-.08.29-.16.47-.24.18-.08.39-.15.63-.2.24-.06.51-.09.79-.09.46,0,.87.09,1.24.28.37.18.67.45.88.8.21.35.32.76.32,1.22,0,.33-.05.64-.14.92s-.2.52-.3.69c-.1.17-.24.39-.41.65-.31.46-.64.9-.99,1.31h2.41v1.67Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m660.16,877.3c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m667.8,879.55h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
          />
          <path
            className="cls-13"
            d="m674.51,877.01c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
        </g>
      </g>
      <g id="penAndPaper">
        <line
          className="cls-2"
          x1="131.49"
          y1="817.61"
          x2="131.49"
          y2="837.03"
        />
        <path
          id="penAndPaperLeaf"
          className="cls-14 leaf"
          d="m135.48,757.71c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m101.34,786.76c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m108.19,791.87h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m117.78,791.87h-2l-3.86-4.15v4.15h-2.22v-7.44h1.99l3.85,4.12v-4.12h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m130.37,791.87h-2.53l-.48-.49c-.31.21-.66.36-1.06.45-.4.09-.8.14-1.2.14-.85,0-1.49-.19-1.94-.56s-.67-.83-.67-1.35c0-.38.11-.71.34-1s.66-.66,1.31-1.1c-.19-.2-.34-.38-.46-.56-.12-.18-.21-.35-.27-.52-.06-.17-.09-.35-.09-.53,0-.35.1-.69.3-1s.49-.56.88-.74.84-.28,1.36-.28c.38,0,.73.06,1.03.18s.55.27.74.45.33.38.43.6c.09.21.14.42.14.61,0,.38-.13.73-.39,1.06-.26.33-.61.6-1.05.82l1,1.07c.31-.28.59-.64.83-1.07h1.79c-.46.88-.99,1.59-1.61,2.15l1.61,1.68Zm-3.99-1.54l-1.31-1.38c-.48.3-.71.6-.71.9,0,.17.08.35.25.53s.42.27.74.27c.39,0,.73-.11,1.03-.33Zm.31-4.12c0-.1-.03-.2-.08-.3-.05-.1-.14-.18-.26-.25-.12-.07-.27-.1-.44-.1-.25,0-.43.06-.55.19-.12.13-.18.26-.18.41,0,.1.03.2.1.3.06.1.15.21.26.33.11.12.22.23.32.34.55-.24.83-.55.83-.92Z"
          />
          <path
            className="cls-13"
            d="m101.34,797.76c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m109.81,802.87h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m117.24,797.76c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m124.1,802.87h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m132.82,802.87h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43c-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m125.04,819.26c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m132.17,819.26c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m139.3,819.26c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <circle className="cls-2" cx="131.49" cy="837.12" r="2.49" />
        <path
          className="cls-2"
          d="m67.92,856.81c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_7" data-name="frequency copy 7">
          <line
            className="cls-1"
            x1="72.35"
            y1="871.21"
            x2="72.35"
            y2="919.11"
          />
          <path
            className="cls-22"
            d="m102.87,936.38c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="45.67"
            y1="933.98"
            x2="45.67"
            y2="948.99"
          />
          <line
            className="cls-1"
            x1="59.61"
            y1="929.97"
            x2="59.61"
            y2="951.98"
          />
          <line
            className="cls-1"
            x1="80.93"
            y1="925.97"
            x2="80.93"
            y2="949.98"
          />
          <circle className="cls-11" cx="59.61" cy="952.39" r="5.7" />
          <circle className="cls-12" cx="80.93" cy="952.39" r="5.7" />
          <circle className="cls-18" cx="45.67" cy="952.39" r="5.7" />
          <circle
            id="penAndPaperFreq"
            className="cls-14 tooltip"
            cx="72.8"
            cy="874.81"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m76.01,869.1h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m68.08,885.69c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m75.21,885.69c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m82.91,883.89c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
            />
          </g>
        </g>
        <g id="likeability_copy_7" data-name="likeability copy 7">
          <line
            className="cls-1"
            x1="192.16"
            y1="880.72"
            x2="192.16"
            y2="922.69"
          />
          <circle
            id="penAndPaperLike"
            className="cls-14 tooltip"
            cx="192.51"
            cy="876.36"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m217.14,936.91c-.53-.33-1.23-.85-2.21-1.47-2.93-1.89-5.36-3.09-5.8-3.32-4.6-2.44-11.95-3.28-13.8-3.46-1.98-.2-8.88-.76-17.52,1.27-3.82.9-8.03,1.89-11.74,4.43-.93.64-5.34,4.01-6.88,5.49-.11.11-.5.5-1.28,1.16-.25.21-.67.42-1.18.47-.88.1-1.98-.11-2.21-.92-.32-1.14.27-1.79.71-2.39.5-.68,1.04-1.31,2.01-2.3,2.34-2.38,2.12-2.09,2.39-2.34,3.3-2.98,7.43-5.59,7.43-5.59,7.67-4.84,15.79-7.46,15.79-7.46,9.48-3.05,17.12-3.19,18.78-3.2,7.71-.07,13.23,1.4,16.93,2.38,0,0,4.03,1.07,9.1,3.96,1.86,1.06,3.34,2.08,4.35,3.94,1.08,1.99,1.04,3.85,1.03,4.23-.02.63-.19,3.13-2.07,5.08-1.64,1.71-3.45,2.25-5.21,2.5-.96.14-3.14.15-5.51-.73-1.42-.53-2.41-1.25-3.13-1.72Z"
          />
          <line
            className="cls-1"
            x1="155.55"
            y1="940.97"
            x2="155.55"
            y2="950.98"
          />
          <line
            className="cls-1"
            x1="213.36"
            y1="931.49"
            x2="213.36"
            y2="953.5"
          />
          <line
            className="cls-1"
            x1="172.06"
            y1="929.49"
            x2="172.06"
            y2="953.5"
          />
          <circle className="cls-18" cx="155.55" cy="952.98" r="5.7" />
          <circle className="cls-11" cx="172.06" cy="952.98" r="5.7" />
          <circle className="cls-21" cx="212.94" cy="952.98" r="5.7" />
          <path
            className="cls-13"
            d="m196.03,873.97h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m188.4,887.91c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m196.03,890.16h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m203.2,888.41h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="Illustrator">
        <line
          className="cls-2"
          x1="1069.11"
          y1="820.84"
          x2="1069.11"
          y2="840.25"
        />
        <path
          id="illustratorLeaf"
          className="cls-14 leaf"
          d="m1074.1,757.94c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m1040.69,793.09h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m1049.33,789.51c0,.76-.14,1.38-.42,1.84s-.6.84-.98,1.12c-.53.42-1.28.63-2.24.63h-4.02v-7.44h3.09c.46,0,.86.02,1.2.07.33.05.63.12.89.2.27.09.49.19.68.3.19.11.35.23.5.35.25.21.48.45.67.74.19.28.34.61.46.98.11.37.17.78.17,1.21Zm-2.28-.1c0-.61-.12-1.08-.35-1.42-.23-.34-.51-.57-.83-.68-.32-.12-.66-.17-.99-.17h-.96v4.41h.96c.59,0,1.1-.14,1.53-.42s.64-.85.64-1.72Z"
          />
          <path
            className="cls-13"
            d="m1058.68,789.37c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.75.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38.82.53,1.42.53c.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m1066.88,790.98c0,.64-.22,1.15-.66,1.54-.44.38-1.05.58-1.84.58h-4.3v-7.44h3.6c.46,0,.87.04,1.22.13.34.09.62.21.83.37.21.16.37.34.47.55.1.21.16.44.16.69,0,.27-.05.52-.16.75-.11.23-.24.42-.4.57-.16.15-.32.25-.48.31.51.2.9.45,1.16.76.27.31.4.7.4,1.19Zm-2.62-3.19c0-.36-.12-.6-.35-.71s-.61-.18-1.11-.18h-.47v1.78h.48c.51,0,.88-.06,1.11-.18.23-.12.34-.36.34-.71Zm.37,3.1c0-.64-.46-.96-1.39-.96h-.91v1.91h.91c.92,0,1.39-.32,1.39-.95Z"
          />
          <path
            className="cls-13"
            d="m1073.93,793.09h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path className="cls-13" d="m1034.77,804.09h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m1042.31,804.09h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m1049.27,804.09h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m1057.7,800.76c0,.64-.12,1.18-.36,1.63-.24.45-.55.8-.95,1.07-.39.26-.81.45-1.27.56-.45.11-.9.17-1.36.17-.63,0-1.24-.11-1.84-.32-.6-.21-1.09-.58-1.5-1.1-.4-.52-.6-1.19-.6-2.01v-4.11h2.24v3.53c0,.49.07.9.21,1.22s.34.55.59.7c.25.15.55.22.89.22s.62-.07.88-.22c.25-.15.45-.38.59-.7.14-.32.21-.72.21-1.21v-3.54h2.25v4.11Z"
          />
          <path
            className="cls-13"
            d="m1064.67,801.93c0,.47-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.08-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51-.19-.14-.47-.28-.84-.43-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.19-.3-.29-.66-.29-1.08s.1-.76.29-1.09c.2-.32.5-.58.9-.78.41-.19.9-.29,1.48-.29.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.58-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16-.13.11-.19.24-.19.4,0,.15.06.27.19.38.12.11.35.24.67.39.57.27,1.03.51,1.38.72s.61.46.81.74.29.63.29,1.05Z"
          />
          <path
            className="cls-13"
            d="m1073.33,798.46h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m1074.99,803.04c0,.32-.11.6-.33.82-.22.22-.49.34-.81.34s-.59-.11-.82-.34c-.23-.23-.34-.5-.34-.82s.12-.59.34-.82c.23-.22.5-.34.82-.34.2,0,.39.05.57.16.18.1.32.24.42.42.1.18.15.37.15.58Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m1063.67,819.49c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m1070.8,819.49c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m1077.93,819.49c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <circle className="cls-2" cx="1069.11" cy="840.35" r="2.49" />
        <path
          className="cls-2"
          d="m1005.54,860.04c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_6" data-name="frequency copy 6">
          <line
            className="cls-1"
            x1="996.35"
            y1="928.64"
            x2="996.35"
            y2="955.29"
          />
          <line
            className="cls-1"
            x1="982.58"
            y1="937.64"
            x2="982.58"
            y2="955.29"
          />
          <line
            className="cls-1"
            x1="1019.84"
            y1="928.89"
            x2="1019.84"
            y2="955.03"
          />
          <line
            className="cls-1"
            x1="1009.98"
            y1="874.44"
            x2="1009.98"
            y2="922.34"
          />
          <circle className="cls-11" cx="996.35" cy="952.43" r="5.7" />
          <path
            className="cls-22"
            d="m1036.52,940.12c-.55-.33-1.27-.85-2.27-1.47-3.02-1.89-5.52-3.09-5.97-3.32-4.74-2.44-12.31-3.28-14.21-3.46-2.03-.2-9.14-.76-18.04,1.27-3.93.9-8.27,1.89-12.09,4.43-.96.64-5.5,4.01-7.09,5.49-.12.11-.51.5-1.32,1.16-.26.21-.69.42-1.22.47-.9.1-2.04-.11-2.28-.92-.33-1.14.28-1.79.74-2.39.51-.68,1.07-1.31,2.07-2.3,2.41-2.38,2.19-2.09,2.47-2.34,3.4-2.98,7.66-5.59,7.66-5.59,7.9-4.84,16.27-7.46,16.27-7.46,9.76-3.05,17.64-3.19,19.34-3.2,7.94-.07,13.63,1.4,17.43,2.38,0,0,4.15,1.07,9.37,3.96,1.92,1.06,3.44,2.08,4.48,3.94,1.12,1.99,1.08,3.85,1.06,4.23-.02.63-.19,3.13-2.13,5.08-1.69,1.71-3.56,2.25-5.36,2.5-.99.14-3.23.15-5.67-.73-1.46-.53-2.48-1.25-3.23-1.72Z"
          />
          <circle className="cls-12" cx="1019.84" cy="952.43" r="5.7" />
          <circle className="cls-18" cx="982.58" cy="952.43" r="5.7" />
          <circle
            id="illustratorFreq"
            className="cls-14 tooltip"
            cx="1010.42"
            cy="878.04"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m1013.64,872.33h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m1005.7,888.92c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m1012.83,888.92c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m1018.47,891.17h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_6" data-name="likeability copy 6">
          <line
            className="cls-1"
            x1="1129.78"
            y1="883.94"
            x2="1129.78"
            y2="925.92"
          />
          <circle
            id="illustratorLike"
            className="cls-14 tooltip"
            cx="1130.14"
            cy="879.59"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m1155.88,940.87c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="1096.61"
            y1="939.45"
            x2="1096.61"
            y2="949.46"
          />
          <line
            className="cls-1"
            x1="1117.11"
            y1="926.63"
            x2="1117.11"
            y2="948.64"
          />
          <line
            className="cls-1"
            x1="1140.07"
            y1="928.64"
            x2="1140.07"
            y2="952.65"
          />
          <circle className="cls-18" cx="1096.61" cy="953.16" r="5.7" />
          <circle className="cls-11" cx="1117.11" cy="953.16" r="5.7" />
          <circle className="cls-21" cx="1140.07" cy="953.15" r="5.7" />
          <path
            className="cls-13"
            d="m1133.65,877.2h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m1126.02,891.13c0,.43-.08.79-.25,1.09s-.39.55-.66.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.3-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.44-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m1133.65,893.39h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.46-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.32-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m1140.87,890.58c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.38-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.46-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.36-.44.11-.34.11-.5Z"
            />
          </g>
          <path
            className="cls-6"
            d="m461.35,454.2l3.39,5.8c1.74-1.07,3.49-2.14,5.23-3.2"
          />
        </g>
      </g>
      <g id="GoogleSheets">
        <path
          className="cls-2"
          d="m435.67,769.29c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <line
          className="cls-2"
          x1="498.24"
          y1="730.08"
          x2="498.24"
          y2="749.5"
        />
        <path
          id="googlesheetsLeaf"
          className="cls-14 leaf"
          d="m506.23,670.18c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m469.54,703.15c-.16.06-.3.11-.41.15-.11.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28-.38-.58-.58-1.29-.58-2.14,0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6.35-.14.68-.23,1.01-.28.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.85-.2-1.41-.2-.65,0-1.17.12-1.56.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m479.27,699.94c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.31.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31.54.2.98.48,1.33.83.35.35.61.75.79,1.22s.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4s-.52-.14-.83-.14c-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m488.63,699.94c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.31.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31.54.2.98.48,1.33.83.35.35.61.75.79,1.22s.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4s-.52-.14-.83-.14c-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m497.05,703.15c-.16.06-.3.11-.41.15-.12.04-.22.08-.33.11-.11.03-.26.07-.46.12-.34.08-.68.14-1.02.18-.34.04-.7.06-1.07.06-.76,0-1.45-.14-2.09-.41-.64-.28-1.15-.7-1.54-1.28s-.58-1.29-.58-2.14c0-.54.1-1.08.3-1.6.2-.52.5-.94.91-1.26.34-.26.68-.46,1.02-.6s.68-.23,1.01-.28c.33-.05.69-.07,1.09-.07.66,0,1.2.05,1.62.15.43.1.89.23,1.4.39v1.76c-.34-.2-.69-.36-1.07-.49-.38-.13-.84-.2-1.41-.2-.65,0-1.17.12-1.55.37-.39.25-.66.54-.81.88-.15.34-.23.67-.23.99,0,.38.09.72.26,1.04.18.32.44.57.79.76s.78.29,1.28.29c.29,0,.59-.04.91-.11v-.88h-1.01v-1.5h2.97v3.58Z"
          />
          <path
            className="cls-13"
            d="m504.47,703.67h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m511.39,703.67h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m467.72,712.51c0,.47-.12.87-.36,1.21-.24.34-.57.6-1,.78s-.92.27-1.47.27c-.15,0-.34,0-.57-.03-.22-.02-.52-.08-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51-.19-.14-.47-.28-.84-.43-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.19-.3-.29-.66-.29-1.08s.1-.76.3-1.09.5-.58.9-.78.9-.29,1.48-.29c.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.58-.37-.17-.77-.26-1.2-.26-.28,0-.48.05-.61.16s-.19.24-.19.4c0,.15.06.27.19.38s.35.24.67.39c.57.27,1.03.51,1.38.72s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
          <path
            className="cls-13"
            d="m477.11,714.67h-2.24v-2.91h-3.38v2.91h-2.25v-7.44h2.25v2.73h3.38v-2.73h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m484.59,714.67h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m491.71,714.67h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m500.35,709.04h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m506.87,712.51c0,.47-.12.87-.36,1.21-.24.34-.57.6-1,.78-.43.18-.92.27-1.47.27-.15,0-.34,0-.57-.03-.22-.02-.52-.08-.89-.16-.37-.09-.76-.22-1.16-.4v-1.83c.38.23.75.43,1.11.58.36.15.75.23,1.17.23.38,0,.63-.06.74-.19.11-.13.17-.25.17-.36,0-.2-.1-.37-.29-.51-.19-.14-.47-.28-.84-.43-.41-.17-.77-.36-1.07-.56-.31-.2-.56-.46-.75-.76-.2-.3-.29-.66-.29-1.08s.1-.76.3-1.09c.2-.32.5-.58.9-.78.4-.19.9-.29,1.48-.29.42,0,.8.04,1.15.12.35.08.64.17.87.27.23.1.39.18.47.24v1.75c-.3-.22-.64-.41-1.02-.58s-.77-.26-1.2-.26c-.28,0-.48.05-.61.16-.12.11-.19.24-.19.4,0,.15.06.27.19.38.13.11.35.24.67.39.57.27,1.03.51,1.38.72s.61.46.81.74c.19.28.29.63.29,1.05Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m495.8,731.73c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m503.47,726.1l-3.47,7.99-1.89-.6,2.48-5.83h-3.29v-1.8h6.16v.23Z"
          />
          <path
            className="cls-13"
            d="m510.63,729.93c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
          />
        </g>
        <g id="frequency_copy_5" data-name="frequency copy 5">
          <line
            className="cls-1"
            x1="439.4"
            y1="836.61"
            x2="439.4"
            y2="863.26"
          />
          <line
            className="cls-1"
            x1="434.7"
            y1="840.54"
            x2="434.7"
            y2="866.68"
          />
          <line
            className="cls-1"
            x1="440.11"
            y1="783.69"
            x2="440.11"
            y2="831.59"
          />
          <circle className="cls-11" cx="434.7" cy="870.85" r="5.7" />
          <path
            className="cls-22"
            d="m469.35,849.81c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <circle className="cls-12" cx="439.62" cy="860.85" r="5.7" />
          <circle className="cls-18" cx="419.12" cy="860.85" r="5.7" />
          <circle
            id="googlesheetsFreq"
            className="cls-14 tooltip"
            cx="440.55"
            cy="787.28"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m443.77,781.58h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m435.83,798.17c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m443.55,797.61c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
            <path
              className="cls-13"
              d="m450.17,797.88c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
          </g>
        </g>
        <g id="likeability_copy_5" data-name="likeability copy 5">
          <line
            className="cls-1"
            x1="559.91"
            y1="793.19"
            x2="559.91"
            y2="835.17"
          />
          <circle
            id="googlesheetsLike"
            className="cls-14 tooltip"
            cx="560.26"
            cy="788.83"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m584.31,851.81c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="533.3"
            y1="843.88"
            x2="533.3"
            y2="857.88"
          />
          <line
            className="cls-1"
            x1="544.3"
            y1="837.88"
            x2="544.3"
            y2="859.88"
          />
          <line className="cls-1" x1="562" y1="838.98" x2="562" y2="862.99" />
          <circle className="cls-18" cx="533.3" cy="861.4" r="5.7" />
          <circle className="cls-11" cx="562" cy="861.4" r="5.7" />
          <circle className="cls-21" cx="543.96" cy="861.4" r="5.7" />
          <path
            className="cls-13"
            d="m563.78,786.45h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m556.15,800.38c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m563.36,800.09c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m570.99,800.45c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
        </g>
        <circle className="cls-2" cx="499.24" cy="749.6" r="2.49" />
      </g>
      <g id="R">
        <path
          id="RLeaf"
          className="cls-14 leaf"
          d="m839.34,621.82c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <path
          className="cls-13"
          d="m802.84,661.31h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06-.17-.22-.34-.37-.5-.43-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.12,1.51.38.39.25.68.55.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.3.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
        />
        <g>
          <path
            className="cls-13"
            d="m828.91,683.37c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m836.58,677.74l-3.47,7.99-1.89-.6,2.48-5.83h-3.29v-1.8h6.16v.23Z"
          />
          <path
            className="cls-13"
            d="m843.17,683.37c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <g id="frequency_copy_4" data-name="frequency copy 4">
          <line
            className="cls-1"
            x1="781.74"
            y1="785.14"
            x2="781.74"
            y2="811.8"
          />
          <line
            className="cls-1"
            x1="755.5"
            y1="793.73"
            x2="755.5"
            y2="809.87"
          />
          <line
            className="cls-1"
            x1="765.34"
            y1="787.14"
            x2="765.34"
            y2="809.8"
          />
          <line
            className="cls-1"
            x1="776.22"
            y1="736.32"
            x2="776.22"
            y2="784.22"
          />
          <circle className="cls-11" cx="765.34" cy="812.56" r="5.7" />
          <path
            className="cls-22"
            d="m805.97,798.65c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <circle className="cls-12" cx="781.74" cy="812.56" r="5.7" />
          <circle className="cls-18" cx="755.5" cy="812.56" r="5.7" />
          <circle
            id="RFreq"
            className="cls-14 tooltip"
            cx="776.66"
            cy="739.92"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m779.88,734.21h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m771.94,750.8c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m779.61,745.17l-3.47,7.99-1.89-.6,2.48-5.83h-3.29v-1.8h6.16v.23Z"
            />
            <path
              className="cls-13"
              d="m784.71,753.06h-2.22v-8.12h2.22v8.12Z"
            />
          </g>
        </g>
        <g id="likeability_copy_4" data-name="likeability copy 4">
          <line
            className="cls-1"
            x1="895.02"
            y1="745.83"
            x2="895.02"
            y2="784.81"
          />
          <circle
            id="RLike"
            className="cls-14 tooltip"
            cx="896.38"
            cy="741.47"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m920.21,800.98c-.54-.33-1.27-.85-2.27-1.47-3.01-1.89-5.51-3.09-5.96-3.32-4.73-2.44-12.28-3.28-14.18-3.46-2.03-.2-9.12-.76-18,1.27-3.93.9-8.25,1.89-12.06,4.43-.96.64-5.49,4.01-7.07,5.49-.12.11-.51.5-1.32,1.16-.26.21-.68.42-1.21.47-.9.1-2.04-.11-2.27-.92-.33-1.14.28-1.79.73-2.39.51-.68,1.07-1.31,2.06-2.3,2.4-2.38,2.18-2.09,2.46-2.34,3.39-2.98,7.64-5.59,7.64-5.59,7.88-4.84,16.23-7.46,16.23-7.46,9.74-3.05,17.6-3.19,19.3-3.2,7.92-.07,13.6,1.4,17.4,2.38,0,0,4.14,1.07,9.35,3.96,1.91,1.06,3.43,2.08,4.47,3.94,1.11,1.99,1.07,3.85,1.06,4.23-.02.63-.19,3.13-2.13,5.08-1.69,1.71-3.55,2.25-5.35,2.5-.99.14-3.23.15-5.66-.73-1.45-.53-2.48-1.25-3.22-1.72Z"
          />
          <line
            className="cls-1"
            x1="859.18"
            y1="802.22"
            x2="859.18"
            y2="812.23"
          />
          <line
            className="cls-1"
            x1="879.97"
            y1="791.57"
            x2="879.97"
            y2="813.58"
          />
          <line
            className="cls-1"
            x1="907.66"
            y1="790.22"
            x2="907.66"
            y2="814.23"
          />
          <circle className="cls-18" cx="859.18" cy="812.56" r="5.7" />
          <circle className="cls-11" cx="879.38" cy="812.56" r="5.7" />
          <circle className="cls-21" cx="907.66" cy="812.56" r="5.7" />
          <path
            className="cls-13"
            d="m899.89,739.08h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m892.26,753.02c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m899.98,752.47c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
            <path
              className="cls-13"
              d="m907.06,747.39l-3.47,7.99-1.89-.6,2.48-5.83h-3.29v-1.8h6.16v.23Z"
            />
          </g>
        </g>
        <circle className="cls-2" cx="835.35" cy="702.23" r="2.49" />
        <path
          className="cls-2"
          d="m771.78,721.92c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
      </g>
      <g id="powerBI">
        <line className="cls-2" x1="238.2" y1="601.23" x2="238.2" y2="620.65" />
        <path
          className="cls-14 leaf"
          id="powerBILeaf"
          d="m255.19,541.33c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m217.92,575.72c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74s-.5.41-.86.55c-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.12.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m227.13,577.09c0,.69-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.31.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.87s.15-1.3.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.54,2.34-.54.69,0,1.3.1,1.84.31.54.2.98.48,1.33.83.35.35.61.75.79,1.22s.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4s-.52-.14-.83-.14c-.6,0-1.07.18-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24.29-.16.51-.39.66-.68.15-.29.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m240.43,573.38l-3.22,7.54h-1.3l-1.93-4.39-1.98,4.39h-1.31l-3.16-7.54h2.33l1.55,4.12,1.77-4.12h1.61l1.74,4.12,1.62-4.12h2.3Z"
          />
          <path
            className="cls-13"
            d="m247.08,580.82h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m255.79,580.82h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06-.17-.22-.34-.37-.5-.43-.16-.06-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.12,1.51.38.39.25.68.55.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.3.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m263.61,578.71c0,.64-.22,1.15-.66,1.54-.44.38-1.05.58-1.84.58h-4.3v-7.44h3.6c.47,0,.87.04,1.22.13.35.09.62.21.83.37.21.16.37.34.47.55.1.21.16.44.16.69,0,.27-.05.52-.16.75-.11.23-.24.42-.4.57-.16.15-.32.25-.48.31.51.2.9.45,1.16.76.27.31.4.7.4,1.19Zm-2.62-3.19c0-.36-.12-.6-.35-.71s-.6-.18-1.11-.18h-.47v1.78h.48c.51,0,.88-.06,1.11-.18.23-.12.34-.36.34-.71Zm.37,3.1c0-.64-.46-.96-1.39-.96h-.91v1.91h.91c.92,0,1.39-.32,1.39-.95Z"
          />
          <path className="cls-13" d="m267.3,580.82h-2.25v-7.44h2.25v7.44Z" />
        </g>
        <g>
          <path
            className="cls-13"
            d="m244.75,602.88c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
          <path
            className="cls-13"
            d="m252.46,602.95c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
          />
          <path
            className="cls-13"
            d="m259.59,602.95c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
          />
        </g>
        <circle className="cls-2" cx="238.2" cy="620.75" r="2.49" />
        <path
          className="cls-2"
          d="m174.63,640.44c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy_3" data-name="frequency copy 3">
          <line
            className="cls-1"
            x1="166.66"
            y1="706.56"
            x2="166.66"
            y2="733.21"
          />
          <line
            className="cls-1"
            x1="152.72"
            y1="711.81"
            x2="152.72"
            y2="727.96"
          />
          <line
            className="cls-1"
            x1="179.07"
            y1="654.84"
            x2="179.07"
            y2="698.74"
          />
          <circle className="cls-11" cx="166.66" cy="731.71" r="5.7" />
          <path
            className="cls-22"
            d="m205.82,715.29c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="183.8"
            y1="706.99"
            x2="183.8"
            y2="729.64"
          />
          <circle className="cls-12" cx="183.8" cy="731.71" r="5.7" />
          <circle className="cls-18" cx="152.72" cy="731.71" r="5.7" />
          <circle
            id="powerBIFreq"
            className="cls-14 tooltip"
            cx="179.51"
            cy="658.43"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m182.73,652.73h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m174.79,669.31c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m182.49,669.38c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m189.64,668.76c0,.38-.07.74-.22,1.09s-.36.66-.64.94-.61.49-1,.65-.81.23-1.28.23c-.68,0-1.26-.15-1.75-.45s-.85-.69-1.1-1.18-.37-1.02-.37-1.58c0-.46.08-.92.23-1.38s.37-.92.67-1.37.63-.87,1.02-1.27.83-.77,1.33-1.12l2,.66c-.32.27-.6.52-.83.75s-.46.46-.67.7-.4.49-.57.74c.15-.04.33-.06.54-.06.48,0,.92.11,1.32.33s.72.53.96.93.36.86.36,1.38Zm-2.11-.04c0-.38-.1-.65-.31-.83s-.45-.27-.74-.27c-.37,0-.64.12-.82.35s-.26.48-.26.74c0,.31.1.58.3.8s.45.33.74.33c.25,0,.46-.06.62-.18s.28-.27.35-.44.11-.34.11-.5Z"
            />
          </g>
        </g>
        <g id="likeability_copy_3" data-name="likeability copy 3">
          <line
            className="cls-1"
            x1="297.87"
            y1="664.34"
            x2="297.87"
            y2="700.32"
          />
          <circle
            id="powerBILike"
            className="cls-14 tooltip"
            cx="299.22"
            cy="659.98"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m327.7,719.08c-.55-.33-1.29-.85-2.3-1.47-3.05-1.89-5.58-3.09-6.04-3.32-4.79-2.44-12.45-3.28-14.36-3.46-2.06-.2-9.24-.76-18.24,1.27-3.98.9-8.36,1.89-12.22,4.43-.97.64-5.56,4.01-7.17,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.06-.11-2.3-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.08-1.31,2.09-2.3,2.43-2.38,2.21-2.09,2.49-2.34,3.43-2.98,7.74-5.59,7.74-5.59,7.98-4.84,16.44-7.46,16.44-7.46,9.87-3.05,17.83-3.19,19.55-3.2,8.03-.07,13.78,1.4,17.62,2.38,0,0,4.19,1.07,9.47,3.96,1.94,1.06,3.48,2.08,4.53,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.15,5.08-1.71,1.71-3.6,2.25-5.42,2.5-1,.14-3.27.15-5.73-.73-1.47-.53-2.51-1.25-3.26-1.72Z"
          />
          <line
            className="cls-1"
            x1="271.52"
            y1="717.15"
            x2="271.52"
            y2="735.16"
          />
          <line
            className="cls-1"
            x1="294.44"
            y1="709.31"
            x2="294.44"
            y2="731.32"
          />
          <line
            className="cls-1"
            x1="303.49"
            y1="709.31"
            x2="303.49"
            y2="729.32"
          />
          <circle className="cls-18" cx="271.52" cy="734.76" r="5.7" />
          <circle className="cls-11" cx="294.44" cy="734.76" r="5.7" />
          <circle className="cls-21" cx="303.49" cy="734.76" r="5.7" />
          <path
            className="cls-13"
            d="m302.74,657.6h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m294.11,671.53c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m301.81,671.6c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m308.37,671.53c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
          </g>
        </g>
      </g>
      <g id="powerpoint">
        <path
          className="cls-2"
          d="m604.82,569.29c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <path
          id="powerpointLeaf"
          className="cls-14 leaf"
          d="m672.38,470.19c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m636.11,499.57c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m645.32,500.95c0,.7-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.88s.15-1.29.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.53,2.34-.53.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.17-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24s.51-.39.66-.68.23-.62.23-.99Z"
          />
          <path
            className="cls-13"
            d="m658.62,497.23l-3.22,7.54h-1.3l-1.93-4.39-1.98,4.39h-1.31l-3.16-7.54h2.33l1.55,4.12,1.77-4.12h1.61l1.74,4.12,1.62-4.12h2.3Z"
          />
          <path
            className="cls-13"
            d="m665.26,504.68h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m673.98,504.68h-2.41l-.59-1.32c-.21-.48-.41-.84-.58-1.06s-.34-.37-.5-.43-.37-.09-.63-.09h-.25v2.91h-2.25v-7.44h3.82c.62,0,1.12.13,1.51.38.39.25.68.56.85.91.17.36.26.7.26,1.02,0,.38-.07.69-.22.95-.14.26-.3.45-.46.57s-.34.23-.54.34c.24.14.44.31.59.5.16.19.37.58.64,1.16l.75,1.62Zm-3.05-5.09c0-.34-.11-.58-.34-.72-.23-.14-.59-.2-1.1-.2h-.47v1.79h.48c.55,0,.92-.06,1.12-.18.2-.12.3-.35.3-.69Z"
          />
          <path
            className="cls-13"
            d="m636.11,510.57c0,.28-.05.54-.14.81-.09.26-.25.51-.46.74-.21.23-.5.41-.86.55-.36.14-.78.21-1.27.21h-1.47v2.79h-2.25v-7.44h3.72c.49,0,.91.07,1.27.21.36.14.65.33.86.56.21.23.36.48.46.75.1.27.14.54.14.82Zm-2.29.01c0-.35-.1-.6-.31-.73-.21-.13-.58-.2-1.12-.2h-.47v1.79h.48c.37,0,.66-.02.86-.07.2-.05.35-.13.44-.26.09-.13.13-.31.13-.54Z"
          />
          <path
            className="cls-13"
            d="m645.32,511.95c0,.7-.16,1.33-.48,1.92-.32.58-.8,1.05-1.43,1.39s-1.41.52-2.32.52-1.7-.18-2.34-.54c-.64-.36-1.11-.83-1.42-1.41-.31-.58-.46-1.21-.46-1.88s.15-1.29.46-1.88c.31-.58.78-1.05,1.42-1.41.64-.36,1.42-.53,2.34-.53.69,0,1.3.1,1.84.31s.98.48,1.33.83c.35.35.61.76.79,1.22.18.46.27.95.27,1.46Zm-2.29,0c0-.28-.04-.53-.12-.77-.08-.23-.21-.43-.37-.6-.17-.17-.37-.3-.61-.4-.24-.09-.52-.14-.83-.14-.6,0-1.07.17-1.42.53-.34.35-.52.81-.52,1.38s.17,1.03.52,1.38c.35.35.82.53,1.42.53.41,0,.76-.08,1.05-.24s.51-.39.66-.68.23-.62.23-.99Z"
          />
          <path className="cls-13" d="m648.97,515.68h-2.25v-7.44h2.25v7.44Z" />
          <path
            className="cls-13"
            d="m658.94,515.68h-2l-3.86-4.15v4.15h-2.22v-7.44h1.99l3.85,4.12v-4.12h2.24v7.44Z"
          />
          <path
            className="cls-13"
            d="m667.94,510.04h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m662.03,531.45c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
          <path
            className="cls-13"
            d="m669.16,531.45c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
          <path className="cls-13" d="m674.72,533.99h-2.22v-8.12h2.22v8.12Z" />
        </g>
        <g id="frequency_copy_2" data-name="frequency copy 2">
          <line
            className="cls-1"
            x1="600.7"
            y1="635.17"
            x2="600.7"
            y2="661.83"
          />
          <line
            className="cls-1"
            x1="582.17"
            y1="641.34"
            x2="582.17"
            y2="657.48"
          />
          <line
            className="cls-1"
            x1="609.26"
            y1="582.69"
            x2="609.26"
            y2="626.59"
          />
          <circle className="cls-11" cx="600.7" cy="658.78" r="5.7" />
          <path
            className="cls-22"
            d="m637.48,644.31c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="622.1"
            y1="637.08"
            x2="622.1"
            y2="653.73"
          />
          <circle className="cls-12" cx="622.1" cy="658.78" r="5.7" />
          <circle className="cls-18" cx="582.17" cy="658.78" r="5.7" />
          <circle
            id="powerpointFreq"
            className="cls-14 tooltip"
            cx="609.7"
            cy="586.29"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m612.92,580.58h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m604.06,596.88c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m611.65,597.67h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
            <path
              className="cls-13"
              d="m618.81,594.41c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
            />
          </g>
        </g>
        <g id="likeability_copy_2" data-name="likeability copy 2">
          <line
            className="cls-1"
            x1="728.06"
            y1="592.2"
            x2="728.06"
            y2="628.18"
          />
          <circle
            id="powerpointLike"
            className="cls-14 tooltip"
            cx="729.41"
            cy="587.84"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m759.16,644.58c-.55-.33-1.28-.85-2.29-1.47-3.04-1.89-5.55-3.09-6.01-3.32-4.77-2.44-12.38-3.28-14.29-3.46-2.05-.2-9.2-.76-18.14,1.27-3.96.9-8.32,1.89-12.16,4.43-.97.64-5.53,4.01-7.13,5.49-.12.11-.52.5-1.33,1.16-.26.21-.69.42-1.22.47-.91.1-2.05-.11-2.29-.92-.33-1.14.28-1.79.74-2.39.51-.68,1.08-1.31,2.08-2.3,2.42-2.38,2.2-2.09,2.48-2.34,3.42-2.98,7.7-5.59,7.7-5.59,7.94-4.84,16.36-7.46,16.36-7.46,9.82-3.05,17.74-3.19,19.45-3.2,7.98-.07,13.71,1.4,17.53,2.38,0,0,4.17,1.07,9.42,3.96,1.93,1.06,3.46,2.08,4.51,3.94,1.12,1.99,1.08,3.85,1.07,4.23-.02.63-.19,3.13-2.14,5.08-1.7,1.71-3.58,2.25-5.39,2.5-1,.14-3.25.15-5.7-.73-1.47-.53-2.49-1.25-3.25-1.72Z"
          />
          <line
            className="cls-1"
            x1="719.21"
            y1="636.4"
            x2="719.21"
            y2="654.41"
          />
          <line
            className="cls-1"
            x1="709.43"
            y1="639.5"
            x2="709.43"
            y2="657.51"
          />
          <line
            className="cls-1"
            x1="737.12"
            y1="634.83"
            x2="737.12"
            y2="654.84"
          />
          <circle className="cls-18" cx="709.43" cy="658.78" r="5.7" />
          <circle className="cls-11" cx="737.12" cy="658.78" r="5.7" />
          <circle className="cls-21" cx="719.21" cy="658.78" r="5.7" />
          <path
            className="cls-13"
            d="m732.93,585.45h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m724.38,599.1c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m731.97,599.89h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
            <path
              className="cls-13"
              d="m739.1,599.89h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
            />
          </g>
        </g>
        <circle className="cls-2" cx="668.39" cy="549.6" r="2.49" />
      </g>
      <g id="tableau">
        <line
          className="cls-2"
          x1="391.11"
          y1="441.16"
          x2="391.11"
          y2="454.58"
        />
        <path
          className="cls-14 leaf"
          id="tableauLeaf"
          d="m396.1,375.26c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m359.52,409.12h-2.73v5.63h-2.24v-5.63h-2.73v-1.81h7.7v1.81Z"
          />
          <path
            className="cls-13"
            d="m368.06,414.75h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m375.85,412.64c0,.64-.22,1.15-.66,1.54-.44.38-1.05.57-1.84.57h-4.3v-7.44h3.6c.47,0,.87.04,1.22.13.35.09.62.21.83.37.21.16.37.34.47.55.1.21.16.44.16.69,0,.27-.05.52-.16.75-.11.23-.24.42-.4.57-.16.15-.32.25-.48.31.51.2.9.45,1.16.76.27.31.4.7.4,1.19Zm-2.62-3.19c0-.36-.12-.6-.35-.71s-.6-.18-1.11-.18h-.47v1.78h.48c.51,0,.88-.06,1.11-.18.23-.12.34-.36.34-.71Zm.37,3.1c0-.64-.46-.96-1.39-.96h-.91v1.91h.91c.92,0,1.39-.32,1.39-.95Z"
          />
          <path
            className="cls-13"
            d="m382.95,414.75h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
          <path
            className="cls-13"
            d="m389.86,414.75h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m399.54,414.75h-2.3l-.61-1.51h-3.23l-.62,1.51h-2.3l3.29-7.44h2.48l3.28,7.44Zm-3.42-2.8l-1.09-2.72-1.1,2.72h2.19Z"
          />
          <path
            className="cls-13"
            d="m407.97,411.42c0,.64-.12,1.18-.36,1.63-.24.45-.55.8-.95,1.07-.39.26-.81.45-1.27.56-.45.12-.9.17-1.36.17-.63,0-1.24-.11-1.84-.32-.6-.21-1.1-.58-1.5-1.1s-.6-1.19-.6-2.01v-4.11h2.24v3.53c0,.49.07.9.21,1.22.14.32.34.56.59.7.25.15.55.22.89.22s.62-.07.88-.22c.25-.15.45-.38.59-.7.14-.32.21-.72.21-1.21v-3.54h2.25v4.11Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m385.75,436.53c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
          />
          <path
            className="cls-13"
            d="m393.37,434.05c0,.61-.13,1.23-.4,1.84s-.64,1.2-1.13,1.76-1.06,1.07-1.71,1.53l-2-.66c.93-.79,1.62-1.53,2.06-2.2-.14.04-.32.06-.54.06-.48,0-.91-.11-1.31-.33s-.72-.53-.96-.93-.36-.86-.36-1.37c0-.38.07-.74.22-1.08s.36-.66.64-.94.62-.5,1-.66.81-.23,1.27-.23c.52,0,.98.09,1.39.26s.75.42,1.02.72.47.65.61,1.03.21.78.21,1.2Zm-2.12-.26c0-.32-.1-.59-.29-.81s-.45-.33-.75-.33c-.25,0-.46.06-.62.18s-.28.27-.35.45-.11.34-.11.5c0,.37.1.65.31.82s.45.27.73.27c.26,0,.47-.06.63-.18s.27-.26.34-.43.1-.32.1-.48Z"
          />
          <path
            className="cls-13"
            d="m400.5,435.02c0,.7-.08,1.32-.25,1.85s-.4.97-.69,1.3-.63.59-1.01.76-.78.25-1.21.25-.83-.08-1.21-.25-.71-.42-1.01-.76-.52-.77-.69-1.3-.25-1.14-.25-1.85.08-1.33.25-1.86.4-.96.69-1.31.63-.6,1.01-.76.78-.25,1.21-.25.83.08,1.21.25.71.42,1.01.76.53.78.7,1.32.25,1.15.25,1.85Zm-2.31,0c0-.72-.05-1.31-.15-1.77s-.33-.69-.71-.69c-.25,0-.44.13-.57.39s-.21.55-.23.89-.04.73-.04,1.18c0,.77.05,1.37.14,1.8s.33.64.71.64.62-.21.71-.64.14-1.03.14-1.8Z"
          />
        </g>
        <circle className="cls-2" cx="391.11" cy="454.68" r="2.49" />
        <path
          className="cls-2"
          d="m327.54,474.37c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency_copy" data-name="frequency copy">
          <line
            className="cls-1"
            x1="307.43"
            y1="540.62"
            x2="307.43"
            y2="567.27"
          />
          <line
            className="cls-1"
            x1="300.96"
            y1="540.62"
            x2="300.96"
            y2="556.76"
          />
          <line
            className="cls-1"
            x1="329.98"
            y1="488.77"
            x2="329.98"
            y2="526.67"
          />
          <circle className="cls-11" cx="307.43" cy="570.28" r="5.7" />
          <path
            className="cls-22"
            d="m354.21,546.03c-.55-.33-1.28-.85-2.29-1.47-3.04-1.89-5.55-3.09-6.01-3.32-4.77-2.44-12.38-3.28-14.29-3.46-2.05-.2-9.2-.76-18.15,1.27-3.96.9-8.32,1.89-12.16,4.43-.97.64-5.53,4.01-7.13,5.49-.12.11-.52.5-1.33,1.16-.26.21-.69.42-1.22.47-.91.1-2.05-.11-2.29-.92-.33-1.14.28-1.79.74-2.39.51-.68,1.08-1.31,2.08-2.3,2.42-2.38,2.2-2.09,2.48-2.34,3.42-2.98,7.7-5.59,7.7-5.59,7.94-4.84,16.36-7.46,16.36-7.46,9.82-3.05,17.74-3.19,19.45-3.2,7.99-.07,13.71,1.4,17.54,2.38,0,0,4.17,1.07,9.43,3.96,1.93,1.06,3.46,2.08,4.51,3.94,1.12,1.99,1.08,3.85,1.07,4.23-.02.63-.19,3.13-2.14,5.08-1.7,1.71-3.58,2.25-5.39,2.5-1,.14-3.25.15-5.7-.73-1.47-.53-2.49-1.25-3.25-1.72Z"
          />
          <line
            className="cls-1"
            x1="341.27"
            y1="538.5"
            x2="341.27"
            y2="555.16"
          />
          <circle className="cls-12" cx="341.27" cy="556.98" r="5.7" />
          <circle className="cls-18" cx="300.96" cy="556.98" r="5.7" />
          <circle
            id="tableauFreq"
            className="cls-14 tooltip"
            cx="332.42"
            cy="492.36"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m335.64,486.66h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m326.78,502.96c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m334.4,503.32c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m341.53,503.32c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
        </g>
        <g id="likeability_copy" data-name="likeability copy">
          <line
            className="cls-1"
            x1="450.78"
            y1="498.27"
            x2="450.78"
            y2="531.25"
          />
          <circle
            id="tableauLike"
            className="cls-14 tooltip"
            cx="452.13"
            cy="493.91"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m472.07,550.89c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="462.44"
            y1="544.57"
            x2="462.44"
            y2="564.58"
          />
          <line
            className="cls-1"
            x1="425.53"
            y1="544.57"
            x2="425.53"
            y2="564.58"
          />
          <line
            className="cls-1"
            x1="411.6"
            y1="550.48"
            x2="411.6"
            y2="565.49"
          />
          <circle className="cls-18" cx="411.6" cy="567.21" r="5.7" />
          <circle className="cls-11" cx="425.53" cy="567.21" r="5.7" />
          <circle className="cls-21" cx="462.44" cy="567.21" r="5.7" />
          <path
            className="cls-13"
            d="m455.65,491.53h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
          <g>
            <path
              className="cls-13"
              d="m447.1,505.18c0,.46-.11.9-.33,1.31s-.54.73-.98.98-.97.37-1.59.37c-.5,0-.98-.06-1.44-.19s-.88-.32-1.26-.59v-1.75c.25.19.6.38,1.06.57s.85.29,1.19.29c.4,0,.68-.1.84-.31s.24-.42.24-.65c0-.18-.05-.36-.14-.52s-.25-.3-.48-.41-.54-.16-.92-.16c-.43,0-.83.08-1.22.23v-4.73h4.71v1.71h-2.91v1.39c.06,0,.13-.01.2-.02s.12,0,.15-.01.09,0,.17,0c.55,0,1.03.12,1.44.35s.73.54.95.92.33.8.33,1.25Z"
            />
            <path
              className="cls-13"
              d="m454.72,505.53c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m461.78,507.72h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
          </g>
        </g>
      </g>
      <g id="excel">
        <line
          className="cls-2"
          x1="132.11"
          y1="374.31"
          x2="132.11"
          y2="393.72"
        />
        <path
          className="cls-14 leaf"
          id="excelLeaf"
          d="m137.1,314.4c-3.66-1.11-6.91-.47-11.58,1.81-8.25,4.03-9.55,4.67-20.91,11.84-7.61,4.8-9.84,6.71-12.26,9.77-.69.88-3.26,5.47-3.41,11.05-.15,5.61,2.19,10.73,2.84,11.64,2.26,3.18,4.39,5.19,11.76,10.37,10.99,7.72,12.25,8.42,20.3,12.86,4.55,2.51,7.77,3.31,11.48,2.38,5.55-1.38,9.42-6.25,13.29-12.81,3.37-5.71,7.65-14.75,7.65-22.44,0-10.04-4.19-17.45-6.91-22.82-3.3-6.5-6.77-12-12.24-13.66Z"
        />
        <g>
          <path
            className="cls-13"
            d="m100.99,353.89h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m110.9,353.89h-2.88l-.79-.93s-.18-.23-.47-.57c-.29-.35-.48-.58-.57-.71-.43.58-.78,1.04-1.05,1.38l-.68.84h-2.84l3.16-3.87-3.01-3.57h2.87l.51.62c.29.36.64.81,1.05,1.35.39-.57.7-1,.93-1.27l.59-.7h2.81l-2.9,3.57,3.27,3.87Z"
          />
          <path
            className="cls-13"
            d="m118.08,353.33c-.31.16-.62.29-.95.39s-.65.17-.98.21c-.33.04-.67.06-1.02.06-.65,0-1.23-.09-1.74-.27-.51-.18-.96-.44-1.34-.79-.38-.35-.66-.76-.85-1.22-.19-.47-.28-.98-.28-1.54,0-.64.11-1.2.33-1.68.22-.48.53-.88.93-1.2.4-.32.85-.55,1.36-.71.51-.15,1.05-.23,1.61-.23.85,0,1.8.19,2.87.56v1.98c-.37-.23-.73-.42-1.09-.57-.36-.15-.78-.23-1.27-.23-.43,0-.84.09-1.21.26s-.68.42-.91.74-.34.69-.34,1.12c0,.38.1.72.3,1.03.2.31.48.56.83.75.36.18.76.28,1.21.28.36,0,.7-.04,1.03-.13.32-.09.59-.19.81-.29.22-.11.45-.23.68-.38v1.89Z"
          />
          <path
            className="cls-13"
            d="m125.21,353.89h-5.61v-7.44h5.52v1.49h-3.28v1.36h3.13v1.5h-3.13v1.59h3.37v1.5Z"
          />
          <path
            className="cls-13"
            d="m132.37,353.89h-5.66v-7.44h2.25v5.66h3.41v1.78Z"
          />
        </g>
        <g>
          <path
            className="cls-13"
            d="m127.23,376.03c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
          />
          <path
            className="cls-13"
            d="m134.33,376.46h-.96v1.75h-2.16v-1.75h-3.3v-1.55l3.72-4.82h1.74v4.97h.96v1.39Zm-3.12-1.39v-2.6l-2.02,2.6h2.02Z"
          />
          <path
            className="cls-13"
            d="m140.92,375.96c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
          />
        </g>
        <circle className="cls-2" cx="133.11" cy="393.82" r="2.49" />
        <path
          className="cls-2"
          d="m69.53,413.51c8.23-5.61,28.87-18.05,58.03-19.03,32.58-1.1,55.94,12.76,64.07,18.11"
        />
        <g id="frequency">
          <line
            className="cls-1"
            x1="83.44"
            y1="466.25"
            x2="83.44"
            y2="496.66"
          />
          <line
            className="cls-1"
            x1="54.74"
            y1="476.42"
            x2="54.74"
            y2="498.94"
          />
          <line
            className="cls-1"
            x1="40.26"
            y1="481.89"
            x2="40.26"
            y2="500.41"
          />
          <line
            className="cls-1"
            x1="71.97"
            y1="427.91"
            x2="71.97"
            y2="465.81"
          />
          <circle
            id="excelFreq"
            className="cls-14 tooltip"
            cx="74.42"
            cy="431.51"
            r="20.85"
          />
          <path
            className="cls-13"
            d="m77.63,425.8h-3.37v3.29h-2.45v-8.12h5.82v1.63h-3.37v1.57h3.37v1.63Z"
          />
          <g>
            <path
              className="cls-13"
              d="m69.27,442.46c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m75.82,442.39c0,.43-.08.79-.25,1.09s-.39.55-.67.74-.57.33-.88.41-.61.13-.9.13c-.41,0-.86-.06-1.36-.17s-.91-.25-1.25-.41v-1.82c.27.23.57.42.88.57s.64.23.98.23c.25,0,.47-.05.64-.14s.3-.21.39-.35.13-.29.13-.45c0-.21-.05-.39-.16-.55s-.27-.29-.47-.38-.45-.14-.72-.14h-.26v-1.31h.31c.27,0,.5-.05.68-.16s.31-.23.38-.38.12-.28.12-.41c0-.25-.09-.46-.28-.65s-.43-.28-.74-.28c-.27,0-.55.05-.84.15s-.56.24-.82.41v-1.56c.38-.16.74-.29,1.08-.38s.72-.14,1.14-.14c.61,0,1.13.12,1.54.36s.71.53.9.86.28.66.28.95c0,.24-.05.48-.16.73s-.24.46-.41.64-.35.33-.53.44c.32.17.61.41.86.71s.38.73.38,1.28Z"
            />
            <path
              className="cls-13"
              d="m83.53,442.46c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
          </g>
          <path
            className="cls-22"
            d="m98.81,484.86c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.37,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.88-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.8,1.4,17.65,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.07,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="212.44"
            y1="474.77"
            x2="212.44"
            y2="493.3"
          />
          <circle className="cls-18" cx="40.26" cy="495.14" r="5.7" />
          <circle className="cls-12" cx="83.44" cy="495.14" r="5.7" />
          <circle className="cls-11" cx="54.74" cy="495.14" r="5.7" />
        </g>
        <g id="likeability">
          <line
            className="cls-1"
            x1="160.77"
            y1="487.01"
            x2="160.77"
            y2="498.13"
          />
          <line className="cls-1" x1="196" y1="433.05" x2="196" y2="466.03" />
          <circle
            id="excelLike"
            className="cls-14 tooltip"
            cx="194.13"
            cy="433.05"
            r="20.85"
          />
          <path
            className="cls-22"
            d="m225.36,483.94c-.55-.33-1.29-.85-2.3-1.47-3.06-1.89-5.59-3.09-6.05-3.32-4.8-2.44-12.47-3.28-14.39-3.46-2.06-.2-9.26-.76-18.27,1.27-3.98.9-8.38,1.89-12.24,4.43-.97.64-5.57,4.01-7.18,5.49-.12.11-.52.5-1.34,1.16-.26.21-.69.42-1.23.47-.91.1-2.07-.11-2.31-.92-.33-1.14.28-1.79.74-2.39.52-.68,1.09-1.31,2.09-2.3,2.44-2.38,2.21-2.09,2.5-2.34,3.44-2.98,7.75-5.59,7.75-5.59,8-4.84,16.47-7.46,16.47-7.46,9.89-3.05,17.86-3.19,19.59-3.2,8.04-.07,13.81,1.4,17.66,2.38,0,0,4.2,1.07,9.49,3.96,1.94,1.06,3.48,2.08,4.54,3.94,1.13,1.99,1.09,3.85,1.08,4.23-.02.63-.2,3.13-2.16,5.08-1.71,1.71-3.6,2.25-5.43,2.5-1,.14-3.27.15-5.74-.73-1.48-.53-2.51-1.25-3.27-1.72Z"
          />
          <line
            className="cls-1"
            x1="186.48"
            y1="451.83"
            x2="186.48"
            y2="470.55"
          />
          <line
            className="cls-1"
            x1="190.3"
            y1="475.92"
            x2="190.3"
            y2="498.48"
          />
          <circle className="cls-18" cx="160.77" cy="496.85" r="5.7" />
          <circle className="cls-21" cx="190.3" cy="496.03" r="5.7" />
          <circle className="cls-11" cx="212.44" cy="496.03" r="5.7" />
          <g>
            <path
              className="cls-13"
              d="m189.75,442.46c0,.19-.04.41-.12.66s-.23.5-.45.75-.55.46-.97.63-.97.25-1.62.25-1.21-.08-1.63-.25-.75-.38-.98-.64-.38-.5-.45-.74-.11-.46-.11-.67c0-.41.12-.8.35-1.16s.55-.64.96-.84c-.33-.21-.58-.44-.76-.71s-.27-.61-.27-1.03c0-.23.05-.48.15-.74s.26-.51.49-.76.52-.44.9-.58.83-.22,1.36-.22,1.02.07,1.39.22.67.34.9.58.38.49.47.75.13.51.13.76c0,.43-.09.77-.26,1.03s-.43.49-.77.71c.27.14.5.31.69.51s.34.43.45.69.17.53.17.8Zm-2.09-.22c0-.25-.05-.47-.16-.65s-.25-.32-.42-.41-.34-.14-.5-.14c-.27,0-.52.11-.74.32s-.33.51-.33.87c0,.39.11.7.33.9s.47.31.76.31.54-.11.75-.33.32-.52.32-.88Zm-.24-3.37c0-.26-.06-.5-.19-.74s-.34-.35-.63-.35-.52.11-.66.34-.21.48-.21.75c0,.32.08.58.25.78s.36.3.58.3.42-.1.59-.3.25-.46.25-.78Z"
            />
            <path
              className="cls-13"
              d="m196.81,444.64h-6.17v-.16c.24-.23.5-.51.79-.83s.65-.74,1.1-1.27c.21-.24.4-.47.58-.7s.34-.45.47-.67.24-.46.33-.72.13-.53.13-.8c0-.38-.11-.68-.33-.91s-.49-.35-.83-.35c-.66,0-1.32.34-1.98,1.03v-1.92c.23-.15.42-.27.57-.36s.32-.18.51-.26.42-.16.69-.22.55-.09.86-.09c.5,0,.95.1,1.35.3s.73.49.96.87.35.83.35,1.33c0,.36-.05.7-.16,1.01s-.21.56-.33.76-.26.43-.45.71c-.34.5-.7.98-1.08,1.43h2.63v1.82Z"
            />
            <path
              className="cls-13"
              d="m203.98,436.75l-3.47,7.99-1.89-.6,2.48-5.83h-3.29v-1.8h6.16v.23Z"
            />
          </g>
          <path
            className="cls-13"
            d="m197.64,430.67h-6.17v-8.12h2.45v6.18h3.72v1.95Z"
          />
        </g>
      </g>
      <g id="infobox">
        <rect
          className="cls-3"
          x="931.74"
          y="97.06"
          width="236.94"
          height="265.83"
        />
        <circle className="cls-18" cx="1048.85" cy="224.14" r="4.26" />
        <circle className="cls-11" cx="1049.25" cy="244.99" r="4.26" />
        <circle className="cls-21" cx="1049.14" cy="266.44" r="4.26" />
        <path
          className="cls-22"
          d="m1071.26,303.98c-.41-.25-.96-.63-1.72-1.1-2.28-1.41-4.17-2.31-4.51-2.48-3.58-1.82-9.31-2.45-10.74-2.58-1.54-.15-6.91-.57-13.64.95-2.97.67-6.25,1.41-9.14,3.3-.73.48-4.16,2.99-5.36,4.1-.09.08-.39.37-1,.87-.2.16-.52.31-.92.35-.68.07-1.54-.08-1.72-.69-.25-.85.21-1.33.56-1.79.39-.51.81-.98,1.56-1.71,1.82-1.78,1.65-1.56,1.86-1.75,2.57-2.22,5.79-4.17,5.79-4.17,5.97-3.62,12.3-5.57,12.3-5.57,7.38-2.28,13.33-2.38,14.62-2.39,6-.05,10.31,1.04,13.18,1.78,0,0,3.14.8,7.09,2.96,1.45.79,2.6,1.56,3.39,2.94.84,1.48.81,2.88.8,3.16-.02.47-.15,2.33-1.61,3.79-1.28,1.27-2.69,1.68-4.05,1.87-.75.1-2.44.12-4.29-.54-1.1-.39-1.88-.93-2.44-1.29Z"
        />
        <g>
          <path
            className="cls-17"
            d="m1062.43,264.23v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
          <path
            className="cls-17"
            d="m1066.03,262.56l1.93,4.38,1.88-4.38h1.38l-3.01,6.91h-.46l-3.11-6.91h1.39Z"
          />
          <path
            className="cls-17"
            d="m1073.31,264.74c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1079.04,264.74c.16,0,.32.04.47.11.15.07.33.19.54.36l-.43,1.05c-.35-.26-.63-.39-.84-.39-.19,0-.37.07-.55.21-.18.14-.33.32-.44.55-.11.23-.16.46-.16.68v2.08h-1.2v-4.56h1.2v1.16h.02c.22-.44.44-.76.66-.95s.46-.3.73-.3Z"
          />
          <path
            className="cls-17"
            d="m1081.32,264.83l1.08,2.45,1.09-2.45h1.29l-3.15,6.86h-1.29l1.45-3.14-1.77-3.72h1.3Z"
          />
          <path
            className="cls-17"
            d="m1089.51,262.56l2.24,2.69,2.24-2.69h1.18v6.82h-1.32v-4.79h-.04l-1.97,2.4h-.19l-1.97-2.4h-.04v4.79h-1.32v-6.82h1.19Z"
          />
          <path
            className="cls-17"
            d="m1097.68,264.83v2.82c0,.3.07.52.22.68.15.15.34.23.59.23.2,0,.4-.06.58-.19s.33-.3.45-.52v-3.02h1.2v4.56h-1.2v-.62c-.43.47-.9.71-1.41.71s-.88-.16-1.18-.48-.45-.74-.45-1.25v-2.92h1.2Z"
          />
          <path
            className="cls-17"
            d="m1104.11,264.74c.53,0,1.01.1,1.44.31v1.02c-.43-.25-.83-.37-1.21-.37-.41,0-.75.13-1.01.38s-.39.6-.39,1.04.13.77.39,1.03c.26.26.61.39,1.05.39.33,0,.74-.11,1.25-.32v.97c-.47.19-.96.29-1.46.29-.74,0-1.34-.21-1.8-.63-.46-.42-.69-.98-.69-1.68s.23-1.31.68-1.75c.45-.44,1.04-.66,1.75-.66Z"
          />
          <path
            className="cls-17"
            d="m1107.73,262.56v2.9h.03c.39-.48.85-.73,1.4-.73.49,0,.88.16,1.17.48s.44.74.44,1.25v2.92h-1.2v-2.69c0-.31-.07-.55-.22-.73-.15-.18-.34-.27-.59-.27-.18,0-.35.05-.52.16-.16.1-.34.28-.52.52v3.02h-1.2v-6.82h1.2Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m1010.57,262.48c.71,0,1.34.15,1.91.44.57.29,1.02.71,1.35,1.26s.5,1.15.5,1.8-.16,1.23-.49,1.77c-.33.55-.78.97-1.35,1.27-.57.3-1.22.45-1.93.45s-1.35-.15-1.93-.46c-.58-.31-1.03-.73-1.35-1.26s-.48-1.13-.48-1.77.16-1.21.48-1.76.77-.98,1.33-1.28,1.22-.46,1.95-.46Zm-2.41,3.5c0,.45.1.86.31,1.22s.49.64.86.84c.37.2.78.3,1.24.3.7,0,1.28-.22,1.73-.66.45-.44.68-1.01.68-1.7,0-.45-.1-.86-.3-1.22-.2-.36-.49-.64-.86-.84-.37-.2-.79-.3-1.25-.3s-.88.1-1.25.3c-.37.2-.65.48-.85.84s-.3.77-.3,1.22Z"
          />
          <path
            className="cls-17"
            d="m1017.34,262.48c.14,0,.28.01.43.04.15.03.27.06.36.1v.98c-.17-.05-.35-.07-.54-.07-.29,0-.5.07-.65.22-.14.15-.21.4-.21.75v.33h.78v.91h-.78v3.65h-1.2v-3.65h-.65v-.91h.65v-.34c0-.62.17-1.1.5-1.46.33-.36.77-.54,1.32-.54Z"
          />
          <path
            className="cls-17"
            d="m1019.4,263.61h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1023.88,264.74c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1029.64,264.74c.49,0,.88.16,1.17.48.29.32.44.74.44,1.27v2.9h-1.2v-2.78c0-.3-.07-.53-.21-.7-.14-.17-.33-.26-.58-.26-.19,0-.36.05-.52.16s-.34.29-.54.54v3.03h-1.2v-4.56h1.2v.64c.22-.26.45-.45.68-.56.23-.11.49-.17.76-.17Z"
          />
          <path
            className="cls-17"
            d="m1039.95,264.23v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m1062.43,242.75v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
          <path
            className="cls-17"
            d="m1068.42,241c.66,0,1.3.17,1.92.5v1.17c-.71-.43-1.33-.64-1.88-.64-.33,0-.59.06-.78.19-.19.13-.28.3-.28.52,0,.26.17.49.52.71.1.06.47.25,1.13.55.56.26.96.56,1.21.88s.37.71.37,1.16c0,.59-.21,1.06-.63,1.42-.42.36-.97.54-1.64.54-.44,0-.81-.05-1.13-.14-.31-.1-.67-.26-1.06-.5v-1.3c.73.61,1.42.91,2.06.91.32,0,.58-.07.78-.21s.3-.33.3-.56c0-.32-.17-.57-.52-.77-.29-.16-.66-.34-1.11-.56-.54-.24-.94-.53-1.2-.85-.27-.33-.4-.7-.4-1.13,0-.57.21-1.03.64-1.37s.99-.51,1.69-.51Z"
          />
          <path
            className="cls-17"
            d="m1073.89,243.26c.48,0,.91.1,1.29.3s.69.48.9.83.32.76.32,1.22-.1.89-.3,1.24c-.2.35-.5.63-.9.84-.4.21-.83.31-1.31.31s-.91-.1-1.3-.31-.69-.48-.89-.84c-.2-.35-.3-.77-.3-1.24s.11-.87.32-1.22.51-.63.9-.83.81-.3,1.28-.3Zm-1.24,2.35c0,.46.11.82.33,1.09.22.27.52.41.9.41s.7-.13.92-.39.34-.63.34-1.12-.11-.82-.34-1.07c-.23-.25-.53-.38-.92-.38-.36,0-.66.13-.89.4s-.34.62-.34,1.06Z"
          />
          <path
            className="cls-17"
            d="m1080.01,243.26c.35,0,.65.08.89.25.24.16.42.38.54.66.26-.32.51-.55.77-.69.25-.15.54-.22.84-.22.48,0,.87.16,1.17.47s.44.73.44,1.26v2.92h-1.2v-2.72c0-.32-.07-.56-.2-.75-.13-.18-.33-.27-.59-.27-.37,0-.72.24-1.06.71v3.03h-1.2v-2.74c0-.31-.07-.56-.21-.73s-.33-.27-.58-.27c-.2,0-.37.06-.54.17s-.34.29-.52.54v3.03h-1.2v-4.56h1.2v.64c.22-.25.44-.43.66-.55s.48-.18.78-.18Z"
          />
          <path
            className="cls-17"
            d="m1087.87,243.26c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1091.64,243.35l1.06,2.63,1.08-2.63h.78l1.07,2.63,1.06-2.63h1.25l-2.03,4.65h-.51l-1.23-2.79-1.23,2.79h-.5l-2.05-4.65h1.25Z"
          />
          <path
            className="cls-17"
            d="m1099.74,241.09v2.9h.03c.39-.48.85-.73,1.4-.73.49,0,.88.16,1.17.48s.44.74.44,1.25v2.92h-1.2v-2.69c0-.31-.07-.55-.22-.73-.15-.18-.34-.27-.59-.27-.18,0-.35.05-.52.16-.16.1-.34.28-.52.52v3.02h-1.2v-6.82h1.2Z"
          />
          <path
            className="cls-17"
            d="m1105.59,243.26c.59,0,1.03.12,1.34.37s.46.6.46,1.04v2.23c0,.17.07.26.21.26.06,0,.14-.03.25-.08.11-.05.2-.11.27-.17v.69c-.42.26-.8.39-1.15.39-.21,0-.38-.04-.5-.11-.12-.07-.2-.2-.24-.38-.46.33-.92.49-1.38.49-.33,0-.61-.11-.85-.33-.24-.22-.35-.49-.35-.8,0-.39.12-.7.35-.93s.64-.43,1.23-.6l.97-.28v-.21c0-.45-.27-.67-.81-.67-.28,0-.55.06-.83.19s-.52.31-.75.56v-1.08c.5-.39,1.09-.59,1.77-.59Zm-.73,3.43c0,.17.05.3.16.4.11.1.24.15.39.15.26,0,.53-.12.79-.36v-1.2c-.33.11-.6.22-.79.32-.19.1-.33.2-.42.31-.09.1-.13.23-.13.38Z"
          />
          <path
            className="cls-17"
            d="m1110.03,242.14h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m986.01,241c.66,0,1.3.17,1.92.5v1.17c-.71-.43-1.33-.64-1.88-.64-.33,0-.59.06-.78.19-.19.13-.28.3-.28.52,0,.26.17.49.52.71.1.06.47.25,1.13.55.56.26.96.56,1.21.88.25.32.37.71.37,1.16,0,.59-.21,1.06-.63,1.42s-.97.54-1.64.54c-.44,0-.81-.05-1.12-.14s-.67-.26-1.06-.5v-1.3c.73.61,1.42.91,2.06.91.32,0,.58-.07.78-.21.2-.14.3-.33.3-.56,0-.32-.17-.57-.52-.77-.29-.16-.66-.34-1.11-.56-.54-.24-.94-.53-1.2-.85-.27-.33-.4-.7-.4-1.13,0-.57.21-1.03.64-1.37.43-.34.99-.51,1.69-.51Z"
          />
          <path
            className="cls-17"
            d="m991.48,243.26c.47,0,.91.1,1.29.3.39.2.69.48.9.83.21.36.32.76.32,1.22s-.1.89-.3,1.24c-.21.35-.5.63-.9.84-.4.21-.83.31-1.31.31s-.91-.1-1.3-.31-.69-.48-.89-.84-.3-.77-.3-1.24.11-.87.32-1.22.51-.63.9-.83c.38-.2.81-.3,1.28-.3Zm-1.24,2.35c0,.46.11.82.33,1.09s.52.41.9.41.7-.13.92-.39.34-.63.34-1.12-.11-.82-.34-1.07-.53-.38-.92-.38c-.37,0-.66.13-.89.4-.23.27-.34.62-.34,1.06Z"
          />
          <path
            className="cls-17"
            d="m997.59,243.26c.35,0,.65.08.89.25s.42.38.54.66c.26-.32.51-.55.77-.69.25-.15.54-.22.84-.22.48,0,.87.16,1.17.47.3.31.45.73.45,1.26v2.92h-1.2v-2.72c0-.32-.07-.56-.2-.75s-.33-.27-.59-.27c-.37,0-.72.24-1.06.71v3.03h-1.2v-2.74c0-.31-.07-.56-.21-.73-.14-.18-.34-.27-.58-.27-.2,0-.38.06-.54.17-.16.11-.34.29-.52.54v3.03h-1.2v-4.56h1.2v.64c.22-.25.44-.43.66-.55s.48-.18.78-.18Z"
          />
          <path
            className="cls-17"
            d="m1005.46,243.26c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94s.61.33,1.05.33c.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.54.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65-.46-.43-.68-1.01-.68-1.73s.21-1.26.63-1.7.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78-.17-.19-.4-.28-.7-.28s-.55.09-.73.27-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1009.82,242.14h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5.12.13.29.19.51.19.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.91-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1012.91,241.24c.19,0,.34.07.48.2.13.13.2.29.2.48s-.06.34-.2.48c-.13.14-.29.21-.48.21s-.34-.07-.48-.21-.2-.3-.2-.48c0-.19.07-.35.21-.48s.29-.2.47-.2Zm.6,2.11v4.56h-1.2v-4.56h1.2Z"
          />
          <path
            className="cls-17"
            d="m1017.39,243.26c.35,0,.65.08.89.25s.42.38.54.66c.26-.32.51-.55.77-.69.25-.15.54-.22.84-.22.48,0,.87.16,1.17.47.3.31.45.73.45,1.26v2.92h-1.2v-2.72c0-.32-.07-.56-.2-.75s-.33-.27-.59-.27c-.37,0-.72.24-1.06.71v3.03h-1.2v-2.74c0-.31-.07-.56-.21-.73-.14-.18-.34-.27-.58-.27-.2,0-.38.06-.54.17-.16.11-.34.29-.52.54v3.03h-1.2v-4.56h1.2v.64c.22-.25.44-.43.66-.55s.48-.18.78-.18Z"
          />
          <path
            className="cls-17"
            d="m1025.25,243.26c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94s.61.33,1.05.33c.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.54.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65-.46-.43-.68-1.01-.68-1.73s.21-1.26.63-1.7.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78-.17-.19-.4-.28-.7-.28s-.55.09-.73.27-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1029.85,243.26c.25,0,.49.03.71.09.22.06.46.15.7.27v.96c-.23-.15-.47-.26-.73-.35-.26-.09-.49-.13-.7-.13-.17,0-.31.03-.41.1s-.15.16-.15.28c0,.07.04.14.12.21.08.07.3.19.67.38.52.26.89.51,1.1.73.21.22.31.49.31.8,0,.44-.15.79-.46,1.04-.31.25-.72.38-1.24.38-.33,0-.63-.04-.91-.11-.28-.07-.52-.16-.7-.26v-1c.59.33,1.08.49,1.48.49.21,0,.37-.04.5-.11s.19-.17.19-.29c0-.07-.02-.14-.07-.2-.05-.06-.12-.12-.21-.18-.09-.06-.38-.21-.86-.44-.37-.18-.64-.37-.81-.57s-.26-.45-.26-.73c0-.4.16-.73.47-.97.32-.24.73-.36,1.25-.36Z"
          />
          <path
            className="cls-17"
            d="m1039.95,242.75v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m1062.43,222.81v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
          <path
            className="cls-17"
            d="m1067.6,221.15l4.05,4.76v-4.76h1.29v6.82h-1.13l-4.08-4.84v4.84h-1.29v-6.82h1.16Z"
          />
          <path
            className="cls-17"
            d="m1076.55,223.32c.48,0,.91.1,1.29.3s.69.48.9.83.32.76.32,1.22-.1.89-.3,1.24c-.2.35-.5.63-.9.84-.4.21-.83.31-1.31.31s-.91-.1-1.3-.31-.69-.48-.89-.84c-.2-.35-.3-.77-.3-1.24s.11-.87.32-1.22.51-.63.9-.83.81-.3,1.28-.3Zm-1.24,2.35c0,.46.11.82.33,1.09.22.27.52.41.9.41s.7-.13.92-.39.34-.63.34-1.12-.11-.82-.34-1.07c-.23-.25-.53-.38-.92-.38-.36,0-.66.13-.89.4s-.34.62-.34,1.06Z"
          />
          <path
            className="cls-17"
            d="m1081.27,222.2h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1089.5,221.15l3.01,6.82h-1.39l-.71-1.66h-3.03l-.66,1.66h-1.38l2.81-6.82h1.35Zm-1.72,4.16h2.2l-1.15-2.7-1.05,2.7Z"
          />
          <path
            className="cls-17"
            d="m1094.41,222.2h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1102.64,221.15l3.01,6.82h-1.39l-.71-1.66h-3.03l-.66,1.66h-1.38l2.81-6.82h1.35Zm-1.72,4.16h2.2l-1.15-2.7-1.05,2.7Z"
          />
          <path className="cls-17" d="m1107.54,221.15v6.82h-1.2v-6.82h1.2Z" />
          <path className="cls-17" d="m1110.02,221.15v6.82h-1.2v-6.82h1.2Z" />
        </g>
        <g>
          <path
            className="cls-17"
            d="m1007.34,221.15c.64,0,1.16.18,1.57.53s.61.82.61,1.39c0,.39-.1.73-.3,1.01-.2.29-.5.52-.89.68.22.12.41.28.58.48s.38.54.63,1.02c.42.83.73,1.4.93,1.71h-1.47c-.1-.15-.24-.39-.41-.72-.38-.73-.65-1.21-.83-1.47s-.34-.43-.51-.54-.35-.16-.56-.16h-.48v2.88h-1.32v-6.82h2.46Zm-.3,2.91c.34,0,.62-.09.81-.26.2-.17.3-.41.3-.71s-.1-.55-.29-.7-.47-.23-.83-.23h-.82v1.9h.84Z"
          />
          <path
            className="cls-17"
            d="m1012.82,223.32c.59,0,1.03.12,1.34.37s.46.6.46,1.04v2.23c0,.17.07.26.21.26.06,0,.14-.03.25-.08.11-.05.2-.11.27-.17v.69c-.42.26-.8.39-1.15.39-.21,0-.38-.04-.5-.11-.12-.07-.2-.2-.24-.38-.46.33-.92.49-1.38.49-.33,0-.61-.11-.85-.33-.24-.22-.35-.49-.35-.8,0-.39.12-.7.35-.93s.64-.43,1.23-.6l.97-.28v-.21c0-.45-.27-.67-.81-.67-.28,0-.55.06-.83.19s-.52.31-.75.56v-1.08c.5-.39,1.09-.59,1.77-.59Zm-.73,3.43c0,.17.05.3.16.4.11.1.24.15.39.15.26,0,.53-.12.79-.36v-1.2c-.33.11-.6.22-.79.32-.19.1-.33.2-.42.31-.09.1-.13.23-.13.38Z"
          />
          <path
            className="cls-17"
            d="m1018.61,223.32c.16,0,.32.04.47.11.15.07.33.19.54.36l-.43,1.05c-.35-.26-.63-.39-.84-.39-.19,0-.37.07-.55.21-.18.14-.33.32-.44.55-.11.23-.16.46-.16.68v2.08h-1.2v-4.56h1.2v1.16h.02c.22-.44.44-.76.66-.95s.46-.3.73-.3Z"
          />
          <path
            className="cls-17"
            d="m1022.03,223.32c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path className="cls-17" d="m1026.39,221.15v6.82h-1.2v-6.82h1.2Z" />
          <path
            className="cls-17"
            d="m1028.34,223.41l1.08,2.45,1.09-2.45h1.29l-3.15,6.86h-1.29l1.45-3.14-1.77-3.72h1.3Z"
          />
          <path
            className="cls-17"
            d="m1039.95,222.81v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m1104.55,193.22v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
          <path
            className="cls-17"
            d="m1109.87,191.56v5.79h3.31v1.03h-4.63v-6.82h1.32Z"
          />
          <path
            className="cls-17"
            d="m1114.58,191.71c.19,0,.34.07.48.2s.2.29.2.48-.07.34-.2.48c-.13.14-.29.21-.48.21s-.34-.07-.48-.21c-.13-.14-.2-.3-.2-.48,0-.19.07-.35.21-.48s.29-.2.47-.2Zm.6,2.11v4.56h-1.2v-4.56h1.2Z"
          />
          <path
            className="cls-17"
            d="m1117.62,191.56v6.82h-1.2v-6.82h1.2Zm3.31,2.26l-1.85,2.25,2.08,2.31h-1.52l-2-2.31,1.88-2.25h1.41Z"
          />
          <path
            className="cls-17"
            d="m1123.64,193.73c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1128.4,193.73c.59,0,1.03.12,1.34.37s.46.6.46,1.04v2.23c0,.17.07.26.21.26.06,0,.14-.03.25-.08.11-.05.2-.11.27-.17v.69c-.42.26-.8.39-1.15.39-.21,0-.38-.04-.5-.11-.12-.07-.2-.2-.24-.38-.46.33-.92.49-1.38.49-.33,0-.61-.11-.85-.33-.24-.22-.35-.49-.35-.8,0-.39.12-.7.35-.93s.64-.43,1.23-.6l.97-.28v-.21c0-.45-.27-.67-.81-.67-.28,0-.55.06-.83.19s-.52.31-.75.56v-1.08c.5-.39,1.09-.59,1.77-.59Zm-.73,3.43c0,.17.05.3.16.4.11.1.24.15.39.15.26,0,.53-.12.79-.36v-1.2c-.33.11-.6.22-.79.32-.19.1-.33.2-.42.31-.09.1-.13.23-.13.38Z"
          />
          <path
            className="cls-17"
            d="m1132.79,191.56v2.55c.35-.25.76-.38,1.21-.38.4,0,.76.1,1.09.3.33.2.58.47.76.83.18.36.27.75.27,1.19,0,.75-.22,1.34-.67,1.77s-1.06.65-1.83.65c-.7,0-1.37-.13-2.03-.39v-6.52h1.2Zm0,5.87c.26.09.56.13.9.13.37,0,.66-.13.88-.4.22-.27.33-.64.33-1.12,0-.43-.11-.77-.33-1.03s-.51-.38-.86-.38c-.17,0-.32.03-.46.09s-.29.16-.45.29v2.42Z"
          />
          <path
            className="cls-17"
            d="m1137.72,191.71c.19,0,.34.07.48.2s.2.29.2.48-.07.34-.2.48c-.13.14-.29.21-.48.21s-.34-.07-.48-.21c-.13-.14-.2-.3-.2-.48,0-.19.07-.35.21-.48s.29-.2.47-.2Zm.6,2.11v4.56h-1.2v-4.56h1.2Z"
          />
          <path className="cls-17" d="m1140.8,191.56v6.82h-1.2v-6.82h1.2Z" />
          <path
            className="cls-17"
            d="m1142.68,191.71c.19,0,.34.07.48.2s.2.29.2.48-.07.34-.2.48c-.13.14-.29.21-.48.21s-.34-.07-.48-.21c-.13-.14-.2-.3-.2-.48,0-.19.07-.35.21-.48s.29-.2.47-.2Zm.6,2.11v4.56h-1.2v-4.56h1.2Z"
          />
          <path
            className="cls-17"
            d="m1145.77,192.61h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1148.92,193.82l1.08,2.45,1.09-2.45h1.29l-3.15,6.86h-1.29l1.45-3.14-1.77-3.72h1.3Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m944.92,191.56v1.03h-2.84v1.76h2.84v1.04h-2.84v2.99h-1.32v-6.82h4.16Z"
          />
          <path
            className="cls-17"
            d="m948.58,193.73c.16,0,.32.04.47.11.15.07.33.19.54.36l-.43,1.05c-.35-.26-.63-.39-.84-.39-.19,0-.37.07-.55.21-.18.14-.33.32-.44.55-.11.23-.16.46-.16.68v2.08h-1.2v-4.56h1.2v1.16h.02c.22-.44.44-.76.66-.95s.46-.3.73-.3Z"
          />
          <path
            className="cls-17"
            d="m951.99,193.73c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m958.19,198.28c-.35.12-.69.19-1.02.19-.41,0-.8-.1-1.16-.3-.36-.2-.64-.48-.84-.83-.2-.35-.3-.74-.3-1.17,0-.48.1-.9.3-1.25s.48-.63.84-.82.79-.28,1.26-.28h2.11v6.86h-1.2v-2.4Zm-.63-3.54c-.97,0-1.46.49-1.46,1.47,0,.41.12.74.36.99.24.25.56.37.96.37.27,0,.52-.06.77-.19v-2.64h-.63Z"
          />
          <path
            className="cls-17"
            d="m961.76,193.82v2.82c0,.3.07.52.22.68.15.15.34.23.59.23.2,0,.4-.06.58-.19s.33-.3.45-.52v-3.02h1.2v4.56h-1.2v-.62c-.43.47-.9.71-1.41.71s-.88-.16-1.18-.48-.45-.74-.45-1.25v-2.92h1.2Z"
          />
          <path
            className="cls-17"
            d="m968.04,193.73c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m973.8,193.73c.49,0,.88.16,1.17.48.29.32.44.74.44,1.27v2.9h-1.2v-2.78c0-.3-.07-.53-.21-.7-.14-.17-.33-.26-.58-.26-.19,0-.36.05-.52.16s-.34.29-.54.54v3.03h-1.2v-4.56h1.2v.64c.22-.26.45-.45.68-.56.23-.11.49-.17.76-.17Z"
          />
          <path
            className="cls-17"
            d="m978.76,193.73c.53,0,1.01.1,1.44.31v1.02c-.43-.25-.83-.37-1.21-.37-.41,0-.75.13-1.01.38s-.39.6-.39,1.04.13.77.39,1.03c.26.26.61.39,1.05.39.33,0,.74-.11,1.25-.32v.97c-.47.19-.96.29-1.46.29-.74,0-1.34-.21-1.8-.63-.46-.42-.69-.98-.69-1.68s.23-1.31.68-1.75c.45-.44,1.04-.66,1.75-.66Z"
          />
          <path
            className="cls-17"
            d="m981.89,193.82l1.08,2.45,1.09-2.45h1.29l-3.15,6.86h-1.29l1.45-3.14-1.77-3.72h1.3Z"
          />
          <path
            className="cls-17"
            d="m993.5,193.22v1.08h-4.88v-1.08h4.88Zm0,2.18v1.08h-4.88v-1.08h4.88Z"
          />
        </g>
        <g>
          <path className="cls-17" d="m1086.7,160.73v6.82h-1.25v-6.82h1.25Z" />
          <path
            className="cls-17"
            d="m1091.37,160.64c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z"
          />
          <path
            className="cls-17"
            d="m1096.65,160.64c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z"
          />
          <path
            className="cls-17"
            d="m1105.26,160.73c.64,0,1.16.18,1.57.53s.61.82.61,1.39c0,.39-.1.73-.3,1.01-.2.29-.5.52-.89.68.22.12.41.28.58.48s.38.54.63,1.02c.42.83.73,1.4.93,1.71h-1.47c-.1-.15-.24-.39-.41-.72-.38-.73-.65-1.21-.83-1.47s-.34-.43-.51-.54-.35-.16-.56-.16h-.48v2.88h-1.32v-6.82h2.46Zm-.3,2.91c.34,0,.62-.09.81-.26.2-.17.3-.41.3-.71s-.1-.55-.29-.7-.47-.23-.83-.23h-.82v1.9h.84Z"
          />
          <path
            className="cls-17"
            d="m1110.93,162.9c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1115.53,162.9c.25,0,.49.03.71.09s.46.15.7.27v.96c-.23-.15-.47-.26-.73-.35s-.49-.13-.7-.13c-.17,0-.31.03-.41.1s-.15.16-.15.28c0,.07.04.14.12.21s.3.19.67.38c.52.26.89.51,1.1.73.21.22.31.49.31.8,0,.44-.15.79-.46,1.04s-.72.38-1.24.38c-.33,0-.63-.04-.91-.11-.28-.07-.52-.16-.7-.26v-1c.59.33,1.08.49,1.48.49.21,0,.37-.04.5-.11s.19-.17.19-.29c0-.07-.02-.14-.07-.2s-.11-.12-.21-.18-.38-.21-.85-.44c-.37-.18-.64-.37-.82-.57s-.26-.45-.26-.73c0-.4.16-.73.47-.97s.73-.36,1.25-.36Z"
          />
          <path
            className="cls-17"
            d="m1120.44,162.9c.65,0,1.18.22,1.57.65.4.44.6,1,.6,1.7,0,.46-.09.87-.28,1.23-.19.36-.45.64-.8.84s-.74.3-1.17.3c-.35,0-.71-.09-1.07-.27v2.48h-1.2v-6.86h1.19v.29c.36-.25.75-.38,1.16-.38Zm-1.15,3.59c.3.17.58.26.84.26.38,0,.68-.14.91-.41s.34-.62.34-1.04c0-.47-.1-.83-.31-1.09-.2-.26-.49-.4-.87-.4-.14,0-.28.02-.41.07s-.3.15-.51.3v2.31Z"
          />
          <path
            className="cls-17"
            d="m1125.83,162.9c.48,0,.91.1,1.29.3s.69.48.9.83.32.76.32,1.22-.1.89-.3,1.24c-.2.35-.5.63-.9.84-.4.21-.83.31-1.31.31s-.91-.1-1.3-.31-.69-.48-.89-.84c-.2-.35-.3-.77-.3-1.24s.11-.87.32-1.22.51-.63.9-.83.81-.3,1.28-.3Zm-1.24,2.35c0,.46.11.82.33,1.09.22.27.52.41.9.41s.7-.13.92-.39.34-.63.34-1.12-.11-.82-.34-1.07c-.23-.25-.53-.38-.92-.38-.36,0-.66.13-.89.4s-.34.62-.34,1.06Z"
          />
          <path
            className="cls-17"
            d="m1131.95,162.9c.49,0,.88.16,1.17.48.29.32.44.74.44,1.27v2.9h-1.2v-2.78c0-.3-.07-.53-.21-.7-.14-.17-.33-.26-.58-.26-.19,0-.36.05-.52.16s-.34.29-.54.54v3.03h-1.2v-4.56h1.2v.64c.22-.26.45-.45.68-.56.23-.11.49-.17.76-.17Z"
          />
          <path
            className="cls-17"
            d="m1137.8,163.09v-2.36h1.2v6.82h-2.11c-.73,0-1.31-.21-1.75-.63-.44-.42-.66-.99-.66-1.72,0-.43.1-.82.3-1.17.2-.35.48-.63.84-.83.36-.2.74-.3,1.16-.3.32,0,.66.06,1.02.19Zm-.63,3.54h.63v-2.64c-.25-.13-.5-.19-.77-.19-.4,0-.72.13-.96.38-.24.25-.36.58-.36.99,0,.98.49,1.47,1.46,1.47Z"
          />
          <path
            className="cls-17"
            d="m1142.23,162.9c.67,0,1.2.21,1.59.64s.59,1.02.59,1.78v.18h-3.23c.05.41.2.72.46.94.25.22.61.33,1.05.33.29,0,.56-.05.83-.15.27-.1.54-.25.82-.45v.89c-.53.38-1.18.57-1.94.57-.72,0-1.31-.22-1.76-.65s-.68-1.01-.68-1.73.21-1.26.63-1.7c.42-.44.97-.66,1.65-.66Zm1.05,1.88c-.03-.33-.13-.59-.3-.78s-.4-.28-.7-.28-.55.09-.73.27c-.18.18-.3.44-.35.79h2.08Z"
          />
          <path
            className="cls-17"
            d="m1148,162.9c.49,0,.88.16,1.17.48.29.32.44.74.44,1.27v2.9h-1.2v-2.78c0-.3-.07-.53-.21-.7-.14-.17-.33-.26-.58-.26-.19,0-.36.05-.52.16s-.34.29-.54.54v3.03h-1.2v-4.56h1.2v.64c.22-.26.45-.45.68-.56.23-.11.49-.17.76-.17Z"
          />
          <path
            className="cls-17"
            d="m1152.01,161.78h.1v1.21h1.56v.91h-1.56v2.1c0,.21.06.37.19.5s.29.19.51.19c.28,0,.6-.1.97-.3v.96c-.43.19-.84.29-1.22.29-.51,0-.92-.14-1.2-.42-.29-.28-.43-.66-.43-1.14v-2.18h-.71v-.2l1.81-1.92Z"
          />
          <path
            className="cls-17"
            d="m1155.93,162.9c.25,0,.49.03.71.09s.46.15.7.27v.96c-.23-.15-.47-.26-.73-.35s-.49-.13-.7-.13c-.17,0-.31.03-.41.1s-.15.16-.15.28c0,.07.04.14.12.21s.3.19.67.38c.52.26.89.51,1.1.73.21.22.31.49.31.8,0,.44-.15.79-.46,1.04s-.72.38-1.24.38c-.33,0-.63-.04-.91-.11-.28-.07-.52-.16-.7-.26v-1c.59.33,1.08.49,1.48.49.21,0,.37-.04.5-.11s.19-.17.19-.29c0-.07-.02-.14-.07-.2s-.11-.12-.21-.18-.38-.21-.85-.44c-.37-.18-.64-.37-.82-.57s-.26-.45-.26-.73c0-.4.16-.73.47-.97s.73-.36,1.25-.36Z"
          />
        </g>
        <line
          className="cls-4"
          x1="1055.16"
          y1="153.21"
          x2="1081.8"
          y2="164.12"
        />
        <line
          className="cls-4"
          x1="1024.17"
          y1="192.23"
          x2="1081.8"
          y2="164.12"
        />
        <line
          className="cls-4"
          x1="1078.23"
          y1="179.7"
          x2="1081.8"
          y2="164.12"
        />
        <circle className="cls-20" cx="1081.8" cy="164.12" r="1.49" />
        <circle className="cls-7" cx="1083.65" cy="316.79" r="4.45" />
        <circle className="cls-7" cx="1053.62" cy="316.79" r="4.45" />
        <circle className="cls-7" cx="1023.6" cy="316.79" r="4.45" />
        <g className="cls-23">
          <g>
            <line
              className="cls-5"
              x1="1030.82"
              y1="327.98"
              x2="1079.71"
              y2="327.98"
            />
            <polygon
              className="cls-22"
              points="1031.43 323.43 1031.43 332.54 1026.88 327.98 1031.43 323.43"
            />
            <polygon
              className="cls-22"
              points="1079.1 323.43 1079.1 332.54 1083.65 327.98 1079.1 323.43"
            />
          </g>
        </g>
        <g>
          <path
            className="cls-17"
            d="m1021.8,338.03c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z"
          />
          <path
            className="cls-17"
            d="m1026.24,338.03c.28,0,.54.07.78.21.24.14.44.33.58.58.14.25.21.51.21.79s-.07.54-.21.78-.33.43-.58.58-.5.21-.78.21-.55-.07-.79-.21c-.25-.14-.44-.33-.58-.58s-.21-.51-.21-.79.07-.55.21-.79.34-.44.58-.58c.25-.14.51-.21.78-.21Zm4.42,0l-4.65,7h-.82l4.65-7h.82Zm-5.17,1.58c0,.21.07.39.22.54s.32.23.53.23.38-.07.52-.22.21-.33.21-.55-.07-.4-.21-.55c-.14-.15-.32-.23-.52-.23s-.38.08-.53.23c-.15.15-.22.34-.22.55Zm4.13,2.27c.28,0,.54.07.78.21.25.14.44.34.58.58.14.24.21.51.21.79s-.07.54-.21.78-.33.43-.57.57c-.24.14-.5.21-.78.21s-.55-.07-.79-.21-.44-.33-.58-.57c-.14-.24-.21-.51-.21-.79s.07-.54.21-.79.34-.44.59-.58.51-.21.78-.21Zm-.75,1.58c0,.22.08.41.22.55s.33.22.53.22.38-.07.52-.22.22-.33.22-.55c0-.21-.07-.39-.22-.54-.14-.16-.32-.24-.52-.24s-.39.08-.53.23-.22.34-.22.55Z"
          />
        </g>
        <g>
          <path className="cls-17" d="m1079.47,338.12v6.82h-1.25v-6.82h1.25Z" />
          <path
            className="cls-17"
            d="m1084.14,338.03c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z"
          />
          <path
            className="cls-17"
            d="m1089.42,338.03c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z"
          />
          <path
            className="cls-17"
            d="m1093.87,338.03c.28,0,.54.07.78.21.24.14.44.33.58.58.14.25.21.51.21.79s-.07.54-.21.78-.33.43-.58.58-.5.21-.78.21-.55-.07-.79-.21c-.25-.14-.44-.33-.58-.58s-.21-.51-.21-.79.07-.55.21-.79.34-.44.58-.58c.25-.14.51-.21.78-.21Zm4.42,0l-4.65,7h-.82l4.65-7h.82Zm-5.17,1.58c0,.21.07.39.22.54s.32.23.53.23.38-.07.52-.22.21-.33.21-.55-.07-.4-.21-.55c-.14-.15-.32-.23-.52-.23s-.38.08-.53.23c-.15.15-.22.34-.22.55Zm4.13,2.27c.28,0,.54.07.78.21.25.14.44.34.58.58.14.24.21.51.21.79s-.07.54-.21.78-.33.43-.57.57c-.24.14-.5.21-.78.21s-.55-.07-.79-.21-.44-.33-.58-.57c-.14-.24-.21-.51-.21-.79s.07-.54.21-.79.34-.44.59-.58.51-.21.78-.21Zm-.75,1.58c0,.22.08.41.22.55s.33.22.53.22.38-.07.52-.22.22-.33.22-.55c0-.21-.07-.39-.22-.54-.14-.16-.32-.24-.52-.24s-.39.08-.53.23-.22.34-.22.55Z"
          />
        </g>
        <g>
          <path d="m1053.27,338.12v1.15h-2.16v1.47h.13s.1,0,.1,0c.42,0,.79.09,1.13.27s.6.43.79.76c.19.33.29.69.29,1.1,0,.64-.22,1.16-.65,1.56-.43.4-1,.6-1.7.6-.62,0-1.18-.13-1.66-.39v-1.14c.51.31.99.47,1.46.47.36,0,.67-.1.91-.31s.37-.46.37-.77c0-.35-.14-.63-.42-.82s-.66-.3-1.14-.3c-.23,0-.48.03-.76.09v-3.74h3.31Z" />
          <path d="m1056.89,338.03c.69,0,1.24.31,1.64.93.4.62.61,1.47.61,2.55s-.2,1.94-.6,2.57-.95.94-1.64.94-1.26-.31-1.67-.94c-.41-.62-.61-1.48-.61-2.56s.2-1.93.61-2.56.96-.94,1.66-.94Zm-1,3.54c0,1.56.33,2.34,1,2.34s.98-.82.98-2.46c0-1.53-.33-2.3-.99-2.3s-.99.81-.99,2.42Z" />
          <path d="m1061.34,338.03c.28,0,.54.07.78.21.24.14.44.33.58.58.14.25.21.51.21.79s-.07.54-.21.78-.33.43-.58.58-.5.21-.78.21-.55-.07-.79-.21c-.25-.14-.44-.33-.58-.58s-.21-.51-.21-.79.07-.55.21-.79.34-.44.58-.58c.25-.14.51-.21.78-.21Zm4.42,0l-4.65,7h-.82l4.65-7h.82Zm-5.17,1.58c0,.21.07.39.22.54s.32.23.53.23.38-.07.52-.22.21-.33.21-.55-.07-.4-.21-.55c-.14-.15-.32-.23-.52-.23s-.38.08-.53.23c-.15.15-.22.34-.22.55Zm4.13,2.27c.28,0,.54.07.78.21.25.14.44.34.58.58.14.24.21.51.21.79s-.07.54-.21.78-.33.43-.57.57c-.24.14-.5.21-.78.21s-.55-.07-.79-.21-.44-.33-.58-.57c-.14-.24-.21-.51-.21-.79s.07-.54.21-.79.34-.44.59-.58.51-.21.78-.21Zm-.75,1.58c0,.22.08.41.22.55s.33.22.53.22.38-.07.52-.22.22-.33.22-.55c0-.21-.07-.39-.22-.54-.14-.16-.32-.24-.52-.24s-.39.08-.53.23-.22.34-.22.55Z" />
        </g>
        <g>
          <path
            className="cls-17"
            d="m299.03,133.35h7.98v1.22h-3.33v8.35h-1.37v-8.35h-3.27v-1.22Z"
          />
          <path
            className="cls-17"
            d="m308.1,133.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m315.77,133.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m317.89,142.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m332.19,141.45v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m333.58,133.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m344.56,139.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m347.91,136.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m351.52,137.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m360.65,142.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m366.32,133.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m376.35,136.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m388.79,136.63h1.33l-2.78,6.4h-.4l-1.86-4.38-1.84,4.38h-.4l-2.8-6.4h1.34l1.65,3.81,1.61-3.81h.92l1.59,3.81,1.64-3.81Z"
          />
          <path
            className="cls-17"
            d="m390.69,142.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m404.47,133.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m411.36,139.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m412.51,137.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m422,139.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m431.77,136.63h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.63-3.87Z"
          />
          <path
            className="cls-17"
            d="m434.69,133.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m436.53,136.63h5.37l-3.33,5.13h3.33v1.16h-5.51l3.31-5.13h-3.17v-1.16Z"
          />
          <path
            className="cls-17"
            d="m445.96,137.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m454.51,136.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3c.64-.61,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58c.39-.39.58-.88.58-1.48s-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m462.24,136.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3c.64-.61,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58c.39-.39.58-.88.58-1.48s-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path className="cls-17" d="m466.98,133.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m469.72,142.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m483.31,142.92v-.81c-.26.29-.57.51-.91.67-.34.16-.68.24-1.02.24-.4,0-.76-.1-1.1-.3-.33-.2-.59-.47-.76-.81-.17-.34-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38.19.26.52.39.99.39.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m485.99,142.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m497.05,139.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m502.59,133.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88-.55-.59-.83-1.38-.83-2.37,0-.93.29-1.69.87-2.28.58-.6,1.32-.9,2.23-.9.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61-.37.41-.55.95-.55,1.64,0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m509.36,133.37h1.24v3.71c.54-.39,1.11-.59,1.72-.59.8,0,1.45.3,1.96.9s.76,1.37.76,2.32c0,1.01-.3,1.82-.91,2.42-.6.6-1.41.9-2.42.9-.41,0-.83-.04-1.28-.13-.45-.09-.8-.2-1.07-.33v-9.2Zm1.24,4.9v3.4c.42.13.86.19,1.31.19.55,0,1-.2,1.35-.59.35-.39.52-.9.52-1.51s-.16-1.13-.49-1.52c-.33-.39-.75-.59-1.28-.59-.46,0-.94.21-1.42.62Z"
          />
          <path
            className="cls-17"
            d="m520.14,136.63h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m530.26,139.14v2.67c0,.21.07.32.22.32s.38-.11.7-.33v.76c-.28.18-.51.31-.68.37-.17.07-.35.1-.54.1-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06.29-.31.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57c.03.19.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51-.18.17-.26.38-.26.64s.08.47.25.64c.17.16.38.25.65.25.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m531.4,137.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.2-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path className="cls-17" d="m299.7,149.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m308.1,155.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m313.4,155.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m315.11,158.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m319.93,153.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path className="cls-17" d="m331.31,149.37h1.37v9.55h-1.37v-9.55Z" />
          <path
            className="cls-17"
            d="m339.03,149.25c.88,0,1.6.46,2.17,1.38s.86,2.08.86,3.5-.29,2.63-.86,3.53-1.31,1.36-2.23,1.36-1.67-.44-2.23-1.33-.84-2.07-.84-3.53.29-2.63.87-3.54,1.33-1.36,2.26-1.36Zm.01,1.3h-.07c-.52,0-.94.32-1.25.97s-.46,1.52-.46,2.62.15,2.02.45,2.66.72.96,1.24.96.95-.32,1.25-.96.46-1.52.46-2.62-.15-1.99-.44-2.65-.69-.98-1.19-.98Z"
          />
          <path
            className="cls-17"
            d="m346.03,149.25c.88,0,1.6.46,2.17,1.38s.86,2.08.86,3.5-.29,2.63-.86,3.53-1.31,1.36-2.23,1.36-1.67-.44-2.23-1.33-.84-2.07-.84-3.53.29-2.63.87-3.54,1.33-1.36,2.26-1.36Zm.01,1.3h-.07c-.52,0-.94.32-1.25.97s-.46,1.52-.46,2.62.15,2.02.45,2.66.72.96,1.24.96.95-.32,1.25-.96.46-1.52.46-2.62-.15-1.99-.44-2.65-.69-.98-1.19-.98Z"
          />
          <path
            className="cls-17"
            d="m357.26,152.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m362.12,152.63v-.38c0-1.01.22-1.77.65-2.26s.95-.75,1.55-.75c.26,0,.57.04.92.12v1.22c-.2-.07-.39-.11-.57-.11-.49,0-.83.13-1.02.39s-.28.72-.28,1.39v.38h1.12v1.12h-1.12v5.17h-1.24v-5.17h-.9v-1.12h.9Z"
          />
          <path
            className="cls-17"
            d="m368.48,153.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m374,149.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m386.39,155.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m391.31,158.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m401.01,158.92v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m405.34,152.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m413.82,152.63h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.63-3.87Z"
          />
          <path
            className="cls-17"
            d="m421.18,155.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m426.18,152.63h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m433.67,152.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m442.96,155.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m444,158.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m449.61,162.12v-9.5h2.18c1.12,0,1.98.28,2.61.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32s-1.33.91-2.24.91c-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61.37-.41.56-.93.56-1.57,0-.41-.09-.77-.26-1.09s-.41-.54-.72-.69c-.3-.14-.75-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m459.7,152.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3c.64-.61,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58c.39-.39.58-.88.58-1.48s-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m465.66,152.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83c.17.35.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m475.62,149.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88-.55-.59-.83-1.38-.83-2.37,0-.93.29-1.69.87-2.28.58-.6,1.32-.9,2.23-.9.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61-.37.41-.55.95-.55,1.64,0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m483.91,155.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m486.5,152.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83c.17.35.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38-.2-.28-.52-.41-.98-.41-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m491.38,153.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.2-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m496.62,158.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m502.95,157.39c.23,0,.43.08.59.24s.25.36.25.59-.08.42-.24.57c-.16.15-.36.23-.6.23s-.43-.08-.59-.23-.24-.35-.24-.57.08-.43.24-.59.36-.24.59-.24Z"
          />
          <path
            className="cls-17"
            d="m299.84,181.37h5.41v1.22h-4.05v2.91h3.91v1.22h-3.91v2.97h4.18v1.22h-5.54v-9.54Z"
          />
          <path
            className="cls-17"
            d="m310.62,187.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m317.36,189.45v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m318.75,181.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m328.79,185.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m337.34,184.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m345.06,184.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path className="cls-17" d="m349.81,181.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m356.43,190.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m362.1,181.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m372.13,184.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m384.57,184.63h1.33l-2.78,6.4h-.4l-1.86-4.38-1.84,4.38h-.4l-2.8-6.4h1.34l1.65,3.81,1.61-3.81h.92l1.59,3.81,1.64-3.81Z"
          />
          <path
            className="cls-17"
            d="m388.03,184.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m398.31,181.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m401.99,184.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m412.46,189.45v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path className="cls-17" d="m413.9,181.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m420.95,190.92v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m428.14,181.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m436.44,187.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m437.48,190.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m447.7,181.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22-.15-.15-.22-.32-.22-.52s.07-.36.22-.51c.15-.15.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m449.25,185.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.2-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m454.49,190.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m465.4,184.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57-.29.38-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m474.69,187.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m475.73,190.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m481.34,194.12v-9.5h2.18c1.12,0,1.98.28,2.61.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32s-1.33.91-2.24.91c-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61.37-.41.56-.93.56-1.57,0-.41-.09-.77-.26-1.09s-.41-.54-.72-.69c-.3-.14-.75-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m493.79,187.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33.54-.6,1.25-.9,2.11-.9s1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m499.85,189.45v1.23c-.62.23-1.24.35-1.83.35-.98,0-1.77-.29-2.35-.88-.59-.58-.88-1.36-.88-2.34s.29-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09.26.06.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.2,1.15.58,1.53.39.38.92.57,1.58.57.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m500.38,185.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.2-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m506.57,181.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m512.85,184.63h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.64-3.87Z"
          />
          <path
            className="cls-17"
            d="m520.21,187.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m304.24,199.21c-.37-.09-.68-.13-.91-.13-.26,0-.47.09-.62.26s-.22.42-.22.74v.25h1.24v1.67h-1.24v4.93h-2.47v-4.93h-1.13v-1.67h1.13v-.12c0-.49.09-.95.28-1.38s.5-.79.95-1.08,1.03-.42,1.75-.42c.41,0,.82.04,1.24.13v1.76Z"
          />
          <path
            className="cls-17"
            d="m310.86,200.34l-.91,2.47c-.37-.36-.75-.53-1.13-.53-.35,0-.65.12-.9.35s-.5.67-.73,1.3v2.99h-2.46v-6.96h2.46v1.68c.15-.41.43-.82.82-1.21s.85-.59,1.38-.59c.28,0,.52.04.73.12s.45.21.74.38Z"
          />
          <path
            className="cls-17"
            d="m318.18,204.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51s-1.17.23-1.96.23c-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3-.45-1.17-.45-1.86.15-1.3.45-1.84.75-.96,1.35-1.27,1.33-.46,2.19-.46c.56,0,1.11.12,1.64.37s.96.64,1.3,1.2.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07s-.54-.4-.95-.4-.74.14-.99.41-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m326.76,210.08h-2.47v-3.57c-.18.11-.34.2-.47.27s-.31.12-.55.18-.52.08-.84.08c-.73,0-1.35-.17-1.86-.52s-.88-.8-1.11-1.35-.36-1.15-.36-1.78c0-.81.16-1.48.47-2.01s.72-.92,1.2-1.17.98-.38,1.49-.38c.36,0,.68.04.94.13s.48.18.64.28.31.22.44.34v-.63h2.47v10.12Zm-2.47-5.25v-2.66c-.14-.13-.31-.25-.51-.35s-.44-.15-.74-.15c-.36,0-.68.14-.95.42s-.41.73-.41,1.34c0,.56.13,1.01.39,1.34s.58.49.96.49c.22,0,.4-.03.55-.09s.38-.18.69-.35Z"
          />
          <path
            className="cls-17"
            d="m335.64,206.92h-2.46v-.99c-.35.37-.71.65-1.09.84-.38.18-.84.28-1.37.28-1.05,0-1.73-.31-2.04-.92s-.46-1.3-.46-2.07v-4.09h2.46v3.76c0,.38.06.71.19.99s.4.43.82.43c.36,0,.65-.1.86-.31.21-.21.43-.47.64-.79v-4.09h2.46v6.96Z"
          />
          <path
            className="cls-17"
            d="m344.36,204.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51s-1.17.23-1.96.23c-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3-.45-1.17-.45-1.86.15-1.3.45-1.84.75-.96,1.35-1.27,1.33-.46,2.19-.46c.56,0,1.11.12,1.64.37s.96.64,1.3,1.2.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07s-.54-.4-.95-.4-.74.14-.99.41-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m353,206.92h-2.46v-3.75c0-.38-.06-.72-.19-1s-.4-.43-.82-.43c-.2,0-.38.04-.53.11s-.29.17-.41.29-.22.23-.3.34-.17.23-.25.35v4.09h-2.46v-6.96h2.46v1c.39-.41.78-.71,1.17-.87s.82-.25,1.3-.25c1.67,0,2.5,1,2.5,2.99v4.09Z"
          />
          <path
            className="cls-17"
            d="m360.44,206.6c-.21.08-.42.15-.65.22s-.48.12-.77.16-.6.06-.93.06c-.76,0-1.4-.13-1.93-.39s-.93-.58-1.22-.97-.48-.79-.59-1.19-.16-.76-.16-1.07.06-.67.17-1.07.31-.8.58-1.18.68-.69,1.21-.95,1.17-.38,1.94-.38c.52,0,.93.04,1.26.11s.65.17.98.29v1.93c-.8-.26-1.43-.38-1.88-.38s-.83.13-1.17.4-.51.67-.51,1.23c0,.37.08.68.25.93s.38.44.64.56.52.18.78.18c.25,0,.53-.04.84-.11s.7-.18,1.15-.31v1.93Z"
          />
          <path
            className="cls-17"
            d="m369.09,199.96l-4.73,10.12h-2.49l1.91-4.07-2.75-6.05h2.65l1.42,3.46,1.61-3.46h2.39Z"
          />
          <path
            className="cls-17"
            d="m381.28,206.92h-2.46v-.99c-.35.37-.71.65-1.09.84-.38.18-.84.28-1.37.28-1.05,0-1.73-.31-2.04-.92s-.46-1.3-.46-2.07v-4.09h2.46v3.76c0,.38.06.71.19.99s.4.43.82.43c.36,0,.65-.1.86-.31.21-.21.43-.47.64-.79v-4.09h2.46v6.96Z"
          />
          <path
            className="cls-17"
            d="m388.3,204.89c0,.64-.23,1.16-.7,1.56s-1.16.6-2.08.6c-.52,0-.97-.05-1.37-.14s-.84-.23-1.31-.4v-1.75c.41.24.77.42,1.08.54s.64.18,1,.18c.62,0,.92-.17.92-.51,0-.11-.04-.22-.13-.3s-.24-.19-.46-.3-.52-.25-.89-.4c-.46-.2-.84-.47-1.16-.81s-.48-.75-.48-1.24c0-.35.11-.68.32-1s.53-.58.96-.78.95-.3,1.55-.3c.15,0,.33.01.56.03s.51.07.85.16.67.21.98.37v1.7c-.15-.09-.27-.16-.37-.22s-.23-.13-.39-.2-.36-.14-.58-.19-.45-.09-.68-.09c-.28,0-.48.05-.58.16s-.16.22-.16.33.05.22.16.32.35.22.73.37c.55.21.98.42,1.31.65s.56.46.7.73.21.58.21.94Z"
          />
          <path
            className="cls-17"
            d="m396.77,204.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51s-1.17.23-1.96.23c-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3-.45-1.17-.45-1.86.15-1.3.45-1.84.75-.96,1.35-1.27,1.33-.46,2.19-.46c.56,0,1.11.12,1.64.37s.96.64,1.3,1.2.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07s-.54-.4-.95-.4-.74.14-.99.41-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m405.34,206.92h-2.47v-.63c-.26.22-.53.4-.82.54s-.69.21-1.2.21-1-.13-1.49-.38-.89-.64-1.2-1.17-.47-1.2-.47-2.01c0-.63.12-1.23.36-1.78s.61-1,1.11-1.35,1.13-.52,1.86-.52c.46,0,.82.05,1.11.15s.53.23.75.38v-2.93h2.47v9.47Zm-2.47-2.21v-2.66c-.29-.16-.51-.27-.67-.34s-.35-.1-.57-.1c-.39,0-.71.16-.97.49s-.39.77-.39,1.34c0,.62.14,1.06.41,1.34s.59.42.95.42c.3,0,.54-.05.72-.14s.36-.21.53-.35Z"
          />
          <path
            className="cls-17"
            d="m418.28,206.57c-.36.14-.69.26-1,.34s-.67.13-1.1.13c-.41,0-.69-.07-.85-.22s-.27-.32-.34-.52c-.26.21-.56.39-.88.53s-.75.21-1.27.21-.92-.09-1.23-.26-.53-.4-.66-.66-.19-.54-.19-.82c0-.43.11-.78.32-1.06s.51-.51.87-.69.85-.36,1.45-.55c.34-.11.6-.19.78-.25s.31-.1.39-.13.18-.07.27-.12c0-.34-.07-.6-.21-.79s-.43-.29-.89-.29c-.54,0-1.04.12-1.5.36s-.88.54-1.26.92v-1.89c.31-.22.64-.4.99-.54s.73-.24,1.11-.31.78-.1,1.18-.1c1.01,0,1.76.19,2.27.58s.76.93.76,1.61v2.69c0,.26.02.45.07.57s.14.19.26.19c.15,0,.36-.07.63-.2v1.29Zm-3.42-1.33v-1.65c-.58.24-1.01.45-1.28.64s-.4.45-.4.77c0,.23.07.41.2.53s.29.18.47.18c.17,0,.34-.05.5-.14s.34-.21.51-.34Z"
          />
          <path
            className="cls-17"
            d="m426.68,206.92h-2.46v-3.75c0-.38-.06-.72-.19-1s-.4-.43-.82-.43c-.2,0-.38.04-.53.11s-.29.17-.41.29-.22.23-.3.34-.17.23-.25.35v4.09h-2.46v-6.96h2.46v1c.39-.41.78-.71,1.17-.87s.82-.25,1.3-.25c1.67,0,2.5,1,2.5,2.99v4.09Z"
          />
          <path
            className="cls-17"
            d="m435.52,206.92h-2.47v-.63c-.26.22-.53.4-.82.54s-.69.21-1.2.21-1-.13-1.49-.38-.89-.64-1.2-1.17-.47-1.2-.47-2.01c0-.63.12-1.23.36-1.78s.61-1,1.11-1.35,1.13-.52,1.86-.52c.46,0,.82.05,1.11.15s.53.23.75.38v-2.93h2.47v9.47Zm-2.47-2.21v-2.66c-.29-.16-.51-.27-.67-.34s-.35-.1-.57-.1c-.39,0-.71.16-.97.49s-.39.77-.39,1.34c0,.62.14,1.06.41,1.34s.59.42.95.42c.3,0,.54-.05.72-.14s.36-.21.53-.35Z"
          />
          <path
            className="cls-17"
            d="m443.82,206.92h-2.47v-6.96h2.47v6.96Zm-.2-8.57c0,.29-.1.53-.31.73s-.45.3-.73.3c-.19,0-.37-.05-.52-.14s-.28-.22-.37-.37-.14-.33-.14-.52c0-.28.1-.53.3-.73s.44-.31.73-.31.53.1.73.31.31.45.31.73Z"
          />
          <path
            className="cls-17"
            d="m451.01,206.52c-.25.12-.61.24-1.06.36-.45.11-.88.17-1.29.17-1.77,0-2.66-.87-2.66-2.6v-2.78h-1.11v-.43l3.3-3.36h.28v2.08h2.35v1.71h-2.35v2.23c0,.26.02.47.05.63s.12.29.27.4c.15.11.37.16.67.16.39,0,.91-.16,1.54-.49v1.92Z"
          />
          <path
            className="cls-17"
            d="m457.53,204.89c0,.64-.23,1.16-.7,1.56-.47.4-1.16.6-2.08.6-.51,0-.97-.05-1.37-.14s-.84-.23-1.31-.4v-1.75c.42.24.77.42,1.08.54s.64.18,1,.18c.62,0,.92-.17.92-.51,0-.11-.04-.22-.13-.3-.09-.09-.24-.19-.46-.3-.22-.11-.52-.25-.88-.4-.46-.2-.84-.47-1.16-.81s-.48-.75-.48-1.24c0-.35.11-.68.32-1,.21-.32.53-.58.96-.78s.95-.3,1.55-.3c.15,0,.33.01.56.03.23.02.51.07.86.16.34.09.67.21.98.37v1.7c-.15-.09-.27-.16-.37-.22-.1-.06-.23-.13-.39-.2s-.36-.14-.58-.19c-.22-.06-.45-.09-.68-.09-.28,0-.48.05-.58.16s-.16.22-.16.33.05.22.16.32.35.22.73.37c.55.21.98.42,1.31.65s.56.46.7.73c.14.26.21.58.21.94Z"
          />
          <path className="cls-17" d="m465.61,206.92h-2.47v-9.47h2.47v9.47Z" />
          <path
            className="cls-17"
            d="m469.89,206.92h-2.47v-6.96h2.47v6.96Zm-.2-8.57c0,.29-.1.53-.31.73s-.45.3-.73.3c-.19,0-.37-.05-.52-.14-.16-.09-.28-.22-.37-.37s-.14-.33-.14-.52c0-.28.1-.53.3-.73s.44-.31.73-.31.53.1.73.31.31.45.31.73Z"
          />
          <path
            className="cls-17"
            d="m479.86,206.92h-3.12l-2.67-3.3v3.3h-2.49v-9.47h2.49v5.56l2.44-3.04h2.95l-2.72,3.25,3.12,3.71Z"
          />
          <path
            className="cls-17"
            d="m487.18,204.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51-.51.15-1.17.23-1.96.23-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3c-.3-.55-.45-1.17-.45-1.86s.15-1.3.45-1.84c.3-.54.75-.96,1.35-1.27s1.33-.46,2.19-.46c.57,0,1.11.12,1.64.37.53.24.96.64,1.3,1.2.34.55.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07-.22-.27-.54-.4-.95-.4s-.74.14-1,.41c-.25.27-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m495.61,206.57c-.36.14-.69.26-1,.34s-.67.13-1.1.13c-.41,0-.69-.07-.85-.22s-.27-.32-.34-.52c-.26.21-.56.39-.88.53s-.75.21-1.27.21-.92-.09-1.23-.26c-.31-.18-.53-.4-.66-.66-.12-.27-.19-.54-.19-.82,0-.43.11-.78.32-1.06.22-.28.51-.51.87-.69.36-.18.85-.36,1.45-.55.34-.11.6-.19.78-.25.17-.06.31-.1.39-.13s.18-.07.27-.12c0-.34-.07-.6-.21-.79s-.43-.29-.89-.29c-.54,0-1.04.12-1.5.36s-.88.54-1.27.92v-1.89c.31-.22.64-.4.99-.54.36-.14.73-.24,1.11-.31s.78-.1,1.18-.1c1.01,0,1.76.19,2.27.58.51.39.76.93.76,1.61v2.69c0,.26.02.45.07.57.05.13.13.19.26.19.16,0,.36-.07.63-.2v1.29Zm-3.42-1.33v-1.65c-.58.24-1.01.45-1.28.64s-.4.45-.4.77c0,.23.07.41.2.53.13.12.29.18.47.18s.34-.05.5-.14c.17-.09.34-.21.51-.34Z"
          />
          <path
            className="cls-17"
            d="m504.22,203.49c0,.81-.16,1.48-.47,2.01s-.72.92-1.2,1.17-.98.38-1.49.38c-.36,0-.68-.04-.95-.13-.27-.08-.47-.18-.62-.27-.15-.1-.3-.22-.46-.35v.63h-2.46v-9.47h2.46v2.93c.18-.14.43-.27.75-.37s.69-.16,1.11-.16c.56,0,1.05.1,1.48.3s.78.48,1.05.82c.27.35.47.73.61,1.17s.2.88.2,1.36Zm-2.59-.05c0-.6-.13-1.05-.4-1.36s-.59-.47-.96-.47-.78.15-1.24.44v2.66c.35.33.76.49,1.24.49.31,0,.61-.12.91-.37s.45-.71.45-1.39Z"
          />
          <path
            className="cls-17"
            d="m508.09,206.92h-2.47v-6.96h2.47v6.96Zm-.2-8.57c0,.29-.1.53-.31.73s-.45.3-.73.3c-.19,0-.37-.05-.52-.14-.16-.09-.28-.22-.37-.37s-.14-.33-.14-.52c0-.28.1-.53.3-.73s.44-.31.73-.31.53.1.73.31.31.45.31.73Z"
          />
          <path className="cls-17" d="m512.38,206.92h-2.47v-9.47h2.47v9.47Z" />
          <path
            className="cls-17"
            d="m516.67,206.92h-2.47v-6.96h2.47v6.96Zm-.2-8.57c0,.29-.1.53-.31.73s-.45.3-.73.3c-.19,0-.37-.05-.52-.14-.16-.09-.28-.22-.37-.37s-.14-.33-.14-.52c0-.28.1-.53.3-.73s.44-.31.73-.31.53.1.73.31.31.45.31.73Z"
          />
          <path
            className="cls-17"
            d="m523.85,206.52c-.25.12-.61.24-1.06.36-.45.11-.88.17-1.29.17-1.77,0-2.66-.87-2.66-2.6v-2.78h-1.11v-.43l3.3-3.36h.28v2.08h2.35v1.71h-2.35v2.23c0,.26.02.47.05.63s.12.29.27.4c.15.11.37.16.67.16.39,0,.91-.16,1.54-.49v1.92Z"
          />
          <path
            className="cls-17"
            d="m532.39,199.96l-4.73,10.12h-2.49l1.91-4.07-2.75-6.05h2.65l1.42,3.46,1.61-3.46h2.39Z"
          />
          <path
            className="cls-17"
            d="m537.02,197.37h1.24v3.71c.54-.39,1.11-.59,1.72-.59.8,0,1.45.3,1.96.9s.76,1.37.76,2.32c0,1.01-.3,1.82-.91,2.42-.6.6-1.41.9-2.42.9-.41,0-.83-.04-1.28-.13-.45-.09-.8-.2-1.07-.33v-9.2Zm1.24,4.9v3.4c.42.13.86.19,1.31.19.55,0,1-.2,1.35-.59.35-.39.52-.9.52-1.51s-.16-1.13-.49-1.52c-.33-.39-.75-.59-1.28-.59-.46,0-.94.21-1.42.62Z"
          />
          <path
            className="cls-17"
            d="m547.8,200.63h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m299.36,222.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m309.06,222.92v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m313.39,216.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m321.87,216.63h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.63-3.87Z"
          />
          <path
            className="cls-17"
            d="m329.23,219.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m334.23,216.63h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m341.72,216.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m351.01,219.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m352.05,222.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m357.66,226.12v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m367.75,216.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m373.71,216.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m383.66,213.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m391.96,219.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m394.55,216.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m399.43,217.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m404.66,222.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m411,221.39c.23,0,.43.08.59.24s.25.36.25.59-.08.42-.24.57-.36.23-.6.23-.43-.08-.59-.23-.24-.35-.24-.57.08-.43.24-.59.36-.24.59-.24Z"
          />
          <path
            className="cls-17"
            d="m299.03,245.35h7.98v1.22h-3.33v8.35h-1.37v-8.35h-3.27v-1.22Z"
          />
          <path
            className="cls-17"
            d="m308.1,245.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m320.49,251.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m329.92,245.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m336.81,251.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m337.95,249.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m347.45,251.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m357.37,254.92v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m360.05,254.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m371.11,251.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m376.65,245.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m383.62,248.63v-.38c0-1.01.22-1.77.65-2.26s.95-.75,1.55-.75c.26,0,.57.04.92.12v1.22c-.2-.07-.39-.11-.57-.11-.49,0-.83.13-1.02.39s-.28.72-.28,1.39v.38h1.12v1.12h-1.12v5.17h-1.24v-5.17h-.9v-1.12h.9Z"
          />
          <path
            className="cls-17"
            d="m389.85,248.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m395.9,248.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m403.12,249.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m408.64,245.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m416.31,245.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m418.43,254.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m432.73,253.45v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m434.11,245.37h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m445.09,251.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m448.45,248.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57-.29.38-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m452.06,249.63l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.2-.49c-.05-.2-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m468.76,254.92h-2.47v-.63c-.26.22-.53.4-.82.54-.29.14-.69.21-1.2.21s-1-.13-1.49-.38-.89-.64-1.2-1.17-.47-1.2-.47-2.01c0-.63.12-1.23.36-1.78s.61-1,1.11-1.35,1.13-.52,1.86-.52c.46,0,.83.05,1.11.15s.53.23.75.38v-2.93h2.47v9.47Zm-2.47-2.21v-2.66c-.29-.16-.51-.27-.67-.34-.16-.07-.35-.1-.57-.1-.39,0-.71.16-.97.49-.26.33-.39.77-.39,1.34,0,.62.14,1.06.41,1.34.27.28.59.42.95.42.3,0,.54-.05.72-.14s.36-.21.53-.35Z"
          />
          <path
            className="cls-17"
            d="m478,251.43c0,.69-.15,1.31-.45,1.85s-.75.97-1.35,1.29c-.6.31-1.33.47-2.19.47s-1.59-.16-2.19-.47c-.6-.31-1.05-.74-1.35-1.29-.3-.54-.45-1.16-.45-1.85,0-.52.08-1,.25-1.43.17-.43.42-.81.76-1.14.34-.33.76-.58,1.25-.76s1.07-.27,1.72-.27,1.24.09,1.74.27c.5.18.92.43,1.25.76.33.32.58.7.75,1.13s.25.91.25,1.44Zm-2.59,0c0-.55-.12-.98-.36-1.3-.24-.31-.59-.47-1.04-.47s-.8.16-1.04.47c-.24.31-.36.74-.36,1.3s.12.98.36,1.3.59.48,1.03.48.8-.16,1.04-.48c.24-.32.36-.75.36-1.3Z"
          />
          <path
            className="cls-17"
            d="m486.42,252.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51-.51.15-1.17.23-1.96.23-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3c-.3-.55-.45-1.17-.45-1.86s.15-1.3.45-1.84c.3-.54.75-.96,1.35-1.27s1.33-.46,2.19-.46c.57,0,1.11.12,1.64.37.53.24.96.64,1.3,1.2.34.55.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07-.22-.27-.54-.4-.95-.4s-.74.14-1,.41c-.25.27-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m493.07,252.89c0,.64-.23,1.16-.7,1.56-.47.4-1.16.6-2.08.6-.51,0-.97-.05-1.37-.14-.4-.09-.84-.23-1.31-.4v-1.75c.42.24.77.42,1.08.54s.64.18,1.01.18c.62,0,.92-.17.92-.51,0-.11-.04-.22-.13-.3-.09-.09-.24-.19-.46-.3-.22-.11-.52-.25-.88-.4-.46-.2-.84-.47-1.16-.81s-.48-.75-.48-1.24c0-.35.11-.68.32-1,.21-.32.53-.58.96-.78.43-.2.95-.3,1.55-.3.15,0,.33.01.56.03.23.02.51.07.86.16.34.09.67.21.98.37v1.7c-.15-.09-.27-.16-.37-.22-.1-.06-.23-.13-.39-.2s-.36-.14-.58-.19c-.22-.06-.45-.09-.68-.09-.28,0-.48.05-.58.16s-.16.22-.16.33.05.22.16.32.35.22.73.37c.55.21.98.42,1.31.65s.56.46.7.73c.14.26.21.58.21.94Z"
          />
          <path
            className="cls-17"
            d="m505.99,254.92h-2.46v-3.75c0-.38-.06-.72-.19-1-.13-.28-.4-.43-.82-.43-.2,0-.38.04-.53.11-.15.08-.29.17-.41.29-.12.12-.22.23-.3.34s-.17.23-.25.35v4.09h-2.46v-6.96h2.46v1c.39-.41.78-.71,1.17-.87.39-.17.82-.25,1.3-.25,1.67,0,2.5,1,2.5,2.99v4.09Z"
          />
          <path
            className="cls-17"
            d="m515.15,251.43c0,.69-.15,1.31-.45,1.85s-.75.97-1.35,1.29c-.6.31-1.33.47-2.19.47s-1.59-.16-2.19-.47c-.6-.31-1.05-.74-1.35-1.29-.3-.54-.45-1.16-.45-1.85,0-.52.08-1,.25-1.43.17-.43.42-.81.76-1.14.34-.33.76-.58,1.25-.76s1.07-.27,1.72-.27,1.24.09,1.74.27c.5.18.92.43,1.25.76.33.32.58.7.75,1.13s.25.91.25,1.44Zm-2.59,0c0-.55-.12-.98-.36-1.3-.24-.31-.59-.47-1.04-.47s-.8.16-1.04.47c-.24.31-.36.74-.36,1.3s.12.98.36,1.3.59.48,1.03.48.8-.16,1.04-.48c.24-.32.36-.75.36-1.3Z"
          />
          <path
            className="cls-17"
            d="m521.92,254.52c-.25.12-.61.24-1.06.36-.45.11-.88.17-1.29.17-1.77,0-2.66-.87-2.66-2.6v-2.78h-1.11v-.43l3.3-3.36h.28v2.08h2.35v1.71h-2.35v2.23c0,.26.02.47.05.63s.12.29.27.4c.15.11.37.16.67.16.39,0,.91-.16,1.54-.49v1.92Z"
          />
          <path
            className="cls-17"
            d="m529.74,254.92h-2.47v-6.96h2.47v6.96Zm-.2-8.57c0,.29-.1.53-.31.73s-.45.3-.73.3c-.19,0-.37-.05-.52-.14-.16-.09-.28-.22-.37-.37s-.14-.33-.14-.52c0-.28.1-.53.3-.73s.44-.31.73-.31.53.1.73.31.31.45.31.73Z"
          />
          <path
            className="cls-17"
            d="m538.87,254.92h-2.46v-3.75c0-.38-.06-.72-.19-1-.13-.28-.4-.43-.82-.43-.2,0-.38.04-.53.11-.15.08-.29.17-.41.29-.12.12-.22.23-.3.34s-.17.23-.25.35v4.09h-2.46v-6.96h2.46v1c.39-.41.78-.71,1.17-.87.39-.17.82-.25,1.3-.25,1.67,0,2.5,1,2.5,2.99v4.09Z"
          />
          <path
            className="cls-17"
            d="m546.31,254.6c-.21.08-.42.15-.65.22s-.48.12-.77.16c-.28.04-.6.06-.93.06-.76,0-1.41-.13-1.93-.39-.53-.26-.93-.58-1.22-.97-.29-.39-.48-.79-.59-1.19s-.16-.76-.16-1.07.06-.67.17-1.07c.11-.41.31-.8.58-1.18s.68-.69,1.21-.95c.53-.26,1.17-.38,1.94-.38.51,0,.93.04,1.26.11s.65.17.98.29v1.93c-.8-.26-1.43-.38-1.88-.38s-.83.13-1.17.4c-.34.26-.51.67-.51,1.23,0,.37.08.68.25.93s.38.44.64.56.52.18.78.18c.25,0,.53-.04.84-.11s.7-.18,1.15-.31v1.93Z"
          />
          <path className="cls-17" d="m550.09,254.92h-2.47v-9.47h2.47v9.47Z" />
          <path
            className="cls-17"
            d="m559.12,254.92h-2.46v-.99c-.35.37-.71.65-1.09.84-.38.18-.84.28-1.37.28-1.05,0-1.73-.31-2.04-.92-.31-.61-.46-1.3-.46-2.07v-4.09h2.46v3.76c0,.38.06.71.19.99s.4.43.82.43c.36,0,.65-.1.86-.31s.42-.47.64-.79v-4.09h2.46v6.96Z"
          />
          <path
            className="cls-17"
            d="m568.06,254.92h-2.47v-.63c-.26.22-.53.4-.82.54-.29.14-.69.21-1.2.21s-1-.13-1.49-.38-.89-.64-1.2-1.17-.47-1.2-.47-2.01c0-.63.12-1.23.36-1.78s.61-1,1.11-1.35,1.13-.52,1.86-.52c.46,0,.83.05,1.11.15s.53.23.75.38v-2.93h2.47v9.47Zm-2.47-2.21v-2.66c-.29-.16-.51-.27-.67-.34-.16-.07-.35-.1-.57-.1-.39,0-.71.16-.97.49-.26.33-.39.77-.39,1.34,0,.62.14,1.06.41,1.34.27.28.59.42.95.42.3,0,.54-.05.72-.14s.36-.21.53-.35Z"
          />
          <path
            className="cls-17"
            d="m576.75,252.03h-4.9c.1.42.33.77.7,1.04s.8.4,1.27.4c.83,0,1.75-.23,2.75-.7v1.52c-.36.19-.8.36-1.31.51-.51.15-1.17.23-1.96.23-.86,0-1.59-.16-2.19-.48s-1.05-.75-1.35-1.3c-.3-.55-.45-1.17-.45-1.86s.15-1.3.45-1.84c.3-.54.75-.96,1.35-1.27s1.33-.46,2.19-.46c.57,0,1.11.12,1.64.37.53.24.96.64,1.3,1.2.34.55.51,1.27.51,2.14v.49Zm-2.31-1.22c0-.45-.11-.8-.33-1.07-.22-.27-.54-.4-.95-.4s-.74.14-1,.41c-.25.27-.38.63-.38,1.06h2.66Z"
          />
          <path
            className="cls-17"
            d="m303.68,270.92v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m307.92,264.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m317.62,267.14v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m320.89,264.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m326.34,270.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m339.76,264.63h1.33l-2.78,6.4h-.4l-1.86-4.38-1.84,4.38h-.4l-2.8-6.4h1.34l1.65,3.81,1.61-3.81h.92l1.59,3.81,1.64-3.81Z"
          />
          <path
            className="cls-17"
            d="m347.04,267.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m349.72,264.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m359.01,267.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m364.56,261.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m367.3,272.57v-.25c.21-.2.35-.39.43-.59s.13-.47.14-.81c-.48-.14-.72-.44-.72-.9,0-.25.08-.46.25-.64s.36-.27.59-.27c.28,0,.51.12.68.37s.27.56.27.94c0,.51-.15.95-.44,1.33s-.69.65-1.2.81Z"
          />
          <path
            className="cls-17"
            d="m372.75,270.47v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m378.44,261.37h1.24v9.55h-1.24v-9.55Zm4.09,3.26h1.48l-2.68,3.08,3.23,3.21h-1.67l-3.15-3.21,2.79-3.08Z"
          />
          <path
            className="cls-17"
            d="m385.79,261.98c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m388.14,274.12v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m395.14,274.12v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m407.58,267.88h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m413.12,261.37h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m422.96,264.62c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m429.01,264.63v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m438.35,264.63v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m447.98,270.92v-.81c-.26.29-.57.51-.91.67-.34.16-.68.24-1.01.24-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path className="cls-17" d="m451,261.37h1.24v9.55h-1.24v-9.55Z" />
          <path className="cls-17" d="m454.07,261.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m464.85,264.63h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.64-3.87Z"
          />
          <path
            className="cls-17"
            d="m471.08,267.14v2.67c0,.21.07.32.22.32s.38-.11.7-.33v.76c-.28.18-.51.31-.68.37-.17.07-.35.1-.54.1-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06.29-.31.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57c.03.19.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51-.18.17-.26.38-.26.64s.08.47.25.64c.17.16.38.25.65.25.4,0,.76-.16,1.1-.49Z"
          />
          <path className="cls-17" d="m473.13,261.37h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m480.18,270.92v-.81c-.26.29-.57.51-.91.67-.34.16-.68.24-1.02.24-.4,0-.76-.1-1.1-.3-.33-.2-.59-.47-.76-.81-.17-.34-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38.19.26.52.39.99.39.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m488.53,267.88h-4.42c.03.6.23,1.08.61,1.44.37.36.85.53,1.44.53.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55-.38.11-.82.16-1.32.16-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16c-.26-.49-.39-1.05-.39-1.69,0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4c-.28.27-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m489.57,270.47v-1.34c.35.25.71.45,1.08.6.37.15.68.23.93.23s.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45c-.12-.12-.38-.29-.78-.52-.8-.45-1.33-.83-1.58-1.15-.25-.32-.37-.66-.37-1.04,0-.48.19-.88.56-1.18.38-.31.86-.46,1.45-.46s1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m495.91,269.39c.23,0,.43.08.59.24s.25.36.25.59-.08.42-.24.57c-.16.15-.36.23-.6.23s-.43-.08-.59-.23-.24-.35-.24-.57.08-.43.24-.59.36-.24.59-.24Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m51.2,132.7l-4.98,11.65h-2.01l-2.99-6.78-3.06,6.78h-2.03l-4.88-11.65h3.59l2.39,6.38,2.74-6.38h2.48l2.69,6.38,2.5-6.38h3.55Z"
          />
          <path
            className="cls-17"
            d="m61.33,144.21h-2.99v-4.38s0-.06,0-.1c0-.03,0-.1,0-.19,0-.4-.09-.77-.26-1.11s-.5-.51-.98-.51c-.38,0-.71.13-1,.38-.29.25-.56.57-.82.95v4.96h-2.99v-11.5h2.99v4.27c.49-.53.98-.88,1.46-1.08.48-.19.99-.29,1.54-.29,2.03,0,3.04,1.14,3.04,3.41v5.19Z"
          />
          <path
            className="cls-17"
            d="m71.89,143.78c-.44.17-.84.31-1.21.42s-.82.16-1.34.16c-.49,0-.84-.09-1.03-.26-.19-.17-.33-.39-.42-.63-.32.26-.68.47-1.07.64-.39.17-.91.25-1.54.25s-1.11-.11-1.49-.32c-.38-.21-.65-.48-.8-.81-.15-.32-.23-.66-.23-1,0-.52.13-.95.39-1.29.26-.34.62-.62,1.06-.83s1.03-.44,1.76-.67c.42-.13.73-.23.94-.3.21-.07.37-.12.48-.16s.22-.09.33-.15c0-.41-.08-.73-.25-.96s-.53-.35-1.08-.35c-.65,0-1.26.14-1.82.43s-1.07.66-1.54,1.11v-2.29c.37-.27.77-.48,1.2-.65.43-.17.88-.29,1.35-.38s.95-.12,1.43-.12c1.22,0,2.14.24,2.76.71.62.47.93,1.12.93,1.95v3.26c0,.31.03.54.09.69.06.15.17.23.32.23.19,0,.44-.08.76-.24v1.57Zm-4.16-1.62v-2c-.71.29-1.23.55-1.55.78-.33.23-.49.54-.49.93,0,.28.08.5.25.65.16.15.35.22.57.22.2,0,.41-.06.61-.17.2-.11.41-.25.62-.41Z"
          />
          <path
            className="cls-17"
            d="m79.49,143.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m92.52,143.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m103.16,139.97c0,.84-.18,1.59-.55,2.25s-.91,1.18-1.64,1.56c-.73.38-1.61.57-2.66.57s-1.93-.19-2.66-.57c-.73-.38-1.27-.9-1.63-1.56-.36-.66-.54-1.41-.54-2.25,0-.64.1-1.21.3-1.73.2-.52.51-.98.92-1.38.41-.4.92-.71,1.52-.93s1.3-.32,2.09-.32,1.5.11,2.11.33c.61.22,1.12.52,1.52.92.4.39.7.85.91,1.38s.31,1.11.31,1.74Zm-3.15,0c0-.67-.15-1.19-.44-1.57-.29-.38-.71-.57-1.27-.57s-.97.19-1.26.57c-.29.38-.44.9-.44,1.57s.15,1.19.44,1.58.71.58,1.25.58.98-.19,1.27-.58c.29-.38.44-.91.44-1.58Z"
          />
          <path
            className="cls-17"
            d="m114.04,139.97c0,.84-.18,1.59-.55,2.25s-.91,1.18-1.64,1.56c-.73.38-1.61.57-2.66.57s-1.93-.19-2.66-.57c-.73-.38-1.27-.9-1.63-1.56-.36-.66-.54-1.41-.54-2.25,0-.64.1-1.21.3-1.73.2-.52.51-.98.92-1.38.41-.4.92-.71,1.52-.93s1.3-.32,2.09-.32,1.5.11,2.11.33c.61.22,1.12.52,1.52.92.4.39.7.85.91,1.38s.31,1.11.31,1.74Zm-3.15,0c0-.67-.15-1.19-.44-1.57-.29-.38-.71-.57-1.27-.57s-.97.19-1.26.57c-.29.38-.44.9-.44,1.57s.15,1.19.44,1.58.71.58,1.25.58.98-.19,1.27-.58c.29-.38.44-.91.44-1.58Z"
          />
          <path className="cls-17" d="m118.74,144.21h-3v-11.5h3v11.5Z" />
          <path
            className="cls-17"
            d="m127.41,141.74c0,.77-.28,1.4-.85,1.89-.57.48-1.41.73-2.53.73-.63,0-1.18-.06-1.67-.17-.49-.11-1.02-.28-1.59-.49v-2.12c.5.29.94.51,1.31.66s.78.22,1.22.22c.75,0,1.12-.2,1.12-.61,0-.14-.05-.26-.16-.37-.11-.11-.3-.23-.56-.37-.27-.14-.63-.3-1.08-.49-.55-.24-1.02-.57-1.41-.98s-.58-.91-.58-1.5c0-.42.13-.82.39-1.21.26-.39.65-.7,1.17-.95.52-.25,1.15-.37,1.88-.37.18,0,.4.01.68.04.27.03.62.09,1.04.2.42.1.81.25,1.19.45v2.07c-.18-.1-.33-.19-.44-.27-.12-.07-.28-.15-.48-.24s-.43-.17-.7-.24c-.27-.07-.54-.1-.83-.1-.34,0-.58.07-.71.2s-.19.27-.19.4.07.27.2.39c.13.12.43.27.89.44.66.25,1.2.52,1.59.78.4.27.68.56.85.88.17.32.25.7.25,1.14Z"
          />
          <path
            className="cls-17"
            d="m142.84,143.78c-.44.17-.84.31-1.21.42s-.82.16-1.34.16c-.49,0-.84-.09-1.03-.26-.19-.17-.33-.39-.42-.63-.32.26-.68.47-1.07.64-.39.17-.91.25-1.54.25s-1.11-.11-1.49-.32c-.38-.21-.65-.48-.8-.81-.15-.32-.23-.66-.23-1,0-.52.13-.95.39-1.29.26-.34.62-.62,1.06-.83s1.03-.44,1.76-.67c.42-.13.73-.23.94-.3.21-.07.37-.12.48-.16s.22-.09.33-.15c0-.41-.08-.73-.25-.96s-.53-.35-1.08-.35c-.65,0-1.26.14-1.82.43s-1.07.66-1.54,1.11v-2.29c.37-.27.77-.48,1.2-.65.43-.17.88-.29,1.35-.38s.95-.12,1.43-.12c1.22,0,2.14.24,2.76.71.62.47.93,1.12.93,1.95v3.26c0,.31.03.54.09.69.06.15.17.23.32.23.19,0,.44-.08.76-.24v1.57Zm-4.16-1.62v-2c-.71.29-1.23.55-1.55.78-.33.23-.49.54-.49.93,0,.28.08.5.25.65.16.15.35.22.57.22.2,0,.41-.06.61-.17.2-.11.41-.25.62-.41Z"
          />
          <path
            className="cls-17"
            d="m151.44,136.21l-1.1,3c-.45-.43-.91-.65-1.38-.65-.42,0-.78.14-1.09.43-.31.28-.6.81-.88,1.58v3.64h-2.99v-8.45h2.99v2.04c.19-.5.52-.99,1-1.47.48-.48,1.03-.72,1.68-.72.34,0,.63.05.88.15.25.1.55.25.9.46Z"
          />
          <path
            className="cls-17"
            d="m160.33,140.7h-5.95c.12.51.4.94.85,1.26s.97.49,1.54.49c1.01,0,2.12-.28,3.34-.85v1.85c-.44.23-.97.43-1.59.62-.62.19-1.42.28-2.38.28-1.04,0-1.93-.19-2.66-.58s-1.28-.91-1.64-1.58c-.36-.66-.54-1.42-.54-2.26s.18-1.57.54-2.23c.36-.66.91-1.17,1.64-1.54.73-.37,1.62-.56,2.66-.56.69,0,1.35.15,1.99.44.64.3,1.17.78,1.58,1.45.41.67.62,1.54.62,2.6v.6Zm-2.81-1.48c0-.54-.13-.98-.4-1.3-.27-.32-.65-.49-1.16-.49s-.9.16-1.21.49c-.31.33-.46.76-.46,1.29h3.23Z"
          />
          <path
            className="cls-17"
            d="m176.13,140.04c0,.98-.19,1.79-.57,2.44-.38.64-.87,1.12-1.46,1.42s-1.2.46-1.81.46c-.44,0-.83-.05-1.15-.15-.32-.1-.58-.21-.76-.33-.18-.12-.37-.26-.56-.43v.76h-2.99v-11.5h2.99v3.55c.22-.17.53-.32.91-.45.39-.13.84-.2,1.34-.2.68,0,1.28.12,1.8.37.52.25.94.58,1.27,1,.33.42.57.89.73,1.42.16.52.24,1.07.24,1.65Zm-3.15-.07c0-.73-.16-1.28-.49-1.66-.33-.38-.71-.57-1.16-.57s-.95.18-1.51.54v3.23c.42.4.92.6,1.51.6.37,0,.74-.15,1.1-.45.37-.3.55-.86.55-1.69Z"
          />
          <path
            className="cls-17"
            d="m186.35,140.7h-5.95c.12.51.4.94.85,1.26s.97.49,1.54.49c1.01,0,2.12-.28,3.34-.85v1.85c-.44.23-.97.43-1.59.62-.62.19-1.42.28-2.38.28-1.04,0-1.93-.19-2.66-.58s-1.28-.91-1.64-1.58c-.36-.66-.54-1.42-.54-2.26s.18-1.57.54-2.23c.36-.66.91-1.17,1.64-1.54.73-.37,1.62-.56,2.66-.56.69,0,1.35.15,1.99.44.64.3,1.17.78,1.58,1.45.41.67.62,1.54.62,2.6v.6Zm-2.81-1.48c0-.54-.13-.98-.4-1.3-.27-.32-.65-.49-1.16-.49s-.9.16-1.21.49c-.31.33-.46.76-.46,1.29h3.23Z"
          />
          <path
            className="cls-17"
            d="m190.96,144.21h-3v-8.45h3v8.45Zm-.24-10.4c0,.35-.12.64-.37.89s-.54.37-.89.37c-.23,0-.44-.06-.64-.17-.19-.11-.34-.26-.45-.45-.11-.19-.17-.4-.17-.64,0-.34.12-.64.37-.89s.54-.37.89-.37.64.12.89.37.37.54.37.89Z"
          />
          <path
            className="cls-17"
            d="m202.05,144.21h-2.99v-4.56c0-.46-.08-.87-.23-1.22-.15-.35-.49-.52-1-.52-.24,0-.46.05-.64.14-.19.09-.35.21-.5.35-.15.14-.27.28-.37.42s-.2.27-.31.42v4.96h-2.99v-8.45h2.99v1.21c.47-.5.94-.86,1.42-1.06.47-.2,1-.3,1.58-.3,2.03,0,3.04,1.21,3.04,3.64v4.96Z"
          />
          <path
            className="cls-17"
            d="m212.34,137.56h-1.48c.52.45.78,1.01.78,1.67,0,.35-.07.68-.22,1-.15.32-.36.61-.65.85-.28.25-.64.45-1.05.61-.42.16-.9.25-1.43.29-.69.03-1.04.21-1.04.56,0,.13.04.23.13.29s.23.11.42.14c.19.03.51.07.97.1.51.04.99.12,1.44.23s.85.34,1.24.7.57.86.57,1.52c0,.53-.14.99-.43,1.39-.28.4-.75.72-1.38.95s-1.48.34-2.52.34c-1.51,0-2.61-.2-3.32-.61-.71-.4-1.06-.94-1.06-1.62,0-.18.05-.39.14-.63.09-.24.28-.47.58-.69.3-.22.73-.37,1.29-.45-.2-.07-.37-.21-.51-.42-.14-.21-.22-.42-.22-.65,0-.29.1-.58.3-.87.2-.29.53-.47.98-.56-.63-.17-1.18-.48-1.64-.94s-.69-1.05-.69-1.78c0-.55.11-1.04.32-1.45.21-.42.51-.75.88-1.01s.81-.45,1.31-.58c.5-.12,1.04-.19,1.64-.19h4.64v1.8Zm-2.71,8.23c0-.37-.2-.61-.59-.72-.4-.11-.8-.16-1.22-.16-.69,0-1.19.07-1.5.22-.31.15-.46.38-.46.7,0,.63.64.95,1.91.95.57,0,1.02-.08,1.36-.24.34-.16.51-.41.51-.74Zm-.6-6.8c0-.43-.15-.77-.44-1.02-.29-.26-.62-.39-.98-.39-.46,0-.82.15-1.08.46-.26.31-.39.64-.39.98,0,.24.06.46.17.66.11.2.27.37.48.49.21.12.46.19.74.19.43,0,.79-.14,1.07-.41s.42-.59.42-.97Z"
          />
          <path
            className="cls-17"
            d="m227.36,144.21h-2.99v-1.2c-.42.45-.86.79-1.33,1.02-.46.22-1.02.34-1.67.34-1.27,0-2.1-.37-2.48-1.12-.38-.74-.56-1.58-.56-2.52v-4.96h2.99v4.57c0,.46.08.86.23,1.21.15.35.48.52.99.52.44,0,.79-.12,1.04-.37s.52-.57.78-.95v-4.96h2.99v8.45Z"
          />
          <path
            className="cls-17"
            d="m235.88,141.74c0,.77-.28,1.4-.85,1.89-.57.48-1.41.73-2.53.73-.63,0-1.18-.06-1.67-.17-.49-.11-1.02-.28-1.59-.49v-2.12c.5.29.94.51,1.31.66s.78.22,1.22.22c.75,0,1.12-.2,1.12-.61,0-.14-.05-.26-.16-.37-.11-.11-.3-.23-.56-.37-.27-.14-.63-.3-1.08-.49-.55-.24-1.02-.57-1.41-.98s-.58-.91-.58-1.5c0-.42.13-.82.39-1.21.26-.39.65-.7,1.17-.95.52-.25,1.15-.37,1.88-.37.18,0,.4.01.68.04.27.03.62.09,1.04.2.42.1.81.25,1.19.45v2.07c-.18-.1-.33-.19-.44-.27-.12-.07-.28-.15-.48-.24s-.43-.17-.7-.24c-.27-.07-.54-.1-.83-.1-.34,0-.58.07-.71.2s-.19.27-.19.4.07.27.2.39c.13.12.43.27.89.44.66.25,1.2.52,1.59.78.4.27.68.56.85.88.17.32.25.7.25,1.14Z"
          />
          <path
            className="cls-17"
            d="m246.17,140.7h-5.95c.12.51.4.94.85,1.26s.97.49,1.54.49c1.01,0,2.12-.28,3.34-.85v1.85c-.44.23-.97.43-1.59.62-.62.19-1.42.28-2.38.28-1.04,0-1.93-.19-2.66-.58s-1.28-.91-1.64-1.58c-.36-.66-.54-1.42-.54-2.26s.18-1.57.54-2.23c.36-.66.91-1.17,1.64-1.54.73-.37,1.62-.56,2.66-.56.69,0,1.35.15,1.99.44.64.3,1.17.78,1.58,1.45.41.67.62,1.54.62,2.6v.6Zm-2.81-1.48c0-.54-.13-.98-.4-1.3-.27-.32-.65-.49-1.16-.49s-.9.16-1.21.49c-.31.33-.46.76-.46,1.29h3.23Z"
          />
          <path
            className="cls-17"
            d="m256.57,144.21h-3v-.76c-.32.27-.65.48-1,.66s-.84.26-1.46.26-1.22-.15-1.81-.46c-.59-.3-1.08-.78-1.46-1.42-.38-.65-.57-1.46-.57-2.44,0-.77.14-1.49.43-2.16.29-.67.74-1.22,1.35-1.64.61-.42,1.37-.63,2.26-.63.55,0,1,.06,1.34.18.34.12.65.28.91.46v-3.55h3v11.5Zm-3-2.69v-3.23c-.35-.19-.62-.33-.82-.42s-.43-.12-.69-.12c-.47,0-.86.2-1.17.6s-.47.94-.47,1.63c0,.75.16,1.29.49,1.63.33.34.71.51,1.15.51.36,0,.65-.06.87-.17.22-.11.43-.26.64-.43Z"
          />
          <path
            className="cls-17"
            d="m38.74,159.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m49.08,160.21h-2.99v-4.38s0-.06,0-.1c0-.03,0-.1,0-.19,0-.4-.09-.77-.26-1.11s-.5-.51-.98-.51c-.38,0-.71.13-1,.38-.29.25-.56.57-.82.95v4.96h-2.99v-11.5h2.99v4.27c.49-.53.98-.88,1.46-1.08.48-.19.99-.29,1.54-.29,2.03,0,3.04,1.14,3.04,3.41v5.19Z"
          />
          <path
            className="cls-17"
            d="m59.54,156.7h-5.95c.12.51.4.94.85,1.26s.97.49,1.54.49c1.01,0,2.12-.28,3.34-.85v1.85c-.44.23-.97.43-1.59.62-.62.19-1.42.28-2.38.28-1.04,0-1.93-.19-2.66-.58s-1.28-.91-1.64-1.58c-.36-.66-.54-1.42-.54-2.26s.18-1.57.54-2.23c.36-.66.91-1.17,1.64-1.54.73-.37,1.62-.56,2.66-.56.69,0,1.35.15,1.99.44.64.3,1.17.78,1.58,1.45.41.67.62,1.54.62,2.6v.6Zm-2.81-1.48c0-.54-.13-.98-.4-1.3-.27-.32-.65-.49-1.16-.49s-.9.16-1.21.49c-.31.33-.46.76-.46,1.29h3.23Z"
          />
          <path
            className="cls-17"
            d="m81.11,160.21h-2.99v-4.51c0-.6-.1-1.04-.29-1.34-.2-.3-.51-.44-.93-.44s-.76.13-1.02.38c-.27.25-.53.57-.8.95v4.96h-2.99v-4.51c0-.57-.09-1.01-.27-1.32s-.51-.46-.97-.46c-.22,0-.42.04-.61.13-.19.09-.34.19-.45.3s-.26.27-.42.49-.27.35-.32.41v4.96h-2.99v-8.45h2.99v1.21c.45-.48.9-.82,1.37-1.04s1-.32,1.61-.32c.29,0,.56.03.82.08.26.05.52.14.77.27.25.13.48.3.68.52s.37.48.49.77c.48-.54.98-.95,1.5-1.23.52-.28,1.11-.42,1.79-.42s1.24.14,1.7.41c.46.27.79.66,1.01,1.17.22.51.33,1.13.33,1.86v5.15Z"
          />
          <path
            className="cls-17"
            d="m92.22,155.97c0,.84-.18,1.59-.55,2.25s-.91,1.18-1.64,1.56c-.73.38-1.61.57-2.66.57s-1.93-.19-2.66-.57c-.73-.38-1.27-.9-1.63-1.56-.36-.66-.54-1.41-.54-2.25,0-.64.1-1.21.3-1.73.2-.52.51-.98.92-1.38.41-.4.92-.71,1.52-.93s1.3-.32,2.09-.32,1.5.11,2.11.33c.61.22,1.12.52,1.52.92.4.39.7.85.91,1.38s.31,1.11.31,1.74Zm-3.15,0c0-.67-.15-1.19-.44-1.57-.29-.38-.71-.57-1.27-.57s-.97.19-1.26.57c-.29.38-.44.9-.44,1.57s.15,1.19.44,1.58.71.58,1.25.58.98-.19,1.27-.58c.29-.38.44-.91.44-1.58Z"
          />
          <path
            className="cls-17"
            d="m100.38,157.74c0,.77-.28,1.4-.85,1.89-.57.48-1.41.73-2.53.73-.63,0-1.18-.06-1.67-.17-.49-.11-1.02-.28-1.59-.49v-2.12c.5.29.94.51,1.31.66s.78.22,1.22.22c.75,0,1.12-.2,1.12-.61,0-.14-.05-.26-.16-.37-.11-.11-.3-.23-.56-.37-.27-.14-.63-.3-1.08-.49-.55-.24-1.02-.57-1.41-.98s-.58-.91-.58-1.5c0-.42.13-.82.39-1.21.26-.39.65-.7,1.17-.95.52-.25,1.15-.37,1.88-.37.18,0,.4.01.68.04.27.03.62.09,1.04.2.42.1.81.25,1.19.45v2.07c-.18-.1-.33-.19-.44-.27-.12-.07-.28-.15-.48-.24s-.43-.17-.7-.24c-.27-.07-.54-.1-.83-.1-.34,0-.58.07-.71.2s-.19.27-.19.4.07.27.2.39c.13.12.43.27.89.44.66.25,1.2.52,1.59.78.4.27.68.56.85.88.17.32.25.7.25,1.14Z"
          />
          <path
            className="cls-17"
            d="m108.66,159.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m118.17,160.21h-3v-8.45h3v8.45Zm-.24-10.4c0,.35-.12.64-.37.89s-.54.37-.89.37c-.23,0-.44-.06-.64-.17-.19-.11-.34-.26-.45-.45-.11-.19-.17-.4-.17-.64,0-.34.12-.64.37-.89s.54-.37.89-.37.64.12.89.37.37.54.37.89Z"
          />
          <path
            className="cls-17"
            d="m129.25,160.21h-2.99v-4.56c0-.46-.08-.87-.23-1.22-.15-.35-.49-.52-1-.52-.24,0-.46.05-.64.14-.19.09-.35.21-.5.35-.15.14-.27.28-.37.42s-.2.27-.31.42v4.96h-2.99v-8.45h2.99v1.21c.47-.5.94-.86,1.42-1.06.47-.2,1-.3,1.58-.3,2.03,0,3.04,1.21,3.04,3.64v4.96Z"
          />
          <path
            className="cls-17"
            d="m142.75,159.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m153.09,160.21h-2.99v-4.38s0-.06,0-.1c0-.03,0-.1,0-.19,0-.4-.09-.77-.26-1.11s-.5-.51-.98-.51c-.38,0-.71.13-1,.38-.29.25-.56.57-.82.95v4.96h-2.99v-11.5h2.99v4.27c.49-.53.98-.88,1.46-1.08.48-.19.99-.29,1.54-.29,2.03,0,3.04,1.14,3.04,3.41v5.19Z"
          />
          <path
            className="cls-17"
            d="m163.55,156.7h-5.95c.12.51.4.94.85,1.26s.97.49,1.54.49c1.01,0,2.12-.28,3.34-.85v1.85c-.44.23-.97.43-1.59.62-.62.19-1.42.28-2.38.28-1.04,0-1.93-.19-2.66-.58s-1.28-.91-1.64-1.58c-.36-.66-.54-1.42-.54-2.26s.18-1.57.54-2.23c.36-.66.91-1.17,1.64-1.54.73-.37,1.62-.56,2.66-.56.69,0,1.35.15,1.99.44.64.3,1.17.78,1.58,1.45.41.67.62,1.54.62,2.6v.6Zm-2.81-1.48c0-.54-.13-.98-.4-1.3-.27-.32-.65-.49-1.16-.49s-.9.16-1.21.49c-.31.33-.46.76-.46,1.29h3.23Z"
          />
          <path
            className="cls-17"
            d="m179,160.21h-3v-.76c-.32.27-.65.48-1,.66-.35.17-.84.26-1.46.26s-1.22-.15-1.81-.46-1.08-.78-1.46-1.42c-.38-.65-.57-1.46-.57-2.44,0-.77.14-1.49.43-2.16.29-.67.74-1.22,1.35-1.64s1.37-.63,2.26-.63c.55,0,1,.06,1.34.18s.65.28.91.46v-3.55h3v11.5Zm-3-2.69v-3.23c-.35-.19-.62-.33-.82-.42-.2-.08-.43-.12-.69-.12-.47,0-.86.2-1.17.6-.31.4-.47.94-.47,1.63,0,.75.16,1.29.49,1.63.33.34.71.51,1.15.51.36,0,.65-.06.87-.17.22-.11.43-.26.64-.43Z"
          />
          <path
            className="cls-17"
            d="m189.66,159.78c-.44.17-.84.31-1.21.42s-.82.16-1.34.16c-.49,0-.84-.09-1.03-.26-.19-.17-.33-.39-.42-.63-.32.26-.68.47-1.07.64-.39.17-.91.25-1.54.25s-1.11-.11-1.49-.32c-.38-.21-.65-.48-.8-.81-.15-.32-.23-.66-.23-1,0-.52.13-.95.39-1.29.26-.34.62-.62,1.06-.83s1.03-.44,1.76-.67c.42-.13.73-.23.94-.3.21-.07.37-.12.48-.16s.22-.09.33-.15c0-.41-.08-.73-.25-.96s-.53-.35-1.08-.35c-.65,0-1.26.14-1.82.43s-1.07.66-1.54,1.11v-2.29c.37-.27.77-.48,1.2-.65.43-.17.88-.29,1.35-.38s.95-.12,1.43-.12c1.22,0,2.14.24,2.76.71.62.47.93,1.12.93,1.95v3.26c0,.31.03.54.09.69.06.15.17.23.32.23.19,0,.44-.08.76-.24v1.57Zm-4.16-1.62v-2c-.71.29-1.23.55-1.55.78-.33.23-.49.54-.49.93,0,.28.08.5.25.65.16.15.35.22.57.22.2,0,.41-.06.61-.17.2-.11.41-.25.62-.41Z"
          />
          <path
            className="cls-17"
            d="m197.26,159.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m207.34,159.78c-.44.17-.84.31-1.21.42s-.82.16-1.34.16c-.49,0-.84-.09-1.03-.26-.19-.17-.33-.39-.42-.63-.32.26-.68.47-1.07.64-.39.17-.91.25-1.54.25s-1.11-.11-1.49-.32c-.38-.21-.65-.48-.8-.81-.15-.32-.23-.66-.23-1,0-.52.13-.95.39-1.29.26-.34.62-.62,1.06-.83s1.03-.44,1.76-.67c.42-.13.73-.23.94-.3.21-.07.37-.12.48-.16s.22-.09.33-.15c0-.41-.08-.73-.25-.96s-.53-.35-1.08-.35c-.65,0-1.26.14-1.82.43s-1.07.66-1.54,1.11v-2.29c.37-.27.77-.48,1.2-.65.43-.17.88-.29,1.35-.38s.95-.12,1.43-.12c1.22,0,2.14.24,2.76.71.62.47.93,1.12.93,1.95v3.26c0,.31.03.54.09.69.06.15.17.23.32.23.19,0,.44-.08.76-.24v1.57Zm-4.16-1.62v-2c-.71.29-1.23.55-1.55.78-.33.23-.49.54-.49.93,0,.28.08.5.25.65.16.15.35.22.57.22.2,0,.41-.06.61-.17.2-.11.41-.25.62-.41Z"
          />
          <path
            className="cls-17"
            d="m222.23,151.76l-3.84,8.45h-2.21l-3.76-8.45h3.21l1.75,4.42,1.94-4.42h2.91Z"
          />
          <path
            className="cls-17"
            d="m226.38,160.21h-3v-8.45h3v8.45Zm-.24-10.4c0,.35-.12.64-.37.89s-.54.37-.89.37c-.23,0-.44-.06-.64-.17-.19-.11-.34-.26-.45-.45-.11-.19-.17-.4-.17-.64,0-.34.12-.64.37-.89s.54-.37.89-.37.64.12.89.37.37.54.37.89Z"
          />
          <path
            className="cls-17"
            d="m236.48,152.03l-4.04,5.97h3.96v2.21h-8.67v-.27l4.04-5.97h-3.7v-2.21h8.41v.27Z"
          />
          <path
            className="cls-17"
            d="m35.23,176.21h-3v-8.45h3v8.45Zm-.24-10.4c0,.35-.12.64-.37.89s-.54.37-.89.37c-.23,0-.44-.06-.64-.17-.19-.11-.34-.26-.45-.45-.11-.19-.17-.4-.17-.64,0-.34.12-.64.37-.89s.54-.37.89-.37.64.12.89.37.37.54.37.89Z"
          />
          <path
            className="cls-17"
            d="m46.31,176.21h-2.99v-4.56c0-.46-.08-.87-.23-1.22-.15-.35-.49-.52-1-.52-.24,0-.46.05-.64.14-.19.09-.35.21-.5.35-.15.14-.27.28-.37.42s-.2.27-.31.42v4.96h-2.99v-8.45h2.99v1.21c.47-.5.94-.86,1.42-1.06.47-.2,1-.3,1.58-.3,2.03,0,3.04,1.21,3.04,3.64v4.96Z"
          />
          <path
            className="cls-17"
            d="m57.04,176.21h-3v-.76c-.32.27-.65.48-1,.66-.35.17-.84.26-1.46.26s-1.22-.15-1.81-.46-1.08-.78-1.46-1.42c-.38-.65-.57-1.46-.57-2.44,0-.77.14-1.49.43-2.16.29-.67.74-1.22,1.35-1.64s1.37-.63,2.26-.63c.55,0,1,.06,1.34.18s.65.28.91.46v-3.55h3v11.5Zm-3-2.69v-3.23c-.35-.19-.62-.33-.82-.42-.2-.08-.43-.12-.69-.12-.47,0-.86.2-1.17.6-.31.4-.47.94-.47,1.63,0,.75.16,1.29.49,1.63.33.34.71.51,1.15.51.36,0,.65-.06.87-.17.22-.11.43-.26.64-.43Z"
          />
          <path
            className="cls-17"
            d="m67.83,176.21h-2.99v-1.2c-.42.45-.86.79-1.33,1.02-.46.22-1.02.34-1.67.34-1.27,0-2.1-.37-2.48-1.12-.38-.74-.56-1.58-.56-2.52v-4.96h2.99v4.57c0,.46.08.86.23,1.21.15.35.48.52.99.52.44,0,.79-.12,1.04-.37s.52-.57.78-.95v-4.96h2.99v8.45Z"
          />
          <path
            className="cls-17"
            d="m76.36,173.74c0,.77-.28,1.4-.85,1.89-.57.48-1.41.73-2.53.73-.63,0-1.18-.06-1.67-.17-.49-.11-1.02-.28-1.59-.49v-2.12c.5.29.94.51,1.31.66s.78.22,1.22.22c.75,0,1.12-.2,1.12-.61,0-.14-.05-.26-.16-.37-.11-.11-.3-.23-.56-.37-.27-.14-.63-.3-1.08-.49-.55-.24-1.02-.57-1.41-.98s-.58-.91-.58-1.5c0-.42.13-.82.39-1.21.26-.39.65-.7,1.17-.95.52-.25,1.15-.37,1.88-.37.18,0,.4.01.68.04.27.03.62.09,1.04.2.42.1.81.25,1.19.45v2.07c-.18-.1-.33-.19-.44-.27-.12-.07-.28-.15-.48-.24s-.43-.17-.7-.24c-.27-.07-.54-.1-.83-.1-.34,0-.58.07-.71.2s-.19.27-.19.4.07.27.2.39c.13.12.43.27.89.44.66.25,1.2.52,1.59.78.4.27.68.56.85.88.17.32.25.7.25,1.14Z"
          />
          <path
            className="cls-17"
            d="m84.64,175.72c-.31.15-.74.29-1.28.43-.55.14-1.07.21-1.56.21-2.15,0-3.23-1.05-3.23-3.15v-3.37h-1.35v-.52l4.01-4.08h.34v2.53h2.86v2.08h-2.86v2.71c0,.32.02.57.06.76s.15.36.33.49c.18.13.45.2.82.2.48,0,1.1-.2,1.88-.6v2.33Z"
          />
          <path
            className="cls-17"
            d="m93.38,168.21l-1.1,3c-.45-.43-.91-.65-1.38-.65-.42,0-.78.14-1.09.43-.31.28-.6.81-.88,1.58v3.64h-2.99v-8.45h2.99v2.04c.19-.5.52-.99,1-1.47.48-.48,1.03-.72,1.68-.72.34,0,.63.05.88.15.25.1.55.25.9.46Z"
          />
          <path
            className="cls-17"
            d="m103.39,167.76l-5.74,12.29h-3.02l2.32-4.95-3.35-7.35h3.21l1.72,4.2,1.95-4.2h2.91Z"
          />
          <path
            className="cls-17"
            d="m109.31,166.96c0,.53-.1.97-.3,1.33s-.61.82-1.25,1.38c-.31.26-.59.62-.84,1.08-.25.46-.37.84-.37,1.14,0,.37-.21.56-.63.56-.33,0-.53-.11-.61-.34-.06-.17-.1-.38-.13-.65s-.04-.47-.04-.61c0-.53.11-1.04.32-1.54.09-.2.18-.4.28-.61.1-.2.17-.39.23-.54.06-.16.09-.3.09-.42,0-.2-.07-.4-.22-.58-.15-.18-.42-.27-.81-.27-.32,0-.65.07-.99.22h-.13l.78-2.31c.56-.17,1.08-.26,1.58-.26.68,0,1.24.12,1.7.35.46.23.8.53,1.02.9s.33.76.33,1.16Zm-1.56,7.61c0,.49-.17.91-.52,1.26-.35.35-.76.53-1.25.53s-.91-.17-1.27-.52-.54-.77-.54-1.26.18-.92.54-1.27c.36-.35.78-.52,1.27-.52s.9.18,1.25.53c.35.35.52.77.52,1.26Z"
          />
        </g>
        <path
          className="cls-14"
          d="m1057.2,107.12c-3.1-.94-5.87-.4-9.83,1.54-7.01,3.42-8.11,3.97-17.74,10.05-6.46,4.08-8.35,5.69-10.4,8.29-.59.74-2.77,4.65-2.9,9.38s1.86,9.11,2.41,9.88c1.92,2.7,3.73,4.41,9.98,8.8,9.33,6.55,10.4,7.15,17.23,10.91,3.86,2.13,6.59,2.81,9.74,2.02,4.71-1.17,8-5.3,11.28-10.87,2.86-4.85,6.49-12.52,6.49-19.04,0-8.52-3.56-14.81-5.86-19.36-2.8-5.52-5.75-10.19-10.39-11.59Z"
        />
        <g>
          <path
            className="cls-13"
            d="m1030.62,129.62h-2.48v5.12h-2.04v-5.12h-2.48v-1.65h7v1.65Z"
          />
          <path
            className="cls-13"
            d="m1036.01,132.26c0,.49-.11.94-.32,1.32s-.54.69-.96.92-.95.34-1.56.34-1.14-.11-1.57-.34c-.43-.22-.75-.53-.96-.92s-.32-.83-.32-1.32c0-.37.06-.71.18-1.02.12-.31.3-.58.54-.81s.54-.42.9-.54c.35-.13.76-.19,1.23-.19s.88.06,1.24.19.66.31.89.54c.24.23.42.5.54.81.12.31.18.65.18,1.03Zm-1.85,0c0-.39-.09-.7-.26-.93-.17-.22-.42-.33-.74-.33s-.57.11-.74.33c-.17.22-.26.53-.26.93s.09.7.26.93c.17.23.42.34.74.34s.57-.11.74-.34c.17-.23.26-.54.26-.93Z"
          />
          <path
            className="cls-13"
            d="m1042.41,132.26c0,.49-.11.94-.32,1.32s-.54.69-.96.92c-.43.22-.95.34-1.57.34s-1.14-.11-1.56-.34-.75-.53-.96-.92c-.21-.39-.32-.83-.32-1.32,0-.37.06-.71.18-1.02s.3-.58.54-.81c.24-.24.54-.42.89-.54.36-.13.77-.19,1.23-.19s.88.06,1.24.19c.36.13.66.31.89.54s.41.5.54.81c.12.31.18.65.18,1.03Zm-1.85,0c0-.39-.09-.7-.26-.93-.17-.22-.42-.33-.75-.33s-.57.11-.74.33c-.17.22-.26.53-.26.93s.09.7.26.93c.17.23.42.34.74.34s.57-.11.75-.34c.17-.23.26-.54.26-.93Z"
          />
          <path className="cls-13" d="m1045.17,134.75h-1.76v-6.77h1.76v6.77Z" />
          <path
            className="cls-13"
            d="m1031.48,144.75h-1.82l-3.51-3.77v3.77h-2.02v-6.77h1.81l3.5,3.75v-3.75h2.04v6.77Z"
          />
          <path
            className="cls-13"
            d="m1038.05,144.5c-.26.1-.49.18-.71.24-.22.06-.48.09-.79.09s-.49-.05-.61-.15c-.12-.1-.2-.23-.24-.37-.19.15-.4.28-.63.38-.23.1-.53.15-.91.15s-.65-.06-.88-.19c-.22-.13-.38-.28-.47-.47-.09-.19-.13-.39-.13-.59,0-.31.08-.56.23-.76.15-.2.36-.36.62-.49.26-.13.61-.26,1.04-.4.24-.08.43-.14.55-.18s.22-.07.28-.1c.06-.02.13-.05.2-.09,0-.24-.05-.43-.15-.57s-.31-.21-.63-.21c-.38,0-.74.08-1.07.25-.33.17-.63.39-.9.65v-1.35c.22-.16.45-.28.71-.38s.52-.17.8-.22c.28-.05.56-.07.84-.07.72,0,1.26.14,1.62.42s.54.66.54,1.15v1.92c0,.18.02.32.05.41.04.09.1.13.19.13.11,0,.26-.05.45-.14v.92Zm-2.45-.95v-1.18c-.42.17-.72.32-.91.46-.19.14-.29.32-.29.55,0,.17.05.29.14.38.1.09.21.13.33.13.12,0,.24-.03.36-.1.12-.07.24-.15.36-.24Z"
          />
          <path
            className="cls-13"
            d="m1047.6,144.75h-1.76v-2.65c0-.35-.06-.61-.17-.79-.12-.17-.3-.26-.55-.26s-.44.07-.6.22-.31.33-.47.56v2.92h-1.76v-2.65c0-.34-.05-.59-.16-.78s-.3-.27-.57-.27c-.13,0-.25.03-.36.08s-.2.11-.27.18-.15.16-.25.29-.16.21-.19.24v2.92h-1.76v-4.97h1.76v.71c.26-.28.53-.48.81-.61s.59-.19.95-.19c.17,0,.33.02.48.05.15.03.3.08.45.16.15.07.28.18.4.31.12.13.22.28.29.45.28-.32.58-.56.88-.72.3-.16.65-.24,1.05-.24s.73.08,1,.24c.27.16.47.39.6.69.13.3.19.67.19,1.1v3.03Z"
          />
          <path
            className="cls-13"
            d="m1053.74,142.69h-3.5c.07.3.24.55.5.74.27.19.57.29.91.29.59,0,1.25-.17,1.96-.5v1.09c-.26.13-.57.25-.93.36-.37.11-.83.16-1.4.16-.61,0-1.13-.11-1.56-.34s-.75-.54-.96-.93c-.21-.39-.32-.83-.32-1.33s.11-.93.32-1.31c.21-.39.53-.69.96-.91s.95-.33,1.56-.33c.4,0,.79.09,1.17.26.38.17.69.46.93.85s.36.91.36,1.53v.35Zm-1.65-.87c0-.32-.08-.57-.24-.76s-.38-.29-.68-.29-.53.1-.71.29c-.18.19-.27.45-.27.76h1.9Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m1045.56,160.64h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m1053.22,157.26c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
          <path
            className="cls-13"
            d="m1059.16,157.26c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <circle className="cls-14" cx="1014.12" cy="194.13" r="17.69" />
        <circle className="cls-14" cx="1079.2" cy="194.13" r="17.69" />
        <path
          className="cls-13"
          d="m1015.79,184.98v1.03h-2.84v1.76h2.84v1.04h-2.84v2.99h-1.32v-6.82h4.16Z"
        />
        <path
          className="cls-13"
          d="m1078.69,184.98v5.79h3.31v1.03h-4.63v-6.82h1.32Z"
        />
        <g>
          <path className="cls-13" d="m1073.82,203.72h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m1081.48,200.34c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
          <path
            className="cls-13"
            d="m1087.43,200.34c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <g>
          <path className="cls-13" d="m1008.62,203.72h-1.85v-6.77h1.85v6.77Z" />
          <path
            className="cls-13"
            d="m1016.28,200.34c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
          <path
            className="cls-13"
            d="m1022.22,200.34c0,.59-.07,1.1-.21,1.54s-.33.8-.58,1.09c-.25.28-.53.49-.84.63s-.65.21-1.01.21-.69-.07-1.01-.21-.6-.35-.84-.63-.44-.64-.58-1.08c-.14-.44-.21-.95-.21-1.54s.07-1.11.21-1.55c.14-.44.33-.8.58-1.09.24-.29.52-.5.84-.64.32-.14.65-.21,1.01-.21s.69.07,1.01.21c.31.14.6.35.84.64s.44.65.58,1.1.21.96.21,1.54Zm-1.93,0c0-.6-.04-1.09-.12-1.47s-.28-.58-.59-.58c-.21,0-.37.11-.48.32-.11.21-.17.46-.2.74-.02.28-.04.61-.04.99,0,.64.04,1.14.12,1.5.08.36.28.53.59.53s.51-.18.59-.53c.08-.36.12-.86.12-1.5Z"
          />
        </g>
        <g>
          <path
            className="cls-17"
            d="m30.99,190h7.98v1.22h-3.33v8.35h-1.37v-8.35h-3.27v-1.22Z"
          />
          <path
            className="cls-17"
            d="m40.06,190.01h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m52.44,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m62.4,198.09v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m63.79,190.01h1.24v4.09c.52-.63,1.16-.95,1.93-.95.42,0,.8.1,1.13.31s.58.5.74.87.24.92.24,1.65v3.58h-1.24v-3.89c0-.46-.11-.83-.34-1.11s-.52-.42-.89-.42c-.27,0-.53.07-.77.21s-.51.38-.8.7v4.5h-1.24v-9.55Z"
          />
          <path
            className="cls-17"
            d="m74.76,195.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m78.12,193.27v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m81.73,194.27l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m91.11,190.01h1.24v3.71c.54-.39,1.11-.59,1.72-.59.8,0,1.45.3,1.96.9s.76,1.37.76,2.32c0,1.01-.3,1.82-.91,2.42s-1.41.9-2.42.9c-.41,0-.83-.04-1.28-.13s-.81-.2-1.07-.33v-9.2Zm1.24,4.9v3.4c.42.13.86.19,1.31.19.55,0,1-.2,1.35-.59s.52-.9.52-1.51-.16-1.13-.49-1.52-.75-.59-1.27-.59c-.46,0-.94.21-1.42.62Z"
          />
          <path
            className="cls-17"
            d="m103.52,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path className="cls-17" d="m104.9,190.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m110.95,193.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m123.39,193.27h1.33l-2.78,6.4h-.4l-1.86-4.38-1.84,4.38h-.4l-2.8-6.4h1.34l1.65,3.81,1.61-3.81h.92l1.59,3.81,1.64-3.81Z"
          />
          <path
            className="cls-17"
            d="m134.85,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m140.53,193.27h1.59l-2.59,3.1,2.77,3.19h-1.6l-1.97-2.26-1.87,2.26h-1.56l2.65-3.19-2.65-3.1h1.57l1.86,2.16,1.79-2.16Z"
          />
          <path
            className="cls-17"
            d="m143.11,202.77v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path className="cls-17" d="m150.22,190.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m156.27,193.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m162.32,193.27v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m171.61,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m172.65,199.11v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m182.38,193.27v-.38c0-1.01.22-1.77.65-2.26s.95-.75,1.55-.75c.26,0,.57.04.92.12v1.22c-.2-.07-.39-.11-.57-.11-.49,0-.83.13-1.02.39s-.28.72-.28,1.39v.38h1.12v1.12h-1.12v5.17h-1.24v-5.17h-.9v-1.12h.9Z"
          />
          <path
            className="cls-17"
            d="m187.06,193.27v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m196.35,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m200.67,193.27h2.35v9.5h-1.24v-3.32c-.54.15-1,.22-1.38.22-.9,0-1.63-.3-2.22-.9-.58-.6-.88-1.36-.88-2.29,0-.98.3-1.76.91-2.34s1.42-.87,2.45-.87Zm1.11,5.1v-3.94h-.79c-.54,0-.9.02-1.08.07-.18.05-.34.11-.47.2-.13.08-.25.19-.36.31-.34.39-.51.86-.51,1.43,0,.64.19,1.17.58,1.57.39.41.89.61,1.5.61.14,0,.26,0,.35-.03.09-.02.29-.08.6-.18l.1-.03.09-.03Z"
          />
          <path
            className="cls-17"
            d="m208.71,199.56v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m217.06,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m219.65,193.27v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m230.12,198.09v1.23c-.62.23-1.23.35-1.83.35-.98,0-1.77-.29-2.35-.88s-.88-1.36-.88-2.34.28-1.79.85-2.39,1.32-.91,2.25-.91c.32,0,.61.03.87.09s.58.18.95.35v1.33c-.63-.4-1.21-.6-1.75-.6s-1.02.2-1.38.59-.54.9-.54,1.51c0,.64.19,1.15.58,1.53s.92.57,1.58.57c.48,0,1.03-.14,1.65-.42Z"
          />
          <path
            className="cls-17"
            d="m235.4,193.27h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m244.57,193.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m249.43,193.27v-.38c0-1.01.22-1.77.65-2.26s.95-.75,1.55-.75c.26,0,.57.04.92.12v1.22c-.2-.07-.39-.11-.57-.11-.49,0-.83.13-1.02.39s-.28.72-.28,1.39v.38h1.12v1.12h-1.12v5.17h-1.24v-5.17h-.9v-1.12h.9Z"
          />
          <path
            className="cls-17"
            d="m260.68,199.56v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path
            className="cls-17"
            d="m263.37,199.11v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m274.42,196.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m35.58,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m38.85,209.27v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m48.8,206.01h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path className="cls-17" d="m55.66,206.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m59.34,206.63c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m61.77,206.01h1.24v9.55h-1.24v-9.55Zm4.09,3.26h1.48l-2.68,3.08,3.23,3.21h-1.67l-3.15-3.21,2.79-3.08Z"
          />
          <path
            className="cls-17"
            d="m73.42,212.53h-4.42c.03.6.23,1.08.6,1.44s.85.53,1.44.53c.82,0,1.58-.26,2.27-.77v1.22c-.38.26-.76.44-1.14.55s-.82.16-1.32.16c-.69,0-1.25-.14-1.68-.43s-.77-.67-1.03-1.16-.39-1.05-.39-1.69c0-.96.27-1.74.81-2.33s1.25-.9,2.11-.9,1.5.29,2,.88.75,1.36.75,2.34v.16Zm-4.4-.75h3.17c-.03-.5-.18-.88-.44-1.15s-.62-.4-1.07-.4-.81.13-1.1.4-.47.65-.56,1.15Z"
          />
          <path
            className="cls-17"
            d="m78.72,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m80.68,206.01h1.24v3.71c.54-.39,1.11-.59,1.72-.59.8,0,1.45.3,1.96.9s.76,1.37.76,2.32c0,1.01-.3,1.82-.91,2.42s-1.41.9-2.42.9c-.41,0-.83-.04-1.28-.13s-.81-.2-1.07-.33v-9.2Zm1.24,4.9v3.4c.42.13.86.19,1.31.19.55,0,1-.2,1.35-.59s.52-.9.52-1.51-.16-1.13-.49-1.52-.75-.59-1.27-.59c-.46,0-.94.21-1.42.62Z"
          />
          <path
            className="cls-17"
            d="m88.38,206.63c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path className="cls-17" d="m90.84,206.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m94.52,206.63c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m96.06,210.27l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m105.47,209.27h1.4l-4.46,9.5h-1.39l2.13-4.56-2.43-4.94h1.42l1.7,3.55,1.63-3.55Z"
          />
          <path
            className="cls-17"
            d="m115.58,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m122.76,211v4.57h-1.25v-3.5c0-.7-.09-1.18-.28-1.46s-.51-.41-.98-.41c-.26,0-.5.06-.71.18s-.46.33-.74.63v4.57h-1.24v-6.29h1.24v.83c.63-.63,1.25-.95,1.86-.95.8,0,1.42.38,1.85,1.13.67-.77,1.36-1.15,2.08-1.15.61,0,1.11.22,1.51.67s.59,1.13.59,2.04v3.71h-1.24v-3.73c0-.52-.11-.93-.32-1.2s-.52-.42-.92-.42c-.52,0-1,.26-1.44.78Z"
          />
          <path
            className="cls-17"
            d="m131.41,209.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m137.37,209.27v.8c.56-.62,1.19-.92,1.89-.92.39,0,.76.1,1.09.3s.59.48.77.83.26.91.26,1.68v3.6h-1.24v-3.58c0-.64-.1-1.1-.29-1.38s-.52-.41-.98-.41c-.59,0-1.09.29-1.5.88v4.49h-1.27v-6.29h1.27Z"
          />
          <path
            className="cls-17"
            d="m142.8,211.45c0-.67.25-1.2.73-1.59s1.16-.58,2.01-.58h2.59v.97h-1.27c.25.25.42.48.51.68s.14.44.14.7c0,.33-.09.65-.28.97s-.43.56-.72.73-.78.3-1.45.4c-.47.07-.7.23-.7.49,0,.15.09.27.26.36s.49.19.95.29c.77.17,1.27.3,1.49.4s.42.23.6.41c.3.3.45.68.45,1.13,0,.6-.27,1.07-.8,1.43s-1.24.53-2.13.53-1.61-.18-2.15-.54-.8-.84-.8-1.44c0-.85.53-1.4,1.58-1.65-.42-.27-.63-.54-.63-.8,0-.2.09-.38.27-.55s.42-.28.73-.36c-.93-.41-1.39-1.07-1.39-1.99Zm2.04,4.41c-.42,0-.76.09-1.03.27s-.4.41-.4.68c0,.65.58.97,1.75.97.55,0,.98-.08,1.28-.24s.45-.39.45-.69-.19-.53-.57-.71-.88-.28-1.48-.28Zm.29-5.5c-.34,0-.62.11-.86.34s-.36.5-.36.82.12.59.35.8.53.32.88.32.64-.11.88-.32.35-.49.35-.81-.12-.6-.36-.82-.53-.33-.89-.33Z"
          />
          <path
            className="cls-17"
            d="m152.91,218.77v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m163,209.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m167.63,218.77v-9.5h2.18c1.11,0,1.98.28,2.6.83.62.56.93,1.33.93,2.33,0,.94-.29,1.72-.88,2.32-.58.61-1.33.91-2.24.91-.4,0-.84-.09-1.33-.27v3.36h-1.27Zm2.15-8.33h-.88v3.87c.38.2.78.29,1.2.29.58,0,1.06-.2,1.43-.61s.56-.93.56-1.57c0-.41-.09-.77-.26-1.09-.17-.31-.41-.54-.72-.69-.3-.14-.74-.22-1.33-.22Z"
          />
          <path
            className="cls-17"
            d="m178.72,215.56v-.81c-.26.29-.57.51-.91.67s-.68.24-1.02.24c-.4,0-.76-.1-1.1-.3s-.59-.47-.76-.81-.26-.9-.26-1.69v-3.6h1.24v3.58c0,.66.09,1.12.28,1.38s.52.39.99.39c.59,0,1.1-.29,1.51-.87v-4.49h1.24v6.29h-1.24Z"
          />
          <path className="cls-17" d="m181.74,206.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m188.73,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m192.09,209.27v1.44l.07-.11c.6-.97,1.2-1.46,1.8-1.46.47,0,.96.24,1.47.71l-.66,1.09c-.43-.41-.83-.62-1.2-.62-.4,0-.75.19-1.04.57s-.44.84-.44,1.36v3.29h-1.25v-6.29h1.25Z"
          />
          <path
            className="cls-17"
            d="m204.39,206.01h1.25v9.55h-2.66c-.93,0-1.67-.29-2.23-.88s-.83-1.38-.83-2.37c0-.93.29-1.69.87-2.28s1.32-.9,2.23-.9c.42,0,.88.09,1.37.27v-3.39Zm0,8.48v-3.99c-.39-.2-.78-.29-1.18-.29-.62,0-1.11.2-1.48.61s-.55.95-.55,1.64c0,.65.16,1.15.48,1.5.19.21.39.35.61.42s.6.11,1.16.11h.96Z"
          />
          <path
            className="cls-17"
            d="m211.28,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m212.42,210.27l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m221.91,211.78v2.67c0,.21.07.32.22.32s.39-.11.7-.33v.76c-.28.18-.51.31-.68.37s-.35.1-.54.1c-.53,0-.85-.21-.94-.63-.53.41-1.09.62-1.69.62-.44,0-.8-.14-1.09-.43s-.44-.65-.44-1.09c0-.4.14-.75.43-1.06s.69-.56,1.21-.74l1.59-.55v-.33c0-.76-.38-1.13-1.13-1.13-.68,0-1.34.35-1.98,1.05v-1.36c.48-.57,1.18-.85,2.08-.85.68,0,1.22.18,1.63.53.14.11.26.27.37.45s.18.38.21.57.04.55.04,1.08Zm-1.22,2.54v-1.87l-.83.32c-.42.17-.72.34-.9.51s-.26.38-.26.64.08.47.25.64.38.25.65.25c.4,0,.76-.16,1.1-.49Z"
          />
          <path
            className="cls-17"
            d="m231.68,209.27h1.35l-2.78,6.4h-.42l-2.84-6.4h1.36l1.7,3.87,1.63-3.87Z"
          />
          <path
            className="cls-17"
            d="m234.6,206.63c.21,0,.38.07.53.21s.22.31.22.52-.07.37-.22.52-.32.22-.53.22c-.19,0-.36-.07-.51-.22s-.22-.32-.22-.52.07-.36.22-.51.31-.22.51-.22Zm-.62,2.65h1.24v6.29h-1.24v-6.29Z"
          />
          <path
            className="cls-17"
            d="m236.44,209.27h5.37l-3.33,5.13h3.33v1.16h-5.51l3.31-5.13h-3.17v-1.16Z"
          />
          <path
            className="cls-17"
            d="m245.87,210.27l2.34-2.3v1.3h1.99v1.12h-1.99v3.08c0,.72.3,1.08.9,1.08.45,0,.92-.15,1.42-.44v1.16c-.48.27-1,.4-1.57.4s-1.04-.17-1.42-.5c-.12-.1-.22-.21-.29-.34s-.14-.29-.19-.49-.08-.59-.08-1.16v-2.79h-1.09v-.12Z"
          />
          <path
            className="cls-17"
            d="m254.43,209.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path
            className="cls-17"
            d="m262.15,209.26c.96,0,1.75.31,2.39.93s.95,1.39.95,2.33-.32,1.66-.96,2.26-1.45.9-2.43.9-1.73-.3-2.37-.91-.95-1.37-.95-2.28.32-1.69.96-2.3,1.44-.92,2.41-.92Zm-.07,1.12c-.6,0-1.09.2-1.47.59s-.57.89-.57,1.5.2,1.09.59,1.47.9.57,1.51.57,1.11-.19,1.5-.58.58-.88.58-1.48-.2-1.09-.61-1.48-.92-.59-1.53-.59Z"
          />
          <path className="cls-17" d="m266.89,206.01h1.24v9.55h-1.24v-9.55Z" />
          <path
            className="cls-17"
            d="m269.63,215.11v-1.34c.35.25.71.45,1.08.6s.68.23.93.23.48-.06.67-.19.28-.28.28-.46-.06-.33-.18-.45-.38-.29-.78-.52c-.8-.45-1.33-.83-1.58-1.15s-.37-.66-.37-1.04c0-.48.19-.88.56-1.18s.86-.46,1.45-.46,1.25.17,1.89.52v1.23c-.74-.45-1.34-.67-1.81-.67-.24,0-.44.05-.58.15-.15.1-.22.24-.22.41,0,.15.07.29.2.42.13.13.37.29.71.48l.44.25c1.05.59,1.57,1.25,1.57,1.97,0,.51-.2.94-.6,1.27-.4.33-.92.5-1.56.5-.37,0-.71-.04-1-.12s-.66-.23-1.1-.44Z"
          />
          <path
            className="cls-17"
            d="m275.97,214.04c.23,0,.43.08.59.24s.25.36.25.59-.08.42-.24.57-.36.23-.6.23-.43-.08-.59-.23-.24-.35-.24-.57.08-.43.24-.59.36-.24.59-.24Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default DataVizChart;
